/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06de3681_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06de3681_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"11de6a30-c373-48e4-b167-775ab6876f68","title":"Tietoja tulostimesta","link":"finding-information-about-printer-topic.html","desc":"Tulostintietojen etsiminen Tiedot ja niiden","descFull":"Tulostintietojen etsiminen Tiedot ja niiden paikallistaminen Mitä tietoja etsit? Etsi vastaus täältä Käyttöönotto-ohjeet. Katso ohjelman mukana toimitettua asennusohjetta. Tulostinohjelmisto Tulostin- tai faksiohjain Tulostimen laiteohjelmisto Apuohjelma Siirry osoitteeseen  www.lexmark.com/downloads . Vuorovaikutteinen  Käyttöopas Siirry osoitteeseen  https://support.lexmark.com . Opasvideot Siirry osoitteeseen  https://infoserve.lexmark.com/idv/ . Tulostinohjelmiston ohjetietojen käyttäminen. Microsoft Windows- tai Macintosh-käyttöjärjestelmien ohje – avaa tulostinohjelmiston ohjelma tai sovellus ja valitse  Ohje . Napsauta   niin saat tilannekohtaista tietoa. Ohje asennetaan automaattisesti tulostinohjelmiston ohessa. Tulostinohjelmisto on tulostimen ohjelmakansiossa tai työpöydällä sen mukaan, mikä käyttöjärjestelmä on käytössä. Oppaat Live chat -tuki Sähköpostituki Äänituki Siirry osoitteeseen  https://support.lexmark.com . Valitse ensin maa tai alue ja sitten tuote, niin saat näkyviin asianomaisen tukisivuston. Omaa maatasi tai aluettasi koskevat tuen yhteystiedot ovat tuen sivustossa tai tulostimen mukana toimitetussa takuuasiakirjassa. Pidä seuraavat tiedot käsillä ottaessasi yhteyttä asiakastukeen: ostopaikka ja -aika laitteen tyyppi ja sarjanumero Lisätietoja on kohdassa  . Turvaohjeita Säädökset Takuu Ympäristötiedot Takuutiedot vaihtelevat maittain tai alueittain: Yhdysvalloissa  voit katsoa rajoitetun takuun rajoitukset ja ehdot tulostimen mukana toimitettavasta Rajoitetut takuuehdot -asiakirjasta tai osoitteessa  http://support.lexmark.com . Muut maat ja alueet  – katso tulostimen mukana toimitettu painettu takuuasiakirja. Tuotetieto-opas –Katso lisätietoja tulostimen mukana toimitetusta asiakirjasta tai osoitteessa  https://support.lexmark.com . Tietoja Lexmarkin digitaalisesta passista Siirry osoitteeseen  https://csr.lexmark.com/digital-passport.php . tulostimen tietojen etsiminen"},{"UUID":"6accefe3-e44d-47a8-8b93-a54ff227b524","title":"Tietoja tulostimesta","link":"finding-printer-serial-number-topic.html","desc":"Tulostimien sarjanumeron etsiminen Avaa lokero.","descFull":"Tulostimien sarjanumeron etsiminen Avaa lokero. Katso sarjanumero tulostimen oikealta sivulta. tulostimen sarjanumero sarjanumero"},{"UUID":"2a8a26b8-bee4-457b-baa0-61d5556b3f85","title":"Tietoja tulostimesta","link":"printer-configurations-topic.html","desc":"Tulostinkokoonpanot Sijoita tulostin tasaiselle, kestävälle","descFull":"Tulostinkokoonpanot Sijoita tulostin tasaiselle, kestävälle ja vakaalle pinnalle. Perusmalli Perustulostinmallin osat 1 Automaattinen asiakirjansyöttölaite 2 Ohjauspaneeli 3 USB-portti 4 Monikäyttösyöttöaukko 5 550 arkin vakiolokero 6 Vakioalusta Varusteltu malli Yhden tai useamman vaihtoehdon asentaminen tulostimeen tai monitoimilaitteeseen saattaa vaatia tulostintuen, huonekalun tai muun ominaisuuden epävakauden ja loukkaantumisvaaran estämiseksi. Lisätietoja tuetuista kokoonpanoista on osoitteessa  www.lexmark.com/multifunctionprinters . Yhden tai useamman vaihtoehdon asentaminen tulostimeen tai monitoimilaitteeseen saattaa vaatia tulostintuen, huonekalun tai muun ominaisuuden epävakauden ja loukkaantumisvaaran estämiseksi. Lisätietoja tuetuista kokoonpanoista saat tulostimen ostopaikasta. Voit vähentää laitteen epävakauden riskiä lisäämällä jokaisen alustan erikseen. Pidä kaikki muut alustat suljettuina, kunnes niitä tarvitaan. Varustellun tulostinmallin osat # Lisälaite Vaihtoehtoinen lisälaite 1  Ei voida asentaa yhdessä vihkoviimeistelijän tai nidonnan ja rei'ityksen viimeistelijän kanssa. 2  On aina asennettava yhdessä valinnaisen 550 arkin lokeron ja joko 2 x 550 arkin lokeron tai 2000 arkin kaksoislokeron kanssa. 3  On aina asennettava valinnaisen 550 arkin lokeron kanssa. 4  On aina asennettava valinnaisen 550 arkin lokeron ja jokin seuraavista kanssa: 2 x 550 arkin lokero, 2000 arkin kaksoislokero tai teline. 1 Nidonnan viimeistelijä 1 Offset-pinoaja 1 Paperinsiirto Paperin siirtoyksikkö taittovalinnalla 2 1500 arkin lokero 2 Ei mitään 3 2000 arkin tandem-lokero 3 2 x 550 arkin lokero 3 Teline 3 4 Valinnainen 550 arkin lokero Ei mitään 5 Vihkoviimeistelijä 4 Nidonnan ja rei'ityksen viimeistelijä 4 Kaikki vaihtoehdot eivät välttämättä ole käytettävissä. Kysy lisätietoja tulostimen ostopaikasta. tulostinkokoonpanot"},{"UUID":"3a72f717-65f0-43a8-b1c7-4724562504dd","title":"Tietoja tulostimesta","link":"using-control-panel-topic.html","desc":"Ohjauspaneelin käyttäminen Ohjauspaneelin osat ja","descFull":"Ohjauspaneelin käyttäminen Ohjauspaneelin osat ja niiden toiminta Ohjauspaneelin osa Toiminto 1 Virtapainike Tulostimen virran kytkeminen ja katkaiseminen. Sammuta tulostin painamalla virtapainiketta viisi sekuntia. Tulostimen siirtäminen lepotilaan. Tulostimen herättäminen lepo- tai valmiustilasta. 2 Näyttö Tulostimen ilmoitusten ja tarvikkeen tilan tarkastelu. Tulostimen asentaminen ja käyttäminen. 3 Merkkivalo Tulostimen tilan tarkistaminen. ohjauspaneeli käyttäminen ohjauspaneelin avulla"},{"UUID":"e06515b2-c424-46ee-a432-8c5630a1de76","title":"Tietoja tulostimesta","link":"using-home-screen-topic.html","desc":"Aloitusnäytön kuvakkeet Aloitusnäyttö voi vaihdella","descFull":"Aloitusnäytön kuvakkeet Aloitusnäyttö voi vaihdella aloitusnäytön ja järjestelmänvalvojan tekemien asetusten sekä aktiivisten upotettujen ratkaisujen mukaan. Aloitusnäytön kuvakkeet ja niiden toiminnot # Kuvakkeen nimi Toiminto 1 Käyttäjä  Näytä, onko käyttäjä kirjautunut tulostimeen. 2 Näytetyt tiedot Näytä mukautetut tulostimen tiedot, kuten tulostimen IP-osoite tai päivämäärä ja aika. 3 Tarvike Näytä tarvikkeiden tila. 4 Ilmoitus Näyttää tulostimen varoituksia tai virheilmoituksia, kun tulostin edellyttää toimenpiteitä, jotta työn käsittelemistä voidaan jatkaa. Katso lisätietoja tulostimen varoituksesta tai ilmoituksesta sekä sen poistamisesta. 5 Tulostaminen Valokuvien ja asiakirjojen tulostaminen. 6 Kopioiminen Valokuvien ja asiakirjojen kopioiminen. 7 Skannaaminen Asiakirjojen skannaaminen. 8 Faksi Lähetä faksiviestejä. aloitusnäytön käyttäminen aloitusnäytön kuvakkeet"},{"UUID":"a67cfb60-9f8c-427d-8101-24f199e56020","title":"Tietoja tulostimesta","link":"colors-of-indicator-light-topic.html","desc":"Merkkivalon värit Merkkivalon väri ja","descFull":"Merkkivalon värit Merkkivalon väri ja sitä vastaava tulostimen tila Merkkivalon väri Tulostimen tila Ei käytössä Tulostin on sammutettu. Palaa sinisenä Tulostin on valmis. Vilkkuu sinisenä Tulostin tulostaa tai käsittelee tietoja. Vilkkuu punaisena Tulostimessa vaaditaan käyttäjän toimia. Tasainen keltainen Tulostin on lepotilassa. Vilkkuu keltaisena Tulostin on syvässä lepotilassa tai valmiustilassa. merkkivalo tulostimen tila tulostimen tila"},{"UUID":"4e5a07d4-68c5-4a4a-be80-ecf12ee7e873","title":"Tietoja tulostimesta","link":"using-ADF-and-scanner-glass-copy-topic.html","desc":"Automaattisen asiakirjansyöttölaitteen ja skannaustason käyttäminen","descFull":"Automaattisen asiakirjansyöttölaitteen ja skannaustason käyttäminen Paperin lisääminen automaattiseen asiakirjansyöttölaitteeseen ja skannaustasolle Automaattinen asiakirjansyöttölaite Skannaustaso Käytä asiakirjansyöttölaitetta monisivuisten asiakirjojen kopioimiseen. Aseta alkuperäinen asiakirja kuvapuoli ylöspäin. Jos käsittelet monisivuisia asiakirjoja, kohdista etureuna ennen lisäämistä. Säädä asiakirjansyöttölaitteen ohjaimet lisättävän paperin leveyden mukaan. Aseta yksisivuiset asiakirjat, kirjojen sivut, pienet esineet (kuten postikortit ja valokuvat), piirtoheitinkalvot, valokuvapaperi tai ohuet materiaalit (kuten lehtileikkeet) skannaustasolle. Aseta asiakirja kuvapuoli alaspäin nuolella merkittyyn kulmaan. kopioiminen asiakirjansyöttölaitteen käyttäminen kopioiminen skannaustason avulla"},{"UUID":"c14c8e69-5545-458d-ab5a-9cd25f9d1d74","title":"Tietoja tulostimesta","link":"locating-security-slot-topic.html","desc":"Turvalukon etsiminen Tulostimessa on suojauslukitustoiminto.","descFull":"Turvalukon etsiminen Tulostimessa on suojauslukitustoiminto. Kiinnitä useimpien kannettavien tietokoneiden kanssa yhteensopiva turvalukko kuvassa näkyvään kohtaan, jotta tulostin pysyy paikallaan. suojausaukko etsiminen turvalukon etsiminen"},{"UUID":"09e0ceeb-3fe9-4a8c-a2fd-4937d510615b","title":"Paperin valinta","link":"paper-guidelines-topic.html","desc":"Paperiohjeet Käyttämällä asianmukaista paperia voit","descFull":"Paperiohjeet Käyttämällä asianmukaista paperia voit estää tukoksia ja varmistaa häiriöttömän tulostuksen. Käytä aina uutta, vahingoittumatonta paperia. Paperia lisättäessä on tiedettävä paperin suositeltava tulostuspuoli. Tämä tieto löytyy yleensä paperipakkauksesta. Älä käytä käsin leikattua tai rajattua materiaalia. Älä lisää samaan lokeroon erikokoisia, -painoisia tai -lajisia papereita, sillä seurauksena voi olla tukos. Älä käytä muuta kuin elektrofotografiseen tulostukseen tarkoitettua päällystettyä paperia. Lisätietoja on  Paperi- ja erikoismateriaalioppaassa . paperi valitseminen paperiohjeet"},{"UUID":"46264c33-da13-48f7-84c2-df5dc4b47626","title":"Paperin valinta","link":"paper-guidelines-topic.html","desc":"Paperin ominaisuudet Seuraavat paperin ominaisuudet","descFull":"Paperin ominaisuudet Seuraavat paperin ominaisuudet vaikuttavat tulostuslaatuun ja -varmuuteen. Ota huomioon seuraavat seikat ennen kuin tulostat näille papereille. Paino Lokeroihin voi lisätä monen painoista paperia. Alle 60 g/m 2 :n paperi ei välttämättä ole riittävän tukevaa, ja se voi aiheuttaa tukoksia. Lisätietoja on ohjeaiheessa Tuetut paperien painot. Käpristyminen Käpristymisellä tarkoitetaan paperin reunojen taipumista. Liiallinen käpristyminen voi aiheuttaa paperinsyöttöhäiriöitä. Käpristymistä esiintyy yleensä, kun paperi kulkee tulostimen läpi, sillä tulostimessa paperi on alttiina korkeille lämpötiloille. Paperin säilyttäminen suojaamattomana kuumissa, kosteissa, kylmissä ja kuivissa tiloissa voi lisätä paperin käpristymistä ennen tulostusta ja aiheuttaa syöttöhäiriöitä. Tasaisuus Paperin tasaisuus vaikuttaa tulostuslaatuun suoraan. Jos paperi on liian karkeaa, väriaine ei kiinnity siihen oikein. Liian sileä paperi voi aiheuttaa syöttöhäiriöitä tai tulostuslaatuongelmia. Suosittelemme käyttämään 50 Sheffield-pisteen paperia. Kosteuspitoisuus Paperin kosteuspitoisuus vaikuttaa sekä tulostuslaatuun että paperinsyöttöön. Säilytä paperia alkuperäisessä pakkauksessaan, kunnes otat sen käyttöön. Paperin altistuminen kosteuspitoisuuden muutoksille voi huonontaa paperin ominaisuuksia. Säilytä paperia ennen tulostamista alkuperäisessä pakkauksessaan 24–48 tunnin ajan. Paperia on säilytettävä samassa ympäristössä, jossa tulostin on. Pidennä valmisteluaikaa useita vuorokausia, jos säilytys- tai kuljetusympäristö poikkeaa tulostimen ympäristöstä huomattavasti. Lisäksi paksun paperin valmisteleminen voi kestää tavallista kauemmin. Syisyys Syisyys viittaa paperin kuitujen suuntaan paperiarkissa. Syyt ovat joko  pitkiä , jolloin ne kulkevat paperin pituussuunnassa, tai  lyhyitä , jolloin ne kulkevat paperin leveyssuunnassa. Tarkista suositeltavat syiden suunnat ohjeaiheesta Tuetut paperien painot. Kuitupitoisuus Useimmat hyvälaatuiset kopiopaperit on tehty 100-prosenttisesta sellukuidusta. Tällainen paperi on tasalaatuista, jolloin paperinsyöttöhäiriöitä on vähän ja tulostuslaatu on hyvä. Jos paperissa on esimerkiksi puuvillakuituja, paperinkäsittelyominaisuudet voivat huonontua. paperin ominaisuudet"},{"UUID":"0e8d66b0-3ae2-443b-9d22-7eb3243da1d7","title":"Paperin valinta","link":"paper-guidelines-topic.html","desc":"Kelpaamaton paperi Seuraavanlaisia papereita ei","descFull":"Kelpaamaton paperi Seuraavanlaisia papereita ei suositella käytettäväksi tulostimessa: Kemiallisesti käsitellyt paperit, joilla voi tehdä kopioita ilman hiilipaperia. Niitä kutsutaan myös itsejäljentäviksi papereiksi, itsejäljentäviksi kopiopapereiksi (CCP) tai ilman hiiltä kopioiviksi (NCR) papereiksi. esipainetut paperit, joiden valmistuksessa on käytetty kemikaaleja, jotka voivat vahingoittaa tulostinta esipainetut paperit, joihin voi vaikuttaa tulostimen kiinnitysyksikön lämpötila esipainetut paperit, jotka edellyttävät kohdistustarkkuutta (tarkkaa tulostuskohtaa sivulla), joka on yli ±2,3 mm, kuten OCR-lomakkeet Joissakin tapauksissa kohdistusta voi säätää sovelluksessa, jolloin näiden lomakkeiden tulostus onnistuu. pinnoitetut paperit, synteettiset paperit, lämpöpaperit karkeareunaiset tai käpristyneet paperit tai paperit, joiden pinta on karkea tai paljon kuvioitu Paperit, jotka eivät ole EN12281:2002-standardin (Eurooppa) mukaisia paperi, jonka paino on alle 60g/m 2 moniosaisia lomakkeita tai asiakirjoja. kelpaamaton paperi"},{"UUID":"0fac3cf9-5633-45e5-b85f-7d50ccda452e","title":"Paperin valinta","link":"paper-guidelines-topic.html","desc":"Paperin varastointi Noudattamalla paperin säilytysohjeita","descFull":"Paperin varastointi Noudattamalla paperin säilytysohjeita voit estää tukoksia ja epätasaista tulostuslaatua: Säilytä paperia samassa lämpötilassa kuin tulostinta 24–48 tuntia ennen tulostamista. Pidennä valmisteluaikaa useita vuorokausia, jos säilytys- tai kuljetusympäristö poikkeaa tulostimen ympäristöstä huomattavasti. Lisäksi paksun paperin valmisteleminen voi kestää tavallista kauemmin. Saat parhaan tuloksen säilyttämällä paperia tilassa, jonka lämpötila on 21 °C ja suhteellinen ilmankosteus 40 %. Useimmat tarrojen valmistajat suosittelevat, että tulostusympäristön lämpötila on 18–24 °C ja suhteellinen kosteus 40–60 %. Säilytä paperia sen omassa laatikossa, mieluummin kuljetuslavalla tai hyllyllä kuin lattialla. Säilytä yksittäisiä pakkauksia tasaisella alustalla. Älä aseta mitään paperipakettien päälle. Poista paperi laatikosta tai pakkauksesta vasta, kun olet valmis lisäämään sen tulostimeen. Laatikko ja pakkaus auttavat pitämään paperin puhtaana, kuivana ja suorana. paperin varastointi"},{"UUID":"10dc8791-6ec2-4922-9ad2-8632480486b6","title":"Paperin valinta","link":"paper-guidelines-topic.html","desc":"Esipainettujen lomakkeiden ja kirjelomakkeiden valinta","descFull":"Esipainettujen lomakkeiden ja kirjelomakkeiden valinta Käytä pitkäsyistä paperia. Käytä vain sellaisia lomakkeita ja kirjelomakkeita, jotka on painettu kivipainossa tai kaiverretulla telalla. Vältä paperia, jossa on karkea tai hyvin kuvioitu pinta. Käytä vain sellaista mustetta, johon väriaineen sisältämä hartsi ei vaikuta. Hapetettu tai öljypohjainen muste tavallisesti täyttää nämä vaatimukset, lateksimuste yleensä ei. Kokeile esipainettujen lomakkeiden tulostamista, ennen kuin ostat niitä suuria määriä. Näin voit määrittää, vaikuttaako esipainettujen lomakkeiden tai kirjelomakkeiden muste tulostuslaatuun. Jos olet epävarma, ota yhteys paperin toimittajaan. Kun tulostat kirjelomakkeelle, lisää paperi tulostimeen oikeassa suunnassa. Lisätietoja on  Paperi- ja erikoismateriaalioppaassa . Kun tulostat kirjelomakkeelle, lisää paperi tulostimeen oikeassa suunnassa. paperi esipainetut lomakkeet esipainetut lomakkeet valitseminen paperi kirjepaperi kirjepaperi valitseminen"},{"UUID":"21263538-f517-4566-b757-6d85a0ee720a","title":"Tuetut paperikoot","link":"paper-guidelines-topic.html","desc":"Peruskokoonpanon tukemat paperikoot Peruskokoonpanon tukemat","descFull":"Peruskokoonpanon tukemat paperikoot Peruskokoonpanon tukemat paperikoot Paperikoko Suunta 550 arkin vakiolokero Monikäyttösyöttöaukko Kaksipuolinen tulostus Automaattinen asiakirjansyöttölaite 1  Tuetaan vain joissain tulostinmalleissa. 2  Tuetaan vain, kun määritetty Yleisasetukset-valikosta. 3  Tukee paperikokoja 95 x 139,7 mm (3,74 x 5,5 tuumaa) - 297 x 355,6 mm (11,69 x 14 tuumaa). 4  Yleisen paperikoon enimmäispituus jatkolomakkeen tapauksessa on 1320,8 mm/52 tuumaa. Lisää vain yksi arkki banneripaperia kerrallaan. 5  Tukee paperikokoja 95 x 139,7 mm (3,74 x 5,5 tuumaa) - 320 x 457,2 mm (12,6 x 18 tuumaa). 6  Tukee paperikokoja 105 x 139,7 mm (4,13 x 5,5 tuumaa) - 320 x 457,2 mm (12,59 x 18 tuumaa). 7  Tukee paperikokoja 76.2 x 128 mm (3 x 5,04 tuumaa) - 297 x 432 mm (11,69 x 17.01 tuumaa). 4x6 kortti Lyhyen reunan syöttäminen X ✓ X X Pitkän reunan syöttäminen X X X X A6 105 x 148 mm (4,13 x 5,83 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ Pitkän reunan syöttäminen X X X X 1/3 A4 Lyhyen reunan syöttäminen ✓ ✓ X ✓ Pitkän reunan syöttäminen X X X X A5 148 x 210 mm (5,83 x 8,27 tuumaa) Lyhyen reunan syöttäminen ✓ X ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ A4 210 x 297 mm (8,27 x 11,7 tuumaa) Lyhyen reunan syöttäminen ✓ X ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 tuumaa) Lyhyen reunan syöttäminen X ✓ ✓ 1 ✓ 1 JIS B5 182 x 257 mm (7,17 x 10,1 tuumaa) Lyhyen reunan syöttäminen ✓ X ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 tuumaa) Lyhyen reunan syöttäminen X ✓ ✓ ✓ Statement 139.7 x 215.9 mm (5,5 x 8,5 tuumaa) Lyhyen reunan syöttäminen ✓ X ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ Executive 184.2 x 266.7 mm (7,25 x 10,5 tuumaa) Lyhyen reunan syöttäminen ✓ X ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ Letter 215.9 x 279.4 mm (8,5 x 11 tuumaa) Lyhyen reunan syöttäminen ✓ X ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ Folio 215.9 x 330.2 mm (8,5 x 13 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ Oficio (Meksiko) 215.9 x 340.4 mm (8,5 x 13,4 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ Legal 215.9 x 355.6 mm (8,5 x 14 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 mm (11 x 17 tuumaa) Lyhyen reunan syöttäminen X ✓ ✓ ✓ 12x18 304.8 x 457.2 mm (12,0 x 18,0 tuumaa) Lyhyen reunan syöttäminen X ✓ ✓ X SRA3 320.04 x 449.58 mm (12,6 x 17,7 tuumaa) Lyhyen reunan syöttäminen X ✓ ✓ X Chokei 3 -kirjekuori 120 x 235 mm (4,75 x 9,25 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Hagaki 100 x 148 mm (3,94 x 5,83 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X B5-kirjekuori 176 x 250 mm (6,93 x 9,84 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Kirjekuori (Commercial #9) 98.4 x 225.4 mm (3,875 x 8,9 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Kirjekuori (Commercial #10) 104.8 x 241.3 mm (4,12 x 9,5 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Kirjekuori (Monarch 7‑3/4) 98.4 x 190.5 mm (3,875 x 7,5 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Kirjekuori (DL) 110 x 220 mm (4,33 x 8,66 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Kirjekuori (ISO C4) 229 x 324 mm (9 x 12,8 tuumaa) Lyhyen reunan syöttäminen X ✓ 2 X X Kirjekuori (ISO C5) 162 x 229 mm (6,38 x 9 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Universal - ✓ 3 ✓ 4, 5 ✓ 6 ✓ 7 tuetut paperikoot paperikoot tuetut"},{"UUID":"37ee4fec-fdfe-4ab0-b332-f023213ce5a0","title":"Tuetut paperikoot","link":"paper-guidelines-topic.html","desc":"Valinnaisten lokerojen tukemat paperikoot Paperikoko","descFull":"Valinnaisten lokerojen tukemat paperikoot Paperikoko Suunta Valinnainen 550 arkin lokero Kaksi 550 arkin lokeroa 2000 arkin kaksoislokero 1500 arkin alusta 1  Tuetaan vain, kun määritetty Yleisasetukset-valikosta. 2  Tukee paperikokoja 139.7 x 215,9 mm (5,5 x 8,5 tuumaa) - 304.8 x 457,2 mm (12 x 18 tuumaa). 4x6 kortti Lyhyen reunan syöttäminen X X X X Pitkän reunan syöttäminen X X X X A6 105 x 148 mm (4,13 x 5,83 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Pitkän reunan syöttäminen X X X X 1/3 A4 Lyhyen reunan syöttäminen X X X X Pitkän reunan syöttäminen X X X X A5 148 x 210 mm (5,83 x 8,27 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Pitkän reunan syöttäminen ✓ ✓ X X A4 210 x 297 mm (8,27 x 11,7 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X JIS B5 182 x 257 mm (7,17 x 10,1 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Pitkän reunan syöttäminen ✓ ✓ X ✓ JIS B4 257 x 364 mm (10,12 x 14,33 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Statement 139.7 x 215.9 mm (5,5 x 8,5 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Pitkän reunan syöttäminen X X X X Executive 184.2 x 266.7 mm (7,25 x 10,5 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Pitkän reunan syöttäminen ✓ ✓ X X Letter 215.9 x 279.4 mm (8,5 x 11 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ Folio 215.9 x 330.2 mm (8,5 x 13 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Oficio (Meksiko) 215.9 x 340.4 mm (8,5 x 13,4 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Legal 215.9 x 355.6 mm (8,5 x 14 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Ledger 279.4 x 431.8 mm (11 x 17 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X 12x18 304.8 x 457.2 mm (12 x 18 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X SRA3 320.04 x 449.58 mm (12,6 x 17,7 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Chokei 3 -kirjekuori 120 x 235 mm (4,75 x 9,25 tuumaa) Lyhyen reunan syöttäminen X X X X Hagaki 100 x 148 mm (3,94 x 5,83 tuumaa) Lyhyen reunan syöttäminen ✓ 1 ✓ 1 X X B5-kirjekuori 176 x 250 mm (6,93 x 9,84 tuumaa) Lyhyen reunan syöttäminen X X X X Kirjekuori (Commercial #9) 98.4 x 225.4 mm (3,875 x 8,9 tuumaa) Lyhyen reunan syöttäminen ✓ 1 ✓ 1 X X Kirjekuori (Commercial #10) 104.8 x 241.3 mm (4,12 x 9,5 tuumaa) Lyhyen reunan syöttäminen X X X X Kirjekuori (Monarch 7‑3/4) 98.4 x 190.5 mm (3,875 x 7,5 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Kirjekuori (DL) 110 x 220 mm (4,33 x 8,66 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Kirjekuori (ISO C4) 229 x 324 mm (9 x 12,8 tuumaa) Lyhyen reunan syöttäminen X X X X Kirjekuori (ISO C5) 162 x 229 mm (6,38 x 9 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X X Universal - ✓ 2 ✓ 2 ✓ ✓ tuetut paperikoot paperikoot tuetut"},{"UUID":"ed106c2f-3b5e-46cb-a2f7-30f5b4cde764","title":"Tuetut paperikoot","link":"paper-guidelines-topic.html","desc":"Vastaanottoalustojen tukemat paperikoot Paperin siirtoyksikkö","descFull":"Vastaanottoalustojen tukemat paperikoot Paperin siirtoyksikkö ja joko nidonnan ja rei'ityksen viimeistelijä tai vihkoviimeistelijä on asennettu tulostimeen. Paperikoko Suunta Paperin siirtoyksikkö + nidonnan ja rei'ityksen viimeistelijä Paperin siirtoyksikkö + vihkoviimeistelijä Vakioalusta (viimeistelijän yläalusta) Alusta 1 (nidonnan ja rei'ityksen viimeistelijä, porrastusalusta) Alusta 2 (paperin siirtoalusta) Vakioalusta (viimeistelijän yläalusta) Alusta 1 (nidonnan ja rei'ityksen viimeistelijä, porrastusalusta) Alusta 2 (viimeistelijän vihkoalusta) Alusta 3 (paperin siirtoalusta) 1  Tukee paperikokoja 90 x 148 mm (3,55 x 5,83 tuumaa) - 320 x 600 mm (12,59 x 23.62 tuumaa). 2  Tukee paperikokoja 90 x 148 mm (3,55 x 5,83 tuumaa) - 320 x 1260 mm (12,59 x 49.6 tuumaa). 3  Tukee paperikokoja 182 x 257 mm (7,17 x 10,12 tuumaa) - 304.8 x 457,2 mm (12 x 18 tuumaa). 4x6 kortti Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ Pitkän reunan syöttäminen X X X X X X ✓ A6 105 x 148 mm (4,13 x 5,83 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ Pitkän reunan syöttäminen X X X X X X X 1/3 A4 Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ Pitkän reunan syöttäminen X X X X X X ✓ A5 148 x 210 mm (5,83 x 8,27 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ A4 210 x 297 mm (8,27 x 11,7 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ JIS B4 257 x 364 mm (10,12 x 14,33 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ Statement 139.7 x 215.9 mm (5,5 x 8,5 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ Executive 184.2 x 266.7 mm (7,25 x 10,5 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ Letter 215.9 x 279.4 mm (8,5 x 11 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ Folio 215.9 x 330.2 mm (8,5 x 13 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ Oficio (Meksiko) 215.9 x 340.4 mm (8,5 x 13,4 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ Legal 215.9 x 355.6 mm (8,5 x 14 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 mm (11 x 17 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 mm (12 x 18 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ SRA3 320.04 x 449.58 mm (12,6 x 17,7 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X ✓ ✓ X ✓ Chokei 3 -kirjekuori 120 x 235 mm (4,75 x 9,25 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ Hagaki 100 x 148 mm (3,94 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ B5-kirjekuori 176 x 250 mm (6,93 x 9,84 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ Kirjekuori (Commercial #9) 98.4 x 225.4 mm (3,875 x 8,9 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ Kirjekuori (Commercial #10) 104.8 x 241.3 mm (4,12 x 9,5 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ Kirjekuori (Monarch 7‑3/4) 98.4 x 190.5 mm (3,875 x 7,5 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ Kirjekuori (DL) 110 x 220 mm (4,33 x 8,66 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ Kirjekuori (ISO C4) 229 x 324 mm (9 x 12,8 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ Kirjekuori (ISO C5) 162 x 229 mm (6,38 x 9 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ Universal - ✓ 1 ✓ 1 ✓ 2 ✓ 1 ✓ 1 ✓ 3 ✓ 2 Paperin siirtoyksikkö taittovalinnalla ja joko nidonnan ja rei'ityksen viimeistelijä tai vihkoviimeistelijä on asennettu tulostimeen. Paperin siirtoyksikkö taittomahdollisuudella + nidonnan ja rei'ityksen viimeistelijä Paperin siirtoyksikkö taittomahdollisuudella + vihkoviimeistelijä Paperikoko Suunta Vakioalusta (viimeistelijän yläalusta) Alusta 1 (nidonnan ja rei'ityksen viimeistelijä, porrastusalusta) Alusta 2 (paperin siirtoalusta) Vakioalusta (viimeistelijän yläalusta) Alusta 1 (nidonnan ja rei'ityksen viimeistelijä, porrastusalusta) Alusta 2 (viimeistelijän vihkoalusta) Alusta 3 (paperin siirtoalusta) 1  Tukee paperikokoja 90 x 148 mm (3,55 x 5,83 tuumaa) - 320 x 600 mm (12,59 x 23.62 tuumaa). 2  Tukee paperikokoja 90 x 148 mm (3,55 x 5,83 tuumaa) - 297 x 1260 mm (11,69 x 49.6 tuumaa). 3  Tukee paperikokoja 182 x 257 mm (7,17 x 10,12 tuumaa) - 304.8 x 457,2 mm (12 x 18 tuumaa). 4x6 kortti Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ Pitkän reunan syöttäminen X X X X X X X A6 105 x 148 mm (4,13 x 5,83 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ Pitkän reunan syöttäminen X X X X X X X 1/3 A4 Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ Pitkän reunan syöttäminen X X X X X X X A5 148 x 210 mm (5,83 x 8,27 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ A4 210 x 297 mm (8,27 x 11,7 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ A3 297 x 420 mm (11,69 x 16,54 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ JIS B4 257 x 364 mm (10,12 x 14,33 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ Statement 139.7 x 215.9 mm (5,5 x 8,5 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ Executive 184.2 x 266.7 mm (7,25 x 10,5 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ Letter 215.9 x 279.4 mm (8,5 x 11 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ X ✓ Folio 215.9 x 330.2 mm (8,5 x 13 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ Oficio (Meksiko) 215.9 x 340.4 mm (8,5 x 13,4 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ Legal 215.9 x 355.6 mm (8,5 x 14 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 mm (11 x 17 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 mm (12 x 18 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X ✓ ✓ ✓ X SRA3 320.04 x 449.58 mm (12,6 x 17,7 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X ✓ ✓ X X Chokei 3 -kirjekuori 120 x 235 mm (4,75 x 9,25 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ Hagaki 100 x 148 mm (3,94 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ B5-kirjekuori 176 x 250 mm (6,93 x 9,84 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ Kirjekuori (Commercial #9) 98.4 x 225.4 mm (3,875 x 8,9 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ Kirjekuori (Commercial #10) 104.8 x 241.3 mm (4,12 x 9,5 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ Kirjekuori (Monarch 7‑3/4) 98.4 x 190.5 mm (3,875 x 7,5 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ Kirjekuori (DL) 110 x 220 mm (4,33 x 8,66 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ Kirjekuori (ISO C4) 229 x 324 mm (9 x 12,8 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ Kirjekuori (ISO C5) 162 x 229 mm (6,38 x 9 tuumaa) Lyhyen reunan syöttäminen X X ✓ X X X ✓ Universal - ✓ 1 ✓ 1 ✓ 2 ✓ 1 ✓ 1 ✓ 3 ✓ 2 tuetut paperikoot paperikoot tuetut"},{"UUID":"e553166a-32c6-4cfe-ad48-0aa8294fe2a9","title":"Tuetut paperikoot","link":"paper-guidelines-topic.html","desc":"Nidonta- ja rei'itystöissä tuetut paperikoot","descFull":"Nidonta- ja rei'itystöissä tuetut paperikoot Nidonnan viimeistelijän tukemat paperikoot Paperikoko Suunta Nitoja Yksittäinen Kaksi Kaksi vasemmalla 4x6 kortti Lyhyen reunan syöttäminen X X X Pitkän reunan syöttäminen X X X A6 105 x 148 mm (4,13 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X X Pitkän reunan syöttäminen X X X 1/3 A4 Lyhyen reunan syöttäminen X X X Pitkän reunan syöttäminen X X X A5 148 x 210 mm (5,83 x 8,27 tuumaa) Lyhyen reunan syöttäminen X X X Pitkän reunan syöttäminen X X X A4 210 x 297 mm (8,27 x 11,7 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ Statement 139.7 x 215.9 mm (5,5 x 8,5 tuumaa) Lyhyen reunan syöttäminen X X X Pitkän reunan syöttäminen X X X Executive 184.2 x 266.7 mm (7,25 x 10,5 tuumaa) Lyhyen reunan syöttäminen ✓ X X Pitkän reunan syöttäminen ✓ ✓ ✓ Letter 215.9 x 279.4 mm (8,5 x 11 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X Pitkän reunan syöttäminen ✓ ✓ X Folio 215.9 x 330.2 mm (8,5 x 13 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X Oficio (Meksiko) 215.9 x 340.4 mm (8,5 x 13,4 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X Legal 215.9 x 355.6 mm (8,5 x 14 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ Ledger 279.4 x 431.8 mm (11 x 17 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ 12x18 304.8 x 457.2 mm (12 x 18 tuumaa) Lyhyen reunan syöttäminen X X X SRA3 320.04 x 449.58 mm (12,6 x 17,7 tuumaa) Lyhyen reunan syöttäminen X X X Chokei 3 -kirjekuori 120 x 235 mm (4,75 x 9,25 tuumaa) Lyhyen reunan syöttäminen X X X Hagaki 100 x 148 mm (3,94 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X X B5-kirjekuori 176 x 250 mm (6,93 x 9,84 tuumaa) Lyhyen reunan syöttäminen X X X Kirjekuori (Commercial #9) 98.4 x 225.4 mm (3,875 x 8,9 tuumaa) Lyhyen reunan syöttäminen X X X Kirjekuori (Commercial #10) 104.8 x 241.3 mm (4,12 x 9,5 tuumaa) Lyhyen reunan syöttäminen X X X Kirjekuori (Monarch 7‑3/4) 98.4 x 190.5 mm (3,875 x 7,5 tuumaa) Lyhyen reunan syöttäminen X X X Kirjekuori (DL) 110 x 220 mm (4,33 x 8,66 tuumaa) Lyhyen reunan syöttäminen X X X Kirjekuori (ISO C4) 229 x 324 mm (9 x 12,8 tuumaa) Lyhyen reunan syöttäminen X X X Kirjekuori (ISO C5) 162 x 229 mm (6,38 x 9 tuumaa) Lyhyen reunan syöttäminen X X X Nidonnan ja rei'ityksen viimeistelijän tukemat paperikoot Paperikoko Suunta Nitoja Rei'itys Yksittäinen Kaksi Kaksi vasemmalla Kaksireikäinen Kolmireikäinen Nelireikäinen 4x6 kortti Lyhyen reunan syöttäminen X X X X X X Pitkän reunan syöttäminen X X X X X X A6 105 x 148 mm (4,13 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X X X X X Pitkän reunan syöttäminen X X X X X X 1/3 A4 Lyhyen reunan syöttäminen X X X X X X Pitkän reunan syöttäminen X X X X X X A5 148 x 210 mm (5,83 x 8,27 tuumaa) Lyhyen reunan syöttäminen X X X ✓ X X Pitkän reunan syöttäminen X X X ✓ X X A4 210 x 297 mm (8,27 x 11,7 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ X X Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ X X Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X ✓ ✓ ✓ Statement 139.7 x 215.9 mm (5,5 x 8,5 tuumaa) Lyhyen reunan syöttäminen X X X ✓ X X Pitkän reunan syöttäminen X X X ✓ X X Executive 184.2 x 266.7 mm (7,25 x 10,5 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ X X Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ Letter 215.9 x 279.4 mm (8,5 x 11 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ X X Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ Folio 215.9 x 330.2 mm (8,5 x 13 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ X X Oficio (Meksiko) 215.9 x 340.4 mm (8,5 x 13,4 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ X X Legal 215.9 x 355.6 mm (8,5 x 14 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ X X Ledger 279.4 x 431.8 mm (11 x 17 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 mm (12 x 18 tuumaa) Lyhyen reunan syöttäminen X X X X X X SRA3 320.04 x 449.58 mm (12,6 x 17,7 tuumaa) Lyhyen reunan syöttäminen X X X X X X Chokei 3 -kirjekuori 120 x 235 mm (4,75 x 9,25 tuumaa) Lyhyen reunan syöttäminen X X X X X X Hagaki 100 x 148 mm (3,94 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X X X X X B5-kirjekuori 176 x 250 mm (6,93 x 9,84 tuumaa) Lyhyen reunan syöttäminen X X X X X X Kirjekuori (Commercial #9) 98.4 x 225.4 mm (3,875 x 8,9 tuumaa) Lyhyen reunan syöttäminen X X X X X X Kirjekuori (Commercial #10) 104.8 x 241.3 mm (4,12 x 9,5 tuumaa) Lyhyen reunan syöttäminen X X X X X X Kirjekuori (Monarch 7‑3/4) 98.4 x 190.5 mm (3,875 x 7,5 tuumaa) Lyhyen reunan syöttäminen X X X X X X Kirjekuori (DL) 110 x 220 mm (4,33 x 8,66 tuumaa) Lyhyen reunan syöttäminen X X X X X X Kirjekuori (ISO C4) 229 x 324 mm (9 x 12,8 tuumaa) Lyhyen reunan syöttäminen X X X X X X Kirjekuori (ISO C5) 162 x 229 mm (6,38 x 9 tuumaa) Lyhyen reunan syöttäminen X X X X X X Vihkoviimeistelijän tukemat paperikoot Paperikoko Suunta Nitoja Rei'itys Yksittäinen Kaksi Kaksi vasemmalla Kaksireikäinen Kolmireikäinen Nelireikäinen 4x6 kortti Lyhyen reunan syöttäminen X X X X X X Pitkän reunan syöttäminen X X X X X X A6 105 x 148 mm (4,13 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X X X X X Pitkän reunan syöttäminen X X X X X X 1/3 A4 Lyhyen reunan syöttäminen X X X X X X Pitkän reunan syöttäminen X X X X X X A5 148 x 210 mm (5,83 x 8,27 tuumaa) Lyhyen reunan syöttäminen X X X ✓ X X Pitkän reunan syöttäminen X X X ✓ X X A4 210 x 297 mm (8,27 x 11,7 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ X X Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ X X X Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ X X JIS B4 257 x 364 mm (10,12 x 14,33 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ X ✓ ✓ ✓ Statement 139.7 x 215.9 mm (5,5 x 8,5 tuumaa) Lyhyen reunan syöttäminen X X X ✓ X X Pitkän reunan syöttäminen X X X ✓ X X Executive 184.2 x 266.7 mm (7,25 x 10,5 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ X X Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ Letter 215.9 x 279.4 mm (8,5 x 11 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ X X Pitkän reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ Folio 215.9 x 330.2 mm (8,5 x 13 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ X X Oficio (Meksiko) 215.9 x 340.4 mm (8,5 x 13,4 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ X X Legal 215.9 x 355.6 mm (8,5 x 14 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ X X Ledger 279.4 x 431.8 mm (11 x 17 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 mm (12 x 18 tuumaa) Lyhyen reunan syöttäminen X X X X X X SRA3 320.04 x 449.58 mm (12,6 x 17,7 tuumaa) Lyhyen reunan syöttäminen X X X X X X Chokei 3 -kirjekuori 120 x 235 mm (4,75 x 9,25 tuumaa) Lyhyen reunan syöttäminen X X X X X X Hagaki 100 x 148 mm (3,94 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X X X X X B5-kirjekuori 176 x 250 mm (6,93 x 9,84 tuumaa) Lyhyen reunan syöttäminen X X X X X X Kirjekuori (Commercial #9) 98.4 x 225.4 mm (3,875 x 8,9 tuumaa) Lyhyen reunan syöttäminen X X X X X X Kirjekuori (Commercial #10) 104.8 x 241.3 mm (4,12 x 9,5 tuumaa) Lyhyen reunan syöttäminen X X X X X X Kirjekuori (Monarch 7‑3/4) 98.4 x 190.5 mm (3,875 x 7,5 tuumaa) Lyhyen reunan syöttäminen X X X X X X Kirjekuori (DL) 110 x 220 mm (4,33 x 8,66 tuumaa) Lyhyen reunan syöttäminen X X X X X X Kirjekuori (ISO C4) 229 x 324 mm (9 x 12,8 tuumaa) Lyhyen reunan syöttäminen X X X X X X Kirjekuori (ISO C5) 162 x 229 mm (6,38 x 9 tuumaa) Lyhyen reunan syöttäminen X X X X X X tuetut paperikoot paperikoot tuetut"},{"UUID":"7e905a36-d787-4121-8b39-34af252306d7","title":"Tuetut paperikoot","link":"paper-guidelines-topic.html","desc":"Taittotöissä tuetut paperikoot Paperin siirtoyksikön","descFull":"Taittotöissä tuetut paperikoot Paperin siirtoyksikön tukemat paperikoot taittomahdollisuudella Paperikoko Suunta Vain paperin siirtoyksikkö taittovalinnalla C-taitto Z‑taitto Z-taitettu puoliarkki V-taitto Vakioalusta Vakioalusta Vakioalusta Vakioalusta 4x6 kortti Lyhyen reunan syöttäminen X X X X Pitkän reunan syöttäminen X X X X A6 105 x 148 mm (4,13 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X X X Pitkän reunan syöttäminen X X X X 1/3 A4 Lyhyen reunan syöttäminen X X X X Pitkän reunan syöttäminen X X X X A5 148 x 210 mm (5,83 x 8,27 tuumaa) Lyhyen reunan syöttäminen X X X X Pitkän reunan syöttäminen X X X X A4 210 x 297 mm (8,27 x 11,7 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ Pitkän reunan syöttäminen X X X X A3 297 x 420 mm (11,69 x 16,54 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 tuumaa) Lyhyen reunan syöttäminen X X X X Pitkän reunan syöttäminen X X X X JIS B4 257 x 364 mm (10,12 x 14,33 tuumaa) Lyhyen reunan syöttäminen X X ✓ ✓ Statement 139.7 x 215.9 mm (5,5 x 8,5 tuumaa) Lyhyen reunan syöttäminen X X X X Pitkän reunan syöttäminen X X X X Executive 184.2 x 266.7 mm (7,25 x 10,5 tuumaa) Lyhyen reunan syöttäminen X X X X Pitkän reunan syöttäminen X X X X Letter 215.9 x 279.4 mm (8,5 x 11 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ Pitkän reunan syöttäminen X X X X Folio 215.9 x 330.2 mm (8,5 x 13 tuumaa) Lyhyen reunan syöttäminen X X X X Oficio (Meksiko) 215.9 x 340.4 mm (8,5 x 13,4 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ Legal 215.9 x 355.6 mm (8,5 x 14 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 mm (11 x 17 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 mm (12 x 18 tuumaa) Lyhyen reunan syöttäminen X X X X SRA3 320.04 x 449.58 mm (12,6 x 17,7 tuumaa) Lyhyen reunan syöttäminen X X X X Chokei 3 -kirjekuori 120 x 235 mm (4,75 x 9,25 tuumaa) Lyhyen reunan syöttäminen X X X X Hagaki 100 x 148 mm (3,94 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X X X B5-kirjekuori 176 x 250 mm (6,93 x 9,84 tuumaa) Lyhyen reunan syöttäminen X X X X Kirjekuori (Commercial #9) 98.4 x 225.4 mm (3,875 x 8,9 tuumaa) Lyhyen reunan syöttäminen X X X X Kirjekuori (Commercial #10) 104.8 x 241.3 mm (4,12 x 9,5 tuumaa) Lyhyen reunan syöttäminen X X X X Kirjekuori (Monarch 7‑3/4) 98.4 x 190.5 mm (3,875 x 7,5 tuumaa) Lyhyen reunan syöttäminen X X X X Kirjekuori (DL) 110 x 220 mm (4,33 x 8,66 tuumaa) Lyhyen reunan syöttäminen X X X X Kirjekuori (ISO C4) 229 x 324 mm (9 x 12,8 tuumaa) Lyhyen reunan syöttäminen X X X X Kirjekuori (ISO C5) 162 x 229 mm (6,38 x 9 tuumaa) Lyhyen reunan syöttäminen X X X X Paperin siirtoyksikön ja vihkoviimeistelijän tukemat paperikoot Paperikoko Suunta Paperin siirtoyksikkö + vihkoviimeistelijä V-taitettu moninkertainen V-taitto Alusta 2 Vakioalusta, alusta 1, alusta 2 4x6 kortti Lyhyen reunan syöttäminen X X Pitkän reunan syöttäminen X X A6 105 x 148 mm (4,13 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X Pitkän reunan syöttäminen X X 1/3 A4 Lyhyen reunan syöttäminen X X Pitkän reunan syöttäminen X X A5 148 x 210 mm (5,83 x 8,27 tuumaa) Lyhyen reunan syöttäminen X X Pitkän reunan syöttäminen X X A4 210 x 297 mm (8,27 x 11,7 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen X X A3 297 x 420 mm (11,69 x 16,54 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen X X JIS B4 257 x 364 mm (10,12 x 14,33 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Statement 139.7 x 215.9 mm (5,5 x 8,5 tuumaa) Lyhyen reunan syöttäminen X X Pitkän reunan syöttäminen X X Executive 184.2 x 266.7 mm (7,25 x 10,5 tuumaa) Lyhyen reunan syöttäminen X X Pitkän reunan syöttäminen X X Letter 215.9 x 279.4 mm (8,5 x 11 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen X X Folio 215.9 x 330.2 mm (8,5 x 13 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Oficio (Meksiko) 215.9 x 340.4 mm (8,5 x 13,4 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Legal 215.9 x 355.6 mm (8,5 x 14 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Ledger 279.4 x 431.8 mm (11 x 17 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ 12x18 304.8 x 457.2 mm (12 x 18 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ SRA3 320.04 x 449.58 mm (12,6 x 17,7 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Chokei 3 -kirjekuori 120 x 235 mm (4,75 x 9,25 tuumaa) Lyhyen reunan syöttäminen X X Hagaki 100 x 148 mm (3,94 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X B5-kirjekuori 176 x 250 mm (6,93 x 9,84 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (Commercial #9) 98.4 x 225.4 mm (3,875 x 8,9 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (Commercial #10) 104.8 x 241.3 mm (4,12 x 9,5 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (Monarch 7‑3/4) 98.4 x 190.5 mm (3,875 x 7,5 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (DL) 110 x 220 mm (4,33 x 8,66 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (ISO C4) 229 x 324 mm (9 x 12,8 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (ISO C5) 162 x 229 mm (6,38 x 9 tuumaa) Lyhyen reunan syöttäminen X X Paperityypit, joita paperin siirtoyksikkö tukee taittomahdollisuudella sekä nidonnan ja rei'ityksen viimeistelijällä Paperikoko Suunta Paperin siirtoyksikkö taittomahdollisuudella + nidonnan ja rei'ityksen viimeistelijä C-taitto Z‑taitto Z-taitettu puoliarkki V-taitto Alusta 2 Alusta 2 Vakioalusta, alusta 2 Vakioalusta, alusta 2 4x6 kortti Lyhyen reunan syöttäminen X X X X Pitkän reunan syöttäminen X X X X A6 105 x 148 mm (4,13 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X X X Pitkän reunan syöttäminen X X X X 1/3 A4 Lyhyen reunan syöttäminen X X X X Pitkän reunan syöttäminen X X X X A5 148 x 210 mm (5,83 x 8,27 tuumaa) Lyhyen reunan syöttäminen X X X X Pitkän reunan syöttäminen X X X X A4 210 x 297 mm (8,27 x 11,7 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ Pitkän reunan syöttäminen X X X X A3 297 x 420 mm (11,69 x 16,54 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 tuumaa) Lyhyen reunan syöttäminen X X X X Pitkän reunan syöttäminen X X X X JIS B4 257 x 364 mm (10,12 x 14,33 tuumaa) Lyhyen reunan syöttäminen X X ✓ ✓ Statement 139.7 x 215.9 mm (5,5 x 8,5 tuumaa) Lyhyen reunan syöttäminen X X X X Pitkän reunan syöttäminen X X X X Executive 184.2 x 266.7 mm (7,25 x 10,5 tuumaa) Lyhyen reunan syöttäminen X X X X Pitkän reunan syöttäminen X X X X Letter 215.9 x 279.4 mm (8,5 x 11 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ Pitkän reunan syöttäminen X X X X Folio 215.9 x 330.2 mm (8,5 x 13 tuumaa) Lyhyen reunan syöttäminen X X X X Oficio (Meksiko) 215.9 x 340.4 mm (8,5 x 13,4 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ Legal 215.9 x 355.6 mm (8,5 x 14 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 mm (11 x 17 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 mm (12 x 18 tuumaa) Lyhyen reunan syöttäminen X X X ✓ SRA3 320.04 x 449.58 mm (12,6 x 17,7 tuumaa) Lyhyen reunan syöttäminen X X X ✓ Chokei 3 -kirjekuori 120 x 235 mm (4,75 x 9,25 tuumaa) Lyhyen reunan syöttäminen X X X X Hagaki 100 x 148 mm (3,94 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X X X B5-kirjekuori 176 x 250 mm (6,93 x 9,84 tuumaa) Lyhyen reunan syöttäminen X X X X Kirjekuori (Commercial #9) 98.4 x 225.4 mm (3,875 x 8,9 tuumaa) Lyhyen reunan syöttäminen X X X X Kirjekuori (Commercial #10) 104.8 x 241.3 mm (4,12 x 9,5 tuumaa) Lyhyen reunan syöttäminen X X X X Kirjekuori (Monarch 7‑3/4) 98.4 x 190.5 mm (3,875 x 7,5 tuumaa) Lyhyen reunan syöttäminen X X X X Kirjekuori (DL) 110 x 220 mm (4,33 x 8,66 tuumaa) Lyhyen reunan syöttäminen X X X X Kirjekuori (ISO C4) 229 x 324 mm (9 x 12,8 tuumaa) Lyhyen reunan syöttäminen X X X X Kirjekuori (ISO C5) 162 x 229 mm (6,38 x 9 tuumaa) Lyhyen reunan syöttäminen X X X X Paperityypit, joita paperin siirtoyksikkö tukee taittomahdollisuudella sekä vihkoviimeistelijällä Paperikoko Suunta Paperin siirtoyksikkö taittomahdollisuudella + vihkoviimeistelijä C-taitto Z‑taitto Z-taitettu puoliarkki V-taitettu moninkertainen V-taitto Alusta 3 Alusta 3 Vakioalusta, alusta 1, alusta 3 Alusta 2 Vakioalusta, alusta 1, alusta 2, alusta 3 4x6 kortti Lyhyen reunan syöttäminen X X X X X Pitkän reunan syöttäminen X X X X X A6 105 x 148 mm (4,13 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X X X X Pitkän reunan syöttäminen X X X X X 1/3 A4 Lyhyen reunan syöttäminen X X X X X Pitkän reunan syöttäminen X X X X X A5 148 x 210 mm (5,83 x 8,27 tuumaa) Lyhyen reunan syöttäminen X X X X X Pitkän reunan syöttäminen X X X X X A4 210 x 297 mm (8,27 x 11,7 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ Pitkän reunan syöttäminen X X X X X A3 297 x 420 mm (11,69 x 16,54 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 tuumaa) Lyhyen reunan syöttäminen X X X ✓ ✓ Pitkän reunan syöttäminen X X X X X JIS B4 257 x 364 mm (10,12 x 14,33 tuumaa) Lyhyen reunan syöttäminen X X ✓ ✓ ✓ Statement 139.7 x 215.9 mm (5,5 x 8,5 tuumaa) Lyhyen reunan syöttäminen X X X X X Pitkän reunan syöttäminen X X X X X Executive 184.2 x 266.7 mm (7,25 x 10,5 tuumaa) Lyhyen reunan syöttäminen X X X X X Pitkän reunan syöttäminen X X X X X Letter 215.9 x 279.4 mm (8,5 x 11 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ Pitkän reunan syöttäminen X X X X X Folio 215.9 x 330.2 mm (8,5 x 13 tuumaa) Lyhyen reunan syöttäminen X X X ✓ ✓ Oficio (Meksiko) 215.9 x 340.4 mm (8,5 x 13,4 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ Legal 215.9 x 355.6 mm (8,5 x 14 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 mm (11 x 17 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 mm (12 x 18 tuumaa) Lyhyen reunan syöttäminen X X X X ✓ SRA3 320.04 x 449.58 mm (12,6 x 17,7 tuumaa) Lyhyen reunan syöttäminen X X X X ✓ Chokei 3 -kirjekuori 120 x 235 mm (4,75 x 9,25 tuumaa) Lyhyen reunan syöttäminen X X X X X Hagaki 100 x 148 mm (3,94 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X X X X B5-kirjekuori 176 x 250 mm (6,93 x 9,84 tuumaa) Lyhyen reunan syöttäminen X X X X X Kirjekuori (Commercial #9) 98.4 x 225.4 mm (3,875 x 8,9 tuumaa) Lyhyen reunan syöttäminen X X X X X Kirjekuori (Commercial #10) 104.8 x 241.3 mm (4,12 x 9,5 tuumaa) Lyhyen reunan syöttäminen X X X X X Kirjekuori (Monarch 7‑3/4) 98.4 x 190.5 mm (3,875 x 7,5 tuumaa) Lyhyen reunan syöttäminen X X X X X Kirjekuori (DL) 110 x 220 mm (4,33 x 8,66 tuumaa) Lyhyen reunan syöttäminen X X X X X Kirjekuori (ISO C4) 229 x 324 mm (9 x 12,8 tuumaa) Lyhyen reunan syöttäminen X X X X X Kirjekuori (ISO C5) 162 x 229 mm (6,38 x 9 tuumaa) Lyhyen reunan syöttäminen X X X X X tuetut paperikoot paperikoot tuetut"},{"UUID":"fc449d28-5c64-4a50-b0c4-80bf2bd0cc76","title":"Tuetut paperikoot","link":"paper-guidelines-topic.html","desc":"Porrastetun pinoamisen töissä tuetut paperikoot","descFull":"Porrastetun pinoamisen töissä tuetut paperikoot Porrastuspinolokeron tai nidonnan viimeistelijän tukemat paperikoot Paperikoko Suunta Offset-pinoaja Nidonnan viimeistelijä 1  Tukee paperikokoja 90 x 148 mm (3,55 x 5,83 tuumaa) - 320 x 600 mm (12,59 x 23.62 tuumaa). 2  Tukee paperikokoja 148 x 148 mm (5,83 x 5,83 tuumaa) - 297 x 431,8 mm (11,69 x 17 tuumaa). 4x6 kortti Lyhyen reunan syöttäminen X X Pitkän reunan syöttäminen X X A6 105 x 148 mm (4,13 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X Pitkän reunan syöttäminen X X 1/3 A4 Lyhyen reunan syöttäminen X X Pitkän reunan syöttäminen X X A5 148 x 210 mm (5,83 x 8,27 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ A4 210 x 297 mm (8,27 x 11,7 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Statement 139.7 x 215.9 mm (5,5 x 8,5 tuumaa) Lyhyen reunan syöttäminen ✓ X Pitkän reunan syöttäminen ✓ X Executive 184.2 x 266.7 mm (7,25 x 10,5 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ Letter 215.9 x 279.4 mm (8,5 x 11 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ Folio 215.9 x 330.2 mm (8,5 x 13 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Oficio (Meksiko) 215.9 x 340.4 mm (8,5 x 13,4 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Legal 215.9 x 355.6 mm (8,5 x 14 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Ledger 279.4 x 431.8 mm (11 x 17 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ 12x18 304.8 x 457.2 mm (12 x 18 tuumaa) Lyhyen reunan syöttäminen X X SRA3 320.04 x 449.58 mm (12,6 x 17,7 tuumaa) Lyhyen reunan syöttäminen X X Chokei 3 -kirjekuori 120 x 235 mm (4,75 x 9,25 tuumaa) Lyhyen reunan syöttäminen ✓ X Hagaki 100 x 148 mm (3,94 x 5,83 tuumaa) Lyhyen reunan syöttäminen ✓ X B5-kirjekuori 176 x 250 mm (6,93 x 9,84 tuumaa) Lyhyen reunan syöttäminen ✓ X Kirjekuori (Commercial #9) 98.4 x 225.4 mm (3,875 x 8,9 tuumaa) Lyhyen reunan syöttäminen ✓ X Kirjekuori (Commercial #10) 104.8 x 241.3 mm (4,12 x 9,5 tuumaa) Lyhyen reunan syöttäminen ✓ X Kirjekuori (Monarch 7‑3/4) 98.4 x 190.5 mm (3,875 x 7,5 tuumaa) Lyhyen reunan syöttäminen ✓ X Kirjekuori (DL) 110 x 220 mm (4,33 x 8,66 tuumaa) Lyhyen reunan syöttäminen ✓ X Kirjekuori (ISO C4) 229 x 324 mm (9 x 12,8 tuumaa) Lyhyen reunan syöttäminen ✓ X Kirjekuori (ISO C5) 162 x 229 mm (6,38 x 9 tuumaa) Lyhyen reunan syöttäminen ✓ X Universal - ✓ 1 ✓ 2 Vastaanottoalustojen tukemat paperikoot Paperikoko Suunta Paperin siirtoyksikkö + nidonnan ja rei'ityksen viimeistelijä Paperin siirtoyksikkö + vihkoviimeistelijä Alusta 1 Alusta 1 1  Tukee paperikokoja 139.7 x 148 mm (5,5 x 5,83 tuumaa) - 304.8 x 600 mm (12 x 23.62 tuumaa). 2  Tukee paperikokoja 125 x 148 mm (4,93 x 5,83 tuumaa) - 304.8 x 457,2 mm (12 x 18 tuumaa). 4x6 kortti Lyhyen reunan syöttäminen X X Pitkän reunan syöttäminen X X A6 105 x 148 mm (4,13 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X Pitkän reunan syöttäminen X X 1/3 A4 Lyhyen reunan syöttäminen X X Pitkän reunan syöttäminen X X A5 148 x 210 mm (5,83 x 8,27 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ A4 210 x 297 mm (8,27 x 11,7 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Statement 139.7 x 215.9 mm (5,5 x 8,5 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ Executive 184.2 x 266.7 mm (7,25 x 10,5 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ Letter 215.9 x 279.4 mm (8,5 x 11 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ Folio 215.9 x 330.2 mm (8,5 x 13 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Oficio (Meksiko) 215.9 x 340.4 mm (8,5 x 13,4 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Legal 215.9 x 355.6 mm (8,5 x 14 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Ledger 279.4 x 431.8 mm (11 x 17 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ 12x18 304.8 x 457.2 mm (12 x 18 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ SRA3 320.04 x 449.58 mm (12,6 x 17,7 tuumaa) Lyhyen reunan syöttäminen X X Chokei 3 -kirjekuori 120 x 235 mm (4,75 x 9,25 tuumaa) Lyhyen reunan syöttäminen X X Hagaki 100 x 148 mm (3,94 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X B5-kirjekuori 176 x 250 mm (6,93 x 9,84 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (Commercial #9) 98.4 x 225.4 mm (3,875 x 8,9 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (Commercial #10) 104.8 x 241.3 mm (4,12 x 9,5 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (Monarch 7‑3/4) 98.4 x 190.5 mm (3,875 x 7,5 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (DL) 110 x 220 mm (4,33 x 8,66 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (ISO C4) 229 x 324 mm (9 x 12,8 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (ISO C5) 162 x 229 mm (6,38 x 9 tuumaa) Lyhyen reunan syöttäminen X X Universal - ✓ 1 ✓ 2 Vastaanottoalustojen tukemat paperikoot (paperin siirtoyksikkö taittovalinnalla) Paperikoko Suunta Paperin siirtoyksikkö taittomahdollisuudella + nidonnan ja rei'ityksen viimeistelijä Paperin siirtoyksikkö taittomahdollisuudella + vihkoviimeistelijä Alusta 1 Alusta 1 1  Tukee paperikokoja 139.7 x 148 mm (5,5 x 5,83 tuumaa) - 304.8 x 600 mm (12 x 23.62 tuumaa). 2  Tukee paperikokoja 125 x 148 mm (4,93 x 5,83 tuumaa) - 304.8 x 457,2 mm (12 x 18 tuumaa). 4x6 kortti Lyhyen reunan syöttäminen X X Pitkän reunan syöttäminen X X A6 105 x 148 mm (4,13 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X Pitkän reunan syöttäminen X X 1/3 A4 Lyhyen reunan syöttäminen X X Pitkän reunan syöttäminen X X A5 148 x 210 mm (5,83 x 8,27 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ A4 210 x 297 mm (8,27 x 11,7 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Statement 139.7 x 215.9 mm (5,5 x 8,5 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ Executive 184.2 x 266.7 mm (7,25 x 10,5 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ Letter 215.9 x 279.4 mm (8,5 x 11 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Pitkän reunan syöttäminen ✓ ✓ Folio 215.9 x 330.2 mm (8,5 x 13 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Oficio (Meksiko) 215.9 x 340.4 mm (8,5 x 13,4 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Legal 215.9 x 355.6 mm (8,5 x 14 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ Ledger 279.4 x 431.8 mm (11 x 17 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ 12x18 304.8 x 457.2 mm (12 x 18 tuumaa) Lyhyen reunan syöttäminen ✓ ✓ SRA3 320.04 x 449.58 mm (12,6 x 17,7 tuumaa) Lyhyen reunan syöttäminen X X Chokei 3 -kirjekuori 120 x 235 mm (4,75 x 9,25 tuumaa) Lyhyen reunan syöttäminen X X Hagaki 100 x 148 mm (3,94 x 5,83 tuumaa) Lyhyen reunan syöttäminen X X B5-kirjekuori 176 x 250 mm (6,93 x 9,84 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (Commercial #9) 98.4 x 225.4 mm (3,875 x 8,9 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (Commercial #10) 104.8 x 241.3 mm (4,12 x 9,5 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (Monarch 7‑3/4) 98.4 x 190.5 mm (3,875 x 7,5 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (DL) 110 x 220 mm (4,33 x 8,66 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (ISO C4) 229 x 324 mm (9 x 12,8 tuumaa) Lyhyen reunan syöttäminen X X Kirjekuori (ISO C5) 162 x 229 mm (6,38 x 9 tuumaa) Lyhyen reunan syöttäminen X X Universal - ✓ 1 ✓ 2 tuetut paperikoot paperikoot tuetut"},{"UUID":"3138d897-b598-434d-b23e-3ee7dd87295d","title":"Paperin valinta","link":"paper-guidelines-topic.html","desc":"Tuetut paperien painot Tuetut paperien","descFull":"Tuetut paperien painot Tuetut paperien painot Tulostimen tukemat paperien painot Vakio tai valinnainen 550 arkin lokero, 2 x 550 arkin lokero, 1500 arkin lokero ja 2000 arkin kaksoislokero Monikäyttösyöttöaukko Kaksipuolinen tulostus Automaattinen asiakirjansyöttölaite 60–300 g/m 2 (16–80 paunan bond) 60–300 g/m 2 (16–80 paunan bond) 60–220 g/m 2 (16–59 paunan bond) 50–150 g/m 2 (14–40 paunan bond) tuetut paperien painot paperin painot tuetut"},{"UUID":"0571f26d-ec48-4d86-bf6b-ecf51366c2a1","title":"Paperin valinta","link":"paper-guidelines-topic.html","desc":"Tuetut paperilajit Tuetut paperilajit Peruskokoonpanon","descFull":"Tuetut paperilajit Tuetut paperilajit Peruskokoonpanon tukemat paperilajit Paperikoko 550 arkin vakiolokero Monikäyttösyöttöaukko Kaksipuolinen tulostus Automaattinen asiakirjansyöttölaite Tavallinen paperi ✓ ✓ ✓ ✓ Kartonki ✓ ✓ ✓ X Uusiopaperi ✓ ✓ ✓ ✓ Kiiltävä ✓ ✓ ✓ X Paksu kiiltävä ✓ ✓ ✓ X Tarrat ✓ ✓ X X Muovitarrat ✓ ✓ X X Kovapaperi ✓ ✓ ✓ ✓ Kirjekuori ✓ ✓ X X Karkea kirjekuori ✓ ✓ X X Kirjelomake ✓ ✓ ✓ ✓ Esipainettu ✓ ✓ ✓ ✓ Värillinen paperi ✓ ✓ ✓ ✓ Kevyt paperi ✓ ✓ ✓ ✓ Painava paperi ✓ ✓ ✓ ✓ Karkea puuvilla ✓ ✓ ✓ X Mukautettu tyyppi ✓ ✓ ✓ ✓ Valinnaisten lokerojen tukemat paperilajit Paperikoko Valinnainen 550 arkin lokero Kaksi 550 arkin lokeroa 2000 arkin kaksoislokero 1500 arkin alusta Tavallinen paperi ✓ ✓ ✓ ✓ Kartonki ✓ ✓ ✓ ✓ Piirtoheitinkalvot X X X X Uusiopaperi ✓ ✓ ✓ ✓ Kiiltävä ✓ ✓ ✓ ✓ Paksu kiiltävä ✓ ✓ ✓ ✓ Tarrat ✓ ✓ X X Muovitarrat ✓ ✓ X X Kovapaperi ✓ ✓ ✓ ✓ Kirjekuori ✓ ✓ X X Karkea kirjekuori ✓ ✓ X X Kirjelomake ✓ ✓ ✓ ✓ Esipainettu ✓ ✓ ✓ ✓ Värillinen paperi ✓ ✓ ✓ ✓ Kevyt paperi ✓ ✓ ✓ ✓ Painava paperi ✓ ✓ ✓ ✓ Karkea puuvilla ✓ ✓ ✓ ✓ Mukautettu tyyppi ✓ ✓ ✓ ✓ Vastaanottoalustan tukemat paperilajit Paperikoko Paperin siirtoyksikkö + nidonnan ja rei'ityksen viimeistelijä Paperin siirtoyksikkö + vihkoviimeistelijä Vakioalusta (viimeistelijän yläalusta) Alusta 1 (nidonnan ja rei'ityksen viimeistelijä, porrastusalusta) Alusta 2 (paperin siirtoalusta) Vakioalusta (viimeistelijän yläalusta) Alusta 1 (nidonnan ja rei'ityksen viimeistelijä, porrastusalusta) Alusta 2 (viimeistelijän vihkoalusta) Alusta 3 (paperin siirtoalusta) *  Yleisen paperikoon enimmäispituus jatkolomakkeen tapauksessa on 1320,8 mm/52tuumaa. Lisää vain yksi arkki banneripaperia kerrallaan. Tavallinen paperi ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Kartonki ✓ ✓ ✓ ✓ ✓ X ✓ Uusiopaperi ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Kiiltävä ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Paksu kiiltävä ✓ ✓ ✓ ✓ ✓ X ✓ Tarrat ✓ ✓ ✓ ✓ ✓ X X Muovitarrat ✓ ✓ ✓ ✓ ✓ X X Kovapaperi ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Kirjekuori X X ✓ X X X ✓ Karkea kirjekuori X X ✓ X X X ✓ Kirjelomake ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Esipainettu ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Värillinen paperi ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Kevyt paperi ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Painava paperi ✓ ✓ ✓ ✓ ✓ X X Karkea puuvilla ✓ ✓ ✓ ✓ ✓ X X Mukautettu tyyppi ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Vastaanottoalustan tukemat paperityypit (paperin siirtoyksikkö taittovaihtoehdolla) Paperikoko Paperin siirtoyksikkö taittomahdollisuudella + nidonnan ja rei'ityksen viimeistelijä Paperin siirtoyksikkö taittomahdollisuudella + vihkoviimeistelijä Vakioalusta (viimeistelijän yläalusta) Alusta 1 (nidonnan ja rei'ityksen viimeistelijä, porrastusalusta) Alusta 2 (paperin siirtoalusta) Vakioalusta (viimeistelijän yläalusta) Alusta 1 (nidonnan ja rei'ityksen viimeistelijä, porrastusalusta) Alusta 2 (viimeistelijän vihkoalusta) Alusta 3 (paperin siirtoalusta) *  Yleisen paperikoon enimmäispituus jatkolomakkeen tapauksessa on 1320,8 mm/52tuumaa. Lisää vain yksi arkki banneripaperia kerrallaan. Tavallinen paperi ✓ ✓ ✓ ✓ ✓ ✓ ✓ Kartonki ✓ ✓ ✓ ✓ ✓ X ✓ Uusiopaperi ✓ ✓ ✓ ✓ ✓ ✓ ✓ Kiiltävä ✓ ✓ ✓ ✓ ✓ ✓ ✓ Paksu kiiltävä ✓ ✓ ✓ ✓ ✓ X ✓ Tarrat ✓ ✓ ✓ ✓ ✓ X ✓ Muovitarrat ✓ ✓ ✓ ✓ ✓ X ✓ Kovapaperi ✓ ✓ ✓ ✓ ✓ ✓ ✓ Kirjekuori X X ✓ X X X ✓ Karkea kirjekuori X X ✓ X X X ✓ Kirjelomake ✓ ✓ ✓ ✓ ✓ X ✓ Esipainettu ✓ ✓ ✓ ✓ ✓ X ✓ Värillinen paperi ✓ ✓ ✓ ✓ ✓ ✓ ✓ Kevyt paperi ✓ ✓ ✓ ✓ ✓ ✓ ✓ Painava paperi ✓ ✓ ✓ ✓ ✓ X X Karkea puuvilla ✓ ✓ ✓ ✓ ✓ X X Mukautettu tyyppi ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Paperityypit, joita paperin siirtoyksikkö tukee taittomahdollisuudella, porrastuspinoajalla ja nidontaviimeistelijällä Paperikoko Vain paperin siirtoyksikkö taittovalinnalla Offset-pinoaja Nidonnan viimeistelijä Tavallinen paperi ✓ ✓ ✓ Kartonki ✓ ✓ ✓ Uusiopaperi ✓ ✓ ✓ Kiiltävä ✓ ✓ ✓ Paksu kiiltävä ✓ ✓ ✓ Tarrat ✓ ✓ ✓ Muovitarrat ✓ ✓ ✓ Kovapaperi ✓ ✓ ✓ Kirjekuori ✓ ✓ ✓ Karkea kirjekuori ✓ ✓ ✓ Kirjelomake ✓ ✓ ✓ Esipainettu ✓ ✓ ✓ Värillinen paperi ✓ ✓ ✓ Kevyt paperi ✓ ✓ ✓ Painava paperi ✓ ✓ ✓ Karkea puuvilla ✓ ✓ ✓ Mukautettu tyyppi ✓ ✓ ✓ Nidonnan ja rei'ityksen viimeistelijän ja vihkoviimeistelijän tukemat paperilajit Paperikoko Viimeistelijän yläalusta (vakioalusta) Nidonnan viimeistelijän alusta (alusta 1) Porrastus Rei'itys Nitoja Taitto Porrastus Rei'itys Nitoja Taitto Tavallinen paperi X ✓ X ✓ ✓ ✓ ✓ ✓ Kartonki X X X X ✓ X X X Uusiopaperi X ✓ X ✓ ✓ ✓ ✓ ✓ Kiiltävä X ✓ X ✓ ✓ ✓ ✓ ✓ Paksu kiiltävä X X X X ✓ X X X Tarrat X X X X ✓ X X X Muovitarrat X X X X ✓ X X X Kovapaperi X ✓ X ✓ ✓ ✓ ✓ ✓ Kirjelomake X ✓ X ✓ ✓ ✓ ✓ ✓ Esipainettu X ✓ X ✓ ✓ ✓ ✓ ✓ Värillinen paperi X ✓ X ✓ ✓ ✓ ✓ ✓ Kevyt paperi X ✓ X ✓ ✓ ✓ ✓ ✓ Painava paperi X X X X ✓ X X X Karkea puuvilla X ✓ X X ✓ ✓ X X Mukautettu tyyppi X ✓ X ✓ ✓ ✓ ✓ ✓ laitteen tukemat paperilajit paperilajit tuetut"},{"UUID":"be16addd-a01b-42e4-be48-ea206ecbb0d0","title":"Tulostimen lisäominaisuudet ja tuki","link":"supported-applications-topic.html","desc":"Tuetut sovellukset Sovellukset ja niiden","descFull":"Tuetut sovellukset Sovellukset ja niiden tuetut tulostinmallit Sovellus Tulostinmallit Skannauskeskus CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 Näytön mukautus CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 Asiakastuki XC8355, XC9635, XC9645, XC9655 Laitekiintiöt XC8355, XC9635, XC9645, XC9655 tulostinsovellukset esiasennetut sovellukset"},{"UUID":"78abcaa5-9243-446c-9e1d-17077030a71d","title":"Tulostimen lisäominaisuudet ja tuki","link":"supported-applications-topic.html","desc":"Tuetut flash-asemat ja tiedostotyypit Flash-asemat","descFull":"Tuetut flash-asemat ja tiedostotyypit Flash-asemat Flash-asemat, jotka tukevat USB 2.0 -versiota ja vanhempia. Flash-asemat, jotka tukevat NTFS (New Technology File System)- tai FAT32 (File Allocation Table -tiedostojärjestelmää. Tiedostotyyppi Tuetut tiedostotyypit Asiakirjat Kuvat PDF (versio 1.7 tai vanhempi) Microsoft-tiedostomuodot (DOC, DOCX, XLS, XLSX, PPT, PPTX) JPEG tai JPG TIFF tai TIF GIF BMP PNG PCX DCX tuetut flash-asemat tuetut tiedostotyypit"},{"UUID":"1400467a-48a5-41db-860c-aecc4c560555","title":"Tulostimen lisäominaisuudet ja tuki","link":"supported-applications-topic.html","desc":"Käytettävissä olevat sisäiset lisälaitteet Kiintolevy","descFull":"Käytettävissä olevat sisäiset lisälaitteet Kiintolevy Lisensoidut ominaisuudet IPDS Viivakoodi Lexmark  Sisäinen sovellusportti (ISP) RS‑232C-sarjakortti MarkNet  N8230 Fiber Ethernet 100BASE-FX(LC), 1000BASE-SX(LC) Sisäinen sovellusportti (ISP) sisäiset lisälaitteet laiteohjelmakortti kiintolevy"},{"UUID":"df6a8445-58c0-46ef-9307-2c0b51b10134","title":"Käyttöönotto, asennus ja kokoonpano","link":"selecting-location-printer-topic.html","desc":"Tulostimen paikan valitseminen Jätä tarpeeksi","descFull":"Tulostimen paikan valitseminen Jätä tarpeeksi tilaa lokeroiden, kansien ja luukkujen avaamista ja lisävarusteiden asentamista varten. Asenna tulostin pistorasian lähelle. Tulipalo- tai sähköiskuriskin välttämiseksi liitä virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Sähköiskuvaaran välttämiseksi älä sijoita tätä tuotetta veden äärelle tai märkään paikkaan, äläkä myöskään käytä sitä sellaisissa paikoissa. Tarkista, että huoneen ilmavirta täyttää ASHRAE 62- tai CEN Technical Committee 156 -standardin uusimmat vaatimukset. Sijoita tulostin tasaiselle, vakaalle alustalle. Tulostimen sijoituspaikan on oltava puhdas, kuiva ja pölytön. kaukana irtonaisista niiteistä ja paperiliittimistä. sellainen, ettei ilmastointilaitteista, lämmittimistä tai tuulettimista tuleva ilmavirta suuntaudu suoraan sinne. kosteusolosuhteiltaan vakaa sekä sellainen, että siihen ei osu suora auringonvalo. Ota huomioon suositellut lämpötilat ja vältä lämpötilavaihteluja: Suositellut lämpötilat Ympäristön lämpötila Varastointilämpötila Jätä tulostimen ympärille vapaata tuuletustilaa vähintään seuraavien suositusten mukaisesti: Suositeltu tila tulostimen ympärillä 1 Ylös 2 Taka 3 oikea reuna 4 Etupuoli 5 vasen reuna tulostin paikan valitseminen paikan valitseminen tulostimelle tulostin vähimmäistila tulostimen siirtäminen"},{"UUID":"94ac69db-ee3e-47dd-a0b2-476a37755df9","title":"Käyttöönotto, asennus ja kokoonpano","link":"printer-ports-topic.html","desc":"Tulostimen portit Sähköiskuvaaran välttämiseksi älä","descFull":"Tulostimen portit Sähköiskuvaaran välttämiseksi älä asenna laitetta tai tee sähkö- tai kaapeliliitäntöjä (esimerkiksi virtajohto, faksi tai puhelin) ukkosmyrskyn aikana. Tulipalo- tai sähköiskuriskin välttämiseksi kytke virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Vältä tulipalon tai sähköiskun vaara: käytä vain tämän tuotteen mukana toimitettua tai valmistajan hyväksymää virtajohtoa. Kun liität tämän tuotteen yleiseen valintaiseen puhelinverkkoon, voit vähentää tulipalon vaaraa käyttämällä vähintään 26 AWG:n tietoliikennejohtoa (RJ-11). Australia: johdon on oltava ACMAn (Australian Communications and Media Authority) hyväksymä. Vältä tietojen menetys tai tulostimen toimintahäiriö olemalla koskettamatta tulostamisen aikana USB-kaapeliin, langattomaan verkkosovittimeen tai tulostimen osoitettua aluetta. Tulostimen portit ja liitännät ja niiden toiminnot Tulostimen portti Toiminto 1 Viimeistelijä tai lisävarusteportti Liitä tulostin viimeistelijään tai lisävarusteeseen. 2 USB-portti Liitä näppäimistö tai muu yhteensopiva lisävaruste. 3 LINE-liitäntä Käytettävissä vain, kun faksikortti on asennettu. Tulostimen liittäminen aktiiviseen puhelinlinjaan tavallisen puhelinpistorasian (RJ‑11), DSL-suodattimen, VoIP-sovittimen tai minkä tahansa muun sovittimen kautta faksien lähettämistä ja vastaanottamista varten. 4 EXT-liitäntä Käytettävissä vain, kun faksikortti on asennettu. Lisälaitteiden (puhelimen tai vastaajan) liittäminen tulostimeen ja puhelinlinjaan. Käytä tätä liitintä, jos tulostimelle ei ole varattu erillistä faksilinjaa ja tätä liitäntätapaa tuetaan käyttömaassa tai -alueella. 5 Tulostimen USB-portti Yhdistä tulostin tietokoneeseen. 6 Ethernet-liitäntä Tulostimen liittäminen verkkoon. 7 Virtajohdon liitin Kytke tulostin maadoitettuun pistorasiaan. tulostimen portit USB-portti Ethernet-liitäntä virtajohdon liitäntä"},{"UUID":"05b3697d-48b9-4777-a52c-d4dad43bfb62","title":"Sovellusten ja ratkaisujen määrittäminen","link":"setting-up-scan-center-topic.html","desc":"Skannauskeskuksen määrittäminen Valitse ohjauspaneelissa ","descFull":"Skannauskeskuksen määrittäminen Valitse ohjauspaneelissa  Skannauskeskus . Valitse ja luo kohdesijainti ja määritä asetukset. Vain Embedded Web Server -palvelimessa luodut kohteet tallennetaan. Lisätietoja on tuotteen käyttöohjeissa. Skannaa asiakirja. Skannauskeskus asetusten määrittäminen"},{"UUID":"8e71dd67-4968-4541-9a7d-891a6dac6f2e","title":"Sovellusten ja ratkaisujen määrittäminen","link":"setting-up-scan-center-topic.html","desc":"Näytön mukauttaminen Näytön mukauttaminen Varmista,","descFull":"Näytön mukauttaminen Näytön mukauttaminen Varmista, että näytönsäästäjä-, diaesitys- ja taustakuva-asetukset ovat käytössä Embedded Web Server -palvelimessa. Siirry kohtaan  Sovellukset Näytön mukauttaminen Määritä Näytönsäästäjän ja diaesityksen kuvien hallinta Lisää tai poista kuva tai muokkaa kuvaa Näytönsäästäjän ja diaesityksen kuvat -osassa. Voit lisätä enintään kymmenen kuvaa. Kun tämä on käytössä, tilakuvakkeet näytetään näytönsäästäjässä vain virhe- ja varoitustilanteissa tai kun tarjolla on pilvipohjaisia ilmoituksia. Ota muutokset käyttöön. Taustakuvan vaihtaminen Valitse ohjauspaneelista  Vaihda taustakuva . Valitse käytettävä kuva. Ota muutokset käyttöön. Diaesityksen käynnistäminen flash-asemasta Aseta flash-asema USB-porttiin. Valitse tulostimen ohjauspaneelissa  Diaesitys . Voit irrottaa flash-aseman, kun diaesitys on alkanut, mutta kuvia ei tallenneta tulostimeen. Jos diaesitys pysähtyy, aseta flash-asema uudelleen paikalleen kuvien katselua varten. Näytön mukautus käyttäminen näytön mukauttaminen taustakuvan vaihtaminen diaesityksen käynnistäminen näytönsäästäjän hallinta"},{"UUID":"71ee87e5-4c30-4c8d-92f9-98eee08d64b9","title":"Sovellusten ja ratkaisujen määrittäminen","link":"setting-up-scan-center-topic.html","desc":"Kirjanmerkkien määrittäminen Kirjanmerkkien luominen Avaa","descFull":"Kirjanmerkkien määrittäminen Kirjanmerkkien luominen Avaa selain ja kirjoita tulostimen IP-osoite selaimen osoitekenttään. Tulostimen IP-osoite näkyy sen tulostimen päänäytössä. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Valitse  Kirjanmerkit Lisää kirjanmerkki  ja kirjoita kirjanmerkin nimi. Valitse  osoite yhteyskäytännön tyyppi ja tee jokin seuraavista toiminnoista: HTTP ja HTTPS: kirjoita URL-osoite, jonka haluat lisätä kirjanmerkkeihin. HTTPS: varmista, että käytät isäntänimeä IP-osoitteen sijaan. Kirjoita esimerkiksi  omasivusto.com/malli.pdf  sen sijaan, että kirjoittaisit  123.﻿123.123.123/malli.pdf . Varmista, että isäntänimi vastaa myös palvelinsertifikaattia kutsumanimeä (CN). Lisätietoja kutsumanimen hakemisesta on selaimen ohjetiedoissa. FTP: kirjoita FTP-osoite. Esimerkki:  omapalvelin/omahakemisto . Anna FTP-portin numero. Komentojen lähetyksen oletusportti on portti 21. SMB: kirjoita verkkokansion osoite. Esimerkiksi  omapalvelin/omajako/omatiedosto.pdf . Kirjoita verkon toimialueen nimi. Valitse tarvittaessa  todennus tyyppi FTP:lle ja SMB:lle. Jos haluat rajoittaa kirjanmerkin käyttöä, lisää PIN-koodi. Sovellus tukee seuraavia tiedostotyyppejä: PDF, JPEG ja TIFF. Muita tiedostotyyppejä, kuten DOCX ja XLSX, tuetaan joissain tulostinmalleissa. Napsauta  Tallenna . Kansioiden luominen Avaa selain ja kirjoita tulostimen IP-osoite selaimen osoitekenttään. Tulostimen IP-osoite näkyy sen tulostimen päänäytössä. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Valitse  Kirjanmerkit Lisää kansio  ja kirjoita kansion nimi. Jos haluat rajoittaa kansion käyttöä, lisää PIN-koodi. Napsauta  Tallenna . kirjanmerkit luominen kirjanmerkkien luominen"},{"UUID":"6620454b-4553-4f9c-88de-f18e17b875a3","title":"Sovellusten ja ratkaisujen määrittäminen","link":"setting-up-scan-center-topic.html","desc":"Osoitekirjan määrittäminen Yhteystietojen lisääminen Avaa","descFull":"Osoitekirjan määrittäminen Yhteystietojen lisääminen Avaa selain ja kirjoita tulostimen IP-osoite selaimen osoitekenttään. Tulostimen IP-osoite näkyy sen tulostimen päänäytössä. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Valitse  Osoitekirja  ja valitse sitten  Lisää yhteystieto . Anna tarvittaessa sovelluksen käyttöoikeus määrittämällä kirjautumismenetelmä. Napsauta  Tallenna . Ryhmien lisääminen Avaa selain ja kirjoita tulostimen IP-osoite selaimen osoitekenttään. Tulostimen IP-osoite näkyy sen tulostimen päänäytössä. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Valitse  Osoitekirja  ja valitse sitten  Lisää yhteystieto . Voit määrittää ryhmään yhden tai useamman yhteystiedon. Napsauta  Tallenna . yhteystietojen lisääminen ryhmien lisääminen Osoitekirja"},{"UUID":"8ea32c53-9583-414e-9f25-790caf7dc814","title":"Helppokäyttötoimintojen käyttöönottaminen ja käyttäminen","link":"activating-voice-guidance-topic.html","desc":"Ääniohjauksen aktivoiminen aloitusnäytössä Pyyhkäise näyttöä","descFull":"Ääniohjauksen aktivoiminen aloitusnäytössä Pyyhkäise näyttöä hitaasti vasemmalle ja sitten ylös yhdellä liikkeellä ja yhdellä sormella, kunnes kuulet ilmoituksen. Valitse kahdella sormella  OK . Jos ele ei toimi, paina kovemmin. Näppäimistöllä Paina  5 -näppäintä, kunnes kuulet ääniviestin. Siirrä kohdistin OK-painikkeeseen painamalla  sarkainta  ja paina sitten  Enter -näppäintä. Kun ääniohjaus on käytössä, valitse kohteita näytössä kahdella sormella. Ääniohjaus ei tue kaikkia kieliä. Ääniohjaus aktivointi Ääniohjauksen aktivoiminen"},{"UUID":"18574e26-663d-4707-9b86-2f02f6e906f9","title":"Helppokäyttötoimintojen käyttöönottaminen ja käyttäminen","link":"activating-voice-guidance-topic.html","desc":"Ääniohjauksen poistaminen käytöstä Pyyhkäise näyttöä","descFull":"Ääniohjauksen poistaminen käytöstä Pyyhkäise näyttöä hitaasti vasemmalle ja sitten ylös yhdellä liikkeellä ja yhdellä sormella, kunnes kuulet ilmoituksen. Tee kahdella sormella jompikumpi seuraavista: Valitse  Ääniohjaus  ja valitse sitten  OK . Valitse  Peruuta . Jos ele ei toimi, paina kovemmin. Myös virtapainikkeen painaminen tai tulostimen asettaminen lepo- tai horrostilaan poistaa ääniohjauksen käytöstä. Ääniohjaus poistaminen käytöstä ääniohjauksen poistaminen käytöstä"},{"UUID":"40df175d-d3e0-499b-acf4-5ff0b0a4962c","title":"Helppokäyttötoimintojen käyttöönottaminen ja käyttäminen","link":"activating-voice-guidance-topic.html","desc":"Siirtyminen näytössä eleillä Useimpia eleitä","descFull":"Siirtyminen näytössä eleillä Useimpia eleitä voi käyttää vain, kun ääniohjaus on käytössä. Käytä fyysistä näppäimistöä merkkien kirjoittamiseen ja tiettyjen asetusten säätämiseen. Eleet ja niiden toiminnot Ele Toiminto Pyyhkäisy vasemmalle ja sitten ylös yhdellä sormella Käynnistä helppokäyttötila tai poistu siitä. Ele toimii myös, kun tulostin on normaalitilassa. Kaksoisnapautus yhdellä sormella Kohteen valitseminen näytössä. Aloituskuvakkeen kaksoisnapautus kahdella sormella Poistuminen helppokäyttötilasta. Kolmoisnapautus yhdellä sormella Tekstin ja kuvien lähentäminen tai loitontaminen. Ota suurennustila käyttöön zoom-ominaisuuden käyttämiseksi. Pyyhkäisy oikealle tai alas yhdellä sormella Siirtyminen seuraavaan kohteeseen näytössä. Pyyhkäisy vasemmalle tai ylös yhdellä sormella Siirtyminen edelliseen kohteeseen näytössä. Pyyhkäisy ylös ja sitten alas yhdellä sormella Siirtyminen ensimmäiseen kohteeseen näytössä. Panorointi Zoomatun kuvan näytön ulkopuolella olevien osien käyttäminen. Vedä zoomattua kuvaa kahdella sormella. Ota käyttöön suurennustila, jotta voit käyttää panorointitoimintoa. Pyyhkäisy ylös ja sitten oikealle yhdellä sormella Lisää äänenvoimakkuutta. Ele toimii myös, kun tulostin on normaalitilassa. Pyyhkäisy alas ja sitten oikealle yhdellä sormella Vähennä äänenvoimakkuutta. Ele toimii myös, kun tulostin on normaalitilassa. Pyyhkäisy ylös ja sitten vasemmalle yhdellä sormella Sovelluksen lopetus ja palaaminen aloitusnäyttöön. Pyyhkäisy alas ja sitten vasemmalle yhdellä sormella Palaaminen edelliseen asetukseen. siirtyminen näytössä eleiden käyttäminen kosketusnäytön eleet näytön eleet"},{"UUID":"5f140d74-e347-4dbf-bc5f-5e2b73d8e891","title":"Helppokäyttötoimintojen käyttöönottaminen ja käyttäminen","link":"activating-voice-guidance-topic.html","desc":"Näyttönäppäimistön käyttäminen Kun näyttönäppäimistö on","descFull":"Näyttönäppäimistön käyttäminen Kun näyttönäppäimistö on näytössä, tee yksi tai useampi seuraavista: lisää ja kirjoita merkki kenttään koskettamalla näppäintä lisää ja kirjoita merkki kenttään vetämällä sormea merkkien päällä lisää merkit kenttään koskettamalla tekstiruutua kahdella sormella poista merkkejä  askelpalauttimella . näyttönäppäimistö käyttäminen"},{"UUID":"58ed86e7-65e5-4eca-be46-6b5f9c2aba42","title":"Helppokäyttötoimintojen käyttöönottaminen ja käyttäminen","link":"activating-voice-guidance-topic.html","desc":"Suurennustilan ottaminen käyttöön Pyyhkäise näyttöä","descFull":"Suurennustilan ottaminen käyttöön Pyyhkäise näyttöä hitaasti vasemmalle ja sitten ylös yhdellä liikkeellä ja yhdellä sormella, kunnes kuulet ilmoituksen. Jos tulostimessa ei ole sisäisiä kaiuttimia, voit kuunnella ilmoituksen kuulokkeilla. Tee kahdella sormella seuraavasti: Valitse  Suurennustila . Valitse  OK . Jos ele ei toimi, paina kovemmin. Lisätietoja siirtymisestä suurennetussa näytössä on kohdassa  . Suurennustila ottaminen käyttöön suurennustilan ottaminen käyttöön"},{"UUID":"f9b53831-fd30-46cd-ade1-0507f0fce242","title":"Helppokäyttötoimintojen käyttöönottaminen ja käyttäminen","link":"activating-voice-guidance-topic.html","desc":"Ääniohjauksen puhenopeuden säätäminen Siirry ohjauspaneelissa","descFull":"Ääniohjauksen puhenopeuden säätäminen Siirry ohjauspaneelissa kohtaan  Asetukset Laite Esteettömyys Puhenopeus . Valitse puhenopeus. Ääniohjaus puhenopeuden säätäminen puhenopeuden säätäminen Ääniohjaus puhenopeuden säätäminen Ääniohjaus"},{"UUID":"c42c99ef-bac9-4131-9161-db19d1a3878d","title":"Helppokäyttötoimintojen käyttöönottaminen ja käyttäminen","link":"activating-voice-guidance-topic.html","desc":"Kuulokkeiden oletusäänenvoimakkuuden säätäminen Siirry ohjauspaneelissa","descFull":"Kuulokkeiden oletusäänenvoimakkuuden säätäminen Siirry ohjauspaneelissa kohtaan  Asetukset Laite Helppokäyttöisyys . Säädä kuulokkeiden äänenvoimakkuutta. Äänenvoimakkuus palautuu oletusarvoon, kun käyttäjä poistuu helppokäyttötilasta tai kun tulostin herää lepo- tai valmiustilasta. kuulokkeiden äänenvoimakkuus, säätäminen kuulokkeiden äänenvoimakkuuden säätäminen"},{"UUID":"711c0e1f-ca9d-4b23-bc13-dd1bdd3c9890","title":"Helppokäyttötoimintojen käyttöönottaminen ja käyttäminen","link":"activating-voice-guidance-topic.html","desc":"Sisäisen kaiuttimen oletusäänenvoimakkuuden säätäminen Pyyhkäise","descFull":"Sisäisen kaiuttimen oletusäänenvoimakkuuden säätäminen Pyyhkäise ohjauspaneelissa oikealle ohjauskeskukseen. Säädä äänenvoimakkuus. Jos hiljainen tila on käytössä, ääni-ilmoitukset eivät ole käytössä. Tämä asetus hidastaa tulostimen toimintaa. Äänenvoimakkuus palautuu oletusarvoon, kun käyttäjä poistuu helppokäyttötilasta tai kun tulostin herää lepo- tai valmiustilasta. kaiuttimen äänenvoimakkuus säätäminen säätäminen, kaiuttimen äänenvoimakkuuden"},{"UUID":"e5c8e721-eb87-45b5-bd33-48224e3278d9","title":"Helppokäyttötoimintojen käyttöönottaminen ja käyttäminen","link":"activating-voice-guidance-topic.html","desc":"Luettujen salasanojen tai henkilökohtaisten PIN-koodien","descFull":"Luettujen salasanojen tai henkilökohtaisten PIN-koodien ottaminen käyttöön Siirry ohjauspaneelissa kohtaan  Asetukset Laite Esteettömyys Lue salasanat/PIN-koodit . Ota asetus käyttöön. luetut salasanat ottaminen käyttöön henkilökohtaiset PIN-koodit ottaminen käyttöön"},{"UUID":"a84a9ce7-d44d-492c-b97e-9294ea412678","title":"Tulostimen asentaminen faksaamista varten","link":"setting-up-printer-to-fax-group.html","desc":"Faksitoiminnon määrittäminen analogisen faksin avulla","descFull":"Faksitoiminnon määrittäminen analogisen faksin avulla Faksitoiminnon määrittäminen analogisen faksin avulla Faksikortti on asennettava, jotta tulostin voi käyttää analogista faksia. Kaikki yhteydenmuodostusmenetelmät eivät ole käytettävissä kaikissa maissa tai kaikilla alueilla. Jos faksitoiminto on otettu käyttöön mutta sitä ei ole asennettu kokonaan, merkkivalo saattaa vilkkua punaisena. Jos käytössä ei ole TCP/IP-ympäristöä, määritä faksin asetukset ohjauspaneelin avulla. Vältä tietojen menetys tai tulostimen toimintahäiriö olemalla koskettamatta kaapeleita tai kuvassa näkyvää tulostimen osaa faksin lähettämisen tai vastaanottamisen aikana. Ohjauspaneelin käyttäminen Siirry ohjauspaneelista kohtaan  Asetukset Faksi Faksiasetukset Yleiset faksiasetukset . Määritä asetukset. Embedded Web Serverin käyttäminen Avaa selain ja kirjoita tulostimen IP-osoite selaimen osoitekenttään. Katso tulostimen IP-osoite ohjauspaneelista. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Valitse  Asetukset Faksi Faksiasetukset Yleiset faksiasetukset . Määritä asetukset. Ota muutokset käyttöön. analoginen faksi asetusten määrittäminen analogisen faksin asennus"},{"UUID":"5a560a8f-dcf4-443f-9218-57219388e73a","title":"Tulostimen asentaminen faksaamista varten","link":"setting-up-printer-to-fax-group.html","desc":"Faksitoiminnon määrittäminen etherFAXin avulla Faksitoiminnon","descFull":"Faksitoiminnon määrittäminen etherFAXin avulla Faksitoiminnon määrittäminen etherFAXin avulla Tulostimen laiteohjelmisto on päivitettävä uusimpaan versioon. Lisätietoja on kohdassa Laiteohjelmiston päivittäminen. Tulostimeen on asennettava oikea käyttöoikeuspaketti. Voit pyytää lisätietoja ottamalla yhteyttä etherFAXiin. Varmista, että olet rekisteröinyt tulostimesi etherFAX-portaaliin. Lisätietoja on osoitteessa  https://www.etherfax.net/lexmark . Rekisteröinnissä tarvitaan tulostimen sarjanumero. Lisätietoja on kohdassa  . Avaa selain ja kirjoita tulostimen IP-osoite selaimen osoitekenttään. Katso tulostimen IP-osoite ohjauspaneelista. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Valitse  Asetukset Faksi Faksiasetukset Yleiset faksiasetukset . Faksiasetukset  näkyy vain, jos  Faksitila -asetuksena on  Faksi . Kirjoita Faksinimi-kenttään yksilöivä nimi. Kirjoita Faksinumero-kenttään etherFAXin antama faksinumero. Valitse  Faksin siirtoyksikkö  -valikosta  etherFAX . Tämä valikko näkyy vain, kun käytettävissä on useita faksin siirtoyksikköjä. Jos tulostimeen on asennettu vain etherFAX, määritys on automaattinen. Ota muutokset käyttöön. etherFAX faksitoiminnon määrittäminen faksitoiminnon määrittäminen etherFAXin käyttäminen"},{"UUID":"fa2697fe-2e23-4cc8-ba9c-0f026839ba98","title":"Tulostimen asentaminen faksaamista varten","link":"setting-up-printer-to-fax-group.html","desc":"Faksitoiminnon määrittäminen faksipalvelimen avulla Tällä","descFull":"Faksitoiminnon määrittäminen faksipalvelimen avulla Tällä toiminnolla voit lähettää faksiviestejä faksipalveluntarjoajalle, joka tukee vastaanottoa sähköpostiin. Toiminto tukee ainoastaan lähteviä faksiviestejä. Jotta voit vastaanottaa fakseja, varmista että tulostimeen on määritetty laitepohjainen faksi, kuten analoginen faksi, etherFAX tai FoIP (Fax over IP). Avaa selain ja kirjoita tulostimen IP-osoite selaimen osoitekenttään. Katso tulostimen IP-osoite ohjauspaneelista. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Valitse  Asetukset Faksi . Valitse  Faksitila -valikosta  Faksipalvelin  ja valitse  Tallenna . Valitse  Faksin pikavalintamääritykset . Kirjoita  Vastaanottomuoto -kenttään  [#]@myfax.com , missä  [#]  on faksinumero ja  myfax.com  faksipalveluntarjoajan toimialue. Määritä tarvittaessa Vastausosoite-, Aihe- tai Viesti-kentät. Jotta tulostin voi vastaanottaa faksiviestejä, ota käyttöön laitepohjaisten faksien vastaanottoasetus. Varmista, että laitepohjainen faksi on määritetty. Napsauta  Tallenna . Valitse  Faksipalvelimen sähköpostiasetukset  ja ota sitten käyttöön valinta  Käytä sähköpostin SMTP-palvelinta . Jos asetuksia ei ole määritetty, katso lisätietoja kohdasta  . Ota muutokset käyttöön. faksipalvelin, käyttäminen faksitoiminnon määrittäminen faksitoiminnon määrittäminen faksipalvelimen avulla"},{"UUID":"12533590-b5c8-4764-99c8-6726f9a7268e","title":"Tulostimen asentaminen faksaamista varten","link":"setting-up-printer-to-fax-group.html","desc":"Tavallista puhelinlinjaa käyttävän faksin määrittäminen","descFull":"Tavallista puhelinlinjaa käyttävän faksin määrittäminen Tavallista puhelinlinjaa käyttävän faksin määrittäminen Nämä ohjeet koskevat vain tulostimia, joihin on asennettu faksikortti. Sähköiskuvaaran välttämiseksi älä asenna laitetta tai tee sähkö- tai kaapeliliitäntöjä (esimerkiksi virtajohto, faksi tai puhelin) ukkosmyrskyn aikana. Sähköiskuvaaran välttämiseksi älä käytä faksitoimintoa ukkosmyrskyn aikana. Kun liität tämän tuotteen yleiseen valintaiseen puhelinverkkoon, voit vähentää tulipalon vaaraa käyttämällä vähintään 26 AWG:n tietoliikennejohtoa (RJ-11). Australia: johdon on oltava ACMAn (Australian Communications and Media Authority) hyväksymä. Asennus 1: Tulostin on liitetty erilliseen faksilinjaan. Liitä puhelinjohdon toinen pää tulostimen linjaporttiin. Liitä johdon toinen pää toimivaan analogiseen puhelinpistorasiaan. Tulostimen voi asettaa vastaanottamaan faksit automaattisesti ( Automaattivastaus -asetus on  Käytössä ) tai manuaalisesti ( Automaattivastaus -asetus on  Ei käytössä ). Jos haluat vastaanottaa faksit automaattisesti, tulostimen voi asettaa vastaamaan soittoon tietyllä soittomäärällä. Asennus 2: Tulostin on samassa linjassa vastaajan kanssa. Jos tilaat tunnistesoittopalvelun, varmista, että tulostimeen asetetaan oikea tunnistesoittokuvio. Muutoin tulostin ei vastaanota fakseja, vaikka se olisi asetettu vastaanottamaan ne automaattisesti. Liitettynä samaan puhelinpistorasiaan Liitä puhelinjohdon toinen pää tulostimen linjaporttiin. Liitä johdon toinen pää toimivaan analogiseen pistorasiaan. Liitä vastaaja tulostimen puhelinporttiin. Liitettynä eri puhelinpistorasioihin Liitä puhelinjohdon toinen pää tulostimen linjaporttiin. Liitä johdon toinen pää toimivaan analogiseen pistorasiaan. Jos linjassa on vain yksi puhelinnumero, aseta tulostin vastaanottamaan faksit automaattisesti. Aseta tulostin vastaamaan soittoihin kaksi soittoa puhelinvastaajan jälkeen. Jos puhelinvastaaja vastaa esimerkiksi neljän soiton jälkeen, määritä tulostimen  Hälytykset ennen vastaamista  -asetukseksi  6 . asentaminen, faksin tavallisen puhelinlinjaliitännän käyttäminen faksimääritykset tavallisen puhelinlinjaliitännän käyttäminen vastaaja asetusten määrittäminen"},{"UUID":"9e251461-fd99-4a74-a4ce-79d0dc302eb7","title":"Tulostimen asentaminen faksaamista varten","link":"setting-up-printer-to-fax-group.html","desc":"Faksin määrittäminen maassa ja alueella,","descFull":"Faksin määrittäminen maassa ja alueella, jossa on erilaiset pistorasiat ja liittimet Faksin määrittäminen maassa ja alueella, jossa on erilaiset pistorasiat ja liittimet Nämä ohjeet koskevat vain tulostimia, joihin on asennettu faksikortti. Sähköiskuvaaran välttämiseksi älä asenna laitetta tai tee sähkö- tai kaapeliliitäntöjä (esimerkiksi virtajohto, faksi tai puhelin) ukkosmyrskyn aikana. Sähköiskuvaaran välttämiseksi älä käytä faksitoimintoa ukkosmyrskyn aikana. Kun liität tämän tuotteen yleiseen valintaiseen puhelinverkkoon, voit vähentää tulipalon vaaraa käyttämällä vähintään 26 AWG:n tietoliikennejohtoa (RJ-11). Australia: johdon on oltava ACMAn (Australian Communications and Media Authority) hyväksymä. Vakiopistorasiamalli useimmissa maissa ja alueilla on RJ‑11. Jos rakennuksessa oleva pistorasia tai laite ei ole yhteensopiva tällaisen liitännän kanssa, käytä puhelinsovitinta. Maassasi tai alueellasi käytettävää sovitinta ei ehkä toimiteta tulostimen mukana. Siinä tapauksessa joudut ostamaan sen erikseen. Tulostimen puhelinportissa saattaa olla sovitinliitin asennettuna. Älä irrota sovitinliitintä tulostimen puhelinportista, jos teet muodostat yhteyttä jaettuun tai sarjassa olevaan puhelinjärjestelmään. Sovitinliittimen osanumero Tuotteen nimi Tuotenumero Lexmark-sovitinliitin 40X8519 Tulostimen liittäminen muuhun kuin RJ-11-pistorasiaan Liitä puhelinjohdon toinen pää tulostimen linjaporttiin. Kytke johdon toinen pää RJ-11-sovittimeen ja kytke sovitin sitten seinäpistorasiaan. Jos haluat liittää samaan pistorasiaan laitteen, jossa on muu kuin RJ-11-liitäntä, liitä se suoraan puhelinsovittimeen. faksimääritykset asentaminen, faksin"},{"UUID":"e817a129-04de-4cf4-93f5-ac4b4b8ea41a","title":"Tulostimen asentaminen faksaamista varten","link":"setting-up-printer-to-fax-group.html","desc":"Tunnusäänipalvelun käyttöönotto Tunnusäänipalvelun avulla samassa","descFull":"Tunnusäänipalvelun käyttöönotto Tunnusäänipalvelun avulla samassa puhelinlinjassa voi olla useita puhelinnumeroita. Kullekin puhelinnumerolle määritetään erilainen soittokuvio. Siirry ohjauspaneelissa kohtaan  Asetukset Faksi Faksiasetukset Faksin vastaanottoasetukset Järjestelmänvalvojan asetukset Vastaus käytössä . Valitse soittokuvio. tunnusäänipalvelu tunnusäänipalvelun käyttöönotto tulostimessa tunnusäänen määrittäminen tulostimelle"},{"UUID":"6b41a11b-649e-4369-9986-a7acfdb71688","title":"Tulostimen asentaminen faksaamista varten","link":"setting-up-printer-to-fax-group.html","desc":"Faksin päivämäärän ja ajan määrittäminen","descFull":"Faksin päivämäärän ja ajan määrittäminen Faksin päivämäärän ja ajan määrittäminen Siirry ohjauspaneelista kohtaan  Asetukset Laite Määritykset Päivämäärä ja aika Määritä . Määritä asetukset. faksaaminen päivämäärän ja ajan asettaminen päivämäärä ja aika faksiasetukset"},{"UUID":"cf14bb70-fa3e-4b37-adbf-3f9f061e9370","title":"Tulostimen asentaminen faksaamista varten","link":"setting-up-printer-to-fax-group.html","desc":"Kesäajan määrittäminen Siirry ohjauspaneelista kohtaan","descFull":"Kesäajan määrittäminen Siirry ohjauspaneelista kohtaan  Asetukset Laite Määritykset Päivämäärä ja aika Määritä . Valitse  Aikavyöhyke -valikossa  (UTC+käyttäjä) Mukautettu . Valitse  Määritä -valikossa  UTC-porrastus . Määritä asetukset. kesäajan määrittäminen kesäaika konfigurointi"},{"UUID":"4597915b-4e54-45b8-bcef-6ff207e9be5c","title":"Tulostimen asentaminen faksaamista varten","link":"setting-up-printer-to-fax-group.html","desc":"Faksin kaiutinasetusten määrittäminen Siirry ohjauspaneelista","descFull":"Faksin kaiutinasetusten määrittäminen Siirry ohjauspaneelista kohtaan  Asetukset Faksi Faksiasetukset Kaiutinasetukset . Toimi seuraavasti: Aseta  kaiutintilaksi Aina käytössä . Aseta  Kaiuttimen äänenvoimakkuudeksi Korkea . Aktivoi  Soittoäänen voimakkuus . asetusten määrittäminen faksin kaiutin faksin kaiutin asetusten määrittäminen"},{"UUID":"ca201b25-8147-4450-864e-0273f1dc572b","title":"Paperin ja erikoismateriaalin lisääminen","link":"loading-trays-group.html","desc":"Erikoismateriaalin koon ja lajin määrittäminen","descFull":"Erikoismateriaalin koon ja lajin määrittäminen Erikoismateriaalin koon ja lajin määrittäminen Tee erikoismateriaaleille, kuten tarroille, korteille ja kirjekuorille, seuraavat toimet: Valitse ohjauspaneelissa  Asetukset Paperi Lokeromääritys Paperikoko/-laji . Valitse paperilähde ja määritä sitten erikoismateriaalin koko ja laji. paperikoon määrittäminen paperilajin määritys"},{"UUID":"65da5814-7a76-441e-b91d-3f57bb89e618","title":"Paperin ja erikoismateriaalin lisääminen","link":"loading-trays-group.html","desc":"Universal-paperiasetusten määrittäminen Universal-paperiasetusten määrittäminen Yleisasetukset","descFull":"Universal-paperiasetusten määrittäminen Universal-paperiasetusten määrittäminen Yleisasetukset -valikossa voit määrittää sellaisen paperikoon leveyden ja korkeuden, jota ei ole asetettu tulostimeen valmiiksi. Siirry ohjauspaneelista kohtaan  Asetukset Paperi Materiaalimääritykset Yleisasetukset . Valitse  Kaikki syöttölokerot  ja määritä sitten mukautettavan paperikoon asetukset. paperikoon määrittäminen paperikoon mukauttaminen"},{"UUID":"8c4e3a1a-ba45-4f36-acec-42432fcdf6ae","title":"Paperin ja erikoismateriaalin lisääminen","link":"loading-trays-group.html","desc":"Paperin lisääminen 550 arkin lokeroon","descFull":"Paperin lisääminen 550 arkin lokeroon Voit vähentää laitteen epävakauden riskiä lisäämällä jokaisen alustan erikseen. Pidä kaikki muut alustat suljettuina, kunnes niitä tarvitaan. Avaa lokero. Älä avaa lokeroita tulostamisen aikana, jotta vältät tukokset. Säädä ohjaimet lisättävän paperin koon mukaan. Lokeron alaosan osoittimet helpottavat ohjainten asettamista. Rei'itettyä paperia tuetaan vain tavallisessa 550 arkin lokerossa. Vain valinnainen 550 arkin lokero tukee A3-koon paperin käyttöä. Taivuta ja ilmaa paperipino ja suorista sen reunat, ennen kuin lisäät sen tulostimeen. Lisää paperipino tulostimeen tulostuspuoli ylöspäin. Älä liu'uta paperia alustalle. Varmista, että sivuohjaimet ovat tiiviisti paperia vasten. Varmista, että pinon korkeus on paperin enimmäistäyttöosoittimen alapuolella. Ylitäyttö voi aiheuttaa tukoksia. Aseta alusta tulostimeen. Määritä tarvittaessa paperin koko ja paperin laji vastaamaan lokerossa olevaa paperia. Kun viimeistelijä on asennettu, sivuja kierretään tulostettaessa 180 astetta. Kun lisäät kirjelomakkeita, tee jompikumpi seuraavista: Ilman viimeistelijää Viimeistelijän kanssa Yksipuolinen tulostus pitkä reuna edellä Yksipuolinen tulostus pitkä reuna edellä Yksipuolinen tulostus lyhyt reuna edellä Yksipuolinen tulostus lyhyt reuna edellä Kaksipuolinen tulostus pitkä reuna edellä Kaksipuolinen tulostus pitkä reuna edellä Kaksipuolinen tulostus lyhyt reuna edellä Kaksipuolinen tulostus lyhyt reuna edellä Kun lisäät rei'itettyä paperia, tee jompikumpi seuraavista: Ilman valinnaista viimeistelijää Käyttäen valinnaista viimeistelijää Yksipuolinen tulostus pitkä reuna edellä Yksipuolinen tulostus pitkä reuna edellä Yksipuolinen tulostus lyhyt reuna edellä Yksipuolinen tulostus lyhyt reuna edellä Kaksipuolinen tulostus pitkä reuna edellä Kaksipuolinen tulostus pitkä reuna edellä Kaksipuolinen tulostus lyhyt reuna edellä Kaksipuolinen tulostus lyhyt reuna edellä 550 arkin alusta lisääminen 550 arkin lokeron täyttäminen lokeroiden täyttäminen"},{"UUID":"57c2609a-e4b9-49bd-8348-8586bfd20fef","title":"Paperin ja erikoismateriaalin lisääminen","link":"loading-trays-group.html","desc":"Paperin lisääminen 2000 arkin kaksoislokeroon","descFull":"Paperin lisääminen 2000 arkin kaksoislokeroon Voit vähentää laitteen epävakauden riskiä lisäämällä jokaisen alustan erikseen. Pidä kaikki muut alustat suljettuina, kunnes niitä tarvitaan. Avaa lokero. Älä vedä lokeroita ulos tulostamisen aikana, jotta vältät tukokset. Taivuta ja ilmaa paperipino ja suorista sen reunat, ennen kuin lisäät sen tulostimeen. Aseta paperipino oikeanpuoleiseen lokeroon tulostuspuoli ylöspäin. Älä liu'uta paperia alustalle. Varmista, että pinon korkeus on paperin enimmäistäyttöosoittimen alapuolella. Ylitäyttö voi aiheuttaa tukoksia. Aseta oikea lokero tulostimeen. Aseta paperipino vasemmanpuoleiseen lokeroon tulostuspuoli ylöspäin. Aseta alusta tulostimeen. Määritä tarvittaessa paperin koko ja laji vastaamaan lokerossa olevaa paperia. Kun viimeistelijä on asennettu, sivuja kierretään tulostettaessa 180 astetta. Kun lisäät esipainettuja kirjelomakkeita yksipuolista tulostusta varten, lataa ne tunnisteosan tulostuspuoli ylöspäin alustan etuosaan päin. Kun lisäät esipainettuja kirjelomakkeita kaksipuolista tulostusta varten, lataa ne tunnisteosan tulostuspuoli alaspäin alustan etuosaan päin. 2000 arkin kaksoislokero lisääminen 2000 arkin kaksoislokeron täyttäminen lokeroiden täyttäminen"},{"UUID":"bc607386-424a-4972-890c-6ee769b38408","title":"Paperin ja erikoismateriaalin lisääminen","link":"loading-trays-group.html","desc":"Paperin lisääminen 1500 arkin lokeroon","descFull":"Paperin lisääminen 1500 arkin lokeroon Voit vähentää laitteen epävakauden riskiä lisäämällä jokaisen alustan erikseen. Pidä kaikki muut alustat suljettuina, kunnes niitä tarvitaan. Avaa luukku K. Älä avaa lokeroita tulostamisen aikana, jotta vältät tukokset. Taivuta ja ilmaa paperipino ja suorista sen reunat, ennen kuin lisäät sen tulostimeen. Lisää paperipino tulostimeen tulostuspuoli alaspäin. Älä liu'uta paperia alustalle. Varmista, että pinon korkeus on paperin enimmäistäyttöosoittimen alapuolella. Ylitäyttö voi aiheuttaa tukoksia. Sulje luukku K. Määritä tarvittaessa paperin koko ja laji vastaamaan lokerossa olevaa paperia. Kun lisäät kirjelomakkeita yksipuolista tulostusta varten, laita ne tulostuspuoli alaspäin ylätunniste kohti tulostimen takaosaa. Kun lisäät kirjelomakkeita kaksipuolista tulostusta varten, laita ne tulostuspuoli ylöspäin ylätunniste kohti tulostimen takaosaa. Kun lisäät erikokoista paperia, muista säätää ohjaimia. Toimi seuraavasti: Irrota ruuvit paperiohjaimista litteäpäisellä ruuvimeisselillä. Poista paperiohjaimet. Kohdista paperinohjaimet lisättävän paperin koon mukaan. Asenna ruuvit paperiohjaimiin. 1500 arkin alusta lisääminen lokeron täyttäminen"},{"UUID":"c42730cd-fa34-4ef4-99fb-9f76f84863b7","title":"Paperin ja erikoismateriaalin lisääminen","link":"loading-trays-group.html","desc":"Monisyöttöaukon täyttö Avaa monisyöttölaite. Säädä","descFull":"Monisyöttöaukon täyttö Avaa monisyöttölaite. Säädä sivuohjaimet lisättävän paperin koon mukaan. Taivuta ja ilmaa paperipino ja suorista sen reunat, ennen kuin lisäät sen tulostimeen. Aseta paperia. Varmista, että sivuohjaimet ovat tiiviisti paperia vasten. Kun lisäät kirjelomakkeita, tee jompikumpi seuraavista: Ilman viimeistelijää Viimeistelijän kanssa Yksipuolinen tulostus pitkä reuna edellä Yksipuolinen tulostus pitkä reuna edellä Kaksipuolinen tulostus pitkä reuna edellä Kaksipuolinen tulostus pitkä reuna edellä Kun lisäät rei'itettyä paperia, tee jompikumpi seuraavista: Ilman viimeistelijää Viimeistelijän kanssa Yksipuolinen tulostus pitkä reuna edellä Yksipuolinen tulostus pitkä reuna edellä Kaksipuolinen tulostus pitkä reuna edellä Kaksipuolinen tulostus pitkä reuna edellä Kirjekuoret Aseta kirjekuori läppäpuoli ylöspäin tulostimen takaosaa kohti. Lisää eurooppalainen kirjekuori läppäpuoli ylöspäin monisyöttöaukkoon ensin. Kun viimeistelijä on asennettu, tulostin kiertää sivuja 180 astetta. paperin asettaminen monikäyttösyöttöaukossa kirjelomakkeiden lisäys rei'itetyn paperin lisääminen"},{"UUID":"092e38e4-a690-45a0-a0dd-f7a9a0f0ccea","title":"Paperin ja erikoismateriaalin lisääminen","link":"loading-trays-group.html","desc":"Lokeroiden yhdistäminen Avaa selain ja","descFull":"Lokeroiden yhdistäminen Avaa selain ja kirjoita tulostimen IP-osoite selaimen osoitekenttään. Tulostimen IP-osoite näkyy sen tulostimen päänäytössä. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Valitse  Asetukset Paperi Lokeromääritys . Määritä yhdistettäville lokeroille sama paperikoko ja -lajiasetukset. Varmista, että täytät yhdistetyt lokerot samalla paperisuunnalla. Tallenna asetukset. Valitse  Asetukset Laite Huolto Määritysvalikko Lokeromääritys . Määritä  Lokeroiden linkitys  -asetukseksi  Automaattinen . Tallenna asetukset. Erota lokerot varmistamalla, ettei lokeroilla ole samoja paperikoko- tai -lajiasetuksia. Kiinnittimen lämpötila vaihtelee määritetyn paperilajin mukaan. Voit välttää tulostusongelmia varmistamalla, että tulostimen paperilajiasetus vastaa lokeroon lisättyä paperia. lokeroiden erottaminen lokeroiden yhdistäminen lokeroiden yhdistäminen lokeroiden erottaminen"},{"UUID":"a7649369-08cb-43fd-9bd0-5cecf81ee724","title":"Ohjelmiston, ohjaimien ja laiteohjelmiston asentaminen ja päivittäminen","link":"installing-printer-software-topic.html","desc":"Tulostinohjelmiston asentaminen Tulostinohjain sisältyy ohjelmiston","descFull":"Tulostinohjelmiston asentaminen Tulostinohjain sisältyy ohjelmiston asennuspakettiin. Jos käyttämässäsi Macintosh-tietokoneessa on macOS-versio 10.7 tai uudempi, sinun ei tarvitse asentaa ohjainta, jotta voit tulostaa AirPrint-sertifioidulla tulostimella. Jos haluat käyttää mukautettuja tulostusominaisuuksia, lataa tulostinohjain. Hanki ohjelmiston asennuspaketti. Tulostimen mukana toimitetulla Ohjelmistot-levyllä. Siirry osoitteeseen  www.lexmark.com/downloads . Siirry osoitteeseen  www.dell.com/support/printers . Sivustostamme tai tulostimen ostopaikasta. Käynnistä asennusohjelma ja seuraa tietokoneen näytön ohjeita. tulostinohjelmiston asentaminen tulostinohjelmisto asentaminen tulostinohjaimen asentaminen tulostinohjain asentaminen"},{"UUID":"d3c02ddd-8d93-4f9b-909f-5f28bd3cdb1d","title":"Ohjelmiston, ohjaimien ja laiteohjelmiston asentaminen ja päivittäminen","link":"installing-printer-software-topic.html","desc":"Faksiohjaimen asentaminen Siirry osoitteeseen ","descFull":"Faksiohjaimen asentaminen Siirry osoitteeseen  www.lexmark.com/downloads , hae tulostinmallisi ja lataa sen asennuspaketti. Hae asennuspaketti joko sivustostamme tai tulostimesi ostopaikasta. Siirry osoitteeseen  www.dell.com/support  ja lataa asennuspaketti. Valitse tulostimessasi  Tulostimen ominaisuudet  ja sitten  Määritykset -välilehti. Käynnistä asennusohjelma ja seuraa tietokoneen näytön ohjeita. Valitse  Faksi  ja sitten  Käytä . faksiohjain asentaminen faksiohjaimen asentaminen"},{"UUID":"e05ffc65-955a-4641-961d-b9fc3cb6eeb5","title":"Ohjelmiston, ohjaimien ja laiteohjelmiston asentaminen ja päivittäminen","link":"installing-printer-software-topic.html","desc":"Tulostimien lisääminen tietokoneeseen Tee jokin","descFull":"Tulostimien lisääminen tietokoneeseen Tee jokin seuraavista: toimista ennen kuin aloitat: Liitä tulostin ja tietokone samaan verkkoon. Lisätietoja tulostimen liittämisestä verkkoon on kohdassa  . Liitä tietokone tulostimeen. Lisätietoja on kohdassa  . Liitä tulostin tietokoneeseen USB-kaapelilla. Lisätietoja on kohdassa  . USB-kaapeli myydään erikseen. Windows-käyttäjät: Asenna tulostusohjain tietokoneeseen. Lisätietoja on kohdassa  . Avaa  Tulostimet & skannerit  ja valitse  Lisää tulostin tai skanneri . Tee tulostimen mallin mukaan jokin seuraavista toimenpiteistä: Valitse tulostin luettelosta ja sitten  Lisää laite . Valitse  Näytä Wi-Fi Direct -tulostimet , valitse tulostin ja sitten  Lisää laite . Valitse  Haluamani tulostin ei ole luettelossa  ja tee sitten  Lisää tulostin  -ikkunassa jokin seuraavista toimenpiteistä: Valitse  Lisää tulostin IP-osoitetta tai isäntänimeä käyttämällä  ja valitse sitten  Seuraava . Valitse Laitetyyppi-kentässä  TCP/IP-laite . Kirjoita Isäntänimi tai IP-osoite -kenttään tulostimen IP-osoite ja valitse sitten  Seuraava . Tulostimen IP-osoite näkyy sen tulostimen päänäytössä. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Valitse tulostinohjain ja sitten  Seuraava . Valitse  Käytä asennettua ohjainta (suositus)  ja sitten  Seuraava . Kirjoita tulostimen nimi ja valitse  Seuraava . Valitse  Valmis . Macintosh-käyttäjät: Avaa  Tulostimet & Skannerit . Valitse  Lisää tulostin, skanneri tai faksi  ja valitse sitten tulostin. Valitse  Lisää tulostin  -valikosta tulostinohjain. Valitse Macintosh-tulostinohjaimen käyttöä varten joko  AirPrint  tai  Secure AirPrint . Jos haluat käyttää mukautettuja tulostusominaisuuksia, valitse Lexmark-tulostinohjain. Ohjaimen asennusohjeet ovat kohdassa  . Jos haluat käyttää mukautettuja tulostusominaisuuksia, valitse valmistajan tulostinohjain. Ohjaimen asennusohjeet ovat kohdassa  . Lisää tulostin. tulostimien lisääminen tietokoneeseen"},{"UUID":"965406f2-53b8-462e-91d6-d6a9d7293ef5","title":"Ohjelmiston, ohjaimien ja laiteohjelmiston asentaminen ja päivittäminen","link":"installing-printer-software-topic.html","desc":"Määritystiedoston vieminen Avaa selain ja","descFull":"Määritystiedoston vieminen Avaa selain ja kirjoita tulostimen IP-osoite selaimen osoitekenttään. Tulostimen IP-osoite näkyy sen tulostimen päänäytössä. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Valitse Embedded Web Server -palvelimessa  Vie määritykset . Valitse vietävä määritystiedosto. Valitsemastasi kokoonpanosta riippuen tiedostot viedään joko ZIP- tai CSV-muodossa. määritystiedoston vienti määritystiedosto vieminen"},{"UUID":"af92fddd-d513-4413-b877-1eaa64f2706c","title":"Ohjelmiston, ohjaimien ja laiteohjelmiston asentaminen ja päivittäminen","link":"installing-printer-software-topic.html","desc":"Asetustiedoston tuominen Avaa selain ja","descFull":"Asetustiedoston tuominen Avaa selain ja kirjoita tulostimen IP-osoite selaimen osoitekenttään. Tulostimen IP-osoite näkyy sen tulostimen päänäytössä. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Valitse Embedded Web Server -palvelimessa  Tuo määritykset . Selaa sijaintiin, johon tiedosto on tallennettu. Tiedostot tallennetaan joko ZIP- tai CSV-muodossa. Valitse  Tuo . tuodaan määritystiedostoa määritystiedosto tuominen"},{"UUID":"aeb1f368-8b41-498b-b565-555f639718ce","title":"Ohjelmiston, ohjaimien ja laiteohjelmiston asentaminen ja päivittäminen","link":"installing-printer-software-topic.html","desc":"Tulostinohjaimen käytettävissä olevien lisävarusteiden lisääminen","descFull":"Tulostinohjaimen käytettävissä olevien lisävarusteiden lisääminen Windows-käyttäjät: Avaa Tulostimet-kansio. Valitse päivitettävä tulostin ja tee jompikumpi seuraavista: Windows 7 tai uudempi: valitse  Tulostimen ominaisuudet . Vanhemmat versiot: valitse  Ominaisuudet . Siirry  Määritykset -välilehteen ja valitse  Päivitä nyt – Kysy tulostimelta . Ota muutokset käyttöön. Macintosh-käyttäjät: Avaa  Tulostimet & Skannerit . Valitse  Lisää tulostin, skanneri tai faksi  ja valitse sitten tulostin. Valitse tulostinohjain. Ota muutokset käyttöön. lisävarusteiden lisääminen tulostinohjaimessa tulostinohjain lisävarusteiden lisääminen"},{"UUID":"82196b6c-7883-4de5-87a3-7b41aecc5d11","title":"Laiteohjelmiston päivittäminen","link":"installing-printer-software-topic.html","desc":"Laiteohjelmiston päivittäminen ohjauspaneelin avulla Ilmoituskeskuksen","descFull":"Laiteohjelmiston päivittäminen ohjauspaneelin avulla Ilmoituskeskuksen käyttäminen Tätä menetelmää voi käyttää vain joissakin tulostinmalleissa. Siirry tulostimen ohjauspaneelista ilmoituskeskukseen ja valitse sitten  Laiteohjelmistopäivitys on saatavilla . Valitse  Asenna nyt . Tulostin käynnistyy automaattisesti uudelleen päivityksen jälkeen. Settings (Asetukset) -valikon käyttäminen Siirry tulostimen ohjauspaneelista kohtaan  Asetukset Laite Päivitä laiteohjelma . Valitse tulostinmallin mukaan  Tarkista päivitykset  tai  Tarkista päivitykset nyt . Jos uusi päivitys on saatavilla, valitse  Asenna nyt . Tulostin käynnistyy automaattisesti uudelleen päivityksen jälkeen. laiteohjelmiston päivittäminen ohjauspaneelin avulla laiteohjelmisto, päivittäminen ohjauspaneelin avulla"},{"UUID":"bb03d14a-9a31-47d3-b337-1b9b7b3e95a2","title":"Laiteohjelmiston päivittäminen","link":"installing-printer-software-topic.html","desc":"Tulostimen laiteohjelmiston päivittäminen Embedded Web","descFull":"Tulostimen laiteohjelmiston päivittäminen Embedded Web Server -palvelimen kautta Tarkista seuraavat asiat ennen aloittamista: Olet ladannut tulostimen uusimman laiteohjelmiston osoitteesta  https://support.lexmark.com  ja tallentanut sen flash-asemaan tai tietokoneeseen. Ota tulostimen laiteohjelmisto käyttöön purkamalla FLS-laiteohjelmistotiedosto ZIP-paketista. Olet ladannut uusimman tulostinohjelmiston ja tallentanut sen flash-asemaan tai tietokoneeseen. Kysy lisätietoja tulostimen ostopaikasta. Olet ladannut uusimman tulostinohjelmiston ja tallentanut sen flash-asemaan tai tietokoneeseen. Pyydä lisätietoja jälleenmyyjältä. Et käytä tulostimessasi erityistä koodia, jotta et menetä tätä toimintoa. Varmista, että kaikkien laiteohjelmistopäivityksen vastaanottavien tulostimien virta on kytketty koko laiteohjelmiston päivityksen ajan. Tulostimen virran katkaiseminen kesken laiteohjelmistopäivityksen voi vahingoittaa sitä vakavasti. Jos tulostin on kytketty verkkoon päivityksiä tarkistettaessa, laiteohjelmistoa ei tarvitse ladata. Avaa selain ja kirjoita tulostimen IP-osoite selaimen osoitekenttään. Tulostimen IP-osoite näkyy sen tulostimen päänäytössä. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Valitse  Laite . Vieritä alas ja napsauta kohtaa  Päivitä laiteohjelma . Valitse tulostinmallin mukaan  Tarkista päivitykset  tai  Tarkista päivitykset nyt . Jos uusi päivitys on saatavilla, valitse  Hyväksyn, käynnistä päivitys . Tulostin käynnistyy automaattisesti uudelleen päivityksen jälkeen. laiteohjelmiston päivittäminen Embedded Web Server -palvelimen käyttö laiteohjelmisto, päivittäminen Embedded Web Server -palvelimen käyttö"},{"UUID":"cc5e77a1-f8a0-400e-8e90-9f3bd57fd276","title":"Lisävarusteiden asentaminen","link":"installing-optional-550-sheet-tray-topic.html","desc":"Valinnaisen 550 arkin lokeron asentaminen","descFull":"Valinnaisen 550 arkin lokeron asentaminen Jos käsittelet ohjainlevyä tai asennat lisävarusteita tai muistilaitteita tulostimen käyttöönoton jälkeen, sähköiskuvaaran välttämiseksi katkaise tulostimesta virta ja irrota virtajohto pistorasiasta ennen toimenpiteiden tekemistä. Jos tulostimeen on kytketty muita laitteita, katkaise niidenkin virta ja irrota kaikki tulostimeen kytketyt kaapelit. Tähän toimenpiteeseen tarvitaan tasapäistä ruuvitalttaa. Katkaise virta tulostimesta. Irrota virtajohto ensin pistorasiasta ja sitten tulostimesta. Poista valinnainen 550 arkin lokero pakkauksesta. Varmista, että pidät kiinni etu- ja takareunasta, kun nostat lokeroa, jotta se ei vahingoitu. Kiinnitä lokeron oikea suojus. Vedä 550 arkin lokeron sisäosa ulos. Irrota lokeron ylempi suojus. Irrota ruuvit. Kiinnitä lokeron alempi suojus. Asenna ruuvit. Kiinnitä lokeron ylempi suojus. Aseta 550 arkin lokeron sisäosa paikalleen. Irrota tulostimen oikean puolen alla oleva kansi. Kohdista tulostin 550 arkin lokeroon ja laske se paikalleen. Jos tulostin painaa yli 20 kg, sen turvallinen siirtäminen edellyttää kahta tai useampaa henkilöä. Vedä vakiolokeron sisäosa kokonaan ulos. Kiinnitä 550 arkin lokero tulostimeen. Aseta vakiolokeron sisäosa paikalleen. Kiinnitä 1500 arkin lokeron takaosa tulostimeen. Liitä virtajohdon toinen pää tulostimeen ja toinen pää pistorasiaan. Tulipalo- tai sähköiskuriskin välttämiseksi kytke virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Kytke tulostimen virta. Lisää lokero tulostinohjaimeen, jotta se on käytettävissä tulostustöissä. Lisätietoja on kohdassa  . 550 arkin lokeron asentaminen 550 arkin alusta asentaminen lisävarusteet 550 arkin alusta"},{"UUID":"ecc255bd-0f87-40ad-ade5-1278dd76959a","title":"Lisävarusteiden asentaminen","link":"installing-optional-550-sheet-tray-topic.html","desc":"2 x 550 arkin lokeron","descFull":"2 x 550 arkin lokeron asentaminen Jos käsittelet ohjainlevyä tai asennat lisävarusteita tai muistilaitteita tulostimen käyttöönoton jälkeen, sähköiskuvaaran välttämiseksi katkaise tulostimesta virta ja irrota virtajohto pistorasiasta ennen toimenpiteiden tekemistä. Jos tulostimeen on kytketty muita laitteita, katkaise niidenkin virta ja irrota kaikki tulostimeen kytketyt kaapelit. Tämä lisävaruste aina asennettava valinnaisen 550 arkin lokeron kanssa. Aseta varuste kokoonpanon alaosaan. Jos 550 arkin lokero on jo asennettu, poista lokero, irrota lokeron sivukansi, irrota lokeron alakansi ja aseta lokero tämän lisävarusteen päälle. Tähän toimenpiteeseen tarvitaan tasapäistä ruuvitalttaa. Katkaise virta tulostimesta. Irrota virtajohto ensin pistorasiasta ja sitten tulostimesta. Pura 2 x 550 arkin lokero pakkauksesta ja poista pakkausmateriaali. Lukitse pyörä, jotta 2 x 550 arkin lokero ei pääse siirtymään paikaltaan. Kohdista 550 arkin 2 x 550 arkin lokeroon ja laske se paikalleen. Varmista, että pidät kiinni etu- ja takareunasta, kun nostat lokeroa, jotta se ei vahingoitu. Vedä 550 arkin lokeron sisäosa ulos. Kiinnitä 550 arkin lokero 2 x 550 arkin lokeroon. Aseta 550 arkin lokeron sisäosa paikalleen. Kiinnitä 550 arkin lokeron takaosa 2 x 550 arkin lokeroon. Irrota tulostimen oikean puolen alla oleva kansi. Kohdista tulostin valinnaisiin lokeroihin ja laske lokero paikalleen. Jos tulostin painaa yli 20 kg, sen turvallinen siirtäminen edellyttää kahta tai useampaa henkilöä. Vedä vakiolokeron sisäosa kokonaan ulos. Kiinnitä 550 arkin lokero tulostimeen. Aseta vakiolokeron sisäosa paikalleen. Kiinnitä 1500 arkin lokeron takaosa tulostimeen. Liitä virtajohdon toinen pää tulostimeen ja toinen pää pistorasiaan. Tulipalo- tai sähköiskuriskin välttämiseksi kytke virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Kytke tulostimen virta. Lisää lokero tulostinohjaimeen, jotta se on käytettävissä tulostustöissä. Lisätietoja on kohdassa  . Kaksi 550 arkin lokeroa asentaminen lisävarusteet Kaksi 550 arkin lokeroa 2 x 550 arkin lokeron asentaminen"},{"UUID":"d39ece0e-20f2-4849-82fc-43aaeb6e5abd","title":"Lisävarusteiden asentaminen","link":"installing-optional-550-sheet-tray-topic.html","desc":"2000 arkin kaksoislokeron asentaminen 2000","descFull":"2000 arkin kaksoislokeron asentaminen 2000 arkin kaksoislokeron asentaminen Jos käsittelet ohjainlevyä tai asennat lisävarusteita tai muistilaitteita tulostimen käyttöönoton jälkeen, sähköiskuvaaran välttämiseksi katkaise tulostimesta virta ja irrota virtajohto pistorasiasta ennen toimenpiteiden tekemistä. Jos tulostimeen on kytketty muita laitteita, katkaise niidenkin virta ja irrota kaikki tulostimeen kytketyt kaapelit. Tämä lisävaruste aina asennettava valinnaisen 550 arkin lokeron kanssa. Aseta tämä varuste kokoonpanon alaosaan. Jos 550 arkin lokero on jo asennettu, poista lokero, irrota lokeron sivukansi, irrota lokeron alakansi ja aseta lokero tämän lisävarusteen päälle. Tähän toimenpiteeseen tarvitaan tasapäistä ruuvitalttaa. Katkaise virta tulostimesta. Irrota virtajohto ensin pistorasiasta ja sitten tulostimesta. Poista kaksoislokero pakkauksesta ja poista sitten pakkausmateriaali. Lukitse pyörä, jotta lokero ei pääse siirtymään paikaltaan. D Kohdista 550 arkin lokero 550 arkin kaksoislokeroon ja laske se paikalleen. Varmista, että pidät kiinni etu- ja takareunasta, kun nostat lokeroa, jotta se ei vahingoitu. Vedä 550 arkin lokeron sisäosa ulos. Kiinnitä 550 arkin lokero kaksoislokeroon. Aseta lokeron sisäosa paikalleen. Kiinnitä 550 arkin lokeron takaosa kaksoislokeroon. Irrota tulostimen oikean puolen alla oleva kansi. Kohdista tulostin valinnaisiin lokeroihin ja laske lokero paikalleen. Jos tulostin painaa yli 20 kg, sen turvallinen siirtäminen edellyttää kahta tai useampaa henkilöä. Vedä vakiolokero ulos. Kiinnitä 550 arkin lokero tulostimeen. Aseta alusta tulostimeen. Kiinnitä 1500 arkin lokeron takaosa tulostimeen. Liitä virtajohdon toinen pää tulostimeen ja toinen pää pistorasiaan. Tulipalo- tai sähköiskuriskin välttämiseksi kytke virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Kytke tulostimen virta. Lisää lokero tulostinohjaimeen, jotta se on käytettävissä tulostustöissä. Lisätietoja on kohdassa  . 2000 arkin kaksoislokero asentaminen lisävarusteet 2000 arkin kaksoislokero 2000 arkin kaksoislokeron asentaminen"},{"UUID":"f63d1ace-e19b-4fdf-af21-58bc083bbdfc","title":"Lisävarusteiden asentaminen","link":"installing-optional-550-sheet-tray-topic.html","desc":"Telineen asentaminen Jos käsittelet ohjainlevyä","descFull":"Telineen asentaminen Jos käsittelet ohjainlevyä tai asennat lisävarusteita tai muistilaitteita tulostimen käyttöönoton jälkeen, sähköiskuvaaran välttämiseksi katkaise tulostimesta virta ja irrota virtajohto pistorasiasta ennen toimenpiteiden tekemistä. Jos tulostimeen on kytketty muita laitteita, katkaise niidenkin virta ja irrota kaikki tulostimeen kytketyt kaapelit. Tämä lisävaruste aina asennettava 550 arkin lokeron kanssa. Aseta tämä varuste kokoonpanon alaosaan. Jos 550 arkin lokero on jo asennettu, poista lokero, irrota lokeron alempi kansi ja aseta se tämän lisävarusteen päälle. Tähän toimenpiteeseen tarvitaan tasapäistä ruuvitalttaa. Ota teline pakkauksestaan ja kokoa se. Katkaise virta tulostimesta. Irrota virtajohto ensin pistorasiasta ja sitten tulostimesta. Lukitse pyörät, jotta teline ei pääse siirtymään paikaltaan. Kiinnitä 550 arkin lokeron sivukansi. Kohdista lokero telineeseen ja laske se paikalleen. Varmista, että pidät kiinni etu- ja takareunasta, kun nostat lokeroa, jotta se ei vahingoitu. Vedä lokeron sisäosa kokonaan ulos. Kiinnitä lokero telineeseen. Aseta lokeron sisäosa paikalleen. Kiinnitä lokeron takaosa telineeseen. Irrota tulostimen oikean puolen alla oleva kansi. Kohdista tulostin telineeseen ja laske se paikalleen. Jos tulostin painaa yli 20 kg, sen turvallinen siirtäminen edellyttää kahta tai useampaa henkilöä. Vedä vakiolokeron sisäosa kokonaan ulos. Kiinnitä 550 arkin lokero tulostimeen. Aseta vakiolokeron sisäosa paikalleen. Kiinnitä 1500 arkin lokeron takaosa tulostimeen. Liitä virtajohdon toinen pää tulostimeen ja toinen pää pistorasiaan. Tulipalo- tai sähköiskuriskin välttämiseksi kytke virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Kytke tulostimen virta. teline asentaminen lisävarusteet teline telineen asentaminen"},{"UUID":"67d05f54-5a1a-4b4c-8a32-26d1c5deb9fd","title":"Lisävarusteiden asentaminen","link":"installing-optional-550-sheet-tray-topic.html","desc":"1500 arkin lokeron asentaminen Jos","descFull":"1500 arkin lokeron asentaminen Jos käsittelet ohjainlevyä tai asennat lisävarusteita tai muistilaitteita tulostimen käyttöönoton jälkeen, sähköiskuvaaran välttämiseksi katkaise tulostimesta virta ja irrota virtajohto pistorasiasta ennen toimenpiteiden tekemistä. Jos tulostimeen on kytketty muita laitteita, katkaise niidenkin virta ja irrota kaikki tulostimeen kytketyt kaapelit. Ennen kuin asennat tämän lisävarusteen, varmista, että valinnainen 550 arkin lokero ja joko 2 x 500 arkin lokero tai 2000 arkin lokero on jo asennettu. Tähän toimenpiteeseen tarvitaan tasapäistä ruuvitalttaa. Katkaise virta tulostimesta. Irrota virtajohto ensin pistorasiasta ja sitten tulostimesta. Irrota liitäntäkansi. Älä heitä kantta pois. Irrota portin suojus. Älä heitä kantta pois. Irrota kierrekannet tulostimesta. Älä heitä kierrekansia pois. Pura 1500 arkin lokero pakkauksesta ja poista pakkausmateriaali. Asenna kiinnitystelineen ruuvit. Kiinnitä asennuspidike tulostimeen. Käytä 1500 arkin lokeron mukana toimitettua kiinnikettä ja ruuveja. Asenna loput ruuvit. Asenna 1500 arkin lokero. Liitä lokeron kaapeli tulostimeen. Kiinnitä lokeron kaapelin suojus. Liu'uta 1500 arkin lokero tulostimeen. Liitä tulostimen virtajohdon toinen pää tulostimeen ja toinen pää pistorasiaan. Tulipalo- tai sähköiskuriskin välttämiseksi kytke virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Kytke tulostimen virta. Lisää lokero tulostinohjaimeen, jotta se on käytettävissä tulostustöissä. Lisätietoja on kohdassa  . 1500 arkin lokeron asentaminen 1500 arkin alusta asentaminen lisävarusteet 1500 arkin alusta"},{"UUID":"5e01e149-15d0-47ef-a615-fe2f5a009ce7","title":"Lisävarusteiden asentaminen","link":"installing-optional-550-sheet-tray-topic.html","desc":"Nidonnan viimeistelijän asentaminen Nidonnan viimeistelijän","descFull":"Nidonnan viimeistelijän asentaminen Nidonnan viimeistelijän asentaminen Jos käsittelet ohjainlevyä tai asennat lisävarusteita tai muistilaitteita tulostimen käyttöönoton jälkeen, sähköiskuvaaran välttämiseksi katkaise tulostimesta virta ja irrota virtajohto pistorasiasta ennen toimenpiteiden tekemistä. Jos tulostimeen on kytketty muita laitteita, katkaise niidenkin virta ja irrota kaikki tulostimeen kytketyt kaapelit. Tähän toimenpiteeseen tarvitaan tasapäistä ruuvitalttaa. Katkaise virta tulostimesta. Irrota virtajohto ensin pistorasiasta ja sitten tulostimesta. Poista nidonnan viimeistelijä pakkauksesta ja poista sitten pakkausmateriaali. Asenna syöttöohjain. Poista vakioalusta. Älä heitä alustaa pois. Aseta vastaanottoalustan lippu suljettuun asentoon ennen lisävarusteen asentamista. Kun lisävaruste poistetaan, aseta vastaanottoalustan lippu avoimeen asentoon. Irrota taustatelan pidike. Älä heitä telaa pois. Paina nidonnan viimeistelijän mukana tullutta syöttötelaa, kunnes se  napsahtaa  paikalleen. Varmista, että metallijousi on syöttötelan edessä. Paina telan kantta, kunnes se  napsahtaa  paikalleen. Avaa etuluukku ja poista kansi tulostimen vasemmalta puolelta. Älä heitä ruuvia tai kantta pois. Poista vasen takakansi. Älä heitä ruuvia tai kantta pois. Irrota alustan sisäkansi. Älä heitä kantta pois. Kohdista ja aseta sitten nidonnan viimeistelijän mukana toimitettu sisempi alustan kansi. Asenna ruuvit alustan sisempään kanteen. Kiinnitä nidonnan viimeistelijän liukusäädin. Aseta nidonnan viimeistelijä paikalleen. Asenna asennuskiinnikkeet kiinnittääksesi viimeistelijän tulostimeen. Käytä viimeistelijän mukana toimitettua ruuvia. Kiinnitä vasen takakansi ja liu'uta sitten nidonnan viimeistelijää vasemmalle. Kiinnitä viimeistelijän mukana toimitettu vasen yläkansi paikalleen. Työnnä niittikasettikoteloa viimeistelijään, kunnes se  napsahtaa  paikalleen. Sulje etuluukku ja liu'uta sitten viimeistelijää tulostinta kohti. Liitä lisävarusteen kaapeli tulostimeen. Liitä tulostimen virtajohdon toinen pää tulostimeen ja toinen pää pistorasiaan. Tulipalo- tai sähköiskuriskin välttämiseksi kytke virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Kytke tulostimen virta. Lisää viimeistelijä tulostinohjaimeen, jotta se on käytettävissä tulostustöissä. Lisätietoja on kohdassa  . nidonnan viimeistelijän asentaminen nidonnan viimeistelijä asentaminen lisävarusteet nidonnan viimeistelijä"},{"UUID":"d08ab312-6586-4f70-94e0-b16242d6863c","title":"Lisävarusteiden asentaminen","link":"installing-optional-550-sheet-tray-topic.html","desc":"Porrastuspinoajan asentaminen Porrastuspinoajan asentaminen Jos","descFull":"Porrastuspinoajan asentaminen Porrastuspinoajan asentaminen Jos käsittelet ohjainlevyä tai asennat lisävarusteita tai muistilaitteita tulostimen käyttöönoton jälkeen, sähköiskuvaaran välttämiseksi katkaise tulostimesta virta ja irrota virtajohto pistorasiasta ennen toimenpiteiden tekemistä. Jos tulostimeen on kytketty muita laitteita, katkaise niidenkin virta ja irrota kaikki tulostimeen kytketyt kaapelit. Katkaise virta tulostimesta. Irrota virtajohto ensin pistorasiasta ja sitten tulostimesta. Poista porrastuspinoaja viimeistelijä pakkauksesta ja poista sitten pakkausmateriaali. Kiinnitä sisempi takakansi porrastuspinoajaan. Poista vakioalusta. Älä heitä alustaa pois. Irrota paperin siirtoyksikön liittimen kansi. Älä heitä kantta pois. Aseta vastaanottoalustan lippu suljettuun asentoon ennen lisävarusteen asentamista. Kohdista ja asenna porrastuspinoaja tulostimeen.  Varmista, että osat on kiinnitetty kunnolla ja kohdistettu tulostimeen. Kiinnitä porrastuspinoajan suojanauhat tulostimeen. Aseta vastaanottoalustan lippu avoimeen asentoon. Aseta alustan lipun kansi paikalleen siten, että se  napsahtaa  paikalleen. Liitä tulostimen virtajohdon toinen pää tulostimeen ja toinen pää pistorasiaan. Tulipalo- tai sähköiskuriskin välttämiseksi kytke virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Kytke tulostimen virta. Lisää offset-pinoaja tulostinohjaimeen, jotta se on käytettävissä tulostustöissä. Lisätietoja on kohdassa  . offset-pinoaja asentaminen porrastuspinoajan asentaminen lisävarusteet asentaminen"},{"UUID":"730a39b6-6982-4264-8753-3a3789bc1ddc","title":"Lisävarusteiden asentaminen","link":"installing-optional-550-sheet-tray-topic.html","desc":"Taittovalinnalla varustetun paperin siirtoyksikön asentaminen","descFull":"Taittovalinnalla varustetun paperin siirtoyksikön asentaminen Jos käsittelet ohjainlevyä tai asennat lisävarusteita tai muistilaitteita tulostimen käyttöönoton jälkeen, sähköiskuvaaran välttämiseksi katkaise tulostimesta virta ja irrota virtajohto pistorasiasta ennen toimenpiteiden tekemistä. Jos tulostimeen on kytketty muita laitteita, katkaise niidenkin virta ja irrota kaikki tulostimeen kytketyt kaapelit. Tämä varuste voidaan myös asentaa yhdessä vihkoviimeistelijän tai nidonnan ja rei'ityksen viimeistelijän kanssa. Tähän toimenpiteeseen tarvitaan tasapäistä ruuvitalttaa. Katkaise virta tulostimesta. Irrota virtajohto ensin pistorasiasta ja sitten tulostimesta. Pura paperin siirtoyksikkö taittomahdollisuudella pakkauksesta ja poista sitten kaikki pakkausmateriaalit. Poista vakioalusta. Älä heitä alustaa pois. Aseta vastaanottoalustan lippu suljettuun asentoon ennen lisävarusteen asentamista. Kun lisävaruste poistetaan, aseta vastaanottoalustan lippu avoimeen asentoon. Irrota taustatelan pidike. Älä heitä telaa pois. Paina varusteen mukana tullutta syöttötelaa, kunnes se  napsahtaa  paikalleen. Varmista, että metallijousi on syöttötelan edessä. Paina telan kantta, kunnes se  napsahtaa  paikalleen. Avaa etuluukku ja poista kansi tulostimen vasemmalta puolelta. Älä heitä ruuvia tai kantta pois. Sulje etuluukku. Irrota paperin siirtoyksikön liittimen kansi. Älä heitä kantta pois. Poista vasen takakansi. Älä heitä ruuvia tai kantta pois. Irrota alustan sisäkansi. Älä heitä ruuvia tai kantta pois. Kohdista ja aseta sitten varusteen mukana toimitettu sisempi alustan kansi. Asenna ruuvit alustan sisempään kanteen. Kiinnitä vaahtoteipin palat varusteeseen. Avaa luukku F ja kiristä ruuvit. Sulje luukku F. Kiinnitä metallinen kiinnike lisävarusteeseen. Laita varuste sisään. Varmista, että metallinen kiinnike on tulostimen etupuolella. Avaa luukku F ja asenna ruuvi lisävarusteen mukana tulleella ruuvitaltalla. Sulje luukku F. Asenna ruuvit lisävarusteeseen. Kiinnitä vasen takakansi. Avaa etuluukku ja kiinnitä kansi tulostimen vasemmalle puolelle. Sulje etuluukku. Nosta alustan läppä ja kohdista ja kiinnitä lisävarusteen alusta. Asenna ruuvit lisävarusteen alustaan. Kiinnitä verhoilukansi. Liitä lisävarusteen kaapeli tulostimeen. Liitä virtajohdon toinen pää tulostimeen ja toinen pää pistorasiaan. Tulipalo- tai sähköiskuriskin välttämiseksi kytke virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Kytke tulostimen virta. lisävarusteet paperin siirto taittovalinnalla paperin siirto taittovalinnalla asentaminen"},{"UUID":"fc54092b-2d12-40a3-8899-c273a2559f2b","title":"Lisävarusteiden asentaminen","link":"installing-optional-550-sheet-tray-topic.html","desc":"Nidonnan ja rei'ityksen viimeistelijän ja","descFull":"Nidonnan ja rei'ityksen viimeistelijän ja paperin siirtoyksikön asentaminen Jos käsittelet ohjainlevyä tai asennat lisävarusteita tai muistilaitteita tulostimen käyttöönoton jälkeen, sähköiskuvaaran välttämiseksi katkaise tulostimesta virta ja irrota virtajohto pistorasiasta ennen toimenpiteiden tekemistä. Jos tulostimeen on kytketty muita laitteita, katkaise niidenkin virta ja irrota kaikki tulostimeen kytketyt kaapelit. Tähän toimenpiteeseen tarvitaan tasapäistä ruuvitalttaa. Katkaise virta tulostimesta. Irrota virtajohto ensin pistorasiasta ja sitten tulostimesta. Poista paperin siirtoyksikkö pakkauksestaan. Poista vakioalusta. Älä heitä alustaa pois. Aseta vastaanottoalustan lippu suljettuun asentoon ennen lisävarusteen asentamista. Kun lisävaruste poistetaan, aseta vastaanottoalustan lippu avoimeen asentoon. Irrota taustatelan pidike. Älä heitä telaa pois. Paina paperin siirtoyksikön mukana tullutta syöttötelaa, kunnes se  napsahtaa  paikalleen. Varmista, että metallijousi on syöttötelan edessä. Paina kantta, kunnes se  napsahtaa  paikalleen. Avaa etuluukku ja poista kansi tulostimen vasemmalta puolelta. Älä heitä ruuvia tai kantta pois. Sulje etuluukku. Irrota paperin siirtoyksikön liittimen kansi. Älä heitä kantta pois. Irrota kansi. Älä heitä kantta pois. Kiinnitä metallinen kiinnike. Asenna paperin siirtoyksikkö. Avaa kahva G ja asenna sitten ruuvi paperin siirtoyksikön etuosaan. Sulje kahva G. Asenna ruuvi paperin siirtoyksikön takaosaan. Avaa etuluukku ja kiinnitä sitten paperin siirtoyksikön mukana tullut kansi tulostimen vasemmalle puolelle. Sulje etuluukku. Poista nidonnan ja rei'ityksen viimeistelijä pakkauksestaan. Asenna vakauttaja. Poista teipin palat viimeistelijän ympäriltä. Liitä kiinnike viimeistelijään. Kiinnitä vaahtoteippi viimeistelijään. Liitä syöttöohjain viimeistelijään. Liitä alusta viimeistelijään. Aseta viimeistelijän luukku ja aseta rei'ittimen laatikko sisään. Aseta alustan jatke viimeistelijän alustalle. Alustan jatketta käytetään A3-kokoiselle tai pidemmälle paperille ja korkean kosteuden olosuhteissa auttamaan paperin pinoamisessa. Alustan kapasiteetti pienenee, kun käytetään jatketta. Sulje viimeistelijän luukku. Kiinnitä asennuspidike tulostimeen. Varmista, että ruuvit ovat kohdakkain kiinnityskannattimen merkkien kanssa. Kiinnitä paperin siirtoyksikön mukana tullut metallinen kiinnike tulostimeen. Avaa viimeistelijän luukku, irrota ruuvi ja vedä sitten viimeistelijän lukosta. Liitä viimeistelijä tulostimeen. Lukitse viimeistelijä tulostimeen ja asenna ruuvi. Liitä viimeistelijän kaapeli tulostimeen. Liitä virtajohdon toinen pää tulostimeen ja toinen pää pistorasiaan. Tulipalo- tai sähköiskuriskin välttämiseksi kytke virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Kytke tulostimen virta. lisävarusteet paperin siirtoyksikkö lisävarusteet nidonnan ja rei'ityksen viimeistelijä paperin siirtoyksikkö asentaminen nidonnan ja rei'ityksen viimeistelijä asentaminen"},{"UUID":"3769afa4-dd17-4a86-8eff-8ff0cafb10f4","title":"Lisävarusteiden asentaminen","link":"installing-optional-550-sheet-tray-topic.html","desc":"Nidonnan ja rei'ityksen viimeistelijän ja","descFull":"Nidonnan ja rei'ityksen viimeistelijän ja paperin siirtoyksikön taittomahdollisuudella asentaminen Jos käsittelet ohjainlevyä tai asennat lisävarusteita tai muistilaitteita tulostimen käyttöönoton jälkeen, sähköiskuvaaran välttämiseksi katkaise tulostimesta virta ja irrota virtajohto pistorasiasta ennen toimenpiteiden tekemistä. Jos tulostimeen on kytketty muita laitteita, katkaise niidenkin virta ja irrota kaikki tulostimeen kytketyt kaapelit. Tähän toimenpiteeseen tarvitaan tasapäistä ruuvitalttaa. Katkaise virta tulostimesta. Irrota virtajohto ensin pistorasiasta ja sitten tulostimesta. Pura paperin siirtoyksikkö taittomahdollisuudella pakkauksesta ja poista sitten kaikki pakkausmateriaalit. Poista vakioalusta. Älä heitä alustaa pois. Aseta vastaanottoalustan lippu suljettuun asentoon ennen lisävarusteen asentamista. Kun lisävaruste poistetaan, aseta vastaanottoalustan lippu avoimeen asentoon. Irrota taustatelan pidike. Älä heitä telaa pois. Paina varusteen mukana tullutta syöttötelaa, kunnes se  napsahtaa  paikalleen. Varmista, että metallijousi on syöttötelan edessä. Paina kantta, kunnes se  napsahtaa  paikalleen. Avaa etuluukku ja poista kansi tulostimen vasemmalta puolelta. Älä heitä ruuvia tai kantta pois. Sulje etuluukku. Irrota paperin siirtoyksikön liittimen kansi. Älä heitä kantta pois. Poista vasen takakansi. Älä heitä ruuvia tai kantta pois. Irrota alustan sisäkansi. Älä heitä ruuvia tai kantta pois. Kohdista ja aseta sitten sisäalustan kansi, joka tuli paperin siirtoyksikön taittovaihtoehdolla mukana. Asenna ruuvit alustan sisempään kanteen. Kiinnitä vaahtoteipin palat varusteeseen. Avaa luukku F ja kiristä ruuvit. Sulje luukku F. Kiinnitä kiinnike lisävarusteeseen. Laita varuste sisään. Varmista, että metallinen kiinnike on tulostimen etupuolella. Avaa luukku F ja asenna ruuvi lisävarusteen mukana tulleella ruuvitaltalla. Sulje luukku F. Asenna ruuvit lisävarusteeseen. Kiinnitä vasen takakansi. Poista nidonnan ja rei'ityksen viimeistelijä pakkauksestaan. Asenna vakauttaja. Poista teipin palat viimeistelijän ympäriltä. Liitä kiinnike viimeistelijään. Kiinnitä vaahtoteippi viimeistelijään. Poista pieni vaahtopala viimeistelylaitteen oikealta puolelta. Liitä syöttöohjain viimeistelijään. Liitä alusta viimeistelijään. Aseta viimeistelijän luukku ja aseta rei'ittimen laatikko sisään. Aseta alustan jatke viimeistelijän alustalle. Alustan jatketta käytetään A3-kokoiselle tai pidemmälle paperille ja korkean kosteuden olosuhteissa auttamaan paperin pinoamisessa. Alustan kapasiteetti pienenee, kun käytetään jatketta. Sulje viimeistelijän luukku. Nosta alustan läppä ja kohdista ja kiinnitä kansi lisävarusteeseen. Asenna ruuvit. Avaa etuluukku ja kiinnitä sitten lisävarusteen mukana tullut verhoilukansi. Kiinnitä asennuspidike tulostimeen. Varmista, että ruuvit ovat kohdakkain kiinnityskannattimen merkkien kanssa. Avaa viimeistelijän luukku, irrota ruuvi ja vedä sitten viimeistelijän lukosta. Liitä lisävarusteen kaapeli tulostimeen. Liitä viimeistelijän kaapeli lisävarusteeseen. Liitä viimeistelijä tulostimeen. Lukitse viimeistelijä tulostimeen ja asenna ruuvi. Sulje viimeistelijän luukku. Liitä virtajohdon toinen pää tulostimeen ja toinen pää pistorasiaan. Tulipalo- tai sähköiskuriskin välttämiseksi kytke virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Kytke tulostimen virta. lisävarusteet paperin siirto taittovalinnalla lisävarusteet nidonnan ja rei'ityksen viimeistelijä paperin siirto taittovalinnalla asentaminen nidonnan ja rei'ityksen viimeistelijä asentaminen"},{"UUID":"88a9611b-260d-4f82-9122-83768e87c6f9","title":"Lisävarusteiden asentaminen","link":"installing-optional-550-sheet-tray-topic.html","desc":"Vihkoviimeistelijän ja paperin siirtoyksikön asentaminen","descFull":"Vihkoviimeistelijän ja paperin siirtoyksikön asentaminen Jos käsittelet ohjainlevyä tai asennat lisävarusteita tai muistilaitteita tulostimen käyttöönoton jälkeen, sähköiskuvaaran välttämiseksi katkaise tulostimesta virta ja irrota virtajohto pistorasiasta ennen toimenpiteiden tekemistä. Jos tulostimeen on kytketty muita laitteita, katkaise niidenkin virta ja irrota kaikki tulostimeen kytketyt kaapelit. Tähän toimenpiteeseen tarvitaan tasapäistä ruuvitalttaa. Katkaise virta tulostimesta. Irrota virtajohto ensin pistorasiasta ja sitten tulostimesta. Poista paperin siirtoyksikkö pakkauksestaan. Poista vakioalusta. Älä heitä alustaa pois. Aseta vastaanottoalustan lippu suljettuun asentoon ennen lisävarusteen asentamista. Kun lisävaruste poistetaan, aseta vastaanottoalustan lippu avoimeen asentoon. Irrota taustatelan pidike. Älä heitä telaa pois. Paina paperin siirtoyksikön mukana tullutta syöttötelaa, kunnes se  napsahtaa  paikalleen. Varmista, että metallijousi on syöttötelan edessä. Paina telan kantta, kunnes se  napsahtaa  paikalleen. Avaa etuluukku ja poista kansi tulostimen vasemmalta puolelta. Älä heitä ruuvia tai kantta pois. Sulje etuluukku. Irrota paperin siirtoyksikön liittimen kansi. Älä heitä kantta pois. Irrota kansi. Älä heitä kantta pois. Kiinnitä metallinen kiinnike. Asenna paperin siirtoyksikkö. Avaa kahva G ja asenna sitten ruuvi paperin siirtoyksikön etuosaan. Sulje kahva G. Asenna ruuvi paperin siirtoyksikön takaosaan. Avaa etuluukku ja kiinnitä sitten paperin siirtoyksikön mukana tullut kansi tulostimen vasemmalle puolelle. Sulje etuluukku. Poista vihkoviimeistelijä pakkauksesta ja poista sitten pakkausmateriaali. Liitä kiinnike viimeistelijään. Kiinnitä vaahtoteippi viimeistelijään. Liitä syöttöohjain viimeistelijään. Liitä yläalusta viimeistelijään. Nosta alustan läppä ja kiinnitä sitten alempi alusta viimeistelijään. Avaa viimeistelijän kansi. Poista pakkausmateriaali rei'ittimen laatikosta ja aseta se sitten viimeistelijään. Aseta alustan jatke viimeistelijän alustalle. Alustan jatketta käytetään A3-kokoiselle tai pidemmälle paperille ja korkean kosteuden olosuhteissa auttamaan paperin pinoamisessa. Alustan kapasiteetti pienenee, kun käytetään jatketta. Kiinnitä kori viimeistelijän takaosaan. Sulje viimeistelijän luukku. Kiinnitä asennuspidike tulostimeen. Varmista, että ruuvit ovat kohdakkain kiinnityskannattimen merkkien kanssa. Kiinnitä paperin siirtoyksikön mukana tullut kiinnike tulostimeen. Avaa viimeistelijän luukku, irrota ruuvi ja vedä sitten viimeistelijän lukosta. Liitä viimeistelijä tulostimeen. Lukitse viimeistelijä tulostimeen ja asenna ruuvi. Sulje viimeistelijän luukku. Liitä viimeistelijän kaapeli tulostimeen. Liitä virtajohdon toinen pää tulostimeen ja toinen pää pistorasiaan. Tulipalo- tai sähköiskuriskin välttämiseksi kytke virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Kytke tulostimen virta. paperin siirtoyksikön asentaminen asentaminen paperin siirtoyksikkö vihkoviimeistelijän asentaminen asentaminen vihkoviimeistelijä"},{"UUID":"1d8a31ff-7d6d-47b3-a5b7-db9d900708d3","title":"Lisävarusteiden asentaminen","link":"installing-optional-550-sheet-tray-topic.html","desc":"Vihkoviimeistelijän ja taittomahdollisuudella varustetun paperin","descFull":"Vihkoviimeistelijän ja taittomahdollisuudella varustetun paperin siirtoyksikön asentaminen Jos käsittelet ohjainlevyä tai asennat lisävarusteita tai muistilaitteita tulostimen käyttöönoton jälkeen, sähköiskuvaaran välttämiseksi katkaise tulostimesta virta ja irrota virtajohto pistorasiasta ennen toimenpiteiden tekemistä. Jos tulostimeen on kytketty muita laitteita, katkaise niidenkin virta ja irrota kaikki tulostimeen kytketyt kaapelit. Tähän toimenpiteeseen tarvitaan tasapäistä ruuvitalttaa. Katkaise virta tulostimesta. Irrota virtajohto ensin pistorasiasta ja sitten tulostimesta. Pura taittomahdollisuudella varustettu paperin siirtoyksikkö pakkauksestaan. Poista vakioalusta. Älä heitä alustaa pois. Aseta vastaanottoalustan lippu suljettuun asentoon ennen lisävarusteen asentamista. Kun lisävaruste poistetaan, aseta vastaanottoalustan lippu avoimeen asentoon. Irrota taustatelan pidike. Älä heitä telaa pois. Paina varusteen mukana tullutta syöttötelaa, kunnes se  napsahtaa  paikalleen. Varmista, että metallijousi on syöttötelan edessä. Paina telan kantta, kunnes se  napsahtaa  paikalleen. Avaa etuluukku ja poista kansi tulostimen vasemmalta puolelta. Älä heitä ruuvia tai kantta pois. Sulje etuluukku. Irrota paperin siirtoyksikön liittimen kansi. Älä heitä kantta pois. Poista vasen takakansi. Älä heitä ruuvia tai kantta pois. Irrota alustan sisäkansi. Älä heitä ruuvia tai kantta pois. Kohdista ja aseta sitten varusteen mukana toimitettu sisempi alustan kansi. Asenna ruuvit alustan sisempään kanteen. Kiinnitä vaahtoteipin palat varusteeseen. Avaa luukku F ja kiristä ruuvit. Sulje luukku F. Kiinnitä kiinnike lisävarusteeseen. Laita varuste sisään. Varmista, että metallinen kiinnike on tulostimen etupuolella. Avaa luukku F ja asenna ruuvi lisävarusteen mukana tulleella ruuvitaltalla. Sulje luukku F. Asenna ruuvit lisävarusteeseen. Kiinnitä vasen takakansi. Poista vihkoviimeistelijä pakkauksesta ja poista sitten pakkausmateriaali. Liitä kiinnike viimeistelijään. Kiinnitä vaahtoteippi viimeistelijään. Liitä syöttöohjain viimeistelijään. Liitä yläalusta viimeistelijään. Nosta alustan läppä ja kiinnitä sitten alempi alusta viimeistelijään. Avaa viimeistelijän kansi. Poista pakkausmateriaali rei'ittimen laatikosta ja aseta se sitten viimeistelijään. Aseta alustan jatke viimeistelijän alustalle. Alustan jatketta käytetään A3-kokoiselle tai pidemmälle paperille ja korkean kosteuden olosuhteissa auttamaan paperin pinoamisessa. Alustan kapasiteetti pienenee, kun käytetään jatketta. Kiinnitä kori viimeistelijän takaosaan. Sulje viimeistelijän luukku. Nosta alustan läppä ja kohdista ja kiinnitä kansi lisävarusteeseen. Asenna ruuvit. Avaa etuluukku ja kiinnitä sitten lisävarusteen mukana tullut verhoilukansi. Kiinnitä asennuspidike tulostimeen. Varmista, että ruuvit ovat kohdakkain kiinnityskannattimen merkkien kanssa. Avaa viimeistelijän luukku, irrota ruuvi ja vedä sitten viimeistelijän lukosta. Liitä lisävarusteen kaapeli tulostimeen. Liitä viimeistelijän kaapeli lisävarusteeseen. Liitä viimeistelijä tulostimeen. Lukitse viimeistelijä tulostimeen ja asenna ruuvi. Sulje viimeistelijän luukku. Liitä virtajohdon toinen pää tulostimeen ja toinen pää pistorasiaan. Tulipalo- tai sähköiskuriskin välttämiseksi kytke virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Kytke tulostimen virta. lisävarusteet paperin siirto taittovalinnalla lisävarusteet vihkoviimeistelijä paperin siirto taittovalinnalla asentaminen vihkoviimeistelijä asentaminen"},{"UUID":"403db85c-1733-4a35-bc2e-823ec11ddbac","title":"Lisävarusteiden asentaminen","link":"installing-optional-550-sheet-tray-topic.html","desc":"Näppäimistöhyllyn asentaminen Katkaise virta tulostimesta.","descFull":"Näppäimistöhyllyn asentaminen Katkaise virta tulostimesta. Avaa luukku B. Irrota etukansi ja sulje sitten luukku B. Pura näppäimistöhylly pakkauksesta. Aseta näppäimistön kaapeli hyllyyn. Kierrä kaapeli hyllyn sisään. Irrota suojatarra. Kohdista ja kiinnitä näppäimistö alustaan. Kohdista hylly, liitä näppäimistön kaapeli tulostimeen, aseta hylly paikalleen ja kiinnitä se sitten tulostimeen. Kytke tulostimen virta. lisävarusteet näppäimistö näppäimistö asentaminen näppäimistöhyllyn asentaminen"},{"UUID":"33c56394-de25-4296-ab69-0368196d9442","title":"Lisävarusteiden asentaminen","link":"installing-optional-550-sheet-tray-topic.html","desc":"Faksikortin asentaminen Jos käsittelet ohjainlevyä","descFull":"Faksikortin asentaminen Jos käsittelet ohjainlevyä tai asennat lisävarusteita tai muistilaitteita tulostimen käyttöönoton jälkeen, sähköiskuvaaran välttämiseksi katkaise tulostimesta virta ja irrota virtajohto pistorasiasta ennen toimenpiteiden tekemistä. Jos tulostimeen on kytketty muita laitteita, katkaise niidenkin virta ja irrota kaikki tulostimeen kytketyt kaapelit. Tähän toimenpiteeseen tarvitaan tasapäistä ruuvitalttaa. Katkaise virta tulostimesta. Irrota virtajohto ensin pistorasiasta ja sitten tulostimesta. Avaa emolevyn kansi. Staattinen sähkö vahingoittaa helposti emolevyn elektronisia osia. Kosketa jotakin tulostimen metalliosaa, ennen kuin kosketat emolevyn elektronisia osia tai liittimiä. Irrota faksiportin suojus. Älä heitä ruuvia tai kantta pois. Poista faksikortti pakkauksestaan. Liitä faksin kaapeli ohjainlevyyn. Kohdista ja asenna faksikortti tulostimeen. Sulje ohjainlevyn kansi, kunnes se  napsahtaa  paikalleen, ja asenna sitten ruuvi. Liitä virtajohdon toinen pää tulostimeen ja toinen pää pistorasiaan. Tulipalon tai sähköiskun vaaran välttämiseksi liitä virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Kytke tulostimen virta. faksikortti asentaminen sisäisten lisävarusteiden asentaminen faksikortti"},{"UUID":"23cd33de-c6bc-43e2-9da8-92db794ae744","title":"Lisävarusteiden asentaminen","link":"installing-optional-550-sheet-tray-topic.html","desc":"Kortinlukijan asentaminen Jos käsittelet ohjainlevyä","descFull":"Kortinlukijan asentaminen Jos käsittelet ohjainlevyä tai asennat lisävarusteita tai muistilaitteita tulostimen käyttöönoton jälkeen, sähköiskuvaaran välttämiseksi katkaise tulostimesta virta ja irrota virtajohto pistorasiasta ennen toimenpiteiden tekemistä. Jos tulostimeen on kytketty muita laitteita, katkaise niidenkin virta ja irrota kaikki tulostimeen kytketyt kaapelit. Katkaise virta tulostimesta. Avaa luukku B. Avaa etuosan USB-portin kansi. Irrota alemman USB-portin kansi. Jos tulostimessasi ei ole tätä osaa, siirry seuraavaan vaiheeseen. Irrota suojakansi kortinlukijasta. Aseta kortinlukija paikalleen. Kiinnitä portin alempi kansi paikalleen siten, että se  napsahtaa  paikalleen. Kiinnitä ohjetarra. Kiinnitä etuosan USB-portin kansi paikalleen siten, että se  napsahtaa  paikalleen. Sulje luukkua B, kunnes se  napsahtaa  paikalleen. Kytke tulostimen virta. kortinlukija asentaminen sisäiset lisälaitteet kortinlukija"},{"UUID":"62c58c3b-e7d3-4704-9947-d4c3064e939a","title":"Lisävarusteiden asentaminen","link":"installing-optional-550-sheet-tray-topic.html","desc":"Sisäisen sovellusportin asentaminen Sisäisen sovellusportin","descFull":"Sisäisen sovellusportin asentaminen Sisäisen sovellusportin asentaminen Jos käsittelet ohjainlevyä tai asennat lisävarusteita tai muistilaitteita tulostimen käyttöönoton jälkeen, sähköiskuvaaran välttämiseksi katkaise tulostimesta virta ja irrota virtajohto pistorasiasta ennen toimenpiteiden tekemistä. Jos tulostimeen on kytketty muita laitteita, katkaise niidenkin virta ja irrota kaikki tulostimeen kytketyt kaapelit. Tähän toimenpiteeseen tarvitaan tasapäistä ruuvitalttaa. Katkaise virta tulostimesta. Irrota virtajohto ensin pistorasiasta ja sitten tulostimesta.  Avaa emolevyn kansi. Staattinen sähkö vahingoittaa helposti emolevyn elektronisia osia. Kosketa jotakin tulostimen metalliosaa, ennen kuin kosketat emolevyn elektronisia osia tai liittimiä. Poista sisäisen sovellusportin (ISP) kansi. Älä heitä ruuvia tai kantta pois. Pura sisäisen sovellusportin sarja pakkauksesta. Sisäisen sovellusportin sarjan osat 1 Sisäinen sovellusportti 2 Sisäisen sovellusportin jatkokaapeli 3 Asennuspidike 4 Sormiruuvit Kiinnitä asennuspidike ohjainlevyyn siten, että se  napsahtaa  paikalleen. Kiinnitä ISP asennuspidikkeeseen ja liitä sitten ISP:n pidennetty kaapeli sen liittimeen ohjainkortilla. Kiinnitä sisäinen sovellusportti tulostimeen. Sulje ohjainlevyn kansi. Liitä virtajohdon toinen pää tulostimeen ja toinen pää pistorasiaan. Tulipalon tai sähköiskun vaaran välttämiseksi liitä virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Kytke tulostimen virta. sisäinen sovellusportti asentaminen lisävarusteiden asentaminen sisäinen sovellusportti"},{"UUID":"ccdea2c4-d664-40d8-8977-f47d0909b334","title":"Lisävarusteiden asentaminen","link":"installing-optional-550-sheet-tray-topic.html","desc":"Tulostimen porttiasetusten muuttaminen sisäisen sovellusportin","descFull":"Tulostimen porttiasetusten muuttaminen sisäisen sovellusportin asentaminen jälkeen Jos tulostimella on kiinteä IP-osoite, älä muuta määrityksiä. Jos tietokoneet on määritetty käyttämään verkkonimeä IP-osoitteen sijaan, älä muuta määrityksiä. Jos lisäät langattoman sisäisen sovellusportin (ISP) tulostimeen, jossa on aiemmin käytetty Ethernet-verkkoyhteyttä, irrota tulostin Ethernet-verkosta. Windows-käyttäjät: Avaa Tulostimet-kansio. Avaa tulostusominaisuudet sen tulostimen pikakuvakevalikosta, jossa on uusi ISP. Määritä portti luettelosta. Päivitä IP-osoite. Ota muutokset käyttöön. Macintosh-käyttäjät: Valitse Apple-valikosta Järjestelmän määritykset (System Preferences) ja etsi tulostinluettelo. Valitse sitten  + IP . Kirjoita IP-osoite osoitekenttään. Ota muutokset käyttöön. tulostimen porttiasetukset muuttaminen tulostimen porttiasetusten muuttaminen sisäisen sovellusportin (ISP) asentamisen jälkeen"},{"UUID":"cd8a9492-473a-4b9b-93e4-817b938fda01","title":"Verkkoyhteydet","link":"connecting-printer-to-wireless-network-topic.html","desc":"Tulostimen yhdistäminen Wi‑Fi-verkkoon Tarkista seuraavat","descFull":"Tulostimen yhdistäminen Wi‑Fi-verkkoon Tarkista seuraavat asiat ennen aloittamista: Aktiivinen sovitin  -asetuksen arvoksi on valittu  Autom . Valitse ohjauspaneelissa  Asetukset Verkko/portit Verkon esittely Aktiivinen sovitin . Ethernet-kaapeli on irti tulostimesta. Ohjauspaneelin käyttäminen Siirry ohjauspaneelissa kohtaan  Asetukset Verkko/portit Langaton Määritä tulostimen ohjauspaneelissa Valitse verkko . Valitse Wi‑Fi-verkko ja kirjoita verkon salasana. Tulostimissa, joissa on sisäänrakennettu Wi-Fi-ominaisuus, Wi-Fi-verkon määrittämistä koskeva kehote tulee näkyviin alkuasennuksen aikana. tulostimen liittäminen Wi‑Fi-verkkoon tulostimen yhdistäminen langattomaan verkkoon langaton verkkoyhteys"},{"UUID":"e48af103-b816-442a-9f03-3c84fd5fbdd3","title":"Verkkoyhteydet","link":"connecting-printer-to-wireless-network-topic.html","desc":"Tulostimen liittäminen langattomaan verkkoon Wi-Fi","descFull":"Tulostimen liittäminen langattomaan verkkoon Wi-Fi Protected Setup (WPS) -toiminnon avulla Tarkista seuraavat asiat ennen aloittamista: Tarkista, että langaton yhteyspiste (langaton reititin) on WPS-sertifioitu tai WPS-yhteensopiva. Lisätietoja on yhteyspisteen käyttöohjeissa. Varmista, että tulostimeen on asennettu langaton verkkosovitin. Lisätietoja on sovittimen mukana toimitetuissa ohjeissa. Aktiivinen sovitin  -asetuksen arvoksi on valittu  Autom . Valitse ohjauspaneelissa  Asetukset Verkko/portit Verkon esittely Aktiivinen sovitin . Painonäppäinmenetelmän käyttäminen Valitse ohjauspaneelissa  Asetukset Verkko/portit Langaton Wi‑Fi Protected Setup Käynnistä painonäppäinmenetelmä . Seuraa näytön ohjeita. PIN-koodi ‑menetelmän käyttäminen Valitse ohjauspaneelissa  Asetukset Verkko/portit Langaton Wi‑Fi Protected Setup Käynnistä PIN-kooditila . Kopioi kahdeksan numeroa sisältävä WPS PIN-koodi. Avaa selain ja kirjoita yhteyspisteen IP-osoite osoitekenttään. Lisätietoja IP-osoitteesta on yhteyspisteen käyttöohjeissa. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Siirry WPS-asetuksiin. Lisätietoja on yhteyspisteen käyttöohjeissa. Anna 8-numeroinen PIN-koodi ja tallenna muutokset. Wi-Fi Protected Setup langaton verkko langaton verkko Wi-Fi Protected Setup yhteyden muodostaminen langattomaan verkkoon PIN-koodi -menetelmän käyttäminen yhteyden muodostaminen langattomaan verkkoon painonäppäinmenetelmän käyttäminen"},{"UUID":"106744d8-ae5c-4d46-9e0f-5aa228720f21","title":"Verkkoyhteydet","link":"connecting-printer-to-wireless-network-topic.html","desc":"Wi-Fi Directin määrittäminen Wi-Fi Direct","descFull":"Wi-Fi Directin määrittäminen Wi-Fi Direct  -tekniikan avulla langattomat laitteet voivat muodostaa suoran yhteyden toisiinsa ilman tukiasemaa (langatonta reititintä). Siirry ohjauspaneelista kohtaan  Asetukset Verkko/Portit Wi-Fi Direct . Määritä asetukset. Ota käyttöön Wi-Fi Direct : määrittää tulostimen käyttämään omaa Wi‑Fi Direct -verkkoaan. Wi‑Fi Direct -nimi : määrittää Wi‑Fi Direct -verkolle nimen. Wi‑Fi Direct -salasana : määrittää salasanan langatonta suojausta varten käytettäessä vertaisverkkoyhteyttä. Näytä salasana asetussivulla : näyttää salasanan verkkoasetussivulla. Ensisijaisen kanavan numero  – määrittää Wi-Fi Direct -verkon ensisijaisen kanavan. Ryhmän omistajan IP-osoite  – määrittää ryhmän omistajan IP-osoitteen. Hyväksy painonäppäinpyynnöt automaattisesti : sallii tulostimen hyväksyä yhteyspyynnöt automaattisesti. Painonäppäinpyyntöjen automaattinen hyväksyntä ei ole suojattua. Wi-Fi Direct -verkkosalasana ei näy oletusarvoisesti tulostimen näytössä. Näytä salasana ottamalla käyttöön salasanan katsomiskuvake. Valitse ohjauspaneelissa  Asetukset Suojaus Muut Ota käyttöön salasanan/PIN-koodin paljastus . Jos haluat tietää Wi-Fi Direct -verkon salasanan näyttämättä sitä tulostimen näytössä, tulosta  Verkkoasetussivu . Siirry ohjauspaneelista kohtaan  Asetukset Raportit Verkko Verkkoasetussivu . Wi‑Fi Direct konfigurointi Wi-Fi Directin määrittäminen"},{"UUID":"28cfd574-344f-4002-915e-458925328603","title":"Verkkoyhteydet","link":"connecting-printer-to-wireless-network-topic.html","desc":"Mobiililaitteen liittäminen tulostimeen Varmista ennen","descFull":"Mobiililaitteen liittäminen tulostimeen Varmista ennen mobiililaitteen yhdistämistä, että Wi‑Fi Direct on määritetty. Lisätietoja on kohdassa  . Wi-Fi Direct -toiminnon käyttäminen Nämä ohjeet koskevat vain mobiililaitteita, jotka käyttävät  Android -alustaa. Siirry mobiililaitteessa  Asetukset -valikkoon. Ota  Wi‑Fi  käyttöön ja valitse  Wi‑Fi Direct . Valitse tulostimen Wi-Fi Direct -nimi. Vahvista yhteys tulostimen ohjauspaneelissa. Wi-Fi:n käyttäminen Siirry mobiililaitteessa  Asetukset -valikkoon. Valitse  Wi-Fi  ja sitten tulostimen Wi‑Fi Direct -nimi. Merkkijono DIRECT-xy (jossa x ja y ovat kaksi satunnaista merkkiä) lisätään Wi-Fi Direct -nimen eteen. Kirjoita Wi‑Fi Direct -salasana. mobiililaitteen liittäminen tulostimelle liittäminen tulostimeen Wi-Fi Direct -toiminnon käyttäminen"},{"UUID":"4872d40d-e67a-494f-bbde-8f6636e93a9d","title":"Verkkoyhteydet","link":"connecting-printer-to-wireless-network-topic.html","desc":"Wi‑Fi Direct Tietokoneen yhdistäminen tulostimeen","descFull":"Wi‑Fi Direct Tietokoneen yhdistäminen tulostimeen Tietokone on helppo yhdistää tulostimeen Wi‑Fi Direct -toiminnolla. Lisätietoja on kohdassa  . Windows-käyttäjät: Avaa  Tulostimet & skannerit  ja valitse  Lisää tulostin tai skanneri . Valitse  Näytä Wi-Fi Direct -tulostimet  ja valitse tulostimen Wi‑Fi Direct -nimi. Huomioi tulostimen kahdeksannumeroinen PIN-koodi tulostimen näytössä. Kirjoita PIN-koodi tietokoneella. Jos tulostinohjainta ei ole asennettu, Windows lataa asianmukaisen ohjaimen. Macintosh-käyttäjät: Valitse langaton kuvake ja valitse tulostimen Wi‑Fi Direct -nimi. Merkkijono DIRECT-xy (jossa x ja y ovat kaksi satunnaista merkkiä) lisätään Wi-Fi Direct -nimen eteen. Kirjoita Wi‑Fi Direct -salasana. Siirrä tietokone takaisin aiempaan verkkoon, kun olet katkaissut sen yhteyden Wi-Fi Direct -verkkoon. tietokoneen liittäminen tulostimeen"},{"UUID":"165515d8-e05a-467e-8a50-837acd73d324","title":"Verkkoyhteydet","link":"connecting-printer-to-wireless-network-topic.html","desc":"Wi‑Fi-verkon poistaminen käytöstä Valitse ohjauspaneelissa","descFull":"Wi‑Fi-verkon poistaminen käytöstä Valitse ohjauspaneelissa  Asetukset Verkko/portit Verkon yleiskatsaus Aktiivinen sovitin Vakioverkko . Käynnistä tulostin uudelleen valitsemalla  Kyllä  . Wi‑Fi-verkon poistaminen käytöstä Wi‑Fi-verkon poistaminen käytöstä"},{"UUID":"edbc5c05-b7aa-4031-996d-753f6dd3730d","title":"Verkkoyhteydet","link":"connecting-printer-to-wireless-network-topic.html","desc":"Tulostimen yhteyden tarkistaminen Tulostimen yhteyden","descFull":"Tulostimen yhteyden tarkistaminen Tulostimen yhteyden tarkistaminen Siirry ohjauspaneelista kohtaan  Asetukset Raportit Verkko Verkkoasetussivu . Tarkista sivun ensimmäinen osa ja varmista, että yhteys on muodostettu. Jos yhteyttä ei ole muodostettu, lähiverkkoliitin ei ehkä ole aktiivinen tai verkkokaapeli voi olla viallinen. Kysy lisätietoja järjestelmänvalvojalta. verkkoyhteyden tarkistaminen tulostimen yhteys verkkoon tarkistaminen"},{"UUID":"921596f6-bdc4-4619-bdfc-89cddd8474fd","title":"Verkkoyhteydet","link":"connecting-printer-to-wireless-network-topic.html","desc":"Sarjatulostuksen määrittäminen (koskee vain Windowsia)","descFull":"Sarjatulostuksen määrittäminen (koskee vain Windowsia) Määritä parametrit tulostimessa. Siirry ohjauspaneelissa porttiasetusten valikkoon. Paikanna sarjaporttiasetusten valikko ja muuta asetuksia tarvittaessa. Ota muutokset käyttöön. Avaa tietokoneessa Tulostimet-kansio ja valitse tulostin. Avaa tulostusominaisuudet ja valitse COM-portti luettelosta. Määritä COM-portin parametrit Laitehallinnassa. Sarjatulostus hidastaa tulostusnopeutta. Varmista, että sarjakaapeli on liitetty tulostimen sarjaporttiin. sarjatulostuksen määrittäminen sarjatulostus asennus"},{"UUID":"b78f0cbb-edee-4b2e-9910-8cdc6f624420","title":"Tulostimen suojaaminen","link":"erasing-printer-memory-topic.html","desc":"Tulostinmuistin tyhjentäminen Kun haluat tyhjentää","descFull":"Tulostinmuistin tyhjentäminen Kun haluat tyhjentää siirrettävän muistin tai puskuroidut tiedot tulostimesta, katkaise tulostimesta virta. Voit tyhjentää pysyvän muistin, laite- ja verkkoasetukset, suojausasetukset ja upotetut ratkaisut seuraavien ohjeiden mukaisesti: Siirry ohjauspaneelista kohtaan  Asetukset Laite Huolto Poistaminen . Valitse  Poista kaikki tiedot pysyvästä muistista  ja valitse sitten  TYHJENNÄ . Valitse  Käynnistä ohjattu alkumääritys  tai  Jätä tulostin offline-tilaan  ja valitse  Seuraava . Aloita prosessi. Prosessi myös tuhoaa salausavaimen, jota käytetään käyttäjätietojen suojaamiseen. Tietoja ei voi palauttaa, jos salausavain tuhotaan. siirrettävä muisti tyhjentäminen pysyvä muisti tyhjentäminen tulostinmuisti tyhjentäminen tyhjentäminen tulostinmuisti tyhjentäminen siirrettävä muisti tyhjentäminen pysyvä muisti"},{"UUID":"926b0ef1-0aab-47ee-865c-8cf8eeff0a9c","title":"Tulostimen suojaaminen","link":"erasing-printer-storage-drive-topic.html","desc":"Tulostimen tallennusaseman tyhjentäminen Tulostimen tallennusaseman","descFull":"Tulostimen tallennusaseman tyhjentäminen Tulostimen tallennusaseman tyhjentäminen Siirry ohjauspaneelista kohtaan  Asetukset Laite Huolto Poistaminen . Tee tulostimeen asennetun tallennusaseman mukaan jompikumpi seuraavista: Kiintolevy: valitse  Tyhjennä kaikki tiedot kiintolevyltä , valitse  TYHJENNÄ  ja valitse tietojen poistomenetelmä. Kiintolevyn tyhjennys voi kestää muutamasta minuutista yli tuntiin. Tänä aikana tulostin ei ole käytettävissä. Jos haluat käyttää älykästä tallennusasemaa, valitse  Tyhjennä kryptologisesti kaikki käyttäjän tiedot ISD:stä  ja valitse sitten  TYHJENNÄ . tallennusasema tyhjentäminen kiintolevy tyhjentäminen älykäs tallennusasema tyhjentäminen tyhjentäminen tallennusasema tyhjentäminen kiintolevy tyhjentäminen älykäs tallennusasema"},{"UUID":"525de7d8-52a7-40ce-a3c9-c6df93b815b1","title":"Tulostimen suojaaminen","link":"restoring-factory-default-settings-topic.html","desc":"Tehdasasetusten palautus Siirry ohjauspaneelista kohtaan","descFull":"Tehdasasetusten palautus Siirry ohjauspaneelista kohtaan  Asetukset Laite Palauta tehdasasetukset . Valitse  Palauta asetukset . Valitse asetukset, jotka haluat palauttaa, ja valitse sitten  PALAUTA . oletusasetukset palauttaminen tulostusasetukset oletusasetusten palauttaminen"},{"UUID":"cdb8a518-8541-4c52-9b5d-76193dbb49b6","title":"Tulostimen suojaaminen","link":"statement-of-volatility-topic.html","desc":"Haihtuvuusjulistus Haihtuvuusjulistus Muistityypit ja niiden","descFull":"Haihtuvuusjulistus Haihtuvuusjulistus Muistityypit ja niiden kuvaukset Muistityyppi Kuvaus Siirrettävä muisti Tulostimessa käytetään vakiomuotoista työmuistia (RAM), johon käyttäjätiedot puskuroidaan väliaikaisesti yksinkertaisten tulostus- ja kopiointitöiden aikana. Pysyvä muisti Tulostimessa voi olla kahdenlaista pysyvää muistia: EEPROM ja NAND (flash-muisti). Kumpaakin tyyppiä käytetään käyttöjärjestelmän, tulostimen asetusten ja verkon tietojen tallentamiseen. Niihin tallennetaan myös skannerin ja kirjanmerkkien asetukset sekä upotetut ratkaisut. Kiintolevyasema Joihinkin tulostimiin on voitu asentaa kiintolevy. Tulostimen kiintolevy on tarkoitettu tulostinkohtaisia toimintoja varten. Kiintolevyn avulla tulostin voi säilyttää puskuroituja käyttäjätietoja, kun kyseessä on monimutkainen tulostustyö. Lisäksi kiintolevyllä voi olla lomake- ja fonttitietoja. Älykäs tallennusasema Joihinkin tulostimiin on voitu asentaa älykäs tallennusasema. Älykkään tallennusaseman pysyvään flash-muistiin tallennetaan monimutkaisten tulostustöiden käyttäjätietoja sekä lomake- ja fonttitietoja. Tyhjennä tulostimeen asennetun muistin sisältö seuraavissa tilanteissa: Tulostin poistetaan käytöstä. Tulostimen kiintolevy tai älykäs tallennusasema vaihdetaan. Tulostin siirretään toiselle osastolle tai toiseen paikkaan. Tulostin huolletaan organisaation ulkopuolella. Tulostin lähetetään toimitilojen ulkopuolelle huoltoa varten. Tulostin myydään toiseen organisaatioon. Hävitä tallennusasemat organisaatiosi käytäntöjen ja ohjeiden mukaisesti. haihtuvuusjulistus siirrettävä muisti Pysyvä muisti kiintolevyasema älykäs tallennusasema tulostinmuistin tyhjentäminen tulostimen tietojen suojaaminen"},{"UUID":"01e03fdd-ebac-4b4e-8b08-afd5b7169d3c","title":"Tulostaminen","link":"printing-from-computer-topic.html","desc":"Tulostaminen tietokoneella Windows-käyttäjät: Kun asiakirja","descFull":"Tulostaminen tietokoneella Windows-käyttäjät: Kun asiakirja on avattu, valitse  Tiedosto Tulosta . Valitse tulostin ja sitten  Ominaisuudet ,  Määritykset ,  Asetukset  tai  Asennus . Säädä asetuksia tarvittaessa. Valitse ensin  OK  ja sitten  Tulosta . Macintosh-käyttäjät: Kun asiakirja on avattu, valitse  Tiedosto Tulosta  . Valitse tulostin ja valitse sitten asetus kohdasta  Esiasetukset . Säädä asetuksia tarvittaessa. Napsauta kohtaa  Tulosta . tulostaminen tietokoneesta asiakirjat, tulostaminen tietokoneesta"},{"UUID":"e96c6b3a-c7e1-4c96-995a-30d64a116427","title":"Tulostaminen mobiililaitteesta","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Tulostaminen mobiililaitteesta Lexmark Printin avulla","descFull":"Tulostaminen mobiililaitteesta Lexmark Printin avulla Lexmark  Print -tulostuspalvelu on mobiilitulostusratkaisu mobiililaitteisiin, joissa on  Android -alustan versio 6.0 tai uudempi. Sillä voi lähettää asiakirjoja ja kuvia verkkoon yhdistettyihin tulostimiin ja tulostuksenhallintapalvelimiin. Lataa Lexmark Print -sovellus  Google Play  -kaupasta ja ota se käyttöön mobiililaitteessa. Varmista, että tulostin ja mobiililaite on yhdistetty samaan verkkoon. Valitse asiakirja mobiililaitteessa tiedostonhallinnassa. Lähetä tai jaa asiakirja Lexmark Printiin. Jotkut kolmansien osapuolten sovellukset eivät välttämättä tue lähettämis- tai jakamisominaisuutta. Lisätietoja on sovelluksen käyttöohjeessa. Valitse tulostin. Säädä asetuksia tarvittaessa. Tulosta asiakirja. Lexmark Print käyttäminen tulostaminen, asiakirjojen mobiililaitteesta mobiililaite tulostaminen"},{"UUID":"0fbb8ab2-de3c-492b-add7-dec1bef36acd","title":"Tulostaminen mobiililaitteesta","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Tulostaminen mobiililaitteesta Mopria™-tulostuspalvelun avulla Mopria-tulostuspalvelu","descFull":"Tulostaminen mobiililaitteesta Mopria™-tulostuspalvelun avulla Mopria-tulostuspalvelu on mobiilitulostusratkaisu mobiililaitteisiin, joissa on  Android -versio 5.0 tai uudempi. Sen avulla voit tulostaa suoraan mihin tahansa Mopria™‑yhteensopivaan tulostimeen. Lataa Mopria-tulostuspalvelu-sovellus  Google Play  -kaupasta ja ota se käyttöön mobiililaitteessa. Avaa yhteensopiva sovellus mobiililaitteessa tai valitse asiakirja tiedostonhallinnassa. Valitse  Tulosta . Valitse tulostin ja määritä asetukset tarpeen mukaan. Valitse  . Mopria-tulostuspalvelu tulostaminen mobiililaitteesta mobiililaite tulostaminen tulostaminen Mopria-tulostuspalvelun käyttäminen"},{"UUID":"0f3db45a-338a-4d57-ad54-6f7891e10267","title":"Tulostaminen mobiililaitteesta","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Tulostaminen mobiililaitteesta AirPrintin avulla AirPrint","descFull":"Tulostaminen mobiililaitteesta AirPrintin avulla AirPrint on mobiilitulostusratkaisu, jonka avulla voit tulostaa Apple-laitteista AirPrint‑sertifioituun tulostimeen. Varmista, että Apple-laite ja tulostin on yhdistetty samaan verkkoon. Jos verkossa on useita langattomia keskittimiä, varmista, että molemmat laitteet on yhdistetty samaan aliverkkoon. Tätä sovellusta tukevat vain jotkin Apple-laitteet. Valitse asiakirja tiedostonhallinnassa tai avaa yhteensopiva sovellus mobiililaitteessa. Valitse  Tulosta . Valitse tulostin ja määritä asetukset tarpeen mukaan. Tulosta asiakirja. AirPrintin käyttäminen tulostaminen mobiililaitteesta mobiililaite tulostaminen"},{"UUID":"d7852818-cf4f-4f54-a687-3608ad6860a1","title":"Tulostaminen mobiililaitteesta","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Tulostaminen mobiililaitteesta Wi‑Fi Direct® -toiminnon","descFull":"Tulostaminen mobiililaitteesta Wi‑Fi Direct® -toiminnon avulla Wi‑Fi Direct  on tulostuspalvelu, jonka avulla voit tulostaa mihin tahansa Wi‑Fi Direct ‑toimintoa tukevaan tulostimeen. Varmista, että mobiililaite on yhdistetty tulostimen langattomaan verkkoon Lisätietoja on kohdassa  . Avaa yhteensopiva sovellus mobiililaitteessa tai valitse asiakirja tiedostonhallinnassa. Toimi mobiililaitteen mallin mukaan seuraavasti: Valitse  Tulosta . Valitse  Tulosta . Valitse  Tulosta . Valitse tulostin ja määritä asetukset tarpeen mukaan. Tulosta asiakirja. Wi‑Fi Direct tulostaminen mobiililaitteesta tulostaminen mobiililaitteesta mobiililaite tulostaminen tulostaminen Wi-Fi Direct -toiminnon käyttäminen"},{"UUID":"ac7b6646-e655-49fa-84ea-72e418adc700","title":"Tulostaminen","link":"printing-from-flash-drive-topic.html","desc":"Tulostaminen flash-asemasta Aseta flash-asema paikalleen.","descFull":"Tulostaminen flash-asemasta Aseta flash-asema paikalleen. Lisätietoja tuetuista flash-asemista on kohdassa  . Jos flash-asemaa liitettäessä avautuu virheilmoitus, tulostin ohittaa flash-aseman. Jos asetat Flash-aseman paikalleen, kun tulostin käsittelee muita tulostustöitä, näyttöön tulee ilmoitus  Varattu . Valitse tulostimen ohjauspaneelissa  Kopioi . Valitse  USB-asema  ja valitse sitten asiakirja, jonka haluat tulostaa. Säädä asetuksia tarvittaessa. Tulosta asiakirja. Vältä tietojen menetys tai toimintahäiriö olemalla koskettamatta flash-aseman tai tulostimen kuvassa näkyviä kohtia, kun tulostin tulostaa tai lukee muistilaitteesta tai kirjoittaa siihen. tulostaminen flash-asemasta flash-asema, tulostaminen"},{"UUID":"5e6d764e-a2d8-4b33-a588-00031f9267c1","title":"Tulostaminen","link":"configuring-confidential-jobs-topic.html","desc":"Luottamuksellisten töiden määrittäminen Siirry ohjauspaneelista","descFull":"Luottamuksellisten töiden määrittäminen Siirry ohjauspaneelista kohtaan  Asetukset Suojaus Luottamukselliset tulostusasetukset . Määritä asetukset. Luottamukselliset tulostusasetukset  -valikkokohdat ja niiden kuvaukset Asetus Kuvaus Virheellinen maks. PIN Aseta virheellisen PIN-koodin syöttöraja. Kun rajoitus on saavutettu, kyseisen käyttäjätunnuksen tulostustyöt poistetaan. Luottamuksellisen työn vanheneminen Määritä kullekin pidossa olevalle työlle oma vanhenemisaika ennen kuin se poistetaan automaattisesti tulostimen muistista, kiintolevyltä tai älykkäästä tallennusasemasta. Pidossa oleva työ on  Luottamuksellinen ,  Toista ,  Pidätä  tai  Vahvista . Toista Työn vanheneminen Määritä toistettavien tulostustöiden vanhenemisaika. Varmenna Työn vanheneminen Määritä aika, jonka aikana tulostin tulostaa käyttäjälle laaduntarkkailukopion ennen jäljellä olevien kopioiden tulostamista. Säilytä Työn vanheneminen Määritä tulostimeen tallennettavien myöhemmin tulostettavien töiden vanhenemisaika. Edellytä kaikkien töiden pitoon asettamista Määritä tulostin asettamaan kaikki tulostustyöt pitoon. Säilytä kahdentuneet asiakirjat Määritä tulostin pitämään kaikki asiakirjat, joilla on sama nimi. luottamukselliset tulostustyöt konfigurointi pidossa olevat työt konfigurointi tulostustöiden tallentaminen tulostustöiden siirtäminen pitoon"},{"UUID":"8bee2baa-ba81-4686-a6ff-38b76f6d4295","title":"Tulostaminen","link":"printing-confidential-and-other-held-jobs-topic.html","desc":"Luottamuksellisten ja muiden pidossa olevien","descFull":"Luottamuksellisten ja muiden pidossa olevien töiden tulostaminen Windows-käyttäjät: Kun asiakirja on avattu, valitse  Tiedosto Tulosta . Valitse tulostin ja sitten  Ominaisuudet ,  Määritykset ,  Asetukset  tai  Asennus . Valitse  Tulosta ja siirrä pitoon . Valitse  Käytä tulostusta ja siirtoa pitoon  ja liitä siihen käyttäjänimi. Valitse jokin seuraavista tulostustyön tyypeistä: Luottamuksellinen tulostus  – Tulostin pyytää henkilökohtaista PIN-koodia ennen kuin se antaa tulostaa työn. Jos valitset tämän työn tyypin, anna nelinumeroinen PIN-koodi. Vahvista tuloste –Tulostin tulostaa yhden kopion ja pitää tulostimen muistissa jäljellä olevat kopiot, jotka olet määrittänyt tulostettavaksi ajurista. Pidätä tuloste –Tulostin tallentaa työn muistiin, jotta voit tulostaa työn myöhemmin. Toista tulostus — Tulostin tulostaa kaikki pyydetyt kopiot ja tallentaa työn muistiin. Näin voit tulostaa lisäkopioita myöhemmin. Valitse  OK . Napsauta kohtaa  Tulosta . Vapauta tulostustyö tulostimen ohjauspaneelista. Valitse  Tulosta . Valitse  Pidossa olevat työt  ja valitse sitten käyttäjänimesi. Valitse luottamuksellisia tulostustöitä varten  Luottamuksellinen , anna PIN-koodi ja valitse sitten  OK . Valitse tulostustyö ja sitten  Tulosta . Macintosh-käyttäjät: Kun asiakirja on avattu, valitse  Tiedosto Tulosta  . Valitse tulostin. Ota avattavasta  Tulostustyön suojaus  -valikosta käyttöön valinta  Tulosta PIN-koodilla  ja anna nelinumeroinen PIN-koodi. Napsauta kohtaa  Tulosta . Vapauta tulostustyö tulostimen ohjauspaneelista. Valitse  Pidossa olevat työt  ja valitse sitten tietokoneen nimi. Valitse  Luottamuksellinen  ja anna sitten PIN-koodi. Valitse tulostustyö ja sitten  Tulosta . tulostaminen pidossa olevat työt tulostaminen luottamukselliset tulostustyöt luottamukselliset tulostustyöt tulostaminen pidossa olevat työt tulostaminen"},{"UUID":"45cca1d8-d4a8-4315-8809-b5ca53091c39","title":"Tulostaminen","link":"printing-font-sample-list-topic.html","desc":"Fonttimalliluettelon tulostaminen Siirry ohjauspaneelista kohtaan","descFull":"Fonttimalliluettelon tulostaminen Siirry ohjauspaneelista kohtaan  Asetukset  Raportit Tulosta Tulosta fontit . Valitse fontin tyyppi. tulostaminen fonttinäyteluettelo fonttinäyteluettelo tulostaminen"},{"UUID":"df3bcfe1-e858-428a-8fc6-0a924f3c03f1","title":"Tulostaminen","link":"printing-directory-list-topic.html","desc":"Hakemistoluettelon tulostaminen Siirry ohjauspaneelista kohtaan","descFull":"Hakemistoluettelon tulostaminen Siirry ohjauspaneelista kohtaan  Asetukset Raportit Tulosta . Valitse  Tulosta hakemisto . tulostaminen hakemistoluettelo hakemistoluettelo tulostaminen"},{"UUID":"60d2b949-0bad-4462-9fa9-cc242609db36","title":"Tulostaminen","link":"placing-separator-sheets-in-print-jobs-topic.html","desc":"Erotinarkkien asettaminen tulostustöihin Kun asiakirja","descFull":"Erotinarkkien asettaminen tulostustöihin Kun asiakirja on avattu, valitse  Tiedosto Tulosta . Valitse tulostin ja sitten  Ominaisuudet ,  Määritykset ,  Asetukset  tai  Asennus . Valitse  Paperi/viimeistely . Valitse asetus  Erotinsivut  -valikosta. Valitse ensin  OK  ja sitten  Tulosta . erotinsivut sijoittaminen erotinsivujen lisääminen"},{"UUID":"f8466b9c-a9a6-4300-b103-16fe9868d9a8","title":"Tulostaminen","link":"canceling-print-job-topic.html","desc":"Tulostustyön peruuttaminen Valitse tulostimen ohjauspaneelissa","descFull":"Tulostustyön peruuttaminen Valitse tulostimen ohjauspaneelissa  Työjono . Valitse  Tulosta  ja valitse sitten peruutettava tulostustyö. Jos asiakirja on jo tulostumassa, lopeta tulostus valitsemalla näytön oikeasta alakulmasta  Peruuta työ  . tulostustyö peruuttaminen tulostustyön peruuttaminen"},{"UUID":"037ad03d-6611-49e1-a079-102a3c7d6aaa","title":"Tulostaminen","link":"adjusting-toner-darkness-topic.html","desc":"Väriaineen tummuuden säätäminen Siirry ohjauspaneelista","descFull":"Väriaineen tummuuden säätäminen Siirry ohjauspaneelista kohtaan  Asetukset Tulosta Laatu . Säädä  Tummuuden säätö  -asetusta. väriaineen tummuus säätäminen väriaineen tummuuden säätäminen"},{"UUID":"f530fb97-5953-461b-917a-59583ef84884","title":"Kopioiminen","link":"making-copies-topic.html","desc":"Kopioiminen Aseta alkuperäinen asiakirja automaattisen","descFull":"Kopioiminen Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Vältä kuvan leikkautuminen varmistamalla, että alkuperäinen asiakirja ja kopiopaperi ovat saman kokoisia. Valitse ohjauspaneelissa  Kopio  ja määritä sitten kopioiden määrä. Määritä tarvittaessa kopiointiasetukset. Kopioi asiakirja. kopioiminen kopioiminen asiakirjat kopioiminen ADF:n käyttäminen kopioiminen skannaustason avulla"},{"UUID":"d3cecf88-7d42-4b99-b570-d1752098a0f4","title":"Kopioiminen","link":"copying-photos-topic.html","desc":"Valokuvien kopioiminen Valokuvien kopioiminen Aseta","descFull":"Valokuvien kopioiminen Valokuvien kopioiminen Aseta valokuva skannaustasolle. Siirry ohjauspaneelista kohtaan  Kopioi Lisää asetuksia Sisältö Content Type Photo . Valitse  Sisältölähde  ja alkuperäiseen valokuvaan parhaiten sopiva asetus. Kopioi valokuva. kopioiminen valokuvat valokuvat, kopiointi"},{"UUID":"91d06215-3fd8-494d-9eaf-a0dbec689f1b","title":"Kopioiminen","link":"copying-on-letterhead-topic.html","desc":"Kopioiminen kirjelomakkeelle Kopioiminen kirjelomakkeelle Aseta","descFull":"Kopioiminen kirjelomakkeelle Kopioiminen kirjelomakkeelle Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Siirry ohjauspaneelissa kohtaan  Kopioi Kopioi kohteesta . Valitse alkuperäisen asiakirjan koko. Valitse  Kopioi kohteeseen  ja valitse sitten paperilähde, jossa kirjelomake on. Jos asetit kirjelomakkeen monikäyttösyöttöaukkoon, valitse  Monikäyttösyöttöaukko , valitse paperikoko ja valitse sitten  Kirjelomake . Kopioi asiakirja. kopioiminen kirjelomakkeelle kirjelomake kopioiminen"},{"UUID":"5337c00d-bc00-465d-99bb-8ad6ef39dfd2","title":"Kopioiminen","link":"copying-on-both-sides-of-paper-topic.html","desc":"Paperin molemmille puolille kopioiminen Paperin","descFull":"Paperin molemmille puolille kopioiminen Paperin molemmille puolille kopioiminen Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Siirry ohjauspaneelista kohtaan  Kopioi Lisää asetuksia Sivut . Valitse asetus. Kopioi asiakirja. kopioiminen paperin molemmille puolille kaksipuolinen kopiointi kaksipuolinen kopiointi"},{"UUID":"2bf97747-49fd-4648-a158-3d7f7791ccaf","title":"Kopioiminen","link":"reducing-or-enlarging-copies-topic.html","desc":"Kopioiden pienentäminen tai suurentaminen Kopioiden","descFull":"Kopioiden pienentäminen tai suurentaminen Kopioiden pienentäminen tai suurentaminen Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Siirry ohjauspaneelista kohtaan  Kopioi Lisää asetuksia Skaalaus . Valitse asetus. Alkuperäisen asiakirjan tai tulosteen koon muuttaminen  skaalausasetuksen  määrittämisen jälkeen palauttaa sovitusasetuksen arvoksi  Automaattinen . Kopioi asiakirja. kopiokoon pienentäminen kopiokoon suurentaminen kopiokoko säätäminen"},{"UUID":"c1c2d159-1079-4bd7-b116-4410e92f9846","title":"Kopioiminen","link":"collating-copies-topic.html","desc":"Kopioiden lajittelu Kopioiden lajittelu Aseta","descFull":"Kopioiden lajittelu Kopioiden lajittelu Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Siirry ohjauspaneelista kohtaan  Kopioi Lisää asetuksia Lajittelu On [1,2,1,2,1,2] . Kopioi asiakirja. kopioiden lajitteleminen useiden kopioiden lajitteleminen"},{"UUID":"f6a7af5a-9e43-47b2-8ba7-a06517e2fb1e","title":"Kopioiminen","link":"placing-separator-sheets-between-copies-topic.html","desc":"Erotinsivujen lisääminen kopioiden väliin Erotinsivujen","descFull":"Erotinsivujen lisääminen kopioiden väliin Erotinsivujen lisääminen kopioiden väliin Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Siirry ohjauspaneelista kohtaan  Kopioi Lisää asetuksia Erotinsivut . Ota valikko käyttöön ja valitse sitten asetus. Kopioi asiakirja. erotinsivut lisääminen erotinsivujen lisääminen"},{"UUID":"08a28109-a8a3-488b-90cb-165a60d5ecb4","title":"Kopioiminen","link":"copying-multiple-pages-onto-single-sheet-topic.html","desc":"Useiden sivujen kopioiminen yhdelle arkille","descFull":"Useiden sivujen kopioiminen yhdelle arkille Useiden sivujen kopioiminen yhdelle arkille Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Siirry ohjauspaneelista kohtaan  Kopioi Lisää asetuksia Sivuja/arkki . Ota valikko käyttöön ja valitse sitten asetus. Kopioi asiakirja. useiden sivujen kopioiminen yhdelle arkille paperin säästäminen"},{"UUID":"ce2fcb0c-a24c-43b1-a069-378e02dd4240","title":"Kopioiminen","link":"copying-cards-topic.html","desc":"Korttien kopioiminen Korttien kopioiminen Aseta","descFull":"Korttien kopioiminen Korttien kopioiminen Aseta kortti skannaustasolle. Siirry ohjauspaneelissa kohtaan  Kopioi Kopioi kohteesta Tunnuskortti . Kopioi kortti. kopioiminen kortit kortit, kopioiminen"},{"UUID":"90e072e2-8cde-41a3-b886-2cb37a898f4b","title":"Kopioiminen","link":"creating-copy-shortcut-topic.html","desc":"Kopioinnin pikavalinnan luominen Kopioinnin pikavalinnan","descFull":"Kopioinnin pikavalinnan luominen Kopioinnin pikavalinnan luominen Valitse tulostimen ohjauspaneelista  Kopioi . Määritä asetukset ja valitse  . Luo pikavalinta. pikavalinnan luominen kopioiminen pikavalinnan lisääminen kopioiminen"},{"UUID":"46de5bbb-cbfe-462f-9ab4-6aa7dbf00c12","title":"Sähköposti","link":"configuring-smtp-settings-topic.html","desc":"SMTP-asetusten määrittäminen SMTP-asetusten määrittäminen Määritä","descFull":"SMTP-asetusten määrittäminen SMTP-asetusten määrittäminen Määritä SMTP-asetukset, jotta voit lähettää skannatun asiakirjan sähköpostitse. Asetukset vaihtelevat sähköpostin palveluntarjoajan mukaan. Ennen kuin aloitat, varmista että tulostin on yhteydessä verkkoon ja verkko on yhteydessä Internetiin. Ohjauspaneelin käyttäminen Siirry ohjauspaneelista kohtaan  Asetukset Sähköposti Sähköpostiasetukset . Määritä asetukset.  Embedded Web Serverin käyttäminen Avaa selain ja kirjoita tulostimen IP-osoite selaimen osoitekenttään. Tulostimen IP-osoite näkyy sen tulostimen päänäytössä. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Valitse  Asetukset Sähköposti . Määritä asetukset  Sähköpostiasetukset -valikossa.  Napsauta  Tallenna . Sähköpostipalveluntarjoajat AOL Mail Comcast Mail Gmail iCloud Mail Mail.com NetEase Mail (mail.126.com) NetEase Mail (mail.163.com) NetEase Mail (mail.yeah.net) Outlook Live tai Microsoft 365 QQ Mail Sina Mail Sohu Mail Yahoo! Mail Zoho Mail Jos havaitset virheitä käyttäessäsi tässä mainittuja asetuksia, ota yhteys sähköpostin palveluntarjoajaan. Jos palveluntarjoajaasi ei ole luettelossa, ota yhteyttä palveluntarjoajaasi. AOL Mail AOL Mail -asetus Asetus Arvo Ensisijainen SMTP-yhdyskäytävä smtp.aol.com Ensisijaisen SMTP-yhdyskäytävän portti 587 Käytä SSL-/TLS-yhteyskäytäntöä Pakollinen Edellytä luotettua varmennetta Ei käytössä Vastausosoite Sähköpostiosoitteesi SMTP-palvelimen todennus Kirjautuminen/tavallinen Laitteeseen perustuva s-posti Käytä laitteen SMTP-valtuuksia Laitekäyttäjätunnus Sähköpostiosoitteesi Laitesalasana Sovelluksen salasana  Luo sovelluksen salasana siirtymällä  AOL Account Security  -sivulle, kirjautumalla tilillesi ja valitsemalla  Generate and manage app passwords . Comcast Mail Comcast Mail -asetukset Asetus Arvo Ensisijainen SMTP-yhdyskäytävä smtp.comcast.net Ensisijaisen SMTP-yhdyskäytävän portti 587 Käytä SSL-/TLS-yhteyskäytäntöä Pakollinen Edellytä luotettua varmennetta Ei käytössä Vastausosoite Sähköpostiosoitteesi SMTP-palvelimen todennus Kirjautuminen/tavallinen Laitteeseen perustuva s-posti Käytä laitteen SMTP-valtuuksia Laitekäyttäjätunnus Sähköpostiosoitteesi Laitesalasana Tilin salasana Varmista, että muiden valmistajien käytön suojausasetus on käytössä tililläsi. Lisätietoja on   Comcast Xfinity Connect -ohjesivulla . Gmail Varmista, että kaksivaiheinen vahvistus on käytössä tililläsi. Ota kaksivaiheinen vahvistus käyttöön siirtymällä  Google Account Security  -tilille, kirjautumalla tilillesi ja valitsemalla  How you sign in to Google  -osassa  2‑Step Verification . Gmailin SMTP-asetukset Asetus Arvo Ensisijainen SMTP-yhdyskäytävä smtp.gmail.com Ensisijaisen SMTP-yhdyskäytävän portti 587 Käytä SSL-/TLS-yhteyskäytäntöä Pakollinen Edellytä luotettua varmennetta Ei käytössä Vastausosoite Sähköpostiosoitteesi SMTP-palvelimen todennus Kirjautuminen/tavallinen Laitteeseen perustuva s-posti Käytä laitteen SMTP-valtuuksia Laitekäyttäjätunnus Sähköpostiosoitteesi Laitesalasana Sovelluksen salasana Luo sovelluksen salasana siirtymällä  Google Account Security  -sivulle, kirjautumalla tilillesi ja valitsemalla   How you sign in to Google  -kohdassa  2‑Step Verification App passwords . App passwords  näkyy ainoastaan, jos kaksiosainen vahvistus on käytössä. iCloud Mail Varmista, että kaksivaiheinen vahvistus on käytössä tililläsi. iCloud Mail -asetukset Asetus Arvo Ensisijainen SMTP-yhdyskäytävä smtp.mail.me.com Ensisijaisen SMTP-yhdyskäytävän portti 587 Käytä SSL-/TLS-yhteyskäytäntöä Pakollinen Edellytä luotettua varmennetta Ei käytössä Vastausosoite Sähköpostiosoitteesi SMTP-palvelimen todennus Kirjautuminen/tavallinen Laitteeseen perustuva s-posti Käytä laitteen SMTP-valtuuksia Laitekäyttäjätunnus Sähköpostiosoitteesi Laitesalasana Sovelluksen salasana Luo sovelluksen salasana siirtymällä  iCloud Account Management  -sivulle, kirjautumalla sisään tilillesi ja valitsemalla sitten  Sign‑In and Security  -osiossa  App‑Specific Passwords Generate an app‑specific password . Mail.com Mail.com-asetukset Asetus Arvo Ensisijainen SMTP-yhdyskäytävä smtp.mail.com Ensisijaisen SMTP-yhdyskäytävän portti 587 Käytä SSL-/TLS-yhteyskäytäntöä Pakollinen Edellytä luotettua varmennetta Ei käytössä Vastausosoite Sähköpostiosoitteesi SMTP-palvelimen todennus Kirjautuminen/tavallinen Laitteeseen perustuva s-posti Käytä laitteen SMTP-valtuuksia Laitekäyttäjätunnus Sähköpostiosoitteesi Laitesalasana Tilin salasana NetEase Mail (mail.126.com) Varmista, että SMTP-palvelu on käytössä tililläsi. Ota palvelu käyttöön valitsemalla NetEase Mail -aloitussivulla  Settings POP3/SMTP/IMAP  ja ottamalla käyttöön joko  IMAP/SMTP service  tai  POP3/SMTP service . NetEase Mail -asetukset (mail.126.com) Asetus Arvo Ensisijainen SMTP-yhdyskäytävä smtp.126.com Ensisijaisen SMTP-yhdyskäytävän portti 465 Käytä SSL-/TLS-yhteyskäytäntöä Pakollinen Edellytä luotettua varmennetta Ei käytössä Vastausosoite Sähköpostiosoitteesi SMTP-palvelimen todennus Kirjautuminen/tavallinen Laitteeseen perustuva s-posti Käytä laitteen SMTP-valtuuksia Laitekäyttäjätunnus Sähköpostiosoitteesi Laitesalasana Valtuutussalasana Saat valtuutussalasanan, kun  IMAP/SMTP service  tai  POP3/SMTP service  on käytössä. NetEase Mail (mail.163.com) Varmista, että SMTP-palvelu on käytössä tililläsi. Ota palvelu käyttöön valitsemalla NetEase Mail -aloitussivulla  Settings POP3/SMTP/IMAP  ja ottamalla käyttöön joko  IMAP/SMTP service  tai  POP3/SMTP service . NetEase Mail -asetukset (mail.163.com) Asetus Arvo Ensisijainen SMTP-yhdyskäytävä smtp.163.com Ensisijaisen SMTP-yhdyskäytävän portti 465 Käytä SSL-/TLS-yhteyskäytäntöä Pakollinen Edellytä luotettua varmennetta Ei käytössä Vastausosoite Sähköpostiosoitteesi SMTP-palvelimen todennus Kirjautuminen/tavallinen Laitteeseen perustuva s-posti Käytä laitteen SMTP-valtuuksia Laitekäyttäjätunnus Sähköpostiosoitteesi Laitesalasana Valtuutussalasana Saat valtuutussalasanan, kun  IMAP/SMTP service  tai  POP3/SMTP service  on käytössä. NetEase Mail (mail.yeah.net) Varmista, että SMTP-palvelu on käytössä tililläsi. Ota palvelu käyttöön valitsemalla NetEase Mail -aloitussivulla  Settings POP3/SMTP/IMAP  ja ottamalla käyttöön joko  IMAP/SMTP service  tai  POP3/SMTP service . NetEase Mail -asetukset (mail.yeah.net) Asetus Arvo Ensisijainen SMTP-yhdyskäytävä smtp.yeah.net Ensisijaisen SMTP-yhdyskäytävän portti 465 Käytä SSL-/TLS-yhteyskäytäntöä Pakollinen Edellytä luotettua varmennetta Ei käytössä Vastausosoite Sähköpostiosoitteesi SMTP-palvelimen todennus Kirjautuminen/tavallinen Laitteeseen perustuva s-posti Käytä laitteen SMTP-valtuuksia Laitekäyttäjätunnus Sähköpostiosoitteesi Laitesalasana Valtuutussalasana Saat valtuutussalasanan, kun  IMAP/SMTP service  tai  POP3/SMTP service  on käytössä. Outlook Live tai Microsoft 365 Nämä asetukset koskevat sähköpostitoimialueita outlook.com ja hotmail.com e‑mail sekä Microsoft 365 -tilejä. Outlook Live- tai Microsoft 365 -asetukset Asetus Arvo Ensisijainen SMTP-yhdyskäytävä smtp.office365.com Ensisijaisen SMTP-yhdyskäytävän portti 587 Käytä SSL-/TLS-yhteyskäytäntöä Pakollinen Edellytä luotettua varmennetta Ei käytössä Vastausosoite Sähköpostiosoitteesi SMTP-palvelimen todennus Kirjautuminen/tavallinen Laitteeseen perustuva s-posti Käytä laitteen SMTP-valtuuksia Laitekäyttäjätunnus Sähköpostiosoitteesi Laitesalasana Tilin salasana tai sovelluksen salasana Jos kaksivaiheinen vahvistus ei ole käytössä tililläsi, käytä tilin salasanaa. Jos kaksivaiheinen vahvistus on käytössä outlook.com- hotmail.com-tililläsi, käytä sovelluksen salasanaa. Luo sovelluksen salasana siirtymällä  Yahoo Account Security  -sivulle, kirjautumalla tilillesi ja valitsemalla  Create a new app password . Lisää asennusvaihtoehtoja Microsoft 365:tä käyttäville yrityksille on  Microsoft 365:n ohjesivulla . QQ Mail Varmista, että SMTP-palvelu on käytössä tililläsi. Ota palvelu käyttöön valitsemalla QQ Mail -aloitussivulla  Settings Account . Ota  POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV Service  -kohdassa käyttöön joko  POP3/SMTP service  tai  IMAP/SMTP service . QQ Mail -asetukset Asetus Arvo Ensisijainen SMTP-yhdyskäytävä smtp.qq.com Ensisijaisen SMTP-yhdyskäytävän portti 587 Käytä SSL-/TLS-yhteyskäytäntöä Pakollinen Edellytä luotettua varmennetta Ei käytössä Vastausosoite Sähköpostiosoitteesi SMTP-palvelimen todennus Kirjautuminen/tavallinen Laitteeseen perustuva s-posti Käytä laitteen SMTP-valtuuksia Laitekäyttäjätunnus Sähköpostiosoitteesi Laitesalasana Valtuutuskoodi Luo valtuutuskoodi valitsemalla QQ Mail -aloitussivulla  Settings Account  ja valitsemalla  POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV Service  -kohdassa  Generate authorization code . Sina Mail Varmista, että POP3/SMTP-palvelu on käytössä tililläsi. Ota palvelu käyttöön valitsemalla Sina Mail -aloitussivulla  Settings More settings User‑end POP/IMAP/SMTP  ja ottamalla käyttöön  POP3/SMTP service . Sina Mail -asetukset Asetus Arvo Ensisijainen SMTP-yhdyskäytävä smtp.sina.com Ensisijaisen SMTP-yhdyskäytävän portti 587 Käytä SSL-/TLS-yhteyskäytäntöä Pakollinen Edellytä luotettua varmennetta Ei käytössä Vastausosoite Sähköpostiosoitteesi SMTP-palvelimen todennus Kirjautuminen/tavallinen Laitteeseen perustuva s-posti Käytä laitteen SMTP-valtuuksia Laitekäyttäjätunnus Sähköpostiosoitteesi Laitesalasana Valtuutuskoodi Luo valtuutuskoodi valitsemalla sähköpostin aloitussivulla  Settings More settings User‑end POP/IMAP/SMTP  ja ottamalla käyttöön  Authorization code status . Sohu Mail Varmista, että SMTP-palvelu on käytössä tililläsi. Ota palvelu käyttöön valitsemalla Sohu Mail -aloitussivulla  Options Settings POP3/SMTP/IMAP  ja ottamalla käyttöön joko  IMAP/SMTP service  tai  POP3/SMTP service . Sohu Mail -asetukset Asetus Arvo Ensisijainen SMTP-yhdyskäytävä smtp.sohu.com Ensisijaisen SMTP-yhdyskäytävän portti 465 Käytä SSL-/TLS-yhteyskäytäntöä Pakollinen Edellytä luotettua varmennetta Ei käytössä Vastausosoite Sähköpostiosoitteesi SMTP-palvelimen todennus Kirjautuminen/tavallinen Laitteeseen perustuva s-posti Käytä laitteen SMTP-valtuuksia Laitekäyttäjätunnus Sähköpostiosoitteesi Laitesalasana Riippumaton salasana Saat riippumattoman salasanan, kun  IMAP/SMTP service  tai  POP3/SMTP service  on käytössä. Yahoo! Mail Yahoo!-asetukset Mail Asetus Arvo Ensisijainen SMTP-yhdyskäytävä smtp.mail.yahoo.com Ensisijaisen SMTP-yhdyskäytävän portti 587 Käytä SSL-/TLS-yhteyskäytäntöä Pakollinen Edellytä luotettua varmennetta Ei käytössä Vastausosoite Sähköpostiosoitteesi SMTP-palvelimen todennus Kirjautuminen/tavallinen Laitteeseen perustuva s-posti Käytä laitteen SMTP-valtuuksia Laitekäyttäjätunnus Sähköpostiosoitteesi Laitesalasana Sovelluksen salasana  Luo sovelluksen salasana siirtymällä  Yahoo Account Security  -sivulle, kirjautumalla tilillesi ja valitsemalla  App password  -kohdassa  Generate app password . Zoho Mail Zoho Mail -asetukset Asetus Arvo Ensisijainen SMTP-yhdyskäytävä smtp.zoho.com Ensisijaisen SMTP-yhdyskäytävän portti 587 Käytä SSL-/TLS-yhteyskäytäntöä Pakollinen Edellytä luotettua varmennetta Ei käytössä Vastausosoite Sähköpostiosoitteesi SMTP-palvelimen todennus Kirjautuminen/tavallinen Laitteeseen perustuva s-posti Käytä laitteen SMTP-valtuuksia Laitekäyttäjätunnus Sähköpostiosoitteesi Laitesalasana Tilin salasana tai sovelluksen salasana Jos kaksivaiheinen vahvistus ei ole käytössä tililläsi, käytä tilin salasanaa. Jos kaksivaiheinen vahvistus on käytössä tililläsi, käytä sovelluksen salasanaa. Luo sovelluksen salasana siirtymällä  Zoho Mail Account Security  -sivulle, kirjautumalla tilillesi ja valitsemalla  Application‑Specific Passwords  -kohdassa  Generate New Password . sähköpostin palveluntarjoajat konfigurointi sähköpostipalvelinasetukset SMTP-asetukset konfigurointi sähköpostitoiminto asetusten määrittäminen sähköpostipalvelinasetukset konfigurointi"},{"UUID":"2375ef93-0c4a-4ebf-9670-0ccf306ce6d4","title":"Sähköposti","link":"sending-email-topic.html","desc":"Sähköpostiviestin lähettäminen Varmista ennen aloittamista,","descFull":"Sähköpostiviestin lähettäminen Varmista ennen aloittamista, että SMTP-asetukset on määritetty. Lisätietoja on kohdassa  . Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Siirry ohjauspaneelista kohtaan  Skannaa Sähköposti . Anna tarvittavat tiedot ja valitse sitten  Seuraava . Säädä asetuksia tarvittaessa. Valitse  Skannaa  ja lähetä sitten sähköposti. sähköposti lähetys sähköpostin lähettäminen"},{"UUID":"abd92c54-93f2-43cf-b796-6efe68e18c5a","title":"Sähköposti","link":"creating-email-shortcut-topic.html","desc":"Sähköpostin pikavalinnan luominen Ohjauspaneelin käyttäminen","descFull":"Sähköpostin pikavalinnan luominen Ohjauspaneelin käyttäminen Siirry ohjauspaneelista kohtaan  Skannaa Sähköposti . Anna tarvittavat tiedot ja valitse sitten  . Luo pikavalinta. Embedded Web Serverin käyttäminen Avaa selain ja kirjoita tulostimen IP-osoite selaimen osoitekenttään. Tulostimen IP-osoite näkyy sen tulostimen päänäytössä. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Valitse  Pikavalinnat Lisää pikavalinta . Määritä asetukset. Napsauta  Tallenna . pikavalinnan luominen sähköposti pikavalinnan lisääminen sähköposti sähköpostin pikavalinta luominen"},{"UUID":"46d24778-746b-4491-8902-01739308ef4f","title":"Faksaaminen","link":"sending-fax-topic.html","desc":"Faksin lähettäminen Faksin lähettäminen Ohjauspaneelin","descFull":"Faksin lähettäminen Faksin lähettäminen Ohjauspaneelin käyttäminen Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Valitse tulostimen ohjauspaneelista  Faksi . Valitse  Lisää vastaanottaja  tai  Osoitekirja . Säädä asetuksia tarvittaessa. Lähetä faksi. Tietokoneen avulla Varmista ennen kuin aloitat, että faksiohjain on asennettu. Lisätietoja on kohdassa  . Windows-käyttäjät: Kun asiakirja on avattu, valitse  Tiedosto Tulosta . Valitse tulostin ja sitten  Ominaisuudet ,  Määritykset ,  Asetukset  tai  Asennus . Valitse  Faksi Ota faksi käyttöön Näytä aina asetukset ennen faksaamista  ja kirjoita vastaanottajan numero. Säädä asetuksia tarvittaessa. Lähetä faksi. Macintosh-käyttäjät: Kun asiakirja on avattu, valitse  Tiedosto Tulosta  . Valitse tulostin, jonka nimen perään on lisätty  ‑ Faksi . Kirjoita Vastaanottaja-kenttään vastaanottajan numero. Säädä asetuksia tarvittaessa. Lähetä faksi. faksin lähettäminen faksin lähettäminen"},{"UUID":"60d7f57c-ab90-4d50-91ed-bc0c124ea090","title":"Faksaaminen","link":"scheduling-fax-topic.html","desc":"Faksin ajastaminen Faksin ajastaminen Aseta","descFull":"Faksin ajastaminen Faksin ajastaminen Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Valitse tulostimen ohjauspaneelista  Faksi . Valitse  Lisää vastaanottaja  tai  Osoitekirja  ja anna sitten tarvittavat tiedot. Valitse  Lähetysaika , määritä päiväys ja aika ja valitse  Valmis . Määritä muut faksiasetukset tarpeen mukaan. Lähetä faksi. faksin ajastaminen faksi, ajastaminen"},{"UUID":"540e26d0-aa97-4918-a12e-e621de1b9f7f","title":"Faksaaminen","link":"creating-fax-destination-shortcut-topic.html","desc":"Faksin kohdepikavalinnan luominen Faksin kohdepikavalinnan","descFull":"Faksin kohdepikavalinnan luominen Faksin kohdepikavalinnan luominen Valitse tulostimen ohjauspaneelista  Faksi . Valitse  Lisää vastaanottaja  tai  Osoitekirja  ja anna sitten tarvittavat tiedot. Säädä asetuksia tarvittaessa. Valitse  -näppäin. Luo pikavalinta. pikavalinnan luominen faksikohde faksikohde pikavalinnan luominen pikavalinnan lisääminen faksikohde pikavalinta, luominen faksikohde"},{"UUID":"8c1f363f-7454-4ac6-a984-c6e8e8e13073","title":"Faksaaminen","link":"changing-fax-resolution-topic.html","desc":"Faksin tarkkuuden muuttaminen Faksin tarkkuuden","descFull":"Faksin tarkkuuden muuttaminen Faksin tarkkuuden muuttaminen Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Valitse tulostimen ohjauspaneelista  Faksi . Valitse  Lisää vastaanottaja  tai  Osoitekirja  ja anna sitten tarvittavat tiedot. Valitse  Tarkkuus  ja valitse asetus. Lähetä faksi. faksin tarkkuus muuttaminen faksin tarkkuuden muuttaminen"},{"UUID":"06d31c70-b8f4-416d-9f88-201d62c5699f","title":"Faksaaminen","link":"adjusting-fax-darkness-topic.html","desc":"Faksin tummuuden säätäminen Faksin tummuuden","descFull":"Faksin tummuuden säätäminen Faksin tummuuden säätäminen Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Valitse tulostimen ohjauspaneelista  Faksi . Valitse  Lisää vastaanottaja  tai  Osoitekirja  ja anna sitten tarvittavat tiedot. Valitse  Lisää asetuksia Tummuus  ja säädä sitten asetusta. Lähetä faksi. faksin tummuuden säätäminen faksin tummuus säätäminen"},{"UUID":"bd309b9e-6abe-4c38-ab40-9af38f075b1d","title":"Faksaaminen","link":"printing-fax-log-topic.html","desc":"Faksilokin tulostaminen Faksilokin tulostaminen Siirry","descFull":"Faksilokin tulostaminen Faksilokin tulostaminen Siirry ohjauspaneelissa kohtaan  Asetukset Raportit Faksi . Valitse faksiloki. faksiloki tulostaminen faksilokin tulostaminen"},{"UUID":"6fef3a00-e28a-4db2-bb23-8ea943f22f3e","title":"Faksaaminen","link":"blocking-junk-faxes-topic.html","desc":"Roskafaksien estäminen Siirry ohjauspaneelissa kohtaan","descFull":"Roskafaksien estäminen Siirry ohjauspaneelissa kohtaan  Asetukset Faksi Faksiasetukset Faksin vastaanottoasetukset Järjestelmänvalvojan asetukset . Ota  Estä nimetön faksi  -valikko käyttöön. roskafaksit estäminen roskafaksien estäminen"},{"UUID":"f4c37dd2-7dc2-4353-81ff-7b4c2b17fe9b","title":"Faksaaminen","link":"holding-faxes-topic.html","desc":"Faksien pysäyttäminen Faksien pysäyttäminen Valitse","descFull":"Faksien pysäyttäminen Faksien pysäyttäminen Valitse ohjauspaneelissa  Asetukset Faksi Faksiasetukset Faksin vastaanottoasetukset Pysäytetään faksit . Valitse asetus. faksien pysäyttäminen vastaanotetut faksit pysäyttäminen faksaaminen pysäyttäminen"},{"UUID":"40a149f2-a080-43f5-8c5d-a405a04807dc","title":"Faksaaminen","link":"forwarding-fax-topic.html","desc":"Faksin välittäminen Faksin välittäminen Siirry","descFull":"Faksin välittäminen Faksin välittäminen Siirry ohjauspaneelissa kohtaan  Asetukset Faksi Faksiasetukset Faksin vastaanottoasetukset Järjestelmänvalvojan asetukset . Valitse  Faksin välitys  ja valitse sitten  Tulosta ja välitä  tai  Välitä . Valitse  Välitä -valikosta kohde ja määritä sitten asetukset. faksin välittäminen faksaaminen välittäminen"},{"UUID":"43b7f6f4-5591-437a-bf0e-0147ae425866","title":"Skannaaminen","link":"scanning-to-computer-topic.html","desc":"Skannaaminen tietokoneeseen Varmista ennen aloittamista,","descFull":"Skannaaminen tietokoneeseen Varmista ennen aloittamista, että tietokone ja tulostin on yhdistetty samaan verkkoon Windows-käyttäjät: Lexmark ScanBack Utilityn käyttäminen Aja tietokoneessa  Lexmark ScanBack Utility  ja valitse sitten  Luo profiili . Lataa apuohjelma osoitteesta  www.lexmark.com/downloads . Jos haluat käyttää olemassa olevaa skannausprofiilia, valitse  Olemassa oleva profiili . Valitse  Asetukset  ja lisää tulostimen IP-osoite. Tulostimen IP-osoite näkyy sen tulostimen päänäytössä. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Valitse  OK  ja valitse sitten  Sulje . Valitse skannattavan asiakirjan muoto ja koko. Valitse tiedostomuoto ja skannaustarkkuus ja sitten  Seuraava . Kirjoita yksilöivä skannausprofiilin nimi. Avaa skannatun asiakirjan tallennuspaikka ja anna tiedostolle nimi. Jos haluat käyttää skannausprofiilia uudelleen, ota käyttöön  Luo pikavalinta  ja kirjoita pikavalinnalle yksilöivä nimi. Valitse  Valmis . Aseta alkuperäinen asiakirja automaattiseen asiakirjansyöttölaitteeseen tai skannaustasolle. Valitse ohjauspaneelissa  Skannausprofiilit Skannaa tietokoneeseen  ja valitse skannausprofiili. Napsauta tietokoneellasi  Skannaus valmis . Windows-käyttäjät: Windowsin faksi ja skannaus -toiminnon käyttäminen Varmista, että tulostin on lisätty tietokoneeseen. Lisätietoja on kohdassa  . Aseta alkuperäinen asiakirja automaattiseen asiakirjansyöttölaitteeseen tai skannaustasolle. Avaa tietokoneessa  Windowsin faksi ja skannaus . Valitse  Uusi skannaus  ja valitse sitten skannerilähde. Muuta tarvittaessa tulostusasetuksia. Skannaa asiakirja. Valitse  Tallenna nimellä , kirjoita tiedostonimi ja valitse  Tallenna . Macintosh-käyttäjät: Varmista, että tulostin on lisätty tietokoneeseen. Lisätietoja on kohdassa  . Aseta alkuperäinen asiakirja automaattiseen asiakirjansyöttölaitteeseen tai skannaustasolle. Tee tietokoneessa jompikumpi seuraavista: Avaa  Kuvansiirtäjä . Avaa  Tulostimet ja skannerit  ja valitse tulostin. Valitse  Skannaa Avaa skanneri . Tee Skanneri-ikkunassa yksi tai useampi seuraavista: Valitse sijainti, johon haluat tallentaa asiakirjan. Valitse alkuperäisen asiakirjan koko. Skannaa asiakirjansyöttölaitteesta valitsemalla  Asiakirjansyöttölaite Skannaa-valikosta  tai ota käyttöön  Käytä dokumentin syöttölaitetta . Määritä tarvittaessa skannausasetukset. Valitse  Skannaa . skannaaminen tietokoneeseen tietokone, skannaaminen Lexmark ScanBack Utility"},{"UUID":"74a566b0-a3fa-48f5-9808-7ddd3b4b982e","title":"Skannaaminen","link":"scanning-ftp-server-using-control-panel-topic.html","desc":"Skannaaminen FTP-palvelimelle Skannaaminen FTP-palvelimelle Varmista","descFull":"Skannaaminen FTP-palvelimelle Skannaaminen FTP-palvelimelle Varmista ennen aloittamista, että tulostin on yhteydessä FTP-palvelimeen. Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Siirry ohjauspaneelissa kohtaan  Skannaa FTP . Anna tarvittavat tiedot ja valitse sitten  Seuraava . Määritä FTP-asetukset tarvittaessa. Skannaa asiakirja. FTP-palvelin skannaaminen skannaaminen FTP-palvelimelle"},{"UUID":"a8685ad0-2a98-4134-94b8-855e1a1d6b45","title":"Skannaaminen","link":"creating-FTP-shortcut-topic.html","desc":"FTP-pikavalintojen luominen FTP-pikavalintojen luominen Valitse","descFull":"FTP-pikavalintojen luominen FTP-pikavalintojen luominen Valitse ohjauspaneelissa  Skannaa FTP . Kirjoita FTP-palvelimen osoite ja valitse  . Luo pikavalinta. pikavalinnan luominen FTP-osoite pikavalinnan lisääminen FTP-osoite"},{"UUID":"7e0077c8-81df-456b-bf4f-521bc9586676","title":"Skannaaminen","link":"scanning-to-network-folder-topic.html","desc":"Skannaaminen verkkokansioon Varmista ensin, että","descFull":"Skannaaminen verkkokansioon Varmista ensin, että verkkokansio, johon haluat skannata asiakirjan, on jo määritetty. Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Siirry tulostimen ohjauspaneelissa kohtaan  Skannauskeskus Verkkokansio . Valitse haluamasi verkkokansio. Verkkokansion lisääminen: katso  . Skannaa asiakirja. skannaaminen verkkokansioon verkkokansio skannaaminen"},{"UUID":"0c2b6779-fc09-476e-a3d6-6bff05ab2950","title":"Skannaaminen","link":"configuring-network-folder-destination-topic.html","desc":"Verkkokansiokohteen määrittäminen Verkkokansiokohteen määrittäminen Siirry","descFull":"Verkkokansiokohteen määrittäminen Verkkokansiokohteen määrittäminen Siirry ohjauspaneelissa kohtaan  Skannauskeskus Verkkokansio Luo verkkokansio . Määritä tarvittavat asetukset. Kirjaudu verkkoon ja valitse  Seuraava . Määritä verkkokansion asetukset ja valitse sitten  Valmis . Jos haluat skannata asiakirjan verkkokansioon, katso kohta  . verkkokansiokohde konfigurointi verkkokansion luominen"},{"UUID":"be9d63a4-ec8b-48f1-9d30-8517f039ccc8","title":"Skannaaminen","link":"creating-network-folder-shortcut-topic.html","desc":"Verkkokansion pikakuvakkeen luominen Avaa selain","descFull":"Verkkokansion pikakuvakkeen luominen Avaa selain ja kirjoita tulostimen IP-osoite selaimen osoitekenttään. Tulostimen IP-osoite näkyy sen tulostimen päänäytössä. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Valitse  Pikavalinnat Lisää pikavalinta . Valitse  Pikavalinnan tyyppi  -valikosta  Verkkokansio  ja määritä sitten asetukset. Ota muutokset käyttöön. verkkokansion pikakuvake pikavalinnan luominen"},{"UUID":"89a8a325-da6e-4dbd-8c3c-f7f177e1494c","title":"Skannaaminen","link":"scanning-to-flash-drive-topic.html","desc":"Skannaaminen flash-asemaan Skannaaminen flash-asemaan Aseta","descFull":"Skannaaminen flash-asemaan Skannaaminen flash-asemaan Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Aseta flash-asema paikalleen. Valitse ohjauspaneelista  Skannaa  ja valitse sitten  USB-asema . Valitse tiedoston tallennuspaikka, anna tiedostonimi ja valitse sitten  Seuraava . Määritä skannausasetukset. Skannaa asiakirja. Vältä tietojen menetys tai toimintahäiriö olemalla koskettamatta flash-aseman tai tulostimen kuvassa näkyviä kohtia, kun tulostin tulostaa tai lukee muistilaitteesta tai kirjoittaa siihen. skannaaminen flash-asemaan flash-asema skannaaminen"},{"UUID":"a11fcd72-6315-47e2-81b5-066f512ff6d0","title":"Tulostimen valikot","link":"menu-map-topic.html","desc":"Valikkokartta 1  Näkyy ainoastaan,","descFull":"Valikkokartta 1  Näkyy ainoastaan, jos tulostimeen on asennettu viimeistelijä. 2  Näkyy vain, kun tallennusasema on asennettu. Laite Määritykset Säästötila Etäkäyttöpaneeli Tiedotteet Virranhallinta Jaa tietoja Lexmarkin kanssa Helppokäyttö Palauta tehdasasetukset Huolto Päivitä laiteohjelma Tietoja tästä tulostimesta Laite Määritykset Säästötila Etäkäyttöpaneeli Tiedotteet Virranhallinta Helppokäyttö Palauta tehdasasetukset Huolto Päivitä laiteohjelmisto Tietoja tästä tulostimesta Tulostaminen Asettelu Viimeistely 1 Asetukset Laatu Töiden seuranta PDF-muoto PostScript PCL Kuva Paperi Lokeromääritys Tulostusmateriaalimääritys Alustamääritys 1 Kopioiminen Kopioinnin oletusasetukset Faksi Faksin oletusasetukset Sähköposti Sähköpostiasetukset Sähköpostin oletusasetukset Web-linkin asetus FTP FTP-oletusasetukset USB-asema Flash-asemaskannaus Flash-asematulostus Verkko/portit Verkon yleiskatsaus Langaton Wi‑Fi Direct Mobiilipalvelujen hallinta Ethernet TCP/IP SNMP IPSec 802.1x LPD-kokoonpano HTTP-/FTP-asetukset ThinPrint USB Rajoita ulkoisen verkon käyttöä Suojaus Kirjautumismenetelmät Ajasta USB-laitteet Suojaustarkistusloki Kirjautumisrajoitukset Luottamukselliset tulostusasetukset Salaus Pyyhi väliaikaiset datatiedostot Ratkaisut, LDAP-asetukset Muut Cloud-palvelut Cloud-palvelujen rekisteröinti Raportit Valikkoasetussivu Laite Tulostaminen Pikavalinnat Faksi Verkko Vianmääritys Tulostuslaadun testisivut Skannerin puhdistaminen Lomakkeiden yhdistäminen 2 Lomakkeiden yhdistäminen valikkokartta tulostimen valikot"},{"UUID":"6023373b-37d1-42a5-8c71-7726b019041d","title":"Laite","link":"preferences-topic.html","desc":"Määritykset Määritykset-valikkokohdat ja niiden kuvaukset","descFull":"Määritykset Määritykset-valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Näytön kieli - [List of languages] Määritä näytön kieli. Maa/alue - [List of countries or regions] Tunnista maa tai alue, jossa tulostin on määritetty toimimaan.  Suorita alkumääritys - Ei käytössä * Käytössä Suorita ohjattu asennustoiminto. Näppäimistö Näppäimistön tyyppi [List of languages] Valitse kieli näppäimistön tyypiksi. Kaikki  näppäimistön tyypit  eivät ehkä näy, tai niiden näkyminen edellyttää erityislaitteistoa. Päivämäärä ja aika Määritä Current Date and Time (Nykyinen päiväys ja aika) Aseta päivämäärä ja aika manuaalisesti Päivämäärän muoto  ( KK‑PP‑VVVV *) Ajan muoto  ( 12 tunnin järjestelmä (am/pm) *) Aikavyöhyke DST (GMT) -siirtymä DST Alku DST Loppu Kesäajan porrastus Määritä tulostimen päivämäärä ja aika sekä verkkoajan yhteyskäytäntö. KK‑PP‑VVVV  on oletusasetus Yhdysvalloissa.  PP-KK-VVVV  on kansainvälinen oletusasetus. UTC (GMT) -siirtymä ,  DST Alku ,  DST Loppu  ja  Kesäajan porrastus  näkyvät vain, kun  Aikavyöhykkeeksi  on määritetty  (UTC+käyt.) Mukaut. . Avaintunnus  ja  Salasana  näkyvät vain, jos  Ota käyttöön todennus  -asetuksena on  MD5-avain . Verkon aikaprotokolla Salli NTP  ( Käytössä *) NTP-palvelin Ota käyttöön todennus  ( Ei mitään *) Avaintunnus Salasana Paperikoot - Yhdysvallat * Metrinen Määritä paperikokojen mittayksikkö. Ensimmäinen paperikokoasetus määräytyy ohjatun asennuksen aikana valitun maa- tai aluekoodin perusteella. Näytön kirkkaus - 20–100%  (100*) Säädä näytön kirkkautta. Flash-aseman käyttö - Ei käytössä Käytössä * Salli tulostimen flash-asematoimintojen käyttö. Salli taustan poisto - Ei käytössä Käytössä * Määritä, voiko taustan poistaa. Salli mukautettujen töiden skannaus - Ei käytössä Käytössä * Määritä, näkyykö  Mukautetun työn skannaus  -asetus kopiointi-, skannaus- ja faksaustöissä. Tämä valikkokohta on näkyvissä vain, kun tallennusväline on asennettu. Yhden sivun tasoskannaus - Ei käytössä * Käytössä Määritä tulostin skannaamaan kaikki skannaustasolla tehtävät työt yksisivuisina. Tasoskannauksen jälkeen tulostin palaa aloitusnäyttöön kehotteiden näyttämisen sijaan. Laitteen äänet Mykistä kaikki äänet Ei käytössä * Käytössä Määritä tulostimen ääniasetukset. Painikepalaute Ei käytössä Käytössä * Äänenvoimakkuus 0–10  (5*) Automaattinen asiakirjansyöttölaitteen lisäysmerkkiääni Ei käytössä Käytössä * Hälytysäänen määritys Ei käytössä Yksi * Jatkuva Kasetin hälytys Ei käytössä Yksi * Jatkuva Kaiutintila Aina pois käytöstä * Aina käytössä On until Connected (Käytössä, kunnes yhteys muodostettu) Soittoäänen voimakkuus Ei käytössä * Käytössä Näytön aikakatkaisu - 5–300 sekuntia  (60*) Määritä sekunteina aika, jonka jälkeen käyttämättömänä olevan tulostimen näyttöön tulee aloitusnäyttö tai tulostin kirjaa käyttäjätilin ulos automaattisesti. valikko Määritykset"},{"UUID":"9256268a-4402-4db6-b416-fbc2c31aa110","title":"Laite","link":"preferences-topic.html","desc":"Säästötila Säästötila-valikkokohdat ja niiden kuvaukset","descFull":"Säästötila Säästötila-valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Tulostaminen Sivut Yksipuolinen Kaksipuolinen * Määritä, tulostetaanko vain sivun toiselle puolelle vai molemmille puolille. Sivua/puoli Ei käytössä * 2 sivua/puoli 3 sivua/puoli 4 sivua/puoli 6 sivua/puoli 9 sivua/puoli 12 sivua/puoli 16 sivua/puoli Määritä, kuinka monta sivua paperiarkin yhdelle puolelle tulostetaan. Värin tummuus 1–5  (4*) Määritä tekstikuvien vaaleus tai tummuus. Värinsäästäjä Ei käytössä * Käytössä Määritä tulostin vähentämään grafiikan ja kuvien väritulostukseen käyttämän väriaineen määrää. Kopioiminen Sivut 1-puolinen 1-puoliseksi 1-puolinen 2-puoliseksi 2-puolinen 1-puoliseksi 2-puolinen 2-puoliseksi Määritä skannaustoiminta alkuperäisen asiakirjan perusteella. Sivua/puoli Ei käytössä * 2 pystysuuntaista sivua 4 pystysuuntaista sivua 2 vaakasuuntaista sivua 4 vaakasuuntaista sivua Määritä, kuinka monta sivua paperiarkin yhdelle puolelle kopioidaan. Tummuus 1–9  (5*) Määritä skannattujen tekstikuvien tummuus. valikko Säästötila"},{"UUID":"f4283129-5ef7-41c5-8727-ac7a06d999df","title":"Laite","link":"preferences-topic.html","desc":"Etäkäyttöpaneeli Etäkäyttöpaneelin valikkokohdat ja niiden","descFull":"Etäkäyttöpaneeli Etäkäyttöpaneelin valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Ulkoinen VNC-yhteys Älä salli * Salli Yhdistä ulkoinen VNC (Virtual Network Computing) -asiakas etäohjauspaneeliin. Todennuksen tyyppi Ei mitään * Vakiotodennus Määritä VNC-työasemapalvelinta käytettäessä käytettävä tunnistuksen tyyppi. VNC-Salasana Asetus on käyttäjän määrittämä. Määritä salasana, jota käytetään yhteyden muodostuksessa VNC-työasemapalvelimeen. Tämä valikkokohta on näkyvissä vain, jos  Tunnistuksen tyypiksi  on määritetty  Vakiotunnistus . valikko Etäkäyttöpaneeli"},{"UUID":"e4994afc-7f53-425e-82d7-620fbd6cc005","title":"Laite","link":"preferences-topic.html","desc":"Tiedotteet Ilmoitukset-valikkokohdat ja niiden kuvaukset","descFull":"Tiedotteet Ilmoitukset-valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Automaattinen asiakirjansyöttölaitteen lisäysmerkkiääni - Ei käytössä Käytössä * Määritä, antaako tulostin mukautetun äänimerkin, kun alkuperäinen asiakirja ladataan asiakirjansyöttölaitteeseen. Hälytysäänen määritys - Ei käytössä Yksi * Jatkuva Määritä, kuinka monta kertaa hälytysääni kuuluu, kun tulostin edellyttää käyttäjän toimia. Tarvikkeet Näytä tarvikearviot Näytä arviot * Älä näytä arvioita Näytä tarvikkeiden arvioitu tila. Kasetin hälytys Ei käytössä Yksi * Jatkuva Määritä, kuinka monta kertaa hälytysääni kuuluu, kun väriainekasetti on ehtymässä. Nidontahälytys Ei käytössä * Yksi Jatkuva Määritä, kuinka monta kertaa hälytysääni kuuluu, kun niittikasetti on tyhjä. Tämä valikkokohta on näkyvissä vain, kun nidonnan viimeistelijä on asennettu. Rei'ityshälytys Ei käytössä * Yksi Jatkuva Aseta kuinka monta kertaa hälytys soi, kun rei'ittimen säiliö on täynnä tai se puuttuu. Tämä valikkokohta näkyy vain, kun nidonnan tai rei'ityksen viimeistelijä on asennettu. Sähköpostihälytysten asetukset Ensisijainen SMTP-yhdyskäytävä Asetus on käyttäjän määrittämä. Kirjoita ensisijaisen SMTP-palvelimen IP-osoite tai isäntänimi. Ensisijaisen SMTP-yhdyskäytävän portti 1–65535  (25*) Kirjoita ensisijaisen SMTP-palvelimen porttinumero. Toissijainen SMTP-yhdyskäytävä Asetus on käyttäjän määrittämä. Kirjoita toissijaisen SMTP-palvelimen IP-osoite tai isäntänimi. Toissijaisen SMTP-yhdyskäytävän portti 1–65535  (25*) Kirjoita toissijaisen SMTP-palvelimen porttinumero. SMTP-aikakatkaisu 5–30 sekuntia  (30*) Määritä, miten monta sekuntia SMTP-palvelin odottaa, ennen kuin se lopettaa sähköpostin lähetysyrityksen. Vastausosoite Asetus on käyttäjän määrittämä. Määritä sähköpostin vastausosoite. Käytä aina SMTP-vastausosoitetta Käytössä Ei käytössä * Käytä SMTP-palvelimessa aina oletusvastausosoitetta. Käytä SSL-/TLS-yhteyskäytäntöä Ei käytössä * Neuvottele Pakollinen Lähetä sähköposti käyttäen salattua linkkiä. Edellytä luotettua varmennetta Käytössä * Ei käytössä Edellytä luotettua varmennetta käytettäessä SMTP-palvelinta. Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Sähköpostihälytysten asetukset SMTP-palvelimen todennus Todennusta ei tarvita * Kirjautuminen/Tavallinen NTLM CRAM-MD5 Digest-MD5 Kerberos 5 Määritä SMTP-palvelimen todennustyyppi. Laitteen lähettämä sähköposti Ei mitään * Käytä laitteen SMTP-tunnistetietoja Määritä, tarvitaanko tunnistetietoja, kun laite lähettää sähköpostia. Käyttäjän lähettämä sähköposti Ei mitään * Käytä laitteen SMTP-tunnistetietoja Käytä istunnon käyttäjätunnusta ja salasanaa Käytä istunnon sähköpostiosoitetta ja salasanaa Kysy käyttäjältä Määritä, tarvitaanko tunnistetietoja, kun käyttäjä lähettää sähköposteja. Käytä AD-laitteen kirjautumistietoja Käytössä Ei käytössä * Ota käyttöön käyttäjän tunnistetiedot ja ryhmämääritykset yhteyden muodostamiseksi SMTP-palvelimeen. Device Userid (Laitekäyttäjätunnus) Asetus on käyttäjän määrittämä. Määritä käyttäjätunnus SMTP-palvelimeen kirjautumista varten. Laitesalasana Asetus on käyttäjän määrittämä. Määritä salasana SMTP-palvelimeen kirjautumista varten. Kerberos 5 REALM Asetus on käyttäjän määrittämä. Määritä Kerberos 5 -todennusprotokollan alue. NTLM-toimialue Asetus on käyttäjän määrittämä. Määritä NTLM-suojausprotokollan toimialuenimi. Poista käytöstä SMTP-palvelinta ei ole määritetty -virhe Käytössä Ei käytössä * Poista käytöstä virheilmoitus SMTP-palvelimen asetuksista. Aseta sähköpostiluettelot ja hälytykset Asetus on käyttäjän määrittämä. Määritä sähköpostiosoitteet ja ota sähköpostihälytykset käyttöön. Tämä valikkokohta näkyy vain Embedded Web Server -palvelimessa. Virheiden estäminen Asiakirjansyöttölaitteen monisyöttösensori Ei käytössä Käytössä * Määritä tulostin tunnistamaan, kun asiakirjansyöttölaite ottaa useamman kuin yhden paperin kerrallaan. Automaattinen jatko Ei käytössä Käytössä * Anna tulostimen jatkaa työn käsittelemistä tai tulostamista automaattisesti, kun tietyt toimenpide-ehdot on käsitelty. Kun asetus on  Käytössä , oletusasetus on 5 sekuntia. Automaattinen uudelleenkäynnistys Uudelleenkäynnistys vapaatilassa Uudelleenkäynnistys aina * Ei uudelleenkäynnistystä Aseta tulostin käynnistymään uudelleen virhetilanteessa. Uudelleenkäynnistysten enimmäismäärä 1–20  (2*) Määritä automaattisten uudelleenkäynnistysten määrä, jonka tulostin voi suorittaa. Automaattisen uudelleenkäynnistyksen ikkuna 1–525600  (720*) Määritä, kuinka monen sekunnin kuluttua tulostin käynnistyy automaattisesti uudelleen. Automaattisen uudelleenkäynnistyksen laskuri Asetus on vain luku -tieto. Näyttää tulostimen tekemien automaattisten uudelleenkäynnistysten määrän. Näytä lyhyen paperin virhe Käytössä Autom. tyhjennys * Määritä tulostin näyttämän viesti, kun ilmenee lyhyen paperin virhe. Lyhyt paperi viittaa lisätyn paperin kokoon. Sivunsuojaus Ei käytössä * Käytössä Määritä tulostin käsittelemään koko sivu muistiin ennen sen tulostamista. Sisällön tukosselvitys Tukosselvitys Ei käytössä Käytössä Automaattinen * Määritä tulostin tulostamaan juuttuneet sivut uudelleen. Skannerin tukoksen selvittäminen Työtaso Sivutaso * Määritä, miten skannaustyö käynnistetään uudelleen paperitukoksen selvittämisen jälkeen. valikko Tiedotteet"},{"UUID":"d1c56930-8400-4f35-8841-40575921541a","title":"Laite","link":"preferences-topic.html","desc":"Virranhallinta Virranhallinta-valikkokohdat ja niiden kuvaukset","descFull":"Virranhallinta Virranhallinta-valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Lepotilaprofiili Tulosta Lepotilasta Pysy hereillä tulostamisen jälkeen Siirry Lepotilaan tulostamisen jälkeen * Määritä tulostin pysymään hereillä tai palaamaan  lepotilaan  tulostamisen jälkeen. Herätä syvästä lepotilasta koskettamalla Ei käytössä Käytössä * Tulostimen käynnistäminen  syvästä lepotilasta . Aikakatkaisut Lepotila 1–114 minuuttia  (15*) Määritä käyttämättömyysaika, jonka kuluttua tulostin siirtyy  lepotilaan . Säästötilan aikakatkaisu Ei käytössä 1 tunti 2 tuntia 3 tuntia 6 tuntia 1 päivä 2 pv 3 päivää * 1 viikko 2 viikkoa 1 kk Määritä aika, jonka jälkeen tulostimen virta katkeaa. Horrostilan aikakatkaisu yhdistettäessä Horros Ei horrostilaa * Määritä  Horrostilan aikakatkaisu  katkaisemaan tulostimen virta, kun olemassa on aktiivinen Ethernet-yhteys. Ajasta virransäästötilat Ajastukset Lisää uusi ajastus Ajasta tulostin siirtymään  lepotilaan  tai  horrostilaan  tiettyyn aikaan. valikko Virranhallinta"},{"UUID":"0cbd11db-6c98-4d0f-bb99-d37f742914af","title":"Laite","link":"preferences-topic.html","desc":"Jaa tietoja Lexmarkin kanssa Jaa","descFull":"Jaa tietoja Lexmarkin kanssa Jaa tietoja Lexmarkin kanssa -valikkokohdat ja niiden kuvaus Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Jaa tietoja Lexmarkin kanssa Kyllä Ei * Lähetä tulostimen käyttö- ja suorituskykytietoja Lexmarkille. Jaettujen tietojen lähetysaika Aloitusaika Lopetusaika Valitse tiedon keräämisen ja siirron aikaikkuna. Jaettujen tietojen lähetysaika  näkyy vain, kun valitset  Kyllä  kohdassa  Jaa tietoja Lexmarkin kanssa . valikko Jaa tietoja Lexmarkin kanssa"},{"UUID":"ec4e78e8-5901-41be-95c2-788d2ffb596a","title":"Laite","link":"preferences-topic.html","desc":"Helppokäyttö Helppokäyttö-valikkokohdat ja niiden kuvaukset","descFull":"Helppokäyttö Helppokäyttö-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Toistuvan näppäinpainalluksen väli 0.00–5.00  (0.00*) Määritä sekunteina väli, jona tulostin ohittaa liitetyn näppäimistön saman näppäimen peräkkäiset painallukset Painikkeen toiston alkuviive 0.25–5.00  (1.00*) Määritä sekunteina alkuviiveen pituus ennen kuin toistava painike alkaa toistaa. Painikkeen toistonopeus 0.5–30.0  (30.0*) Määritä toistuvan painikkeen painallusten määrä sekunnissa. Pitkä näytön aikakatk. Ei käytössä * Käytössä Anna käyttäjän pysyä samassa paikassa ja nollata  Näytön aikakatkaisu  -asetuksen aloitusnäyttöön palaamisen sijaan. Kuulokkeiden äänenvoimakkuus 1–10  (5*) Säädä kuulokkeiden äänenvoimakkuutta. Ota käyttöön ääniohjaus, kun kuulokkeet on liitetty Ei käytössä * Käytössä Ota ääniopastus käyttöön, kun kuulokkeet on asetettu kuulokeliitäntään. Lue salasanat/PIN-koodit Ei käytössä * Käytössä Määritä tulostin lukemaan salasanat tai PIN-koodit ääneen. Puhenopeus Erittäin hidas Hidas Normaali * Nopea Nopeampi Erittäin nopea Ripeä Erittäin ripeä Nopein Säädä Ääniohjauksen puhenopeutta. valikko Helppokäyttö"},{"UUID":"c30e1306-d073-4c9e-b50b-a1aef8ace7c9","title":"Laite","link":"preferences-topic.html","desc":"Palauta tehdasasetukset Palauta tehdasasetukset -valikkokohta","descFull":"Palauta tehdasasetukset Palauta tehdasasetukset -valikkokohta ja sen kuvaus Valikkokohta Asetukset Kuvaus Palauta asetukset Palauta kaikki asetukset Palauta tulostimen asetukset Palauta verkkoasetukset Palauta faksiasetukset Palauta sovellusasetukset Palauta tulostimen tehdasasetukset. valikko Palauta tehdasasetukset"},{"UUID":"4acb11a8-65ae-4492-90bd-fdd5b5ab1412","title":"Huolto","link":"preferences-topic.html","desc":"Määritys-valikko Määritys-valikkokohdat ja niiden kuvaukset","descFull":"Määritys-valikko Määritys-valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. USB-kokoonpano USB PnP 1 * 2 Paranna tulostimen yhteensopivuutta tietokoneen kanssa muuttamalla tulostimen USB-ohjaimen tilaa. Paikallinen USB-skannaus Käytössä * Ei käytössä Määritä, lasketaanko USB-laiteohjain yksinkertaiseksi USB-laitteeksi (yksi liitäntä) vai USB-yhdistelmälaitteeksi (useita liitäntöjä). USB-nopeus Täysi Automaattinen * Aseta USB-portti toimimaan täydellä nopeudella ja poista nopeat toiminnot käytöstä. Lokeromääritys Koon tunnistus Lokeron  [x]  tunnistus  ( Käytössä *) Määritä lokero tunnistamaan automaattisesti siihen lisätty paperikoko. Lokeroiden linkitys Automaattinen * Ei käytössä Määritä tulostin yhdistämään lokerot, joilla on samat paperilaji- ja -kokoasetukset. Näytä lokeronasennusilmoitus Ei käytössä Vain kun kokoa ei tunneta * Always (Siirto aina) Näytä käyttäjälle ilmoitus paperikoon ja -lajin valitsemisesta lokeron asentamisen jälkeen Paperikehotteet Automaattinen * Monikäyttösyöttöaukko Manuaalinen paperi Määritä paperilähde, jonka käyttäjä täyttää, kun näyttöön tulee kehote lisätä paperia. Jotta  Monikäyttösyöttöaukko  tulee näkyviin, määritä  Paperi -valikossa  Monisyötön asetukseksi Kasetti . Kirjekuorikehotteet Automaattinen * Monikäyttösyöttöaukko Manuaalinen kirjekuori Määritä paperilähde, jonka käyttäjä täyttää, kun näyttöön tulee kehote lisätä kirjekuori. Jotta  Monikäyttösyöttöaukko  tulee näkyviin, määritä  Paperi -valikossa  Monisyötön asetukseksi Kasetti . Toiminto kehotteille Kehota käyttäjää * Jatka Käytä nykyistä Määritä tulostin ratkaisemaan paperiin tai kirjekuoriin liittyvät vaihtokehotteet. Useita Universal-kokoja Ei käytössä * Käytössä Määritä lokero tukemaan useita Universal-paperikokoja. Raportit - Valikkoasetussivu Tapahtumaloki Tapahtumalokin yhteenveto Tulosta raportteja, joissa on tulostimen valikkoasetukset, tila ja tapahtumalokit. Tarvikkeen käyttö ja laskurit Tyhjennä tarvikkeen käyttöhistoria Käynnistä Palauta tarvikkeen käyttöhistoria tehdasasetukseen. ITM:n nollaus Käynnistä Nollaa laskuri uuden tarvikkeen tai huoltopaketin asentamisen jälkeen. Nollaa mustan värikasetin laskuri Käynnistä Nollaa syaanin värikasetin laskuri Käynnistä Nollaa magentan värikasetin laskuri Käynnistä Nollaa keltaisen värikasetin laskuri Käynnistä Nollaa mustan kuvayksikön laskuri Käynnistä Nollaa värillisen kuvansiirtopaketin laskuri Käynnistä Nollaa monikäyttösyöttöaukon rullapakettilaskuri Käynnistä Nollaa 1500 arkin lokeron rullapakettilaskuri Käynnistä Nollaa rullapakettilaskuri Käynnistä Asteittaisen peiton alueet Asteittaisen peiton mittarit  ( Näytä *) Näytä Asteittaisen peiton laskutus -osio Laitetilastot-raportissa. Asteittaisen peiton alueet Suurikokoisen materiaalin säädöt Ei käytössä * Käytössä Salli säädöt, kun tulostetaan suurikokoiselle tai paksulle paperille. Tulostimen emuloinnit PPDS-emulointi Ei käytössä * Käytössä Määritä tulostin tunnistamaan PPDS-tietovirta ja käyttämään sitä. PS-emulointi Ei käytössä Käytössä * Määritä tulostin tunnistamaan PS-tietovirta ja käyttämään sitä. Ota käyttöön Formsmerge Ei käytössä * Käytössä Aktivoi Lomakkeiden yhdistäminen. Formsmerge-lisenssin on oltava asennettuna. Käyttäjän flash-muisti on oltava asennettuna. Ota käyttöön Prescribe Ei käytössä * Käytössä Aktivoi PRESCRIBE-tulostinkieli. PRESCRIBE-lisenssin on oltava asennettuna. Emulaattorin suojaus Sivun aikakatkaisu  (60*) Määritä sivun aikakatkaisu emuloinnin aikana. Nollaa emulaattori työn jälkeen  ( Ei käytössä *) Nollaa emulaattori tulostustyön jälkeen. Poista käytöstä tulostimen ilmoitusten käyttö  ( Käytössä *) Selvitä, voiko emulaattori käyttää tulostimen alkuasetuksia vai ei. Faksimääritykset Faksin väh.virran tuki Poista lepotila käytöstä Salli lepotila Automaattinen * Selvitä, tukeeko tulostin virransäästöarkkitehtuurin faksiosaa. Faksin tallennuspaikka Levy * NAND Määritä kaikkien faksien tallennuspaikka. Tämä valikkokohta on näkyvissä vain, kun tallennusväline on asennettu. Tulostusmääritykset Vain musta -tila Ei käytössä * Käytössä Tulosta muut kuin kopiointityöt harmaasävyisinä. Värin lihotus Ei käytössä 1 2 * 3 4 5 Kompensoi tulostimen kohdistusvirhettä parantamalla tulostetta. Fontin terävöinti 0–150  (24*) Määritä tekstin pistekokoarvo, jonka alittuessa fonttitietojen tulostamiseen käytetään suuritiheyksisiä näyttöjä. Jos arvo on esimerkiksi 24, kaikki fontit, joiden pistekoko on enintään 24, käyttävät suuritiheyksisiä näyttöjä. Käytä alkuperäisiä ISD-fontteja Käytössä * Ei käytössä Anna käyttäjän valita, käytetäänkö älykkäässä tallennusasemassa (ISD) olevia ilmaisia ​​fontteja. Tämä valikkokohta on näkyvissä vain, kun älykäs tallennusasema on asennettu. Laitteen toiminnot Hiljainen tila Ei käytössä * Käytössä Säädä tulostimen äänitaso. Tämän asetuksen ottaminen käyttöön hidastaa tulostimen toimintaa. Ota käyttöön pursketila Käytössä * Ei käytössä Aseta tulostin nopeuttamaan yhden sivun ja mahdollisesti ensimmäisen sivun tulostamista monisivuisessa työssä, jotta työ valmistuu nopeammin. Tämä valikkokohta tulee näkyviin vain tietyissä tulostinmalleissa. Turvatila Ei käytössä * Käytössä Määritä tulostin toimimaan erityisessä tilassa, jossa se yrittää tarjota mahdollisimman laajat toiminnot tunnetuista ongelmista huolimatta. Esimerkiksi jos asetuksena on  Käytössä  ja arkinkääntäjän moottori ei toimi, tulostin tulostaa asiakirjat yksipuolisina, vaikka työ olisi määritetty tulostettavaksi kaksipuolisena. Tämän asetuksen ottaminen käyttöön sallii tulostamisen vain monikäyttösyöttöaukosta. Kopioinnin vähimmäismuisti 20 Mt 30 Mt 50 Mt 80 Mt 100 Mt Määritä kopiointitöiden tallennukselle varattava vähimmäismuisti. Tyhjennä mukautettu tila Käynnistä Poista mukautettuja  Oletus - tai  Vaihtoehtoinen -viestejä koskevat käyttäjän määrittämät merkkijonot. Poista kaikki etäasennetut viestit Käynnistä Poista etäasennetut viestit. Näytä virhenäytöt automaattisesti Ei käytössä Käytössä * Näytä nykyiset virheilmoitukset näytössä, kun tulostin pysyy ei-aktiivisena aloitusnäytössä tietyn ajan. Käytä suuntaa pikakopioinnissa Ei käytössä * Käytössä Määritä tulostin käyttämään  Kopio -valikon suunta-asetusta lähetettäessä pikakopiointitöitä. Palvelun pysyvä muisti Salauksen tila Näyttää tallennusaseman salauksen tilan. Salaa palvelun pysyvä muisti Ota peilisalaus käyttöön manuaalisesti. Väriainealueen tunnistimen (TPS) asennus Kalibrointivälimääritys Ei käytössä Vähiten värisäätöjä Vähemmän värisäätöjä Normaali * Parempi väritarkkuus Paras väritarkkuus Määritä tulostin käyttämään oikea määrä väriainetta, jotta värit säilyvät yhdenmukaisina. Täysi kalibrointi Käynnistä Suorita täysi värikalibrointi. Tulosta TPS-tietosivu Käynnistä Tulosta vianmäärityssivu, jolla on tietoja väriainealueen tunnistimen kalibroinnista. Sovellusmääritykset LES-sovellukset Ei käytössä Käytössä * Ota käyttöön Lexmark Embedded Solutions (LES) -sovellukset. Skannerimääritykset Skannerin manuaalinen rekisteröinti Tulostuksen pikatesti Etu-ADF-rekisteröinti Taka-ADF-rekisteröinti Tasorekisteröinti Tulosta pikatestin kohdesivu tai rekisteröi taso ja automaattinen asiakirjansyöttölaite (ADF) manuaalisesti sen jälkeen, kun olet vaihtanut arkinsyöttölaitteen, skannerin lasin tai ohjainlevyn. Kun tulostat pikatestin kohdesivua, varmista, että kohdesivun marginaaliväli on tasainen koko kohteen ympärillä. Jos ne eivät ole, tulostimen marginaalit on määritettävä uudelleen. Nollaa huoltolaskuri Asiakirjansyöttölaitteen huoltolaskurin nollaaminen  ( Käynnistä ) Nollaa huoltolaskuri, kun olet vaihtanut automaattisen asiakirjansyöttölaitteen huoltopaketin. Reunojen poistaminen Tason reunojen poistaminen  (3*) ADF-reunojen poistaminen  (3*) Määritä automaattisen asiankirjasyöttölaitteen tai skannaustason työn tulostamattoman alueen koko millimetreinä. Asiakirjansyöttölaitteen suoristus Asiakirjansyöttölaitteen mekaaninen suoristus  ( Käytössä *) Korjaa vinot asiakirjat, jotka on skannattu automaattisesta asiankirjasyöttölaitteesta. Poista skanneri käytöstä Ei * Kyllä Vain ADF Poista skanneri käytöstä, jos se ei toimi oikein. Tiff-tavujärjestys CPU-tavujärjestys Little Endian Big Endian Määritä TIFF‑muotoillun skannaustuloksen tavujärjestys. Exact Tiff Rows Per Strip Käytössä * Ei käytössä Määritä TIFF‑muotoillun skannaustuloksen RowsPerStrip-tunnistearvo. Skannaustason puhdistuskynnys 1000–30000  (10000*) Aseta skannausten määrä ennen kuin käyttäjää kehotetaan puhdistamaan skannaustaso. valikko Määritys-valikko"},{"UUID":"6863a4fd-a2b8-4754-bdc8-7c6ee2c05f7b","title":"Huolto","link":"preferences-topic.html","desc":"Poistaminen Poistaminen-valikkokohdat ja niiden kuvaukset","descFull":"Poistaminen Poistaminen-valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Poistaminen Muistin viimeisin tyhjennys Asetus on vain luku -tieto. Näytä, milloin tulostimen muisti on viimeksi tyhjennetty. Kiintolevyn viimeisin tyhjennys Asetus on vain luku -tieto. Näytä, milloin kiintolevy on viimeksi tyhjennetty. Tämä valikkokohta näkyy ainoastaan, kun kiintolevy on asennettu. ISD tyhjennetty viimeksi Asetus on vain luku -tieto. Näytä, milloin älykäs tallennusasema (ISD) on viimeksi tyhjennetty. Tämä valikkokohta on näkyvissä vain, kun älykäs tallennusasema on asennettu. Poista kaikki tiedot pysyvästä muistista Poista kaikki tulostin- ja verkkoasetukset Poista kaikki sovellukset ja sovellusasetukset Poista kaikki pikavalinnat ja pikavalinta-asetukset Tyhjennä kaikki tiedot pysyvästä muistista Tyhjennä kaikki tiedot kiintolevyltä Poista lataukset (poistaa kaikki makrot, fontit, PFO:t jne.) Poista puskuroidut työt Poista pidossa olevat työt Poistetaanko kaikki tiedot kiintolevyltä? Tämä valikkokohta näkyy ainoastaan, kun tulostimen kiintolevy on asennettu. Tyhjennä älykäs tallennusasema Pyyhi Tyhjennä kaikki tiedot ISD:stä. Tämä valikkokohta on näkyvissä vain, kun älykäs tallennusasema on asennettu. valikko Poistaminen"},{"UUID":"4215bbef-7e3a-427d-bb37-39b736b2b5b0","title":"Laite","link":"preferences-topic.html","desc":"Päivitä laiteohjelmisto  Päivitä laiteohjelmisto","descFull":"Päivitä laiteohjelmisto  Päivitä laiteohjelmisto -valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Nykyinen versio Asetus on vain luku -tieto. Näyttää tulostimeen asennetun nykyisen laiteohjelmiston version. Tarkista päivitykset nyt Asenna nyt Asenna myöhemmin Tarkista laiteohjelmiston päivitykset Tarkista päivitykset automaattisesti Käytössä Ei käytössä * Aseta tulostin tarkistamaan laiteohjelmiston päivitykset automaattisesti. valikko Päivitä laiteohjelmisto"},{"UUID":"589dfcdd-dfcb-441b-b3de-50bf43555104","title":"Laite","link":"preferences-topic.html","desc":"Tietoja tästä tulostimesta Tietoja tästä","descFull":"Tietoja tästä tulostimesta Tietoja tästä tulostimesta -valikkokohdat ja niiden kuvaukset Valikkokohta Kuvaus Asset-tunniste Määritä tulostimen identiteetti. Tulostimen sijainti Määritä tulostimen sijainti. Ota yhteyttä Määrittää tulostimen yhteystiedot. Laiteohjelmiston versio Näyttää tulostimeen asennetun laiteohjelmiston version. Kone Näytä tulostimen koneiston numero. Sarjanumero Näytä tulostimen sarjanumero. Vie määritystiedosto USB-asemaan Vie määritystiedosto flash-asemaan. Vie pakatut lokit USB-asemaan Vie tulostimen pakatut lokitiedostot flash-asemaan. Lähetä lokit Lähetä tulostimen lokitiedot Lexmarkille. valikko Tietoja tästä tulostimesta"},{"UUID":"cb612004-476a-4227-8b71-b0dc1f2aa5bb","title":"Tulostaminen","link":"layout-topic.html","desc":"Asettelu Asettelu-valikkokohdat ja niiden kuvaukset","descFull":"Asettelu Asettelu-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Sivut Yksipuolinen Kaksipuolinen * Määritä, tulostetaanko vain sivun toiselle puolelle vai molemmille puolille. Kääntötyyli Pitkä reuna * Lyhyt reuna Määritä kaksipuolisena tulostetun asiakirjan sidottava reuna. Tyhjät sivut Tulostaminen Älä tulosta * Tulosta tulostustyöhön kuuluvat tyhjät sivut. Lajittelu Ei käytössä (1,1,1,2,2,2) Käytössä (1,2,1,2,1,2) * Säilytä tulostustyön sivut järjestyksessä varsinkin tulostettaessa useita kopioita työstä. Erotinsivut Ei mitään * Kopioiden väliin Töiden väliin Arkkien väliin Lisää tulostettaessa tyhjiä erotinsivuja. Erotinsivujen lähde Lokero  [x] (1*) Monikäyttösyöttöaukko Määritä erotinsivun paperilähde. Sivua/puoli Ei käytössä * 2 sivua/puoli 3 sivua/puoli 4 sivua/puoli 6 sivua/puoli 9 sivua/puoli 12 sivua/puoli 16 sivua/puoli Tulosta paperiarkin yhdelle puolelle useita pienennettyjä sivuja. Sivuja/arkki-järjestys Vaakasuunta * Käänteinen vaaka Pystysuora Käänteinen pysty Määritä monisivuisten kuvien paikka, kun käytössä on  Sivuja/arkki -valikko. Sivuja/arkki-suunta Automaattinen * Vaaka Pysty Määritä monisivuisten kuvien suunta, kun käytössä on  Sivuja/arkki -valikko. Sivuja/arkki-kehys Ei mitään * Tasainen Tulosta reunus jokaisen sivun ympärille, kun käytössä on  Sivuja/arkki -valikko. Kopiot 1–9999  (1*) Määritä kunkin tulostustyön kopiomäärä. Tulostusalue Normaali * Sovita sivulle Koko sivu Määritä paperiarkin tulostusalue. valikko Asettelu"},{"UUID":"089dc966-ed3e-49f7-ae51-6f9fda699b60","title":"Tulostaminen","link":"layout-topic.html","desc":"Viimeistely Viimeistely-valikon kohteet ja niiden","descFull":"Viimeistely Viimeistely-valikon kohteet ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Nidontatyö Ei käytössä * 1 niitti, vasen yläkulma 2 niittiä, vasen reuna 1 niitti, oikea yläkulma 2 niittiä, yläreuna 1 niitti, vasen alakulma 2 niittiä, alareuna 1 niitti, oikea alakulma 2 niittiä, oikea reuna Määritä kaikkien tulostustöiden nidontakohta. Tämä valikkokohta on näkyvissä vain, kun nidonnan viimeistelijä on asennettu. Nitojan testi Käynnistä Tarkista, toimiiko nidonnan viimeistelijä oikein. Tämä valikkokohta on näkyvissä vain, kun nidonnan viimeistelijä on asennettu. Rei'itys Ei käytössä * Käytössä Tulostin rei'ittää tulosteiden reunan. Tämä valikkokohta näkyy vain, kun nidonnan tai rei'ityksen viimeistelijä on asennettu. Rei'itystila 2 reikää 3 reikää 4 reikää Määritä tulosteiden rei'itystila. 3 reikää  on oletusasetus Yhdysvalloissa.  4 reikää  on kansainvälinen oletusasetus. Tämä valikkokohta näkyy vain, kun nidonnan, rei'ityksen tai vihkon viimeistelijä on asennettu. Porrasta sivut Ei mitään * Kopioiden väliin Töiden väliin Porrasta kunkin tulostustyön tulosteet tai tulostustyön kopiot. Jos valitset  Kopioiden väliin , laite porrastaa tulostustyön kopiot, jos  Lajittele -asetus on  Käytössä [1,2,1,2,1,2] . Jos  Lajittele -asetus on  Ei käytössä [1,1,1,2,2,2] , tulostettujen sivujen jokainen osio porrastetaan (kaikki sivut 1, kaikki sivut 2 ja niin edelleen). Töiden väliin  -asetus määrittää saman porrastuskohdan koko tulostustyölle tulostettavien kopioiden määrästä riippumatta. valikko Viimeistely"},{"UUID":"8c153fbc-4771-4327-b83a-0687bb50a5a4","title":"Tulostaminen","link":"layout-topic.html","desc":"Asetukset Asetus-valikkokohdat ja niiden kuvaukset","descFull":"Asetukset Asetus-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Komentokieli PCL-emulointi PS-emulointi * Määritä tulostimen kieli. Komentokielen asettaminen oletukseksi ei estä sovellusohjelmaa lähettämästä töitä, joiden tulostusta ohjataan jollakin muulla komentokielellä. Työ odottaa Ei käytössä * Käytössä Tallenna tarvikkeita vaativia tulostustöitä. Näin voidaan tulostaa töitä, joissa ei käytetä puuttuvia tarvikkeita. Tämä valikkokohta on näkyvissä vain, kun tallennusväline on asennettu. Työn pidon aikakatkaisu 0–255  (30*) Määritä, miten monta sekuntia tulostin odottaa käyttäjän toimia, ennen kuin liikaa resursseja vaativa työ siirretään pitoon. Tämä valikkokohta on näkyvissä vain, kun tallennusväline on asennettu. Tallennuspaikka RAM * Flash-muisti Levy Määritä, mihin tallennetaan kaikki pysyvät resurssit, jotka on ladattu tulostimeen. Tämä valikkokohta on näkyvissä vain, kun tallennusväline on asennettu. Tulost. käyttö Enimmäisnopeus Enimmäismäärä * Selvitä, irrottaako sisäänvetolaitteisto värillisestä kehitinyksiköistä vai kytkeytyykö niihin tulostuksen aikana. Kun asetus on  Enimmäisriitto , laitteisto pysyy kytkettynä värillisiin kehitysyksikköihin, kun tulostin on käyttämättömänä. Kun asetus on  Enimmäisnopeus , laitteisto pysyy yhteydessä värillisiin kehitysyksiköihin riippumatta siitä, sisältääkö työ mustavalko- vai värisisältöä. Hitaan tulostimen käyttö Enimmäismäärä * Enimmäisnopeus Anna tulostimen vaihtaa suuren riittoisuuden (vain musta tila) ja nopean (väritila) välillä, kun se toimii alhaisella nopeudella. Asetus muuttaa tulostimen toimintaa vain, kun tulostimen koneiston käsittelynopeus on 25 sivua minuutissa. Se ei vaikuta, kun tulostimen koneiston käsittelynopeus on tätä suurempi. Resurssien tallennus Ei käytössä * Käytössä Määritä, mitä tulostin tekee ladatuille resursseille, kun tulostin vastaanottaa työn, joka edellyttää muistia enemmän kuin on käytettävissä. Kun asetuksena on  Ei käytössä , tulostin säilyttää ladatut resurssit vain siihen asti, kunnes muistia tarvitaan. Ei-aktiiviseen komentokieleen liittyvät resurssit poistetaan. Kun asetuksena on  Käytössä , tulostin tallentaa kaikki pysyvät ladatut resurssit kaikissa kielenvalitsimissa. Tulostin näyttää tarvittaessa Muisti täynnä -ilmoitukset pysyvien resurssien poistamisen sijaan. Kaikkien töiden tulostusjärjestys Aakkosellinen * Uusimmat ensin Vanhimmat ensin Määritä järjestys, jossa kaikki pidossa olleet ja luottamukselliset työt tulostetaan. Keskeytettyjen tulostustöiden automaattinen poisto Ei käytössä * Käytössä Määritä tulostin peruuttamaan automaattisesti jonossa olevat tulostustyöt, jotka ovat keskeytyneet virheiden, kuten paperitukosten ja puuttuvien tarvikkeiden, vuoksi. valikko Asetukset"},{"UUID":"e24ab56f-94fe-4744-ada1-8b188d3bf7d5","title":"Tulostaminen","link":"layout-topic.html","desc":"Laatu Laatu-valikkokohdat ja niiden kuvaukset","descFull":"Laatu Laatu-valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Tulostustila - Mustavalko Väri * Määritä, miten tulostin luo värisisällön. Tulostustarkkuus - 4800 CQ * 1 200 dpi Määritä tulosteiden tarkkuus. 4800 CQ  takaa korkealaatuisen tulosteen enimmäisnopeudella. Värin tummuus - 1 - 5  (4*) Määritä tekstikuvien vaaleus tai tummuus. Rasteri - Normaali * Yksityiskohta Paranna tulostetta siten, että sillä on pehmeämmät viivat ja tarkemmat reunat. Värinsäästäjä - Ei käytössä * Käytössä Kuvien tulostamiseen käytetyn väriaineen määrän vähentäminen. Kun asetus on  Käytössä , tämä asetus ohittaa  Värin tummuus  -asetuksen arvon. RGB-kirkkaus - ‑6 - 6  (0*) Säädä sivulla olevien RGB-kohteiden ja harmaiden kohteiden kirkkautta. Tämä asetus ei vaikuta tiedostoihin, joissa käytetään CMYK-värimäärityksiä. RGB-kontrasti - 0 - 5  (0*) Säädä sivulla olevien RGB-kohteiden ja harmaiden kohteiden kontrastia. Tämä asetus ei vaikuta tiedostoihin, joissa käytetään CMYK-värimäärityksiä. RGB-kylläisyys - 0 - 5  (0*) Säilytä mustavalkoarvot, kun säädät sivulla olevien kohteiden väriarvoja. Tämä asetus ei vaikuta tiedostoihin, joissa käytetään CMYK-värimäärityksiä. Kuvankäsittelyn lisäasetukset Väritasapaino Syaani  (0*) Magenta  (0*) Keltainen  (0*) Musta  (0*) Säädä kussakin värissä käytetyn väriaineen määrää. Palauta oletukset Palauta kaikkien väriasetusten oletusarvot. Värinkorjaus Ei käytössä Automaattinen * Manuaalinen Muokkaa asiakirjojen tulostuksessa käytettäviä väriasetuksia. Ei käytössä  -asetus määrittää tulostimen vastaanottamaan värinkorjauksen ohjelmistosta. Automaattinen -asetus määrittää tulostimen käyttämään eri väriprofiilia kullekin tulostetun sivun objektille. Manuaalinen -asetuksen avulla käyttäjät voivat itse määrittää RGB- tai CMYK-värinmuunnot, joita käytetään jokaisessa tulostettavan sivun objektissa. Väriesimerkit Tulosta värinäytteet Tulosta esimerkkisivuja jokaisesta tulostimessa käytettävästä RGB- ja CMYK-värinmuuntotaulukosta Värinsäätö Värinsäätö Säädä tulosteiden värien epäsuhtaisuutta kalibroimalla tulostin. Spottivärin vaihtaminen Aseta mukautettu CMYK Määritä tiettyjä CMYK-arvoja 20 nimettyyn spottiväreihin. valikko Laatu"},{"UUID":"8de3a900-57f8-4881-9db3-7a0af3fac498","title":"Tulostaminen","link":"layout-topic.html","desc":"Työkirjanpito Työkirjanpito-valikon kohteet ja niiden","descFull":"Työkirjanpito Työkirjanpito-valikon kohteet ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Työkirjanpito Ei käytössä * Käytössä Määritä tulostin luomaan loki vastaanottamistaan tulostustöistä. Työkirjanpito-lokin aikaväli Päivittäin Viikoittain Kuukausittain * Määritä, kuinka usein tulostin luo lokitiedoston. Kirjaa toiminta lokiin aikavälin lopussa Ei mitään * Lähetä nykyinen loki sähköpostina Lähetä nykyinen loki sähköpostina ja poista se Julkaise nykyinen loki Julkaise ja poista nykyinen loki Määritä, miten tulostin reagoi, kun aikaväli tulee täyteen. Työkirjanpito-lokin aikaväliksi  määritetty arvo määrää, milloin toiminto suoritetaan. Kirjaa, kun melkein täynnä Käytössä * (5 Mt) Ei käytössä Määritä lokitiedoston enimmäiskoko ennen kuin tulostin suorittaa  Kirjaa, kun melkein täynnä  -toiminnon. Tämä valikkokohta on näkyvissä vain, kun tallennusväline on asennettu. Kirjaa, kun melkein täynnä Ei mitään * Lähetä nykyinen loki sähköpostina Lähetä nykyinen loki sähköpostina ja poista se Lähetä vanhin loki sähköpostina ja poista se Julkaise nykyinen loki Julkaise ja poista nykyinen loki Julkaise ja poista vanhin loki Poista nykyinen loki Poista vanhin loki Poista kaikki paitsi nykyinen Poista kaikki lokit Määritä, miten tulostin reagoi, kun tallennuslevy on lähes täynnä. Loki lähes täynnä  -tasoksi määritetty arvo määrää, milloin toiminto suoritetaan. Kirjaa, kun täynnä Ei mitään * Lähetä nykyinen loki sähköpostina ja poista se Lähetä vanhin loki sähköpostina ja poista se Julkaise ja poista nykyinen loki Julkaise ja poista vanhin loki Poista nykyinen loki Poista vanhin loki Poista kaikki paitsi nykyinen Poista kaikki lokit Määritä, miten tulostin reagoi, kun tallennusaseman käyttö saavuttaa enimmäisrajan (100 Mt). Lähetyslokin URL Asetus on käyttäjän määrittämä. Määritä, mihin tulostin julkaisee työkirjanpidon lokit. Sähköpostiosoite lokien lähettämistä varten Asetus on käyttäjän määrittämä. Määritä sähköpostiosoite, johon tulostin lähettää työkirjanpidon lokit. Lokitiedoston etuliite Asetus on käyttäjän määrittämä. Määritä lokitiedostoissa käytettävä etuliite. TCP/IP-valikossa määritettyä nykyistä palvelimen nimeä käytetään lokitiedoston etuliitteen oletuksena. valikko Töiden seuranta"},{"UUID":"427a74e4-da94-4b87-b8f8-095a2e4a0a6d","title":"Tulostaminen","link":"layout-topic.html","desc":"PDF-muoto PDF-valikkokohdat ja niiden kuvaukset","descFull":"PDF-muoto PDF-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Skaalaa sopivan kokoiseksi Ei käytössä * Käytössä Muuta sivun kokoa siten, että se mahtuu valitulle paperikoolle. Kommentit Tulostaminen Älä tulosta * Määritä, tulostetaanko PDF-tiedoston kommentit. Tulosta PDF-virhe Ei käytössä Käytössä * Ota käyttöön PDF-virheen tulostus. valikko PDF-muoto"},{"UUID":"a2db73bb-e7a2-4ce9-ab68-d7f3dc843c12","title":"Tulostaminen","link":"layout-topic.html","desc":"PostScript PostScript PostScript-valikkokohdat ja niiden","descFull":"PostScript PostScript PostScript-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Tulosta PS-virhe Ei käytössä * Käytössä Tulosta sivu, joka kuvaa PostScript®-virheen. Virheen tapahtuessa työn käsittely pysähtyy, tulostin tulostaa virheilmoituksen ja loput tulostustyöstä tyhjennetään. Vähimmäisrivinleveys 1–30  (2*) Määritä vähimmäispiirtoleveys. 1200 dpi:n tarkkuudella tulostetut työt käyttävät arvoa suoraan. Lukitse PS-käynnistystila Ei käytössä Käytössä * Poista k. SysStart-tiedosto SysStart-tiedoston ottaminen käyttöön altistaa tulostimen tai verkon tietoturvariskille. Kuvan tasoitus Ei käytössä * Käytössä Paranna kuvantarkkuudeltaan pienten kuvien kontrastia ja terävyyttä. Tämä asetus ei vaikuta kuviin, joiden tarkkuus on vähintään 300 dpi. Fonttijärjestys Vakio * Flash/levy Määrittää fonttien hakujärjestyksen Vakio  määrittää tulostimen etsimään fontteja ensin tulostimen muistista, ennen kuin niitä etsitään tallennusasemasta. Flash/levy  määrittää tulostimen etsimään fontteja ensin tallennusasemasta ja vasta sitten tulostimen muistista Tämä valikkokohta on näkyvissä vain, kun tallennusväline on asennettu. Odotuksen aikakatkaisu Ei käytössä Käytössä * Määritä tulostin odottamaan lisätietoja, ennen kuin se peruuttaa tulostustyön. Kun asetus on  Käytössä , tehdasasetus on 40 sekuntia. valikko PostScript"},{"UUID":"384f9cf0-d7f5-4eae-b11d-e668a76bfe0d","title":"Tulostaminen","link":"layout-topic.html","desc":"PCL PCL-valikkokohdat ja niiden kuvaukset","descFull":"PCL PCL-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Fonttilähde Vakio * Levy Lataa Flash-muisti Fonttikortti Kaikki Valitse lähde, jossa on oletusfonttivalikoima. Levy  näkyy vain, jos asennettuna on toimiva, luku- ja kirjoitussuojaamaton kiintolevy, jossa fontit ovat. Lataus  näkyy vain, jos ladatut fontit ovat tulostimen muistissa. Flash  näkyy vain, jos asennettuna on toimiva, luku- ja kirjoitussuojaamaton flash-muisti, jossa fontit ovat. Fonttikortti  näkyy vain, jos kelvollinen fonttikortti on asennettu tai älykäs tallennusasema on määritetty. Fontin nimi [Käytettävissä olevien fonttien luettelo] ( Courier *) Valitse fontti määritetystä fonttilähteestä. Merkistö [Luettelo käytettävissä olevista merkistöistä ( 10U PC‑8 *) Määritä kunkin fonttinimen merkistö. Merkistö on aakkosten ja numeroiden, väli- ja erikoismerkkien sarja. Merkistöt tukevat eri kieliä tai tiettyjä sovelluksia, kuten tieteellisessä tekstissä käytettäviä matemaattisia symboleja. Tiheys 0.08–100.00  (10.00*) Määritä tasavälisten tai kiinteävälisten fonttien tiheys. Valikkokohta viittaa kiinteävälisten merkkien lukumäärään yhdellä tuumalla vaakasuuntaista tekstiä. Suunta Pysty * Vaaka Käänteinen pysty Käänteinen vaaka Määrittää tekstin ja kuvien suunnan sivulla Riviä/sivu 1–255 Määritä kullekin sivulle PCL®-tietovirran kautta tulostettavien tekstirivien määrä. Tämä valikkokohta aktivoi pystysuuntaisen välistyksen, jollin rivit tulostuvat sivun oletusreunusten väliin. 60 on tehdasasetus Yhdysvalloissa. 64 on kansainvälinen tehdasasetus. PCL5-vähimmäisrivinleveys 1–30  (2*) Aseta 1 200 dpi:n tarkkuudella tulostettujen töiden alkuperäinen vähimmäispiirtoleveyden arvo soveltuvan emulaattorin avulla. PCLXL-vähimmäisrivinleveys 1–30  (2*) A4-leveys 198 mm * 203 mm Määritä A4-paperin loogisen sivun leveys. Looginen sivu on se fyysisen sivun alue, johon tiedot tulostetaan. Autom.CR LFn jälkeen Käytössä Ei käytössä * Määritä tulostin tekemään rivinvaihto rivinsiirtokomennon jälkeen. Rivinvaihto käskee tulostinta siirtämään kohdistimen saman rivin alkuun. Autom.LF CRn jälkeen Käytössä Ei käytössä * Määritä tulostin tekemään rivinsiirto rivinvaihtokomennon jälkeen. Lokeron uud.num. Määritä monisyöttö Määritä lokero  [x] Määr. käsins. paperi Määritä kirjekuoren käsins. Määritä tulostin toimimaan sellaisen eri tulostinohjaimen tai mukautetun sovelluksen kanssa, jonka paperilähdemääritykset ovat erilaiset. Valitse jokin seuraavista vaihtoehdoista: Ei käytössä * – tulostin käyttää oletusasetusten mukaisia paperilähdemäärityksiä Ei mitään  -asetus ohittaa paperinsyötön valintakomennon. 0–199  – Valitaan paperilähteen mukautettua asetusta määrittävä luku. Näytä tehdasoletukset Näytä kullekin paperilähteelle määritetty oletusarvo. Palauta oletusasetukset Palauta lokeroiden uudelleennumerointiarvojen oletukset.  Tulostuksen aikakatkaisu Ei käytössä Käytössä * (90) Määritä tulostin lopettamaan tulostustyö sen jälkeen, kun se on ollut käyttämättömänä määritetyn ajan. valikko PCL"},{"UUID":"97dda99b-f837-4979-83ef-c7a59f2164be","title":"Tulostaminen","link":"layout-topic.html","desc":"Kuva Kuva-valikkokohdat ja niiden kuvaukset","descFull":"Kuva Kuva-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Automaattinen sovitus Käytössä Ei käytössä * Valitse kuvalle paras käytettävissä oleva paperikoko- ja suunta-asetus. Kun asetus on  Käytössä , tämä asetus ohittaa kuvan skaalaus- ja suunta-asetukset. Käänteinen Ei käytössä * Käytössä Muuta kaksisävyiset mustavalkokuvat käänteisiksi. Asetus ei koske GIF- ja JPEG-kuvamuotoja. Skaalaaminen Parhaiten sopiva * Ankkuroi ylävasen Ankkuroi keskelle Sovita korkeus/leveys Sovita korkeus Sovita leveys Säädä kuva sopimaan tulostusalueelle. Kun  Automaattinen sovitus  -asetus on  Käytössä ,  Skaalaus -asetus on automaattisesti  Parhaiten sopiva . Suunta Pysty * Vaaka Käänteinen pysty Käänteinen vaaka Määrittää tekstin ja kuvien suunnan sivulla valikko Kuva"},{"UUID":"beff1245-bf4d-4eaa-aca2-a196d729846d","title":"Paperi","link":"tray-configuration-topic.html","desc":"Lokeromääritys Lokeromääritys-valikkokohdat ja niiden kuvaukset","descFull":"Lokeromääritys Lokeromääritys-valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. oletuslähde - Lokero  [x] (1*) Monikäyttösyöttöaukko Manuaalinen paperi Manuaalinen kirjekuori Kaikkien tulostustöiden oletuspaperilähteen määrittäminen. Paperikoko/-laji Lokero  [x] Monikäyttösyöttöaukko Manuaalinen paperi Manuaalinen kirjekuori Koko Tyyppi Määritä kuhunkin paperilähteeseen lisätty paperikoko tai paperilaji. Korvaava paperikoko - Ei käytössä A5/Statement Letter/A4 11 x 17/A3 Kaikki listatut * Määritä tulostin korvaamaan määritetty paperikoko, jos pyydetyn kokoista paperi ei ole lisättynä yhteenkään paperilähteeseen. Jos asetusarvo on  Ei käytössä , laite kehottaa käyttäjää lisäämään tarvittavaa paperikokoa. Koko luettelo  sallii kaikki käytettävissä olevat korvaukset. Monisyötön asetus - Kasetti * Manuaalinen Ensimmäinen Määritä monikäyttösyöttöaukon toiminta. Kasetti -asetuksella monikäyttösyöttöaukko määritetään automaattiseksi paperilähteeksi. Kun  Manuaalinen -vaihtoehto valitaan, monikäyttösyöttöaukkoa voidaan käyttää ainoastaan manuaalisesti syötettyjen tulostustöiden yhteydessä. Ensimmäinen -asetuksella monikäyttösyöttöaukko määritetään ensisijaiseksi paperilähteeksi. valikko Lokeromääritys"},{"UUID":"c1d935a5-60f0-4f08-a68b-5ec149038458","title":"Paperi","link":"tray-configuration-topic.html","desc":"Tulostusmateriaalimääritys Materiaalimääritykset-valikkokohdat ja niiden kuvaukset","descFull":"Tulostusmateriaalimääritys Materiaalimääritykset-valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Mittayksiköt - Tuumat Millimetrit Määritä Universal-paperikoon mittayksikkö. Tuumat  on oletusasetus Yhdysvalloissa.  Millimetrit  on kansainvälinen oletusasetus. Yleisasetukset Kaikki syöttölokerot Pystykuvan leveys Määritä Universal-paperin pystyleveys. Pystykuvan korkeus Määritä Universal-paperin pystykorkeus. Syöttösuunta  ( Lyhyt reuna *) Määritä tulostin poimimaan paperi lyhyestä tai pitkästä reunasta. Pitkä reuna  näkyy ainoastaan, jos pisin reuna on lyhyempi kuin tuettu enimmäisleveys. Mukautetut skannauskoot Skannauskoon nimi Asetus on käyttäjän määrittämä. Anna mukautetulle skannaukselle nimi. Leveys 1–8,5 tuumaa  (8.5*) 25–215,9 mm  (215.9*) Määritä alkuperäisen asiakirjan leveys. Korkeus 1–25 tuumaa  (11*) 25–635 mm  (279.4*) Määritä alkuperäisen asiakirjan korkeus. Suunta Pysty * Vaaka Määritä alkuperäisen asiakirjan sisällön suunta. 2 skannausta sivua kohti Ei käytössä * Käytössä Määritä skannausten oletusmäärä tulostimen molemmille puolille. Materiaalityypin asetus [Paperilajien luettelo] Laatu Paino Lisäyssuunta Lähetä alustaan Määritä paperin laatu, paino ja suunta. valikko Tulostusmateriaalimääritys"},{"UUID":"2a0d47c8-1ce2-4166-a1a3-19d1c1e28955","title":"Paperi","link":"tray-configuration-topic.html","desc":"Alustamääritys Alustamääritykset-valikkokohdat ja niiden kuvaukset","descFull":"Alustamääritys Alustamääritykset-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Vastaanottoalusta Vakioalusta * Alusta  [x] Määritä tulostustöiden vastaanottoalusta. Määr. vast.ot.al Postilaatikko * Yhdistä Link Optional (Yhdis. alustat) Lajin määritys Määritä vastaanottoalustojen toimintatilan. Postilaatikko  sallii vakioalustan ja minkä tahansa lisäalustan valitsemisen erikseen. Yhdistä -asetus sallii kaikkien vastaanottoalustojen yhdistämisen, jolloin tulostin käsittelee niitä yhtenä isona vastaanottoalustana. Yhdistä alustat  -asetus yhdistää kaikki valinnaiset alustat yhdeksi suureksi vastaanottoalustaksi. Lajin määritys  -asetus määrittää kullekin paperilajille vastaanottoalustan tai yhdistetyn alustajoukon. Mukautetut alustojen nimet Vakioalusta Alusta  [x] Määritä kullekin alustalle nimi. valikko Alustamääritys"},{"UUID":"97cbc658-b9d3-4afe-ab1e-5274968eb37f","title":"Kopioiminen","link":"copy-defaults-topic.html","desc":"Kopioinnin oletusasetukset  Kopioinnin oletusasetukset","descFull":"Kopioinnin oletusasetukset  Kopioinnin oletusasetukset -valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehdot Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Sisältölaji - Teksti Teksti/valokuva * Valokuva Grafiikka Paranna tulosteen laatua alkuperäisen asiakirjan sisällön mukaan. Sisältölähde - Mustavalkolaser Värilaser * Mustesuihku Valokuva/filmi Aikakauslehti Sanomalehti Painotuote Muu Paranna tulosteen laatua alkuperäisen asiakirjan lähteen mukaan. Puolet - 1-puolinen 1-puoliseksi 1-puolinen 2-puoliseksi 2-puolinen 1-puoliseksi 2-puolinen 2-puoliseksi Määritä skannaustoiminta alkuperäisen asiakirjan perusteella. Erotinsivut - Ei mitään * Kopioiden väliin Töiden väliin Arkkien väliin Määrittää, lisätäänkö tulostettaessa tyhjiä erotinsivuja. Erotinsivujen lähde - Lokero  [x] (1*) Monikäyttösyöttöaukko Määritä erotinsivun paperilähde. Väri - Ei käytössä Käytössä * Automaattinen Määritä tulostin luomaan skannaustyöstä värituloste. Sivua/puoli - Ei käytössä * 2 pystysuuntaista sivua 4 pystysuuntaista sivua 2 vaakasuuntaista sivua 4 vaakasuuntaista sivua Määritä, kuinka monta sivukuvaa paperiarkin yhdelle puolelle tulostetaan. Tulosta sivun reunat - Ei käytössä * Käytössä Aseta reunus kunkin kuvat ympärille tulostettaessa useita sivuja yhdelle sivulle. Lajittelu - Ei käytössä [1,1,1,2,2,2] Käytössä [1,2,1,2,1,2] * Tulosta useita kopioita järjestyksessä. Porrasta sivut - Ei mitään * Kopioiden väliin Töiden väliin Porrasta kunkin tulostustyön tulosteet tai tulostustyön kopiot. Jos valitset  Kopioiden väliin , laite porrastaa tulostustyön kopiot, jos  Lajittele -asetus on  Käytössä [1,2,1,2,1,2] . Jos  Lajittele -asetus on  Ei käytössä [1,1,1,2,2,2] , tulostettujen sivujen jokainen osio porrastetaan (kaikki sivut 1, kaikki sivut 2 ja niin edelleen). Töiden väliin  -asetus määrittää saman porrastuskohdan koko tulostustyölle tulostettavien kopioiden määrästä riippumatta. Tämä valikkokohta on näkyvissä vain, kun porrastusalusta tai nidonnan ja rei'ityksen viimeistelijä on asennettuna. Nitoja - Ei käytössä * 1 niitti, vasen yläkulma 2 niittiä, vasen reuna 1 niitti, oikea yläkulma 2 niittiä, yläreuna 1 niitti, vasen alakulma 2 niittiä, alareuna 1 niitti, oikea alakulma 2 niittiä, oikea reuna 4 niittiä Määritä kaikkien tulostustöiden nidontakohta. Tämä valikkokohta on näkyvissä vain, kun nidonnan viimeistelijä on asennettu. Lävistä - Ei käytössä * 2 reikää 3 reikää 4 reikää Tulosteiden rei'ittäminen. Tämä valikkokohta näkyy vain, kun nidonnan, rei'ityksen tai vihkon viimeistelijä on asennettu. Kopioi kohteesta -koko [Paperikokoluettelo] Määritä alkuperäisen asiakirjan paperikoko. Letter  on tehdasasetus Yhdysvalloissa.  A4  on kansainvälinen tehdasasetus. Kopioi kohteeseen -lähde - Lokero  [x] (1*) Monikäyttösyöttöaukko Automaattinen koon tunnistus Määritä kopiointityön paperilähde. Lämpötila - ‑4 - 4  (0*) Määritä, pitääkö tulosteen olla viileämpi vai lämpimämpi. Tummuus - 1 - 9  (5*) Säädä skannatun kuvan tummuutta. Kopiomäärä - 1–9999  (1*) Määritä kopioiden määrä. Ylätunniste/alatunniste - Vasen ylätunniste Keskimmäinen ylätunniste Oikea ylätunniste Vasen alatunniste Keskimmäinen alatunniste Oikea alatunniste Määritä skannatun kuvan ylä- tai alatunnisteen tiedot. Peittokuva - Luottamuksellinen Kopioiminen Vedos Kiireellinen Mukautettu Ei käytössä * Määritä peittokuvan teksti, joka tulostetaan kopioihin. Mukautettu peittokuva - Asetus on käyttäjän määrittämä. Kirjoita  Peittokuva -valikon  Mukautettu -valinnan teksti. Kuvankäsittelyn lisäasetukset Väritasapaino Syaani–Punainen  (0*) Magenta–Vihreä  (0*) Keltainen–Sininen  (0*) Säädä syaanin, magentan ja keltaisen värin voimakkuutta. Värinpoisto Värinpoisto  ( Ei mitään *) Punainen oletuskynnysarvo  (128*) Vihreä oletuskynnysarvo  (128*) Sininen oletuskynnysarvo  (128*) Määritä skannauksen aikana poistettava väri ja sen värinpoistoasetus. Autom. värintunn. Väriherkkyys  (5*) Alueherkkyys  (5*) Määritä automaattisen värintunnistuksen asetus. Kontrasti Sisällön mukaan * 0–5 Määritä skannatun kuvan kontrasti. Taustan poisto Taustan tunnistus  ( Sisältöpohjainen *) Taso  (0*) Poista taustaväri tai kuvan häiriöt alkuperäisestä asiakirjasta. Sisältöpohjainen  poistaa taustavärin alkuperäisestä asiakirjasta. Kiinteä  poistaa kuvasta häiriöitä. Automaattinen keskitys Ei käytössä * Käytössä Keskitä sisältö sivun keskelle. Peilikuva Ei käytössä * Käytössä Luo alkuperäisestä asiakirjasta peilikuva. Negatiivinen kuva Ei käytössä * Käytössä Luo alkuperäisestä asiakirjasta negatiivikuva. Varjojen yksityiskohtaisuus ‑4 - 4  (0*) Säädä alkuperäisen asiakirjan varjojen yksityiskohtaisuutta. Skannaus reunasta reunaan Ei käytössä * Käytössä Skannaa alkuperäinen asiakirja reunasta reunaan. Terävyys 1–5  (3*) Säädä skannatun kuvan terävyyttä Järjestelmänvalvojan asetukset Salli värikopiot Ei käytössä Käytössä * Tulosta kopiot värillisinä. Salli tärkeimmät kopiot Ei käytössä Käytössä * Keskeytä tulostustyö kopiointia varten. Mukautetun työn skannaus Ei käytössä * Käytössä Määritä tulostin skannaamaan alkuperäisten asiakirjojen ensimmäinen sarja käyttäen määritettyjä asetuksia ja skannaa sitten seuraava sarja samoilla tai eri asetuksilla. Salli tallennus pikavalintana Ei käytössä Käytössä * Tallenna kopiointiasetukset pikavalinnaksi. Mallikopio Ei käytössä * Käytössä Tulosta mallikopio ja tarkista laatu ennen jäljellä olevien kopioiden tulostamista. valikko Kopioinnin oletusasetukset"},{"UUID":"9e5f10ef-55fa-417a-8841-1740d4804c1c","title":"Faksin oletusasetukset","link":"fax-defaults-subgroup.html","desc":"Faksitila Faksitila -valikkokohta ja sen","descFull":"Faksitila Faksitila -valikkokohta ja sen kuvaus Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Faksitila Faksi * Faksipalvelin Ei käytössä Valitse faksitila. valikko Faksitila"},{"UUID":"4edb83b0-dc8b-4c15-b5f5-70b01d048230","title":"Faksin oletusasetukset","link":"fax-defaults-subgroup.html","desc":"Faksiasetukset Yleiset faksiasetukset -valikkokohdat ja","descFull":"Faksiasetukset Yleiset faksiasetukset -valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Yleiset faksiasetukset Faksinimi Asetus on käyttäjän määrittämä. Oman faksitunnuksen määrittäminen. Faksinumero Asetus on käyttäjän määrittämä. Oman faksinumeron määrittäminen. Faksitunnus Faksinimi Faksinumero * Määritä faksineuvottelussa käytettävä faksitunnus. Ota käyttöön manuaalinen faksaus Ei käytössä * Käytössä Ota käyttöön tulostimen manuaalinen faksitoiminto. Tämä valikkokohta edellyttää linjajakajaa ja puhelinkuuloketta. Tavallisella puhelinlinjalla voit vastata tulevaan faksityöhön ja valita faksinumeron. Voit siirtyä manuaaliseen faksaustoimintoon suoraan valitsemalla näppäimistöllä  #  ja  0 . Muistin käyttö Vain vastaanotto Mostly receive (Lähinnä vastaanotto) Yhtä suuri * Lähinnä lähetys Vain lähetys Määritä faksaukseen varattavan sisäisen tulostinmuistin määrä. Tämä valikkokohta estää muistipuskurin ongelmat ja epäonnistuneet faksit. Peruuta faksit Salli ** Älä salli Peruuta lähtevät tai saapuvat faksit. Faksinumeron piilotus Ei käytössä * Vasemmalta Oikealta Määritä lähtevän faksinumeron piilottamisen muoto. Yleiset faksiasetukset Piilotettavat numerot 0–58  (0*) Määritä, miten monta numeroa piilotetaan lähtevän faksin numerossa. Ota käyttöön puhelinlinjan kytkennän tunnistus Ei käytössä Käytössä * Määritä, onko puhelinlinja liitetty tulostimeen. Tapahtumat havaitaan heti. Ota käyttöön puhelinlinjan väärän liitännän tunnistus Ei käytössä Käytössä * Määritä, onko puhelinlinja liitetty oikeaan tulostimen porttiin. Tapahtumat havaitaan heti. Ota käyttöön alanumeron tuki Ei käytössä Käytössä * Määritä, käyttääkö toinen laite, esimerkiksi toinen puhelin, samaa puhelinlinjaa. Tapahtumat havaitaan heti. Optimoi faksin yhteensopivuus Asetus on käyttäjän määrittämä. Määritä tulostimen faksitoiminto mahdollisimman hyvin yhteensopivaksi muiden faksilaitteiden kanssa. Faksin siirtoyksikkö T.38 Analoginen G.711 etherFAX Määritä faksin siirtotapa. Tämä valikkokohta näkyy vain, jos tulostimeen on asennettu etherFAX- tai FoIP (Fax over IP) -käyttöoikeus. HTTPS-faksiasetukset Tämä valikko näkyy vain, jos  Faksin siirtoyksikkö  -asetuksena on  etherFAX . HTTPS-palvelun URL Asetus on käyttäjän määrittämä. Määritä etherFAX-palvelun URL. HTTPS-välityspalvelin Asetus on käyttäjän määrittämä. Määritä välityspalvelimen URL. HTTPS-välityspalvelimen käyttäjä Asetus on käyttäjän määrittämä. Määritä välityspalvelimen käyttäjätunnus ja salasana. HTTPS-välityspalvelimen salasana Faksin lähetyksen salaus Ei käytössä Käytössä * Pakollinen Ota käyttöön lähtevien faksiviestien salaus. Faksin vastaanoton salaus Ei käytössä Käytössä * Pakollinen Ota käyttöön saapuvien faksiviestien salaus. HTTPS-faksin tila Asetus on vain luku -tieto. Näytä etherFAX-tiedonsiirron tila. Faksin lähetysasetukset Erottelutarkkuus Vakio * Tarkka Erittäin tarkka Huipputarkka Määritä skannatun kuvan tarkkuus. Suurempi tarkkuus pidentää faksin lähetysaikaa ja vaatii enemmän muistia. Alkuper. koko [Paperikokoluettelo] ( Eri koot *) Alkuperäisen asiakirjan koon määrittäminen. Suunta Pysty * Vaaka Määritä alkuperäisen asiakirjan suunta. Puolet Ei käytössä * Lyhyt reuna Pitkä reuna Määritä alkuperäisen asiakirjan suunta skannattaessa asiakirjan molemmille puolille. Sisältölaji Teksti * Teksti/valokuva Valokuva Grafiikka Paranna tulosteen laatua alkuperäisen asiakirjan sisällön mukaan. Sisältölähde Mustavalkolaser Värilaser * Mustesuihku Valokuva/filmi Aikakauslehti Sanomalehti Painotuote Muu Paranna tulosteen laatua alkuperäisen asiakirjan lähteen mukaan. Tummuus 1–9  (5*) Säädä skannatun kuvan tummuutta. Vaihteen alanumero Käytössä Ei käytössä * Tilaajavaihdevalinta-asetuksen avulla tulostin valitsee faksinumeron odottamatta valintaäänen tunnistamista. Automaattinen puhelinvaihde (PABX) on puhelinverkko, joka sallii yhden käyttönumeron tarjota useita linjoja ulkopuolisille soittajille. Numeronvalintatila Äänitaajuus * Pulssi Määritä tulevien ja lähtevien faksien numeronvalintatila. Kuvankäsittelyn lisäasetukset Väritasapaino Syaani - Punainen  (0*) Magenta - Vihreä  (0*) Keltainen - Sininen  (0*) Säädä värien voimakkuutta skannauksen aikana. Värinpoisto Sisällön mukaan * 0 1 2 3 4 5 Määritä tulosteen kontrasti. Peilikuva Ei käytössä * Käytössä Luo alkuperäisestä asiakirjasta peilikuva. Varjojen yksityiskohtaisuus ‑4 - 4  (0*) Säädä skannatussa kuvassa näkyvien varjon yksityiskohtien määrää. Skannaus reunasta reunaan Ei käytössä Käytössä * Salli alkuperäisen asiakirjan skannaus reunasta reunaan. Terävyys 1–5  (3*) Säädä skannatun kuvan terävyyttä Lämpötila ‑4 - 4  (0*) Määritä, pitääkö tulosteen olla viileämpi vai lämpimämpi. Järjestelmänvalvojan asetukset Automaattinen uudelleenvalinta 0–9  (5*) Määritä, miten monta kertaa tulostin valitsee uudelleen, ennen kuin se peruuttaa faksin lähettämisen määritettyyn kohteeseen. Redial Frequency (Uudelleensoittoväli) 1–200  minuuttia (3*) Paranna faksin lähettämisen onnistumismahdollisuuksia kasvattamalla uudelleenvalintayritysten väliaikaa. Ota ECM käyttöön Käytössä * Ei käytössä Ota käyttöön faksitöiden virheenkorjaustila (ECM). ECM havaitsee ja korjaa faksin lähetyksen virheet, jotka aiheutuvat puhelinlinjan kohinasta ja heikosta signaalista. Ota faksin skannaus käyttöön Käytössä * Ei käytössä Luo fakseja tulostimen skannerilla. Ota ohjainfaksaus käyttöön Käytössä * Ei käytössä Salli tulostinohjaimen lähettää fakseja. Salli tallennus pikavalintana Käytössä * Ei käytössä Tallenna faksinumeroita pikavalintoina tulostimeen. Enimmäisnopeus 33600 * 14400 9600 4800 2400 Määritä enimmäislähetysnopeus. Mukautetun työn skannaus Ei käytössä * Käytössä Ota käyttöön mukautettujen töiden skannaus oletuksena. Skannauksen esikatselu Ei käytössä * Käytössä Näytä skannauksen esikatselu näytössä. Autom. syöttölaitteen vinouden säätö Ei käytössä Käytössä * Tällä korjataan vähäinen vinous skannatussa kuvassa. Ota käyttöön värifaksien skannaus Oletusarvoisesti ei käytössä * Oletusarvoisesti käytössä Älä käytä koskaan Käytä aina Ota käyttöön faksin väriskannaus. Muunna värifaksit automaattisesti mustavalkofakseiksi Käytössä * Ei käytössä Muunna kaikki lähtevät värifaksit mustavalkoisiksi. Vahvista faksinumero Ei käytössä * Käytössä Pyydä käyttäjää vahvistamaan faksinumero. Valinnan etuliite Asetus on käyttäjän määrittämä. Määritä valinnan etuliite. Valinnan etuliitesäännöt Asetus on käyttäjän määrittämä. Määritä valinnan etuliitesääntö. Faksin vastaanottoasetukset Faksityö odottaa Ei mitään * Väriaine Väriaine ja tarvikkeet Poista tulostusjonosta faksityöt, jotka pyytävät tiettyjä, käyttämättömissä olevia resursseja. Hälytykset ennen vastaamista 1–25  (3*) Valitse soittokertojen määrä, ennen kuin tulostin vastaa saapuviin puheluihin. Automaattinen tiivistys Käytössä * Ei käytössä Sovita tulevat faksit sivulle. Paperilähde Lokero  [x] Automaattinen * Määritä paperilähde tulevien faksien tulostamista varten. Puolet Käytössä Ei käytössä * Tulosta paperin molemmille puolille. Erotinsivut Ei mitään * Ennen työtä Työn jälkeen Määrittää, lisätäänkö tulostettaessa tyhjiä erotinsivuja. Erotinsivujen lähde Lokero  [x] (1*) Määritä erotinsivun paperilähde. Vastaanottoalusta Vakioalusta Määritä vastaanotettujen faksien vastaanottoalusta. Faksin alatunniste Käytössä Ei käytössä * Tulosta lähetystiedot vastaanotetun faksin kunkin sivun alareunaan. Faksin alatunnisteen aikaleima Vastaanotto * Tulostaminen Tulosta aikaleima vastaanotetun faksin kunkin sivun alareunaan. Faksien pysäytys Pysäytetty faksi -tila  (Ei käytössä*) Siirrä saapuneiden faksien tulostus myöhempään ajankohtaan. Faksin pysäytysaikataulu Määritä faksien pysäyttämisaikataulu. Tämä valikkokohde näkyy vain, jos  Pysäytetty faksi -tila  -asetus on  Ajastettu . Järjestelmänvalvojan asetukset Ota käyttöön faksivastaanotto Käytössä * Ei käytössä Määritä tulostin vastaanottamaan faksit. Ota käyttöön värifaksien vastaanoton Käytössä * Ei käytössä Määritä tulostin vastaanottamaan värillisiä fakseja. Ota käyttöön soittajan tunnus Käytössä Ei käytössä * Näytä saapuvan puhelun soittajan numerotiedot tulostimen näytössä. Estä nimetön faksi Käytössä Ei käytössä * Estä saapuvat faksit, joilla ei ole faksitunnusta. Estetty faksi -luettelo Lisää estetty faksi Määritä puhelinnumerot, jonka haluat estää. Vastaus käytössä Kaikki soitot * Vain yksi soitto Vain kaksi soittoa Vain kolme soittoa Vain yksi tai kaksi soittoa Vain yksi tai kolme soittoa Vain kaksi tai kolme soittoa Määritä tunnusääni saapuville fakseille. Automaattivastaus Käytössä * Ei käytössä Määritä tulostin vastaanottamaan faksit automaattisesti. Manuaalinen vastauskoodi 0–9  (9*) Aloita faksin vastaanottaminen syöttämällä koodi puhelimen numeronäppäimillä. Tämä valikkokohta näkyy vain, kun tulostin jakaa puhelinlinjan puhelimen kanssa Tämä valikkokohta näkyy vain, kun tulostin asetetaan vastaanottamaan faksit manuaalisesti. Fax Forwarding (Faksin välitys) Tulosta * Tulosta ja välitä Välitä Määritä, välitetäänkö saapunut faksi. Välitä Kohde 1 Kohde 2 Määritä, mihin saapuneet faksit välitetään. Tämä valikkokohta näkyy vain, kun  Faksin välitys  -asetuksena on  Tulosta ja välitä  tai  Välitä . Enimmäisnopeus 33600 * 14400 9600 4800 2400 Määritä faksien enimmäislähetysnopeus. Faksin kansilehti Faksin kansilehti Oletusarvoisesti ei käytössä * Oletusarvoisesti käytössä Älä käytä koskaan Käytä aina Määritä faksin kansilehden asetukset. Sisällytä Vastaanottaja-kenttä Ei käytössä * Käytössä Sisällytä Lähettäjä-kenttä Ei käytössä * Käytössä Lähettäjä Asetus on käyttäjän määrittämä. Sisällytä viestikenttä Ei käytössä * Käytössä Viesti: Asetus on käyttäjän määrittämä. Sisällytä logo Ei käytössä * Käytössä Sisällytä alaviite [x] Ei käytössä * Käytössä Alaviite [x] Asetus on käyttäjän määrittämä. Faksilokiasetukset Lähetyslokin aikaväli Aina * Ei koskaan Vain virhetilanteessa Määritä, kuinka usein tulostin luo lähetyslokin. Lähetyslokin toiminto Tulosta  ( Käytössä *) Sähköposti  ( Ei käytössä *) Tulosta tai lähetä sähköpostilla loki onnistuneista faksilähetyksistä tai lähetysvirheistä. Vastaanottovirheloki Älä tulosta * Tulosta virhetilanteessa Tulosta loki faksin vastaanottovirheistä. Tulosta lokit automaattisesti Käytössä * Ei käytössä Tulosta kaikki faksitoiminta. Lokin paperilähde Lokero  [x] (1*) Määritä paperilähde lokien tulostamista varten. Logs Display (Lokinäyttö) Vastaanottajan faksinimi * Valittu numero Tunnista lähettäjä etäfaksinimen tai faksinumeron perusteella. Enable Job Log (Ota käyttöön työloki) Käytössä * Ei käytössä Näytä kaikkien faksitöiden yhteenveto. Enable Call Log (Ota käyttöön soittoloki) Käytössä * Ei käytössä Näytä faksipuheluhistorian yhteenveto. Log Output Bin (Lokin vastaanottoalusta) Vakioalusta * Alusta  [x] Määritä tulostettujen lokien vastaanottoalusta. Kaiutinasetukset Kaiutintila Aina pois käytöstä * Aina käytössä On until Connected (Käytössä, kunnes yhteys muodostettu) Määritä faksin kaiutintila. Speaker Volume (Kaiuttimen äänenvoimakkuus) Matala * Suuri Säädä faksin kaiuttimen äänenvoimakkuutta. Soittoäänen voimakkuus Ei käytössä * Käytössä Ota soittoäänen voimakkuus käyttöön. VoIP-asetukset VoIP-protokolla SIP * H.323 Määritä VoIP (Voice over Internet Protocol) -yhteyskäytäntö. STUN-palvelin Asetus on käyttäjän määrittämä. Läpäise palomuuri määrittämällä STUN-palvelin. Pakota faksitila Ei käytössä Käytössä * Vaihda VoIP-yhdyskäytävä analogisesta T.38:aan faksipuhelun alussa. Pakota faksitilan viive 0–15  (7*) Määritä sekunteina viive lähetettäessä uutta  Pakota faksitila  -kutsua. SIP-asetukset Välipalvelin Asetus on käyttäjän määrittämä. Määritä sen järjestelmän IP-osoite, joka muuntaa puhelinnumeron IP-osoitteeksi, johon faksi lähetetään. Rekisteröijä Asetus on käyttäjän määrittämä. Määritä sen järjestelmän nimi tai IP-osoite, joka hoitaa SIP (Session Initiation Protocol) -asiakaslaitteiden rekisteröinnin. Käyttäjä Asetus on käyttäjän määrittämä. Määritä SIP-käyttäjän nimi. Salasana Asetus on käyttäjän määrittämä. Määritä salasana, jota käytetään rekisteröitäessä SIP-rekisteröijään. Valtuutustunnus Asetus on käyttäjän määrittämä. Rekisteröitäessä käytettävä käyttäjätunnus. Jos  Valtuutustunnus -asetusta ei ole määritetty, asetus käyttää Käyttäjä-kentässä olevaa käyttäjätunnusta. Rekisteröinnin siirto UDP * TCP Määritä SIP-siirtotyyppi rekisteröintiä varten. Tulevien puhelujen siirto UDP * TCP UDP ja TCP Määritä SIP-siirtotyyppi saapuvia puheluja varten. Lähtevien puhelujen siirto UDP * TCP Määritä SIP-siirtotyyppi lähteviä puheluja varten. Lähtevä välipalvelin Asetus on käyttäjän määrittämä. Määritä lähtevä välipalvelin, joka välittää kaiken SIP-viestinnän. Yhteyshenkilö Asetus on käyttäjän määrittämä. Määrittää SIP-yhteyshenkilön nimen. Alue Asetus on käyttäjän määrittämä. Määritä SIP-alueen nimi. Jos Alue-asetusta ei ole määritetty, asetus käyttää  Ota yhteyttä  -kentässä olevaa nimeä. SIP-rekisteröinnin tila Asetus on vain luku -tieto. Näyttää SIP-rekisteröinnin tilan. H.323-asetukset Yhdyskäytävä Asetus on käyttäjän määrittämä. Määritä H.323-yhdyskäytävän IP-osoite. Gatekeeper Asetus on käyttäjän määrittämä. Määritä H.323-gatekeeper. Käyttäjä Asetus on käyttäjän määrittämä. Määritä H.323-yhdyskäytävässä käytettävä käyttäjätunnus. Salasana Asetus on käyttäjän määrittämä. Määritä H.323-yhdyskäytävän salasana. Ota käyttöön nopea käynnistys Ei käytössä * Käytössä Ota käyttöön nopea käynnistys. Poista käytöstä H.245-tunneli Ei käytössä * Käytössä Poista käytöstä H.323-tunneli. Poista käytöstä Gatekeeper-etsintä Ei käytössä Käytössä * Poista käytöstä H.323-gatekeeper-etsintä. T.38-asetukset Ilmaisimen vikasieto 0–5  (3*) Määritä, miten monta kertaa faksi-ilmaisin toistetaan T.38-viestinnässä. Pienen nopeuden vikasieto 0–5  (3*) Määritä, miten monta kertaa pienen nopeuden tiedot toistetaan T.38-viestinnässä. Suuren nopeuden vikasieto 0–5  (1*) Määritä, miten monta kertaa suuren nopeuden tiedot toistetaan T.38-viestinnässä. valikko Faksiasetukset"},{"UUID":"79e5e953-211b-4f59-bb35-398fd8005500","title":"Faksin oletusasetukset","link":"fax-defaults-subgroup.html","desc":"Faksipalvelimen asetukset Yleiset faksiasetukset Yleiset","descFull":"Faksipalvelimen asetukset Yleiset faksiasetukset Yleiset faksiasetukset -valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Muotoon - Määritä faksin vastaanottaja. Jos haluat käyttää faksinumeroa, lisää numeromerkki (#) numeron edelle. Vastausosoite - Määritä faksilähetyksen vastausosoite. Aihe - Määritä faksin aihe ja viesti. Ilmoitus - Ota käyttöön analoginen vastaanotto Ei käytössä * Käytössä Määritä tulostin vastaanottamaan analogiset faksit. Faksipalvelimen sähköpostiasetukset Faksipalvelimen sähköpostiasetukset  -valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Käytä SMTP-sähköpostipalvelinta Käytössä Ei käytössä * Käytä sähköpostin SMTP (Simple Mail Transfer Protocol) -asetuksia faksien vastaanottamisessa ja lähettämisessä. Kun asetus on  Käytössä , muita  Faksipalvelimen sähköpostiasetukset  -valikon asetuksia ei näytetä. Ensisijainen SMTP-yhdyskäytävä - Kirjoita ensisijaisen SMTP-palvelimen IP-osoite tai isäntänimi. Ensisijaisen SMTP-yhdyskäytävän portti 1–65535 (25*) Kirjoita ensisijaisen SMTP-palvelimen porttinumero. Toissijainen SMTP-yhdyskäytävä - Kirjoita toissijaisen SMTP-palvelimen tai SMTP-varmistuspalvelimen IP-osoite tai isäntänimi. Toissijaisen SMTP-yhdyskäytävän portti 1–65535 (25*) Kirjoita toissijaisen SMTP-palvelimen tai SMTP-varmistuspalvelimen porttinumero. SMTP-aikakatkaisu 5–30 (30*) Määritä, kuinka pian tulostin aikakatkaistaan, jos SMTP-palvelin ei vastaa. Vastausosoite - Määritä faksilähetyksen vastausosoite. Käytä SSL-/TLS-yhteyskäytäntöä Ei käytössä * Neuvottele Pakollinen Määritä, lähetetäänkö faksi salatun linkin kautta. Edellytä luotettua varmennetta Ei käytössä Käytössä * Määritä luotettu varmenne käytettäessä SMTP-palvelinta. SMTP-palvelimen todennus Todennusta ei tarvita * Kirjautuminen/tavallinen NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Määritä SMTP-palvelimen todennustyyppi. Laitteeseen perustuva s-posti Ei mitään * Käytä laitteen SMTP-tunnistetietoja Määritä, tarvitaanko tunnistetietoja, kun laite lähettää sähköpostia. Käyttäjän lähettämä sähköposti Ei mitään * Käytä laitteen SMTP-tunnistetietoja Käytä istunnon käyttäjätunnusta ja salasanaa Käytä istunnon sähköpostiosoitetta ja salasanaa Kysy käyttäjältä Määritä, tarvitaanko tunnistetietoja, kun käyttäjä lähettää sähköpostia. Käytä AD-laitteen kirjautumistietoja Ei käytössä * Käytössä Ota käyttöön käyttäjän tunnistetiedot ja ryhmäkohteet yhteyden muodostamiseksi SMTP-palvelimeen. Device Userid (Laitekäyttäjätunnus) - Määritä käyttäjätunnus ja salasana yhteyden muodostamiseksi SMTP-palvelimeen. Laitesalasana - Kerberos 5 REALM - Määritä Kerberos 5 -todennusprotokollan alue. NTLM-toimialue - Määritä NTLM-suojausprotokollan toimialuenimi. Poista käytöstä SMTP-palvelinta ei ole määritetty -virhe Ei käytössä * Käytössä Piilota SMTP-palvelinta ei ole määritetty -virheilmoitus. Faksipalvelimen skannausasetukset Faksipalvelimen skannausasetukset  -valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Kuvan tiedostomuoto TIFF (.tif) PDF (.pdf) * XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Määritä skannatun kuvan tiedostomuoto. Sisältölaji Teksti * Teksti/valokuva Valokuva Grafiikka Paranna tulosteen laatua alkuperäisen asiakirjan sisällön mukaan. Sisältölähde Mustavalkolaser Värilaser * Mustesuihku Valokuva/filmi Aikakauslehti Sanomalehti Painotuote Muu Paranna tulosteen laatua alkuperäisen asiakirjan lähteen mukaan. Faksin tarkkuus Vakio * Tarkka Erittäin tarkka Huipputarkka Määritä faksin tarkkuus. Puolet Ei käytössä * Lyhyt reuna Pitkä reuna Määritä alkuperäisen asiakirjan suunta skannattaessa asiakirjan molemmille puolille.   Tummuus 1–9 (5*) Määritä tulosteen tummuus. Suunta Pysty * Vaaka Määrittää tekstin ja kuvien suunnan sivulla Alkuper. koko [Paperikokoluettelo] Määritä alkuperäisen asiakirjan paperikoko. Eri koot  on tehdasasetus Yhdysvalloissa.  A4  on kansainvälinen oletusasetus. Asetus voi vaihdella tulostinmallin mukaan. Käytä monisivuisia TIFF-kuvia Ei käytössä Käytössä * Valitse yksi- tai monisivuiset TIFF-tiedostot. valikko Faksipalvelimen määritys"},{"UUID":"13d46555-e8de-42b8-a3bf-69fa571aa64f","title":"Sähköposti","link":"email-setup-topic.html","desc":"Sähköpostiasetukset  Sähköpostiasetukset-valikkokohdat ja niiden","descFull":"Sähköpostiasetukset  Sähköpostiasetukset-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Ensisijainen SMTP-yhdyskäytävä Asetus on käyttäjän määrittämä. Kirjoita sähköpostin lähettämiseen käytettävän ensisijaisen SMTP-palvelimen IP-osoite tai isäntänimi. Ensisijaisen SMTP-yhdyskäytävän portti 1–65535 (25*) Kirjoita ensisijaisen SMTP-palvelimen porttinumero. Toissijainen SMTP-yhdyskäytävä Asetus on käyttäjän määrittämä. Kirjoita toissijaisen SMTP-palvelimen tai SMTP-varmistuspalvelimen IP-osoite tai isäntänimi. Toissijaisen SMTP-yhdyskäytävän portti 1–65535  (25*) Kirjoita toissijaisen SMTP-palvelimen tai SMTP-varmistuspalvelimen porttinumero. SMTP-aikakatkaisu 5–30 sekuntia  (30*) Määritä, kuinka pian tulostin aikakatkaistaan, jos SMTP-palvelin ei vastaa. Vastausosoite Asetus on käyttäjän määrittämä. Määritä sähköpostin vastausosoite. Käytä aina SMTP-vastausosoitetta Käytössä Ei käytössä * Käytä SMTP-palvelimessa aina oletusvastausosoitetta. Käytä SSL-/TLS-yhteyskäytäntöä Ei käytössä * Neuvottele Pakollinen Määritä, lähetetäänkö sähköposti salatun linkin kautta. Edellytä luotettua varmennetta Ei käytössä Käytössä * Edellytä luotettua varmennetta käytettäessä SMTP-palvelinta. SMTP-palvelimen todennus Todennusta ei tarvita * Kirjautuminen/tavallinen NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Määritä SMTP-palvelimen todennustyyppi. Laitteen lähettämä sähköposti Ei mitään * Ei mitään * Käytä laitteen SMTP-tunnistetietoja Määritä, tarvitaanko tunnistetietoja, kun laite lähettää sähköpostia. Käyttäjän lähettämä sähköposti Ei mitään * Käytä laitteen SMTP-tunnistetietoja Käytä istunnon käyttäjätunnusta ja salasanaa Käytä istunnon sähköpostiosoitetta ja salasanaa Kysy käyttäjältä Määritä, tarvitaanko tunnistetietoja, kun käyttäjä lähettää sähköpostia. Käytä AD-laitteen kirjautumistietoja Ei käytössä * Käytössä Määritä, tarvitaanko tunnistetietoja, kun käyttäjä lähettää sähköpostia. Device Userid (Laitekäyttäjätunnus) Asetus on käyttäjän määrittämä. Määritä käyttäjätunnus ja salasana yhteyden muodostamiseksi SMTP-palvelimeen. Laitesalasana Asetus on käyttäjän määrittämä. Kerberos 5 REALM Asetus on käyttäjän määrittämä. Määritä Kerberos 5 -todennusprotokollan alue. NTLM-toimialue Asetus on käyttäjän määrittämä. Määritä NTLM-suojausprotokollan toimialuenimi. Poista käytöstä SMTP-palvelinta ei ole määritetty -virhe Ei käytössä * Käytössä Piilota SMTP-palvelinta ei ole määritetty -virheilmoitus. valikko Sähköpostiasetukset"},{"UUID":"4011c17d-3e2a-4984-b06a-892645badd50","title":"Sähköposti","link":"email-setup-topic.html","desc":"Sähköpostin oletusasetukset  Sähköpostin oletusasetukset","descFull":"Sähköpostin oletusasetukset  Sähköpostin oletusasetukset -valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehdot Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Aihe: - Asetus on käyttäjän määrittämä. Määritä sähköpostiviestin aihe ja viesti. Viesti: - Asetus on käyttäjän määrittämä. Tiedostonimi - Asetus on käyttäjän määrittämä. Määritä skannatun asiakirjan tiedostonimi. Muoto - JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) CSV (.csv) Määritä skannatun asiakirjan tiedostomuoto. Valikkokohdat voivat vaihdella tulostinmallin mukaan. Yleiset tekstintunnistusasetukset Tunnistetut kielet [List of languages] Määritä optisen tekstintunnistuksen (OCR) asetukset. Tämä valikkokohta tulee näkyviin vain, jos olet ostanut ja asentanut OCR-ratkaisun. Automaattinen kierto Ei käytössä * Käytössä Rakeisuuden poisto Ei käytössä * Käytössä Automaattinen kontrastinparannus Ei käytössä * Käytössä PDF-asetukset PDF-versio 1.3 1.4 1.5 * 1.6 1.7 Määritä skannatun kuvan PDF-asetukset. Arkistoversio - ja  Arkisto (PDF/A)  -asetusta tuetaan vain, jos  PDF-versioksi  on määritetty 1.4 tai 1.7. Tiiviisti pakattu  näkyy vain, kun tallennusasema on asennettu. Suojattu  on tuettu vain, kun  PDF-version  asetuksena on 1.4 tai uudempi. Arkisto (PDF/A) Ei käytössä * Käytössä Arkistoversio A‑1a * A‑1b A‑2u Tiiviisti pakattu Ei käytössä * Käytössä Suojattu Ei käytössä * Käytössä Haettavissa Ei käytössä * Käytössä Jaa työ sivuittain 0 * Sisältölaji - Teksti Teksti/valokuva * Valokuva Grafiikka Määritä alkuperäisen asiakirjan sisältö. Sisältölähde - Mustavalkolaser * Värilaser Mustesuihku Valokuva/filmi Aikakauslehti Sanomalehti Painotuote Muu Määritä alkuperäisen asiakirjan lähde. Väri - Mustavalko Harmaasävy Väri * Automaattinen Määritä alkuperäisen asiakirjan tallennustapa. Erottelutarkkuus - 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi Määritä skannatun kuvan tarkkuus. Tummuus - 1–9  (5*) Säädä skannatun kuvan tummuutta. Suunta - Pysty * Vaaka Määritä alkuperäisen asiakirjan suunta. Alkuper. koko - Eri koot Määritä alkuperäisen asiakirjan paperikoko. Puolet - Ei käytössä * Lyhyt reuna Pitkä reuna Määritä alkuperäisen asiakirjan suunta skannattaessa asiakirjan molemmille puolille. Kuvankäsittelyn lisäasetukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Väritasapaino Syaani Magenta Keltainen ‑4–4  (0*) ‑4–4  (0*) ‑4–4  (0*) Säädä syaanin, magentan ja keltaisen värin voimakkuutta. Värinpoisto Värinpoisto Ei mitään * Punainen Vihreä Sininen Määritä skannauksen aikana poistettava väri ja sen värinpoistoasetus. Punainen oletuskynnysarvo 0–255  (128*) Vihreä oletuskynnysarvo 0–255  (128*) Sininen oletuskynnysarvo 0–255  (128*) Autom. värintunn. Väriherkkyys 1–9  (5*) Määritä automaattisen värintunnistuksen asetus. Alueherkkyys 1–9  (5*) Sähköpostin bittimäärä 1 bitti * 8 bittiä Vähimmäisskannaustarkkuus 75 dpi 150 dpi 200 dpi 300 dpi * JPEG-laatu - Sisällön mukaan * 5–95 Määritä skannatun kuvan JPEG-laatu. Kontrasti - Sisällön mukaan * 0–5 Määritä skannatun kuvan kontrasti. Taustan poisto Taustan tunnistus Sisältöpohjainen * Kiinteä Taso  ‑4 - 4  (0*) Poista taustaväri tai kuvan häiriöt alkuperäisestä asiakirjasta. Peilikuva - Ei käytössä * Käytössä Luo alkuperäisestä asiakirjasta peilikuva. Negatiivinen kuva - Ei käytössä * Käytössä Luo alkuperäisestä asiakirjasta negatiivikuva. Varjojen yksityiskohtaisuus - ‑4 - 4  (0*) Säädä skannatun kuvan varjojen yksityiskohtaisuutta. Skannaus reunasta reunaan - Ei käytössä * Käytössä Skannaa alkuperäinen asiakirja reunasta reunaan. Terävyys - 1–5  (3*) Säädä skannatun kuvan terävyyttä. Lämpötila - ‑4 - 4  (0*) Luo sinisempi tai punaisempi tuloste alkuperäisestä asiakirjasta. Tyhjät sivut Tyhjän sivun poistaminen Älä poista * Poista Poista tyhjät sivut alkuperäisestä asiakirjasta. Tyhjien sivujen herkkyys 1–9  (5*) Määritä skannauksen herkkyys tyhjien sivujen suhteen alkuperäisessä asiakirjassa. Järjestelmänvalvojan asetukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Max Email Size (Enimmäissähköpostikoko) 0–65535  (0*) Määritä kunkin sähköpostiviestin sallittu tiedostokoko. Kokovirheilmoitus Asetus on käyttäjän määrittämä. Määritä virheilmoitus, jonka tulostin lähettää, kun sähköpostiviesti ylittää sallitun tiedostokoon. Voit kirjoittaa enintään 1024 merkkiä. Rajoita kohteita Asetus on käyttäjän määrittämä. Rajoita sähköpostilähetys ainoastaan määritettyihin toimialuenimiin. Erota toimialueet toisistaan pilkulla. Lähetä kopio itselle Ei näy * Oletusarvoisesti käytössä Oletusarvoisesti ei käytössä * Aina käytössä Lähetä sähköpostiviestin kopio itselle. Salli sähköpostit vain itselle Ei käytössä * Käytössä Määritä tulostin lähettämään sähköpostia vain itsellesi. Kopio/piilokopio: Ei käytössä * Käytössä Ota käyttöön kopio ja piilokopio sähköpostissa. Käytä monisivuisia TIFF-kuvia Ei käytössä * Käytössä Ota käyttöön useiden TIFF-kuvien skannaus yhteen TIFF-tiedostoon. TIFF-pakkaus JPEG LZW * Määritä TIFF-tiedostojen pakkaustyyppi. Tekstin oletusarvo 5–95  (75*) Määritä skannattavan sisällön tekstin laatu. Tekstin/kuvan oletusarvo 5–95  (75*) Määritä skannattavan sisällön tekstin ja valokuvan laatu. Valokuvan oletusarvo 5–95  (50*) Määritä skannattavan sisällön valokuvan laatu. Autom. syöttölaitteen vinouden säätö Ei käytössä * Käytössä Määritä tulostin säätämään asiakirjansyöttölaitteesta skannattujen asiakirjojen kuvien vinous. Lähetysloki Tulosta loki * Älä tulosta lokia Tulosta vain virhetilanteessa Tulosta sähköpostiskannausten lähetysloki. Lokin paperilähde Lokero  [x] (1*) Monikäyttösyöttöaukko Määritä paperilähde lokien tulostamista varten. Mukautetun työn skannaus Ei käytössä * Käytössä Määritä tulostin skannaamaan alkuperäisten asiakirjojen ensimmäinen sarja käyttäen määritettyjä asetuksia ja skannaa sitten seuraava sarja samoilla tai eri asetuksilla. Tämä valikkokohta on näkyvissä vain, kun tallennusväline on asennettu. Skannauksen esikatselu Ei käytössä Käytössä * Näytä alkuperäisen asiakirjan skannauksen esikatselu. Tämä valikkokohta on näkyvissä vain, kun tallennusväline on asennettu. Salli tallennus pikavalintana Ei käytössä Käytössä * Tallenna sähköpostiosoite pikavalintana. Sähköpostikuvat lähetetty muodossa Liite * Web Link (Web-linkki) Määritä, miten sähköpostissa olevat kuvat lähetetään. Palauta sähköpostin tiedot lähetyksen jälkeen Ei käytössä Käytössä * Palauta Vastaanottaja-, Aihe-, Viesti- ja Tiedostonimi-kentät oletusarvoihinsa sähköpostin lähettämisen jälkeen. valikko Sähköpostin oletusasetukset"},{"UUID":"29153aed-6c50-4246-b508-df928a9cccc8","title":"Sähköposti","link":"email-setup-topic.html","desc":"Web-linkin asetukset Web-linkin asetus -valikkokohdat","descFull":"Web-linkin asetukset Web-linkin asetus -valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Server (Palvelin) Asetus on käyttäjän määrittämä. Määritä sen palvelimen tunnistetiedot, joka isännöi sähköpostissa olevia kuvia. Kirjaudu Asetus on käyttäjän määrittämä. Salasana Asetus on käyttäjän määrittämä. Path (Polku) Asetus on käyttäjän määrittämä. Tiedostonimi Asetus on käyttäjän määrittämä. Web-linkki Asetus on käyttäjän määrittämä. valikko Web-linkin asetus"},{"UUID":"fcbf0a94-abb0-4614-8e9b-bc50f543c660","title":"FTP","link":"ftp-defaults-topic.html","desc":"FTP-oletusasetukset  FTP-oletusasetukset-valikkokohdat ja niiden","descFull":"FTP-oletusasetukset  FTP-oletusasetukset-valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehdot Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Muoto - JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) CSV (.csv) Määritä skannatun kuvan tiedostomuoto. Yleiset tekstintunnistusasetukset Tunnistetut kielet [List of languages] Määritä optisen tekstintunnistuksen (OCR) asetukset. Tämä valikko tulee näkyviin vain, jos olet ostanut ja asentanut OCR-ratkaisun. Automaattinen kierto Ei käytössä * Käytössä Rakeisuuden poisto Ei käytössä * Käytössä Automaattinen kontrastinparannus Ei käytössä * Käytössä PDF-asetukset PDF-versio 1.3 1.4 1.5 * 1.6 1.7 Määritä skannatun kuvan PDF-asetukset. Arkistoversio - ja  Arkisto (PDF/A)  -asetusta tuetaan vain, jos  PDF-versioksi  on määritetty 1.4 tai 1.7. Tiiviisti pakattu  näkyy vain, kun tallennusasema on asennettu. Suojattu  on tuettu vain, kun  PDF-version  asetuksena on 1.4 tai uudempi. Arkisto (PDF/A) Ei käytössä * Käytössä Arkistoversio A‑1a * A‑1b A‑2u Tiiviisti pakattu Ei käytössä * Käytössä Suojattu Ei käytössä * Käytössä Haettavissa Ei käytössä * Käytössä Jaa työ sivuittain 0 * Sisältölaji - Teksti Teksti/valokuva * Grafiikka Valokuva Paranna tulosteen laatua alkuperäisen asiakirjan sisältötyypin mukaan. Sisältölähde - Mustavalkolaser Värilaser * Mustesuihku Valokuva/filmi Aikakauslehti Sanomalehti Painotuote Muu Paranna tulosteen laatua alkuperäisen asiakirjan sisältölähteen mukaan. Väri - Mustavalko Harmaasävy Väri * Automaattinen Määritä tulostin tallentamaan tiedoston sisältö värillisenä tai mustavalkoisena. Erottelutarkkuus - 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi Määritä skannatun kuvan tarkkuus. Tummuus - 1–9  (5*) Säädä skannatun kuvan tummuutta. Suunta - Pysty * Vaaka Määritä alkuperäisen asiakirjan suunta. Alkuper. koko - Eri koot * Määritä alkuperäisen asiakirjan paperikoko. Puolet - Ei käytössä * Pitkä reuna Lyhyt reuna Määritä suunta skannattaessa asiakirjan molemmille puolille. Tiedostonimi - Asetus on käyttäjän määrittämä. Määritä skannatun kuvan tiedostonimi. Kuvankäsittelyn lisäasetukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Väritasapaino Syaani Magenta Keltainen ‑4–4  (0*) ‑4–4  (0*) ‑4–4  (0*) Säädä syaanin, magentan ja keltaisen värin voimakkuutta. Värinpoisto Värinpoisto Ei mitään * Punainen Vihreä Sininen Määritä skannauksen aikana poistettava väri ja sen värinpoistoasetus. Punainen oletuskynnysarvo 0–255  (128*) Vihreä oletuskynnysarvo 0–255  (128*) Sininen oletuskynnysarvo 0–255  (128*) Autom. värintunn. Väriherkkyys 1–9  (5*) Määritä automaattisen värintunnistuksen asetus. Alueherkkyys 1–9  (5*) Sähköpostin bittimäärä 1 bitti * 8 bittiä Vähimmäisskannaustarkkuus 75 dpi 150 dpi 200 dpi 300 dpi * JPEG-laatu - Sisällön mukaan * 5–95 Määritä skannatun kuvan JPEG-laatu. Kontrasti - Sisällön mukaan * 0–5 Määritä skannatun kuvan kontrasti. Taustan poisto Taustan tunnistus Sisältöpohjainen * Kiinteä Taso  ‑4 - 4  (0*) Poista taustaväri tai kuvan häiriöt alkuperäisestä asiakirjasta. Peilikuva - Ei käytössä * Käytössä Luo alkuperäisestä asiakirjasta peilikuva. Negatiivinen kuva - Ei käytössä * Käytössä Luo alkuperäisestä asiakirjasta negatiivikuva. Varjojen yksityiskohtaisuus - ‑4 - 4  (0*) Säädä skannatun kuvan varjojen yksityiskohtaisuutta. Skannaus reunasta reunaan - Ei käytössä * Käytössä Skannaa alkuperäinen asiakirja reunasta reunaan. Terävyys - 1–5  (3*) Säädä skannatun kuvan terävyyttä. Lämpötila - ‑4 - 4  (0*) Luo sinisempi tai punaisempi tuloste alkuperäisestä asiakirjasta. Tyhjät sivut Tyhjän sivun poistaminen Älä poista * Poista Poista tyhjät sivut alkuperäisestä asiakirjasta. Tyhjien sivujen herkkyys 1–9  (5*) Määritä skannauksen herkkyys tyhjien sivujen suhteen alkuperäisessä asiakirjassa. Järjestelmänvalvojan asetukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Tekstin oletusarvo 5–95  (75*) Määritä skannatun kuvan tekstin laatu. Tekstin/kuvan oletusarvo 5–95  (75*) Määritä skannatun kuvan tekstin ja valokuvan laatu. Valokuvan oletusarvo 5–95  (50*) Määritä skannatun kuvan valokuvan laatu. Käytä monisivuisia TIFF-kuvia Käytössä * Ei käytössä Ota käyttöön useiden TIFF-kuvien skannaus yhteen TIFF-tiedostoon. TIFF-pakkaus LZW * JPEG Määritä TIFF-tiedostojen pakkaustyyppi. Lähetysloki Tulosta loki * Älä tulosta lokia Tulosta vain virhetilanteessa Tulosta FTP-skannauksen lähetysloki. Lokin paperilähde Lokero  [x] (1*) Monikäyttösyöttöaukko Määritä paperilähde FTP-lokien tulostamista varten. Mukautetun työn skannaus Ei käytössä * Käytössä Määritä tulostin skannaamaan alkuperäisten asiakirjojen ensimmäinen sarja käyttäen määritettyjä asetuksia ja skannaa sitten seuraava sarja samoilla tai eri asetuksilla. Tämä valikkokohta on näkyvissä vain, kun tallennusväline on asennettu. Skannauksen esikatselu Ei käytössä Käytössä * Näytä alkuperäisen asiakirjan esikatselu. Tämä valikkokohta on näkyvissä vain, kun tallennusväline on asennettu. Salli tallennus pikavalintana Ei käytössä Käytössä * Tallenna FTP-osoite pikavalintana. valikko FTP-oletusasetukset"},{"UUID":"2a0f2fd7-b2e7-44d4-ad32-c77a0b334880","title":"USB-asema","link":"flash-drive-scan-topic.html","desc":"Flash-asemaskannaus Flash-asemaskannaus-valikkokohdat ja niiden kuvaukset","descFull":"Flash-asemaskannaus Flash-asemaskannaus-valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Muoto - JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) * DOCX (.doc) XLSX (.xlsx) CSV (.csv) Määritä skannatun kuvan tiedostomuoto. TXT (.txt) ,  RTF (.rtf) ,  DOCX (.docx) ,  XLSX (.xlsx)  ja  CSV (.csv)  näkyvät vain, jos olet ostanut ja asentanut OCR-ratkaisun. Yleiset tekstintunnistusasetukset Tunnistetut kielet [List of languages] Määritä OCR-asetukset. Tämä valikko tulee näkyviin vain, jos olet ostanut ja asentanut OCR-ratkaisun. Automaattinen kierto Ei käytössä * Käytössä Rakeisuuden poisto Ei käytössä * Käytössä Automaattinen kontrastinparannus Ei käytössä * Käytössä PDF-asetukset PDF-versio 1.3 1.4 1.5 * 1.6 1.7 Määritä skannatun kuvan PDF-asetukset. Arkisto (PDF/A) - ja  Arkistoversio -asetusta tuetaan vain, jos  PDF-versioksi  on määritetty 1.4 tai 1.7. Tiiviisti pakattu  näkyy ainoastaan, kun tulostimen kiintolevy on asennettu. Suojattu  on tuettu vain, kun  PDF-version  asetuksena on 1.4 tai uudempi. Arkisto (PDF/A) Ei käytössä * Käytössä Arkistoversio A‑1a * A‑1b A‑2u Tiiviisti pakattu Ei käytössä * Käytössä Suojattu Ei käytössä * Käytössä Haettavissa Ei käytössä * Käytössä Sisältölaji - Teksti Teksti/valokuva * Valokuva Grafiikka Paranna tulosteen laatua alkuperäisen asiakirjan sisältötyypin mukaan. Sisältölähde - Mustavalkolaser Värilaser * Mustesuihku Valokuva/filmi Aikakauslehti Sanomalehti Painotuote Muu Paranna tulosteen laatua alkuperäisen asiakirjan sisältölähteen mukaan. Väri - Mustavalko Harmaasävy Väri * Automaattinen Määritä tulostin tallentamaan tiedoston sisältö värillisenä tai mustavalkoisena. Erottelutarkkuus - 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi Määritä skannatun kuvan tarkkuus. Tummuus - 1–9  (5*) Säädä skannatun kuvan tummuutta. Suunta - Pysty * Vaaka Määritä alkuperäisen asiakirjan suunta. Alkuper. koko - Eri koot * Määritä alkuperäisen asiakirjan paperikoko. Puolet - Ei käytössä * Lyhyt reuna Pitkä reuna Määritä alkuperäisen asiakirjan suunta skannattaessa asiakirjan molemmille puolille. Tiedostonimi - Asetus on käyttäjän määrittämä. Määritä skannatun kuvan tiedostonimi. Kuvankäsittelyn lisäasetukset Väritasapaino Syaani  (0*) Magenta  (0*) Keltainen  (0*) Säädä syaanin, magentan ja keltaisen värin voimakkuutta. Värinpoisto Värinpoisto  ( Ei mitään *) Punainen oletuskynnysarvo  (128*) Vihreä oletuskynnysarvo  (128*) Sininen oletuskynnysarvo  (128*) Määritä skannauksen aikana poistettava väri ja sen värinpoistoasetus. Autom. värintunn. Väriherkkyys  (5*) Alueherkkyys  (5*) Skannauksen värimäärä  (1 bitti*) Vähimmäisskannaustarkkuus  (300 dpi*) Määritä automaattisen värintunnistuksen asetus. JPEG-laatu Sisällön mukaan * 5–95 Määritä skannatun kuvan JPEG-laatu. Kontrasti Sisällön mukaan * 0–5 Määritä skannatun kuvan kontrasti. Taustan poisto Taustan tunnistus  ( Sisältöpohjainen *) Taso  (0*) Poista taustaväri tai kuvan häiriöt alkuperäisestä asiakirjasta. Peilikuva Ei käytössä * Käytössä Luo alkuperäisestä asiakirjasta peilikuva. Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Kuvankäsittelyn lisäasetukset Negatiivinen kuva Ei käytössä * Käytössä Luo alkuperäisestä asiakirjasta negatiivikuva. Varjojen yksityiskohtaisuus ‑4 - 4  (0*) Säädä skannatun kuvan varjojen yksityiskohtaisuutta. Skannaus reunasta reunaan Ei käytössä * Käytössä Skannaa alkuperäinen asiakirja reunasta reunaan. Terävyys 1–5  (3*) Säädä skannatun kuvan terävyyttä. Lämpötila ‑4 - 4  (0*) Luo sinisempi tai punaisempi tuloste alkuperäisestä asiakirjasta. Tyhjät sivut Tyhjien sivujen poisto  ( Älä poista *) Tyhjien sivujen herkkyys  (5*) Määritä skannauksen herkkyys tyhjien sivujen suhteen alkuperäisessä asiakirjassa. Järjestelmänvalvojan asetukset Tekstin oletusarvo 5–95  (75*) Määritä skannatun kuvan tekstin laatu. Tekstin/kuvan oletusarvo 5–95  (75*) Määritä skannatun kuvan tekstin ja valokuvan laatu. Valokuvan oletusarvo 5–95  (50*) Määritä skannatun kuvan valokuvan laatu. Käytä monisivuisia TIFF-kuvia Ei käytössä Käytössä * Ota käyttöön useiden TIFF-kuvien skannaus yhteen TIFF-tiedostoon. TIFF-pakkaus JPEG LZW * Määritä TIFF-tiedostojen pakkaustyyppi. Mukautetun työn skannaus Ei käytössä * Käytössä Määritä tulostin skannaamaan alkuperäisten asiakirjojen ensimmäinen sarja käyttäen määritettyjä asetuksia ja skannaa sitten seuraava sarja samoilla tai eri asetuksilla. Tämä valikkokohta on näkyvissä vain, kun tallennusväline on asennettu. Skannauksen esikatselu Ei käytössä * Käytössä Näytä alkuperäisen asiakirjan skannauksen esikatselu. Tämä valikkokohta on näkyvissä vain, kun tallennusväline on asennettu. Autom. syöttölaitteen vinouden säätö Ei käytössä Käytössä * Määritä tulostin säätämään asiakirjansyöttölaitteesta skannattujen asiakirjojen kuvien vinous. valikko Flash-asemaskannaus"},{"UUID":"28437d72-fb7a-49ad-ad72-d633efb5985c","title":"USB-asema","link":"flash-drive-scan-topic.html","desc":"Flash-asematulostus Flash-asematulostus-valikkokohdat ja niiden kuvaukset","descFull":"Flash-asematulostus Flash-asematulostus-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Kopiomäärä 1–9999  (1*) Määritä tulostustyön kopiomäärä. Paperilähde Lokero  [x] (1*) Monikäyttösyöttöaukko Manuaalinen paperi Manuaalinen kirjekuori Määritä tulostustyön paperilähde. Väri Ei käytössä Käytössä * Tulosta flash-aseman sisältö värillisenä. Lajittelu Ei käytössä [1,1,1,2,2,2] Käytössä [1,2,1,2,1,2] * Säilytä tulostustyön sivut järjestyksessä varsinkin tulostettaessa useita kopioita työstä. Puolet Yksipuolinen * Kaksipuolinen Määritä, tulostetaanko vain sivun toiselle puolelle vai molemmille puolille. Nitoja Ei käytössä * 1 niitti, vasen yläkulma 2 niittiä, vasen reuna 1 niitti, oikea yläkulma 2 niittiä, yläreuna 1 niitti, vasen alakulma 2 niittiä, alareuna 1 niitti, oikea alakulma 2 niittiä, oikea reuna Määritä kaikkien tulostustöiden nidontakohta. Tämä valikkokohta on näkyvissä vain, kun nidonnan viimeistelijä on asennettu. Rei'itys Ei käytössä * 2 reikää 3 reikää 4 reikää Määritä kaikkien tulostustöiden rei'itystila. Tämä valikkokohta näkyy vain, kun nidonnan, rei'ityksen tai vihkon viimeistelijä on asennettu. Porrasta sivut Ei mitään * Kopioiden väliin Töiden väliin Porrasta kunkin tulostustyön tulosteet tai tulostustyön kopiot. Jos valitset  Kopioiden väliin , laite porrastaa tulostustyön kopiot, jos  Lajittele -asetus on  Käytössä [1,2,1,2,1,2] . Jos  Lajittelu -asetus on  Ei käytössä [1,1,1,2,2,2] , tulostettujen sivujen jokainen osio porrastetaan (kaikki sivut 1, kaikki sivut 2 ja niin edelleen). Töiden väliin  -asetus määrittää saman porrastuskohdan koko tulostustyölle tulostettavien kopioiden määrästä riippumatta. Kääntötyyli Pitkä reuna * Lyhyt reuna Määritä kaksipuolisena tulostetun asiakirjan sidottava reuna. Sivua/puoli Ei käytössä * 2 sivua/puoli 3 sivua/puoli 4 sivua/puoli 6 sivua/puoli 9 sivua/puoli 12 sivua/puoli 16 sivua/puoli Tulosta paperiarkin yhdelle puolelle useita pienennettyjä sivuja. Sivuja/arkki-järjestys Vaakasuunta * Käänteinen vaaka Käänteinen pysty Pystysuora Määritä monisivuisten kuvien paikka, kun käytössä on  Sivuja/arkki -valikko. Sivuja/arkki-suunta Automaattinen * Vaaka Pysty Määritä monisivuisten kuvien suunta, kun käytössä on  Sivuja/arkki -valikko. Sivuja/arkki-kehys Ei mitään * Tasainen Tulosta reunus jokaisen sivun ympärille, kun käytössä on  Sivuja/arkki -valikko. Erotinsivut Ei käytössä * Kopioiden väliin Töiden väliin Arkkien väliin Lisää tulostettaessa tyhjiä erotinsivuja. Erotinsivujen lähde Lokero  [x] (1*) Monikäyttösyöttöaukko Määritä erotinsivun paperilähde. Tyhjät sivut Älä tulosta * Tulostaminen Tulosta tulostustyön tyhjät sivut. valikko Flash-asematulostus"},{"UUID":"e1d187fc-ef9e-4aa0-841e-76b4ab079891","title":"Verkko/portit","link":"network-overview-topic.html","desc":"Verkon yleiskatsaus Verkon yleiskatsaus -valikkokohdat","descFull":"Verkon yleiskatsaus Verkon yleiskatsaus -valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Aktiivinen sovitin Automaattinen * Vakioverkko Langaton Määritä verkkoyhteyden tyyppi. Langaton  on käytettävissä vain tulostimissa, jotka on yhdistetty langattomaan verkkoon. Verkon tila Asetus on vain luku -tieto. Näytä tulostinverkon yhteystila. Näytä Verkon tila tulostimessa Ei käytössä Käytössä * Näytä verkon tila näytössä. Nopeus, kaksipuolisuus Asetus on vain luku -tieto. Näytä aktiivisen verkkokortin nopeus. IPv4 Asetus on vain luku -tieto. Näytä IPv4-osoite. Kaikki IPv6-osoitteet Asetus on vain luku -tieto. Näytä kaikki IPv6-osoitteet. Nollaa tulostuspalvelin Käynnistä Nollaa kaikki aktiiviset verkkoyhteydet tulostimeen. Tämä asetus poistaa kaikki verkon määritysasetukset. Verkkotyön aikakatkaisu Ei käytössä Käytössä * (90 sekuntia) Määritä aika, jonka kuluttua tulostin peruuttaa verkkotulostustyön. Otsikkosivu Ei käytössä Käytössä * Tulosta otsikkosivu. Scan to PC Port Range (PC-skannaus-porttialue) Asetus on käyttäjän määrittämä. Määritä kelvollinen porttialue tulostimille, jotka ovat portin palomuurin takana. Ota käyttöön verkkoyhteydet Ei käytössä Käytössä * Anna tulostimen luoda yhteys verkkoon. Ota LLDP käyttöön Ei käytössä * Käytössä Näytä verkon tila aloitusnäytössä. valikko Verkon yleiskatsaus"},{"UUID":"fe347b39-8e6e-430d-97a2-2a3c2ba2efd3","title":"Verkko/portit","link":"network-overview-topic.html","desc":"Langaton Tämä valikko on käytettävissä","descFull":"Langaton Tämä valikko on käytettävissä vain tulostimissa, jotka on yhdistetty Wi-Fi-verkkoon tai joissa on langaton verkkosovitin.  Langaton-valikon kohteet ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Määritä tulostimen ohjauspaneelissa Valitse verkko [Käytettävissä olevien langattomien verkkojen luettelo] Määritä langaton verkko, johon tulostin muodostaa yhteyden. Lisää Wi-Fi-verkko Verkkonimi Verkkotila  ( Infrastruktuuri *) Langaton suojaustila  ( Ei käytössä *) Anna verkon nimi ja tyyppi manuaalisesti. Wi-Fi Protected Setup - Käynnistä painonäppäinmenetelmä Käynnistä PIN-kooditila Muodosta Wi-Fi-verkko ja ota käyttöön verkon suojaus. Käynnistä painonäppäinmenetelmä  yhdistää tulostimen Wi-Fi-verkkoon, kun tulostimen ja yhteyspisteen (langattoman reitittimen) painikkeita painetaan tietyn ajan kuluessa. Käynnistä PIN-kooditila  yhdistää tulostimen Wi-Fi-verkkoon, kun tulostimen PIN-koodi kirjoitetaan yhteyspisteen langattoman yhteyden asetuksiin. Verkkotila - BSS-tyyppi Infrastruktuuri * Määritä verkkotila. Yhteensopivuus - 802.11b/g/n (2.4GHz) * 802.11a/b/g/n/ac (2,4 GHz / 5 GHz) 802.11a/n/ac (5 GHz) Määritä Wi-Fi-verkon standardi. 802.11a/b/g/n/ac (2,4 GHz / 5 GHz)  ja  802.11a/n/ac (5 GHz)  näkyvät vain, kun Wi‑Fi-lisävaruste on asennettu. Langaton suojaustila - Ei käytössä * WPA2/WPA - Personal WPA2 - Personal WPA3/WPA-Personal WPA3-Personal 802.1x - RADIUS Määritä suojaustila, jolla tulostin yhdistetään Wi-Fi-laitteisiin. WPA2/WPA Personal - AES Ota Wi-Fi-suojaus käyttöön WPA:n kautta. Tämä valikkokohde näkyy vain, kun  Langaton suojaustila  -asetus on  WPA2/WPA-Personal . Määritä PSK - Asetus on käyttäjän määrittämä. Määritä suojatulle Wi-Fi-yhteydelle salasana. WPA2-Personal - AES Ota Wi-Fi-suojaus käyttöön WPA2:n kautta. Tämä valikkokohde näkyy vain, kun  Langaton suojaustila  -asetus on  WPA2-Personal . 802.1x-salaustila - WPA+ WPA2 * Ota Wi-Fi-suojaus käyttöön 802.1x-standardin kautta. Tämä valikkokohde näkyy vain, kun  Langaton suojaustila  -asetus on  802.1x - RADIUS . 802.1x - RADIUS  voidaan muuttaa vain Embedded Web Server -palvelimen avulla. IPv4 Ota DHCP käyttöön Käytössä * Ei käytössä Ota käyttöön ja määritä IPv4-asetukset tulostimessa. Määritä kiinteä IP-osoite IP-osoite Verkkopeite Yhdyskäytävä IPv6 Ota käyttöön IPv6 Käytössä * Ei käytössä Ota käyttöön ja määritä IPv6-asetukset tulostimessa. Ota DHCPv6 käyttöön Käytössä Ei käytössä * Tilattoman osoitteen automaattinen määrittäminen Käytössä * Ei käytössä DNS-palvelimen osoite Asetus on käyttäjän määrittämä. Manuaalisesti määritetty IPv6-osoite Asetus on käyttäjän määrittämä. Manuaalisesti määritetty IPv6-reititin Asetus on käyttäjän määrittämä. Osoitteen etuliite Asetus on käyttäjän määrittämä. Kaikki IPv6-osoitteet Asetus on käyttäjän määrittämä. Kaikki IPv6-reititinosoitteet Asetus on käyttäjän määrittämä. Verkko-osoite - UAA LAA Tarkastele verkko-osoitteita. PCL-työn tunnis. - Ei käytössä Käytössä * Määritä tulostin käyttämään automaattisesti PCL-emulointia, kun tulostustyö edellyttää sitä, oletuskomentokielestä riippumatta. Jos  PCL SmartSwitch  -asetus on  Ei käytössä , tulostin ei tarkista saapuvia tietoja ja käyttää  Asetukset -valikossa määritettyä tulostimen oletuskomentokieltä. PS-työn tunnist. - Ei käytössä Käytössä * Määritä tulostin käyttämään automaattisesti PS-emulointia, kun tulostustyö edellyttää sitä, oletuskomentokielestä riippumatta. Jos  PS SmartSwitch  -asetus on  Ei käytössä , tulostin ei tarkista saapuvia tietoja ja käyttää  Asetukset -valikossa määritettyä tulostimen oletuskomentokieltä. Työn puskurointi - Käytössä Ei käytössä * Tallenna tulostustyöt tilapäisesti tallennusasemaan ennen tulostamista. Tämä valikkokohta on näkyvissä vain, kun tallennusväline on asennettu. Mac binaari PS - Automaattinen * Käytössä Ei käytössä Määritä tulostin käsittelemään Macintoshin binaarimuotoisia PostScript-tulostustöitä Käytössä -asetus käsittelee binaarimuotoiset PostScript-emuloinnin tulostustyöt. Ei käytössä  -asetus suodattaa tulostustöitä käyttäen vakioyhteyskäytäntöä. valikko Langaton"},{"UUID":"f07b114e-4dae-4b7b-9d76-4dcce1b04c29","title":"Verkko/portit","link":"network-overview-topic.html","desc":"Wi‑Fi Direct Wi‑Fi Direct -valikkokohdat","descFull":"Wi‑Fi Direct Wi‑Fi Direct -valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Ota käyttöön Wi-Fi Direct Käytössä Ei käytössä * Määritä tulostin muodostamaan yhteys suoraan Wi-Fi-laitteisiin. Wi-Fi Direct -nimi Asetus on käyttäjän määrittämä. Määritä Wi-Fi Direct -verkon nimi. Wi‑Fi Direct -salasana Asetus on käyttäjän määrittämä. Määritä salasana todentamaan ja vahvistamaan käyttäjät Wi‑Fi-yhteydellä. Näytä salasana asetussivulla Ei käytössä Käytössä * Näytä  Wi‑Fi Direct -salasana Verkkoasetussivulla . Ensisijaisen kanavan numero 1–11 Automaattinen * Määritä Wi‑Fi-verkon ensisijainen kanava. Ryhmän omistajan IP-osoite Asetus on käyttäjän määrittämä. Määritä ryhmän omistajan IP-osoite. Hyväksy painonäppäinpyynnöt automaattisesti Ei käytössä * Käytössä Hyväksy pyynnöt muodostaa yhteys verkkoon automaattisesti. Asiakkaiden automaattista hyväksymistä ei ole suojattu. valikko Wi‑Fi Direct"},{"UUID":"2015cf90-0829-4775-919b-8310a1a4350d","title":"Verkko/portit","link":"network-overview-topic.html","desc":"Mobiilipalvelujen hallinta Mobiilipalvelujen hallinta -valikkokohdat","descFull":"Mobiilipalvelujen hallinta Mobiilipalvelujen hallinta -valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Ota IPP-tulostus käyttöön Käytössä * Ei käytössä Salli verkkotulostimen tulostaa töitä Internet Printing Protocol (IPP) -protokollan avulla. Ota IPP-faksaus käyttöön Käytössä * Ei käytössä Salli USB-tulostimen lähettää faksitöitä IPP:n avulla. IPP otettiin käyttöön USB:n kautta Käytössä * Ei käytössä Salli USB-tulostimen lähettää tulostustöitä IPP:n avulla. IPP on yleensä suunniteltu verkkotulostimille. Ota skannaus käyttöön Käytössä * Ei käytössä Salli verkkotulostimen tulostaa töitä eSCL-protokollan avulla. Ota käyttöön Mopria-etsintä Käytössä * Ei käytössä Salli mobiililaitteiden löytää Mopria™-sertifioitu tulostin. valikko Mobiilipalvelujen hallinta"},{"UUID":"33d60d2d-de00-4da5-99af-cd5253079ca9","title":"Verkko/portit","link":"network-overview-topic.html","desc":"Ethernet Ethernet-valikkokohdat ja niiden kuvaukset","descFull":"Ethernet Ethernet-valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Verkon nopeus - Asetus on vain luku -tieto. Näytä aktiivisen verkkosovittimen nopeus. IPv4 Ota DHCP käyttöön Käytössä * Ei käytössä Määritä IPv4-asetukset. Asetukset ovat käyttäjän määrittämiä. Määritä kiinteä IP-osoite IP-osoite Verkkopeite Yhdyskäytävä IPv6 Ota käyttöön IPv6 Käytössä * Ei käytössä Määritä IPv6-asetukset. Ota DHCPv6 käyttöön Ei käytössä * Käytössä Tilattoman osoitteen automaattinen määrittäminen Käytössä * Ei käytössä DNS-palvelimen osoite Asetus on käyttäjän määrittämä. Manuaalisesti määritetty IPv6-osoite Asetus on käyttäjän määrittämä. Manuaalisesti määritetty IPv6-reititin Asetus on käyttäjän määrittämä. Osoitteen etuliite (64*) 0–128  (64*) Kaikki IPv6-osoitteet Asetus on vain luku -tieto. Kaikki IPv6-reititinosoitteet Asetus on vain luku -tieto. Verkko-osoite - UAA LAA Määritä verkko-osoite. PCL-työn tunniste - Ei käytössä Käytössä * Määritä tulostin käyttämään automaattisesti PCL-emulointia, kun tulostustyö edellyttää sitä, oletuskomentokielestä riippumatta. Jos tämä asetus ei ole käytössä, tulostin ei tarkista saapuvia tietoja ja käyttää  Asetus -valikossa määritettyä tulostimen oletuskomentokieltä. PS-työn tunnist. - Ei käytössä Käytössä * Määritä tulostin käyttämään automaattisesti PostScript-emulointia, kun tulostustyö edellyttää sitä, oletuskomentokielestä riippumatta. Jos tämä asetus ei ole käytössä, tulostin ei tarkista saapuvia tietoja ja käyttää  Asetus -valikossa määritettyä tulostimen oletuskomentokieltä. Työn puskurointi - Ei käytössä * Käytössä Tallenna tulostustyöt tilapäisesti tallennusasemaan ennen tulostamista. Tämä valikkokohta on näkyvissä vain, kun tallennusväline on asennettu. Mac binaari PS - Automaattinen * Ei käytössä Käytössä Määritä tulostin käsittelemään Macintoshin binaarimuotoisia PostScript-tulostustöitä Automaattinen  käsittelee tulostustöitä, jotka lähetetään joko Windows- tai Macintosh-käyttöjärjestelmää käyttävistä tietokoneista. Ei käytössä  -asetus suodattaa PostScript-emulaation tulostustyöt käyttämällä vakioyhteyskäytäntöä. Energiatehokas Ethernet - Käytössä Ei käytössä Automaattinen * Vähennä virrankulutusta, kun tulostin ei vastaanota tietoja Ethernet-verkosta. valikko Ethernet"},{"UUID":"4eb3cb8f-22d3-4099-92ff-e027c07ce089","title":"Verkko/portit","link":"network-overview-topic.html","desc":"TCP/IP Tämä valikko näkyy ainoastaan","descFull":"TCP/IP Tämä valikko näkyy ainoastaan verkkotulostimissa tai tulostuspalvelimeen liitetyissä tulostimissa. TCP/IP-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Aseta isäntänimi Asetus on käyttäjän määrittämä. Aseta TCP/IP-yhteyskäytännön nykyisen palvelimen nimi. Toimialueen nimi Asetus on käyttäjän määrittämä. Aseta toimialuenimi. Salli DHCP-/BOOTP-protokollan päivittää NTP-palvelin Käytössä * Ei käytössä Anna Dynamic Host Configuration Protocol (DHCP)- ja BOOTstrap Protocol (BOOTP) -asiakkaiden päivittää tulostimen NTP-asetukset. Zero Configuration-nimi Asetus on käyttäjän määrittämä. Määritä zero configuration -verkon palvelunimi. Ota automaattinen IP käyttöön Ei käytössä Käytössä * Määritä IP-osoite automaattisesti. DNS-palvelimen osoite Asetus on käyttäjän määrittämä. Määritä nykyinen DNS (Domain Name System) -palvelinosoite. DNS-varmistuspalvelimen osoite Asetus on käyttäjän määrittämä. Määritä DNS-varmistuspalvelimen osoitteet. DNS-varmistuspalvelimen osoite 2 DNS-varmistuspalvelimen osoite 3 Toimialueen hakujärjestys Asetus on käyttäjän määrittämä. Paikallista verkon eri toimialueilla olevat tulostimet ja niiden resurssit määrittämällä toimialuenimien luettelo. Ota DDNS käyttöön Ei käytössä * Käytössä Päivitä dynaamiset DNS-asetukset. DDNS TTL Asetus on käyttäjän määrittämä. Määritä nykyiset DDNS-asetukset. Oletus-TTL DDNS-päivitysaika Ota mDNS käyttöön Ei käytössä Käytössä * Päivitä DNS-monilähetysasetukset. WINS Server Address (WINS-palvelinosoite) Asetus on käyttäjän määrittämä. Määritä WINS (Windows Internet Name Service) -palvelimen osoite. Ota BOOTP käyttöön Ei käytössä * Käytössä Salli BOOTP-protokollan määrittää tulostimen IP-osoite. Restricted Server List (Rajattu palvelinluet.) Asetus on käyttäjän määrittämä. Määritä IP-osoitteet, joiden sallitaan olla yhteydessä tulostimeen TCP/IP-yhteyden kautta. Erota IP-osoitteet toisistaan pilkulla. Voit lisätä enintään 50 IP-osoitetta. Rajattu palvelinluet. -asetukset Estä kaikki portit * Estä vain tulostus Estä vain tulostus ja HTTP Määritä niiden IP-osoitteiden käyttöasetukset, jotka eivät ole luettelossa. MTU 256–1500 Ethernet  (1500*) Määritä TCP-yhteyksien MTU (maximum transmission unit) -parametri. Raw Print Port 1–65535  (9100*) Määritä raw port -numero verkkoon liitetyille tulostimille. Lähtevän liikenteen enimmäisnopeus Ei käytössä * Käytössä Määritä tulostimen enimmäissiirtonopeus. Kun tämä on käytössä, se on 100–1 000 000 kilobittiä sekunnissa. TLS-tuki Ota käyttöön TLSv1.0  ( Ei käytössä )*) Ota käyttöön TLSv1.1  ( Ei käytössä *) Ota käyttöön TLSv1.2  ( Käytössä *) Ota käyttöön TLS (Transport Layer Security) -yhteyskäytäntö. SSL-salausluettelo Asetus on käyttäjän määrittämä. Määritä salausalgoritmit, joita käytetään SSL- tai TLS-yhteyksissä. TLSv1.3:n SSL-salausluettelo valikko TCP/IP"},{"UUID":"3cf6032e-ba46-4f62-abdc-286c2af35d2b","title":"Verkko/portit","link":"network-overview-topic.html","desc":"SNMP Valikko näkyy ainoastaan verkkotulostimissa","descFull":"SNMP Valikko näkyy ainoastaan verkkotulostimissa tai tulostuspalvelimeen liitetyissä tulostimissa. SNMP-valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. SNMP-versiot 1 ja 2c Käytössä Ei käytössä Käytössä * Määritä SNMP (Simple Network Management Protocol) -versiot 1 ja 2c tulostinohjainten ja sovellusten asentamiseksi. Salli SNMP-asetus Ei käytössä Käytössä * Ota käyttöön PPM MIB Ei käytössä Käytössä * SNMP-yhteisö Asetus on käyttäjän määrittämä. SNMP-versio 3 Käytössä Ei käytössä Käytössä * Ota SNMP-versio 3 käyttöön tulostimen suojauksen asennusta ja päivitystä varten. Kontekstinimi Asetus on käyttäjän määrittämä. Anna kontekstinimi. Aseta luku-/kirjoitustunnistetiedot Käyttäjätunnus Todennuksen salasana Tietosuojan salasana Anna SNMP-version 3 luku- ja kirjoitustunnistetiedot. Aseta vain luku -tunnistetiedot Käyttäjätunnus Todennuksen salasana Tietosuojan salasana Anna SNMP-version 3 vain luku -tunnistetiedot. Todennuksen hajautus MD5 SHA1 * Määritä soveltuva todennushajautus. Todennuksen vähimmäistaso Ei todennusta, Ei suojausta Todennus, Ei suojausta Todennus, Suojaus * Määritä soveltuva vähimmäistodennustaso. Yksityisyysalgoritmi DES AES‑128 * Määritä soveltuva tietosuoja-algoritmi. valikko SNMP"},{"UUID":"0095f762-e45c-484a-95bc-7320d3562f92","title":"Verkko/portit","link":"network-overview-topic.html","desc":"IPSec Valikko näkyy ainoastaan verkkotulostimissa","descFull":"IPSec Valikko näkyy ainoastaan verkkotulostimissa tai tulostuspalvelimeen liitetyissä tulostimissa. IPSec-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Ota IPSec käyttöön Ei käytössä * Käytössä Ota käyttöön IPSec (Internet Protocol Security). Peruskokoonpano Oletus * Yhteensopivuus Suojattu Määritä IPSec-peruskokoonpano. Tämä valikkokohta näkyy vain, jos  Ota käyttöön IPSec  -asetus on  Käytössä . DH (Diffie‑Hellman) -ryhmäehdotus modp2048 (14) * modp3072 (15) modp4096 (16) modp6144 (17) Määritä IPSec-peruskokoonpano. Tämä valikkokohta näkyy vain, jos  Peruskokoonpano -asetus on  Yhteensopivuus . Ehdotettu salausmenetelmä 3DES AES * Määritä salausmenetelmä. Tämä valikkokohta näkyy vain, jos  Peruskokoonpano -asetus on  Yhteensopivuus . Ehdotettu todennusmenetelmä SHA1 SHA256 * SHA512 Määritä todentamismenetelmä. Tämä valikkokohta näkyy vain, jos  Peruskokoonpano -asetus on  Yhteensopivuus . IKE-suojaussidoksen käyttöikä (tunteja) 1 2 4 8 24 * Määritä IKE SA:n vanhenemiskausi. Tämä valikkokohta näkyy vain, jos  Peruskokoonpano -asetus on  Suojattu . IPSec-suojaussidoksen käyttöikä (tunteina) 1 2 4 8 24 * Määritä IPSec SA:n vanhenemiskausi. Tämä valikkokohta näkyy vain, jos  Peruskokoonpano -asetus on  Suojattu . IPSec-laitevarmenne oletus * Määritä IPSec-varmenne. Tämä valikkokohta näkyy vain, jos  Ota käyttöön IPSec  -asetus on  Käytössä . Esijaetulla avaimella todennetut yhteydet Isäntä  [x] Määritä tulostimen todennetut yhteydet. Nämä valikkokohteet näkyvät vain, jos  Ota käyttöön IPSec  -asetus on  Käytössä . Varmenteella todennetut yhteydet Isäntä  [x]  Osoite[/subnet] valikko IPSec"},{"UUID":"48664a09-b69c-4d8a-9181-0a01b939507f","title":"Verkko/portit","link":"network-overview-topic.html","desc":"802.1x 802.1x Valikko näkyy ainoastaan","descFull":"802.1x 802.1x Valikko näkyy ainoastaan verkkotulostimissa tai tulostuspalvelimeen liitetyissä tulostimissa. 802.1x-valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehdot Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Aktiivinen - Ei käytössä * Käytössä Anna tulostimen liittyä verkkoihin, joiden käyttämiseen tarvitaan todennusta. 802.1x-todennus Laitteen kirjautumisnimi Asetus on käyttäjän määrittämä. Määritä yksilöllinen kirjautumisnimi. Laitteen kirjautumissalasana Asetus on käyttäjän määrittämä. Määritä yksilöllinen salasana. Tarkista palvelimen varmenne<1> Käytössä * Ei käytössä Ota tämä asetus käyttöön, jos haluat vaatia todennuspalvelimen suojausvarmenteen tarkistamista. Ota käyttöön tapahtumaloki Käytössä Ei käytössä * Salli tulostimen tallentaa yhteyslokeja. 802.1x-laitevarmenne oletus * Valitse digitaalinen varmenne, jota haluat käyttää. Jos vain yksi varmenne on asennettu,  oletus  on ainoa näkyviin tuleva vaihtoehto.  Todennusmekanismi EAP ‑ MD5 Käytössä * Ei käytössä Ota käyttöön Extensible Authentication Protocol (EAP) MD5 -kehys. EAP - MSCHAPv2 Käytössä * Ei käytössä Ota käyttöön EAP Microsoft Challenge Handshake Authentication Protocol (MSCHAP) version 2 todennusmenetelmä. LEAP Käytössä * Ei käytössä Ota käyttöön Lightweight Extensible Authentication Protocol (LEAP), MSCHAP:n muokattu versio. PEAP Käytössä * Ei käytössä Ota Protected Extensible Authentication Protocol (PEAP) käyttöön. Se on menetelmä, joka tarjoaa turvallisemman todennuksen 802.11 WLAN -verkoille. PEAP tukee 802.1x portin käytön valvontaa. EAP - TLS Käytössä * Ei käytössä Ota käyttöön EAP Transport Layer Security (TLS), protokolla, jossa asiakas ja palvelin todentavat toisensa digitaalisilla varmenteilla. EAP - TTLS Käytössä * Ei käytössä Ota käyttöön EAP tunneloitu Transport Layer Security (TLS), joka on samankaltainen kuin EAP_TLS, paitsi että vain palvelimella on varmenne, jolla sen todentaa itsensä ensin asiakkaalle. TTLS-todennusmenetelmä CHAP MSCHAP MSCHAPv2 * PAP Valitse laitteessa käytettävä EAP TTLS -menetelmä. valikko 802.1x"},{"UUID":"c534a020-22b0-42d6-a83e-55c08a73bd50","title":"Verkko/portit","link":"network-overview-topic.html","desc":"LPD-kokoonpano Valikko näkyy ainoastaan verkkotulostimissa","descFull":"LPD-kokoonpano Valikko näkyy ainoastaan verkkotulostimissa tai tulostuspalvelimeen liitetyissä tulostimissa. LPD-kokoonpano-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. LPD-aikakatkaisu 0–65535 sekuntia  (90*) Määritä aikakatkaisun arvo, jotta LPD (Line Printer Daemon) -palvelin ei odota jumittuneita tai virheellisiä tulostustöitä loputtomasti. LPD-otsikkosivu Ei käytössä * Käytössä Tulosta kaikkien LPD-tulostustöiden otsikkosivu. Otsikkosivu on tulostustyön ensimmäinen sivu, jota käytetään tulostustöiden erotinsivuna ja josta tunnistetaan tulostustyöpyynnön aloittaja. LPD Trailer Page (LPD-loppusivu) Ei käytössä * Käytössä Tulosta kaikkien LPD-tulostustöiden loppusivu. Loppusivu on tulostustyön viimeinen sivu. LPD: rivinvaihdon muunnos Ei käytössä * Käytössä Ota käyttöön rivinvaihdon muunnos. Rivinvaihto käskee tulostinta siirtämään kohdistimen saman rivin alkuun. valikko LPD-kokoonpano"},{"UUID":"e6b11518-575f-4934-816b-f75ea4219882","title":"Verkko/portit","link":"network-overview-topic.html","desc":"HTTP/FTP-asetukset HTTP-/FTP-asetukset-valikkokohdat ja niiden kuvaukset","descFull":"HTTP/FTP-asetukset HTTP-/FTP-asetukset-valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Välipalvelin HTPP-välityspalvelimen IP-osoite Asetus on käyttäjän määrittämä. Määritä HTTP-palvelimen asetukset. HTTP-oletus-IP-portti Asetus on käyttäjän määrittämä. Määritä HTTP:n oletus-IP-portin osoite. HTTP-protokollan oletusportti on 80. FTP-välityspalvelimen IP-osoite Asetus on käyttäjän määrittämä. Määritä FTP-asetukset. FTP-oletus-IP-portti Asetus on käyttäjän määrittämä. Määritä FTP:n oletus-IP-portin osoite. HTTP-protokollan oletusportti on 21. Todennus Ei mitään Automaattinen * Perusasetus Digest NTLM Määritä todennustunnukset. Käyttäjätunnus Asetus on käyttäjän määrittämä. Määritä yksilöllinen käyttäjätunnus. Salasana Asetus on käyttäjän määrittämä. Määritä yksilöllinen salasana. Paikalliset toimialueet Asetus on käyttäjän määrittämä. Määritä HTTP- ja FTP-palvelinten toimialuenimet. Muut asetukset Ota käyttöön HTTP-palvelin Käytössä * Ei käytössä Salli Embedded Web Serverin valvoa ja hallinnoida tulostinta. Ota käyttöön HTTPS Käytössä * Ei käytössä Ota käyttöön HTTPS (Hypertext Transfer Protocol Secure) -protokolla tulostuspalvelimen tiedonsiirron salaamista varten. Pakota HTTPS-yhteydet Käytössä Ei käytössä * Pakota tulostin käyttämään HTTPS-yhteyksiä. Ota FTP/TFTP käyttöön Käytössä * Ei käytössä Lähetä tiedostoja FTP:n/TFTP:n kautta. HTTPS-laitevarmenne oletus * Näytä tulostimen käyttämä HTTP-laitevarmenne. HTTP/FTP-pyyntöjen aikakatkaisu 1–299 sekuntia  (30*) Määritä, miten pian palvelinyhteys katkeaa. HTTP/FTP-pyyntöjen uudelleenyritykset 1–299 sekuntia  (3*) Määritä, miten monta kertaa HTTP-/FTP-palvelimeen yritetään yhdistää. valikko HTTP-/FTP-asetukset"},{"UUID":"95e8f158-143b-4d29-b253-77ca5bcc815b","title":"Verkko/portit","link":"network-overview-topic.html","desc":"ThinPrint ThinPrint-valikkokohdat ja niiden kuvaukset","descFull":"ThinPrint ThinPrint-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Ota ThinPrint käyttöön Ei käytössä * Käytössä Tulosta ThinPrint-asetuksella. Porttinumero 4000–4999  (4000*) Määritä ThinPrint-palvelimen porttinumero. Kaistanleveys (bittiä sekunnissa) 100–1000000  (0*) Määritä ThinPrint-ympäristön tiedonsiirtonopeus. Paketin koko (kt) 0–64000  (0*) Määritä tiedonsiirron paketin koko. valikko ThinPrint"},{"UUID":"38e2a0a4-4d58-4f52-9ef9-6f401791f398","title":"Verkko/portit","link":"network-overview-topic.html","desc":"USB USB-valikkokohdat ja niiden kuvaukset","descFull":"USB USB-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. PCL-työn tunniste Ei käytössä Käytössä * Määritä tulostin käyttämään PCL-emulointia, kun USB-portin kautta saapunut tulostustyö edellyttää sitä, oletuskomentokielestä riippumatta. Jos tämä asetus ei ole käytössä, tulostin ei tarkista saapuvia tietoja ja käyttää  Asetus -valikossa määritettyä tulostimen oletuskomentokieltä. PS-työn tunnist. Ei käytössä Käytössä * Määritä tulostin käyttämään PostScript-emulointia, kun USB-portin kautta saapunut tulostustyö edellyttää sitä, oletuskomentokielestä riippumatta. Jos tämä asetus ei ole käytössä, tulostin ei tarkista saapuvia tietoja ja käyttää  Asetus -valikossa määritettyä tulostimen oletuskomentokieltä. Työn puskurointi Ei käytössä * Käytössä Tallenna tulostustyöt tilapäisesti tallennusasemaan ennen tulostamista. Tämä valikkokohta on näkyvissä vain, kun tallennusväline on asennettu. Mac binaari PS Automaattinen * Käytössä Ei käytössä Määritä tulostin käsittelemään Macintoshin binaarimuotoisia PostScript-tulostustöitä Automaattinen  käsittelee tulostustöitä, jotka lähetetään joko Windows- tai Macintosh-käyttöjärjestelmää käyttävistä tietokoneista. Ei käytössä  -asetus suodattaa PostScript-emulaation tulostustyöt käyttämällä vakioyhteyskäytäntöä. Ota USB-portti käyttöön Ei käytössä Käytössä * Ota käyttöön etu- ja taka-USB-asemaportit. valikko USB"},{"UUID":"5432abc6-2cd4-484a-aea7-7b1b69f5ac81","title":"Verkko/portit","link":"network-overview-topic.html","desc":"Rajoita ulkoisen verkon käyttöä Rajoita","descFull":"Rajoita ulkoisen verkon käyttöä Rajoita ulkoisen verkon käyttöä -valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Rajoita ulkoisen verkon käyttöä Ei käytössä * Käytössä Rajoita verkkosivustojen käyttöä. Ulkoisen verkon osoite Asetus on käyttäjän määrittämä. Määritä verkko-osoitteet, joiden käyttöä rajoitetaan. Sähköpostiosoite ilmoitusta varten Asetus on käyttäjän määrittämä. Määritä sähköpostiosoite, johon ilmoitus kirjatuista tapahtumista lähetetään. Ping-tiheys 1–300  (10*) Määritä verkkokyselyjen aikaväli sekunteina. Aihe Asetus on käyttäjän määrittämä. Määritä ilmoitussähköpostiviestin aihe ja viesti. Ilmoitus valikko Rajoita ulkoisen verkon käyttöä"},{"UUID":"30aa0e1a-dc88-42a9-aae3-a71f2ea16708","title":"Kirjautumismenetelmät","link":"login-methods-subgroup.html","desc":"Oikeuksien hallinta Oikeuksien hallinta -valikkokohdat","descFull":"Oikeuksien hallinta Oikeuksien hallinta -valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Toiminnon käyttö Käytä osoitekirjaa sovelluksissa Muokkaa osoitekirjaa Pikavalintojen hallinta Luo profiileja Kirjanmerkkien hallinta Flash-asematulostus Flash-asematulostus (väri) Flash-asemaskannaus Kopiointitoiminto Kopiointi – väritulostus Värinpoisto Sähköpostitoiminto Faksitoiminto FTP-toiminto Vapauta pysäytetyt faksit Pysäytettyjen töiden käyttö Käytä profiileja Peruuta työt laitteessa Vaihda kieli Internet Printing Protocol (IPP) Aloita skannaukset etäkäyttötilassa MV-tulostus Väritulostus Verkkokansio – skannaus Kiintolevy – tulostus Kiintolevy – väritulostus Kiintolevy – skannaus Määritä tulostimen toiminnot, joita käyttäjä voi käyttää. Jotkut valikkokohdat näkyvät vain, kun tallennusväline on asennettu. Järjestelmänvalvojan valikot Suojaus-valikko Verkko/portit-valikko Paperivalikko Raportit-valikko Toimintojen määritysvalikot Tarvikkeet-valikko Lisäkortti-valikko SE-valikko Laite-valikko Määritä tulostimen valikot, joita käyttäjä voi käyttää. Laitehallinta Etähallinta Laiteohjelmistopäivitykset Sovellusten määritys Käyttöpaneelin lukitus Embedded Web Server -käyttöoikeus Tuo/vie kaikki asetukset Poistaminen Cloud-palvelujen rekisteröinti Määritä  Laitehallinnan  toiminnot, joita käyttäjä voi käyttää. Sovellukset Uudet sovellukset Diaesitys Vaihda taustakuva Näytönsäästäjä Korttikopiointi Skannauskeskus Skannauskeskus, mukautettu  [x] Hallinnoi tulostimen sovellusten käyttöä. valikko Oikeuksien hallinta"},{"UUID":"c95a50e7-6588-49a5-b23c-9d4c8727e5cb","title":"Kirjautumismenetelmät","link":"login-methods-subgroup.html","desc":"Paikalliset tilit Paikalliset tilit -valikkokohdat","descFull":"Paikalliset tilit Paikalliset tilit -valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Ryhmien/oikeuksien hallinta Lisää ryhmä Asetus on käyttäjän määrittämä. Määritä ryhmät, joilla on oikeudet tulostimen toimintoihin, hallintavalikoihin, tulostimen hallintavaihtoehtoihin ja sovelluksiin. Kaikki käyttäjät Tuo käyttöoikeuksien hallinta Tuo käytönhallinta tulostimeen rekisteröidyiltä tileiltä. Lisää käyttäjä Käyttäjätunnus/salasana Käyttäjätunnus Salasana PIN Asetus on käyttäjän määrittämä. Lisää käyttäjä ja määritä kirjautumistapa tulostimeen. valikko Paikalliset tilit"},{"UUID":"4372602b-0f34-44c7-b7fa-3e93696657e2","title":"Kirjautumismenetelmät","link":"login-methods-subgroup.html","desc":"Oletuskirjautumismenetelmät Tämä valikko näkyy vain,","descFull":"Oletuskirjautumismenetelmät Tämä valikko näkyy vain, kun määrität asetuksia  Paikalliset tilit  -valikossa. Oletuskirjautumismenetelmät-valikon kohteet ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Ohjauspaneeli Käyttäjätunnus/salasana Käyttäjätunnus Salasana PIN Määritä oletuskirjautumismenetelmä, jolla ohjauspaneelia voi käyttää. Selain Käyttäjätunnus/salasana Käyttäjätunnus Salasana PIN Määritä oletuskirjautumismenetelmä, jolla selainta voi käyttää. valikko Oletuskirjautumismenetelmät"},{"UUID":"69addcff-54d2-4fe3-90b8-ac698720686d","title":"Suojaus","link":"login-methods-subgroup.html","desc":"Ajasta USB-laitteet Ajasta USB-laitteet -valikkokohta","descFull":"Ajasta USB-laitteet Ajasta USB-laitteet -valikkokohta ja sen kuvaus Valikkokohta Alivalikon vaihtoehdot Asetukset Kuvaus Ajastukset Lisää uusi ajastus Tallenna ajoitus Toiminto Päivät Aika Ajasta etuosan USB-portin käyttö. valikko Ajasta USB-laitteet"},{"UUID":"d21fe6ef-4ed8-4637-b8aa-e665714a3a46","title":"Suojaus","link":"login-methods-subgroup.html","desc":"Suojaustarkistusloki Suojaustarkistusloki-valikkokohdat ja niiden kuvaukset","descFull":"Suojaustarkistusloki Suojaustarkistusloki-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Ota tarkistus käyttöön Ei käytössä * Käytössä Aseta tulostin tallentamaan tapahtumat suojaustarkistuslokiin ja etä-syslogiin. Ota etä-syslog käyttöön Ei käytössä * Käytössä Aseta tulostin lähettämään tarkistuslokit etäpalvelimelle. Etä-syslog-palvelin Asetus on käyttäjän määrittämä. Määritä etäjärjestelmälokipalvelin. Etä-syslog-portti 1–65535  (514*) Määritä etä-syslog-portti, johon tulostin lähettää etäpalvelimelle tapahtumalokin. Etä-syslog-menetelmä Normaali UDP * Stunnel Määritä yhteyskäytäntö, jota tulostin käyttää välittäessään tapahtumalokia etäpalvelimelle. Syslog-etätoiminto 0 - Ytimen viestit 1 - Käyttäjätason viestit 2 - Postijärjestelmä 3 - Järjestelmä-daemonit 4 - Suojaus-/vahvistusviestit * 5 - Järjestelmälokit loivat viestit sisäisesti 6 - Rivitulostinalijärjestelmä 7 - Verkkouutisten alijärjestelmä 8 - UUCP-alijärjestelmä 9 - Kello-daemon 10 - Suojaus-/vahvistusviestit 11 - FTP-daemon 12 - NTP-alijärjestelmä 13 - Lokin tarkistus 14 - Lokihälytys 15 - Kello-daemon 16 - Paik. käyttö 0 (local0) 17 - Paik. käyttö 1 (local1) 18 - Paik. käyttö 2 (local2) 19 - Paik. käyttö 3 (local3) 20 - Paik. käyttö 4 (local4) 21 - Paik. käyttö 5 (local5) 22 - Paik. käyttö 6 (local6) 23 - Paik. käyttö 7 (local7) Määritä arvo, jota tulostin käyttää lähettäessään lokitapahtumia etäpalvelimeen. Lokiin kirjattavien tapahtumien vakavuus 0 - Hätätapaus 1 - Hälytys 2 - Kriittinen 3 ‑ Virhe 4 - Varoitus * 5 ‑ Ilmoitus 6 - Tiedotus 7 - Virheenkorjaus Määritä kunkin tapahtuman vakavuusarvo. Kirjaamattomien tapahtumien etä-syslog Ei käytössä * Käytössä Aseta tulostin lähettämään kaikki soveltuvat tapahtumat. Järjestelmänvalvojan sähköpostiosoite Asetus on käyttäjän määrittämä. Määritä tulostimen järjestelmänvalvojan sähköpostiosoite, jolle ilmoitetaan tietyistä lokitapahtumista. Sähköpostilokin tyhjentämisen hälytys Ei käytössä * Käytössä Aseta tulostin lähettämään sähköposti järjestelmänvalvojalle aina kun loki poistetaan. Sähköpostilokin rivityksen hälytys Ei käytössä * Käytössä Aseta tulostin lähettämään järjestelmänvalvojalle sähköposti, kun lokimerkinnät rivitetään. Kirjaa kaikki toiminnot Kirjoita vanhimpien merkintöjen päälle * Lähetä loki sähköpostitse ja poista kaikki merkinnät Määritä, miten tulostin toimii, jos loki täyttää sille varatun muistin. Sähköpostin % täysi hälytys Ei käytössä * Käytössä Aseta tulostin lähettämään järjestelmänvalvojalle sähköpostiviesti, kun loki täyttää sille varatun muistin. % täydellinen hälytystaso 1–99  (90*) Määritä, onko lokin viemä tila yhtä suuri kuin täynnä-hälytystaso, vai sitä suurempi. Sähköpostilokin viennin hälytys Ei käytössä * Käytössä Lähetä sähköposti-ilmoitus järjestelmänvalvojalle, kun loki viedään. Sähköpostilokin asetusten muutoksen hälytys Ei käytössä * Käytössä Aseta tulostin lähettämään sähköpostia järjestelmänvalvojalle, kun  Ota tarkistus käyttöön  -valikon arvo vaihtuu. Lokirivien päätteet LF (\\n) * CR (\\r) CRLF (\\r\\n) Määritä, kuinka tulostin käsittelee lokitiedoston rivinpäätteitä sen mukaan, missä käyttöjärjestelmässä tiedosto jäsennetään tai sitä tarkastellaan. Allekirjoita viennit digitaalisesti Ei käytössä * Käytössä Aseta tulostin allekirjoittamaan viedyt suojauslokit automaattisesti. Tyhjennä loki Asetus on käyttäjän määrittämä. Poista kaikki tarkistuslokit Vie loki Syslog (RFC 5424) Syslog (RFC 3164) CSV Vie lokit tulostimesta tai flash-asemasta. valikko Suojaustarkistusloki"},{"UUID":"d9397825-199a-48db-9fea-14372214b6e3","title":"Suojaus","link":"login-methods-subgroup.html","desc":"Kirjautumisrajoitukset Kirjautumisrajoitukset-valikkokohdat ja niiden kuvaukset","descFull":"Kirjautumisrajoitukset Kirjautumisrajoitukset-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Virhekirjautumiset 1–10  (3*) Määritä, kuinka monta virheellistä kirjautumisyritystä sallitaan, ennen kuin käyttäjä suljetaan ulos. Kirjautumisvirheen aikaraja 1–60 minuuttia  (5*) Määritä virheellisten kirjautumisyritysten välinen sallittu aika, ennen kuin käyttäjä suljetaan ulos. Lukitusaika 1–60 minuuttia  (5*) Määritä se ajan pituus, jona kirjautuminen ei ole sallittua. Verkkokirjautumisen aikakatkaisu 1–120 minuuttia  (10*) Määritä aika, jonka etäkäyttöliittymä, kuten verkkosivu, voi olla käyttämättömänä, ennen kuin käyttäjä kirjataan automaattisesti ulos. valikko Kirjautumisrajoitukset"},{"UUID":"816d94dc-e0b1-46d6-8ca1-b95c5c418f7a","title":"Suojaus","link":"login-methods-subgroup.html","desc":"Luottamuksellisen tulostuksen asetukset Luottamuksellisen tulostuksen","descFull":"Luottamuksellisen tulostuksen asetukset Luottamuksellisen tulostuksen asetukset -valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Virheellinen maks. PIN 2–10 Aseta virheellisen PIN-koodin syöttöraja. Kun rajoitus on saavutettu, kyseisen käyttäjätunnuksen tulostustyöt poistetaan. Luottamuksellisen työn vanheneminen Ei käytössä * 1 tunti 4 tuntia 24 tuntia 72 tuntia 1 viikko Määritä eri tyyppisille pidossa olevalle työlle oma vanhenemisaika ennen kuin se poistetaan automaattisesti tulostimen muistista. Pidossa olevien töiden tyypit ovat  Luottamuksellinen ,  Repeat ,  Reserve  ja  Verify . Jos vanhenemisajan asetusta muutetaan, kun tulostimen muistissa tai kiintolevyllä on luottamuksellisia tulostustöitä, kyseisten tulostustöiden vanhenemisaikaa ei muuteta uuden oletusarvon mukaiseksi. Jos tulostimesta katkaistaan virta, kaikki sen muistissa olevat luottamukselliset työt poistetaan. Toista Työn vanheneminen Ei käytössä * 1 tunti 4 tuntia 24 tuntia 72 tuntia 1 viikko Määritä toistettavien tulostustöiden vanhenemisaika. Varmenna Työn vanheneminen Ei käytössä * 1 tunti 4 tuntia 24 tuntia 72 tuntia 1 viikko Määritä aika, jonka aikana tulostin tulostaa käyttäjälle laaduntarkkailukopion ennen jäljellä olevien kopioiden tulostamista. Säilytä Työn vanheneminen Ei käytössä * 1 tunti 4 tuntia 24 tuntia 72 tuntia 1 viikko Määritä tulostimeen tallennettavien myöhemmin tulostettavien töiden vanhenemisaika. Edellytä kaikkien töiden pitoon asettamista Ei käytössä * Käytössä Määritä tulostin asettamaan kaikki tulostustyöt pitoon. Säilytä kahdentuneet asiakirjat Ei käytössä * Käytössä Määritä tulostin pitämään kaikki asiakirjat, joilla on sama nimi. valikko Luottamukselliset tulostusasetukset"},{"UUID":"db46aa8b-4530-440f-a1f3-6c4f70eb019c","title":"Suojaus","link":"login-methods-subgroup.html","desc":"Salaus Salausvalikon kohteet ja niiden","descFull":"Salaus Salausvalikon kohteet ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Sisäinen tallennustila Asetus on vain luku -tieto. Näyttää sisäisen tallennusaseman salauksen tilan. Kiintolevy Asetus on vain luku -tieto. Näyttää kiintolevyn rekisteröinnin tilan. Tämä valikkokohta näkyy ainoastaan, kun tulostimen kiintolevy on asennettu. Älykäs tallennusasema Asetus on vain luku -tieto. Näyttää älykkään tallennusaseman (ISD) salauksen tilan. Tämä valikkokohta on näkyvissä vain, kun älykäs tallennusasema on asennettu. valikko Salaus"},{"UUID":"1e208684-1894-446f-9aa9-bf821206f7ff","title":"Suojaus","link":"login-methods-subgroup.html","desc":"Pyyhi väliaikaiset datatiedostot Pyyhi väliaikaiset","descFull":"Pyyhi väliaikaiset datatiedostot Pyyhi väliaikaiset datatiedostot -valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Tallennettu laitteen muistiin Ei käytössä * Käytössä Määritä tulostin poistamaan kaikki työn tiedot muististaan, kun työ on valmis. Tallennettu kiintolevylle 1-kertapyyhintä * 3-kertapyyhintä 7-kertapyyhintä Määritä tapa, jolla tulostin poistaa kaikki työn tiedot kiintolevyltään työn valmistumisen jälkeen. Tämä valikkokohta näkyy ainoastaan, jos tulostimeen on asennettu kiintolevy. valikko Pyyhi väliaikaiset datatiedostot"},{"UUID":"02232ae7-4e29-4e4e-8b2b-9578d508652a","title":"Suojaus","link":"login-methods-subgroup.html","desc":"Ratkaisut, LDAP-asetukset Ratkaisut, LDAP-asetukset -valikkovaihtoehdot","descFull":"Ratkaisut, LDAP-asetukset Ratkaisut, LDAP-asetukset -valikkovaihtoehdot ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Seuraa LDAP-suosituksia Ei käytössä * Käytössä Etsi kirjautunutta käyttäjätiliä toimialueen eri palvelimista. LDAP-sertifikaatin tarkistaminen Kyllä Ei * Ota käyttöön LDAP-varmenteiden tarkistaminen. valikko Ratkaisut, LDAP-asetukset"},{"UUID":"59899393-e35e-4f29-bb01-f538928ad2ae","title":"Suojaus","link":"login-methods-subgroup.html","desc":"Muut Muut-valikkokohdat ja niiden kuvaukset","descFull":"Muut Muut-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Suojatut ominaisuudet Näytä * Piilota Näytä kaikki toiminnon käyttöoikeuksien hallinnan (Function Access Control, FAC) suojaamat toiminnot käyttäjän tietoturva-asetuksista riippumatta. Piilota  näyttää vain ne FAC-suojatut ominaisuudet, joita käyttäjä saa käyttää. Tulostusoikeus Ei käytössä * Käytössä Edellytä käyttäjän kirjautumista sisään ennen tulostamista. Tulostusoikeuden oletuskirjautuminen Käyttäjätunnus/salasana Käyttäjätunnus Määritä  Tulostusoikeuden  oletuskirjautumistiedot. Välivirtajohdon suojausnollaus Ota käyttöön vieraskäyttö * Ei vaikutusta Määritä tulostimen käyttöoikeudet. Ota käyttöön vieraskäyttö  -asetuksella annetaan kaikille käyttäjille oikeus käyttää kaikkia tulostimen ominaisuuksia. Ei vaikutusta  voi estää tulostimen käytön, jos tarvittavat suojaustiedot eivät ole saatavilla. Käytä käyttäjätietojen tallentamiseen älykästä tallennusasemaa Ei käytössä Käytössä * Käytä käyttäjätietojen tallentamiseen älykästä tallennusasemaa. Tämä valikkokohta on poissa käytöstä, kun tulostimen kiintolevy on asennettu. Salasanan vähimmäispituus 0–32  (0*) Määritä salasanan vähimmäispituus, jota käytetään sisäisille tileille, kuten   Salasana - ja   Käyttäjänimi Salasana -tileille. Ota käyttöön salasanan/PIN-koodin paljastus Ei käytössä Käytössä * Näytä salasana tai henkilökohtainen PIN-koodi. Salli palvelun pysyvän muistin salaus Ei käytössä * Käytössä Ota käyttöön laitteen pysyvän muistin salaus. Tämä asetus on käytettävissä, jos valinta  Salaa palvelun pysyvä muisti  on poistettu käytöstä. valikko Muut"},{"UUID":"f1a31a97-b51d-4ad9-836a-b83dd74fd2d0","title":"Cloud-palvelut","link":"cloud-services-enrollment-topic.html","desc":"Cloud-palvelujen rekisteröinti Cloud-palvelujen rekisteröinti -valikkokohdat","descFull":"Cloud-palvelujen rekisteröinti Cloud-palvelujen rekisteröinti -valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Näytä lisätietoja Asetus on vain luku -tieto. Katso lisätietoja Lexmark Cloud -palvelujen käytöstä. Ota käyttöön tiedonsiirto Lexmark Cloud -palvelujen kanssa Ei käytössä * Käytössä Ota käyttöön tulostimen tiedonsiirto Lexmark Cloud -palvelujen kanssa. Näytä nykyinen tila Asetus on vain luku -tieto. Näytä tulostimen ja Lexmark Cloud -palvelujen välisen yhteyden tila. valikko Cloud-palvelujen rekisteröinti"},{"UUID":"c9e3cc5a-3a4a-4066-9ba8-f0343d3ca69f","title":"Raportit","link":"menu-settings-page-topic.html","desc":"Valikkoasetussivu Valikkoasetussivu -valikkokohta ja sen","descFull":"Valikkoasetussivu Valikkoasetussivu -valikkokohta ja sen kuvaus Valikkokohta Kuvaus Valikkoasetussivu Tulosta raportti, jossa on tulostimen valikot. valikko Valikkoasetussivu"},{"UUID":"6290cfd0-77ac-4c5e-85b7-4fb6bb3f681b","title":"Raportit","link":"menu-settings-page-topic.html","desc":"Laite Laite-valikkokohdat ja niiden kuvaukset","descFull":"Laite Laite-valikkokohdat ja niiden kuvaukset Valikkokohta Kuvaus Laitetiedot Tulosta raportti, jossa on tietoja faksin tulostimesta. Laitetilastot Tulosta raportti tarvikkeiden tilasta, paperimäärästä, työn tiedoista ja muusta. Profiililuettelo Tulosta tulostimeen tallennettujen profiilien luettelo. Inventaariraportti Tulosta tulostusongelmien vianmääritystyökalu. Jotta sisältö ei leikkaudu, tulosta raportti Letter‑ tai A4‑kokoiselle paperille. valikko Laite"},{"UUID":"6197293a-bfcf-4a9c-8462-c5dbe4e541c5","title":"Raportit","link":"menu-settings-page-topic.html","desc":"Tulostaminen Tulostus-valikkokohdat ja niiden kuvaukset","descFull":"Tulostaminen Tulostus-valikkokohdat ja niiden kuvaukset Valikkokohta Asetukset Kuvaus Tulosta fontit PCL-fontit PS-fontit Tulosta fonttien näytteitä ja tietoja, jotka ovat saatavilla kussakin tulostuskielessä. Tulosta esitys Demo Page (Esittelysivu) Tulosta tulostusongelmien vianmääritystyökalu. Jotta sisältö ei leikkaudu, tulosta raportti Letter‑ tai A4‑kokoiselle paperille. Tämä valikkokohta näkyy ainoastaan, jos tulostimeen on asennettu demosivu. Tulosta hakemisto Asetus on käyttäjän määrittämä. Tulosta raportti, joka näyttää resurssit, jotka on tallennettu flash-asemaan tai tulostimen kiintolevylle. valikko Tulostaminen"},{"UUID":"6f3c921b-e7f2-48c9-a824-85697b3772d9","title":"Raportit","link":"menu-settings-page-topic.html","desc":"Pikavalinnat Pikavalinnat-valikkokohdat ja niiden kuvaukset","descFull":"Pikavalinnat Pikavalinnat-valikkokohdat ja niiden kuvaukset Valikkokohta Kuvaus Kaikki pikavalinnat Tulosta raportti, jossa luetellaan tulostimeen tallennetut pikavalinnat. Faksin pikavalinnat  näkyy vain, kun  faksi  on asennettu. Fax Shortcuts (Faksin pikavalinnat) Kopioinnin pikavalinnat Sähköpostin pikavalinnat FTP Shortcuts (FTP-pikavalinnat) Verkkokansion pikakuvakkeet valikko Pikavalinnat"},{"UUID":"2a88a668-f584-49de-b018-055fcb406237","title":"Raportit","link":"menu-settings-page-topic.html","desc":"Faksi Tämä valikko näkyy vain,","descFull":"Faksi Tämä valikko näkyy vain, jos faksi on määritetty ja  Ota käyttöön työloki  -asetus on  Käytössä . Faksi-valikkokohdat ja niiden kuvaukset Valikkokohta Kuvaus Faksityön loki Tulosta raportti, jossa on tietoja 200 viimeisimmistä faksityöstä. Faksisoiton loki Tulosta raportti, jossa on tietoja 100 viimeisimmästä yritetystä, saapuneesta ja estetystä soitosta valikko Faksi"},{"UUID":"0203f4f7-9b2c-47c5-ad61-5490b07bae3c","title":"Raportit","link":"menu-settings-page-topic.html","desc":"Verkko Verkko-valikon kohteet ja niiden","descFull":"Verkko Verkko-valikon kohteet ja niiden kuvaukset Valikkokohta Kuvaus Verkkoasetussivu Tulosta sivu, jossa näytetään tulostimeen määritetyt verkkoasetukset ja langattomat asetukset. Tämä valikkokohta näkyy ainoastaan verkkotulostimissa tai tulostuspalvelimeen liitetyissä tulostimissa. Wi‑Fi Direct -yhteyden kautta liitetyt asiakaslaitteet Tulosta sivu, jolla on niiden laitteiden luettelo, jotka on liitetty tulostimeen Wi‑Fi Direct -yhteyden kautta. Tämä valikkokohta näkyy vain, jos  Ota käyttöön Wi-Fi Direct  -asetus on  Käytössä . valikko Verkko"},{"UUID":"d6561377-81af-4716-bed1-e01e47ca010b","title":"Tulostimen valikot","link":"troubleshooting-menu-topic.html","desc":"Vianmääritys Vianmääritys-valikkokohdat ja niiden kuvaukset","descFull":"Vianmääritys Vianmääritys-valikkokohdat ja niiden kuvaukset Valikkokohta Kuvaus Tulostuslaadun testisivut Tulosta testisivuja, joiden avulla voit tunnistaa ja korjata tulostuslaadun puutteita. Skannerin puhdistaminen Tulosta skannerin puhdistusohjeet. valikko Vianmääritys Tulostuslaadun testisivut Skannerin puhdistaminen"},{"UUID":"38c2d87c-eeab-4809-a0b0-781c56f7abc9","title":"Tulostimen valikot","link":"forms-merge-topic.html","desc":"Lomakkeiden yhdistäminen Tämä valikkokohta on","descFull":"Lomakkeiden yhdistäminen Tämä valikkokohta on näkyvissä vain, kun tallennusväline on asennettu. Lomakkeiden yhdistäminen -valikkokohdat ja niiden kuvaukset Valikkokohta Alivalikon vaihtoehto Asetukset Kuvaus Arvon kohdalla oleva tähti (*) osoittaa tehtaan oletusasetuksen. Yhdistämistila - Tulosta * Tietojen keruu Ei käytössä Määritä Lomakkeiden yhdistämisen toimintatila. Kerättyjen tietojen kohde - Flash * Määritä kohde, johon kerätyt tiedot välitetään. Tämä valikkokohta näkyy vain, kun  yhdistämistilaksi  on määritetty  Tiedonkeruu . Tulostusportti- ja suodatinasetukset Verkkoportti Käytössä * Ei käytössä Ota käyttöön Lomakkeiden yhdistäminen, jotta voit käsitellä kaikki verkkoporttiin lähetetyt tiedot. Verkkosuodatin Ei käytössä * TYHJÄ OFIS OFIS+TYHJÄ OFIS+AS400 AS400 PCL ZPL ZPLF Määritä verkkosuodatin kaikille tulostimeen lähetettäville tiedoille. USB-portti Käytössä * Ei käytössä Ota käyttöön Lomakkeiden yhdistäminen, jotta voit käsitellä kaikki USB-porttiin lähetetyt tiedot. USB-suodatin Ei käytössä * TYHJÄ OFIS OFIS+TYHJÄ OFIS+AS400 AS400 PCL ZPL ZPLF Määritä USB-suodatin kaikille tulostimeen lähetettäville tiedoille. Paikallisen portin aikakatkaisu 1–100  (10*) Määritä paikalliseen porttiin lähetettyjen lomakkeiden yhdistämistöiden aikakatkaisuarvo. Muut Tulosta kaikki lomakkeet Käynnistä Tulosta kaikki älykkääseen tallennusasemaan tai tulostimen kiintolevylle tallennetut lomakejoukot. Virhesivun tulostus Käytössä * Ei käytössä Salli lomakkeiden yhdistämistyössä ilmenneen virheen virhesivun tulostaminen. valikko Forms Merge"},{"UUID":"0d3f92e3-1dc6-4b97-bb1a-b8e8d5b0e3d5","title":"Tulostimen valikot","link":"printing-menu-settings-page-topic.html","desc":"Valikkoasetussivun  tulostus Siirry ohjauspaneelissa","descFull":"Valikkoasetussivun  tulostus Siirry ohjauspaneelissa kohtaan  Asetukset Raportit . Valitse  Valikkoasetussivu . tulostaminen Valikkoasetussivu Valikkoasetussivu tulostaminen tulostimen valikot"},{"UUID":"f05fe4ac-b72b-41af-90b8-12cd593f7ecb","title":"Tulostimen viimeistelijän vaihtoehdot","link":"using-staple-finisher-topic.html","desc":"Nidonnan viimeistelijän käyttäminen Nidonta tulostinohjaimella","descFull":"Nidonnan viimeistelijän käyttäminen Nidonta tulostinohjaimella Windows-käyttäjät: Kun asiakirja on avattu, valitse  Tiedosto Tulosta . Valitse tulostin ja sitten  Ominaisuudet ,  Määritykset ,  Asetukset  tai  Asennus . Valitse  Paperi/viimeistely  ja määritä sitten  Paperi -asetukset. Valitse  Nitoja -valikosta haluamasi asetus. Valitse ensin  OK  ja sitten  Tulosta . Macintosh-käyttäjät: Kun asiakirja on avattu, valitse  Tiedosto Tulosta  . Valitse tulostin. Valitse  Viimeistelyvaihtoehdot -valikosta  Käytä viimeistelyjä Tulostinasetukset . Valitse  Nido  ja valitse asetus. Napsauta kohtaa  Tulosta . Nidonta ohjauspaneelin avulla Valitse ohjauspaneelissa  Tulosta  ja valitse sitten tulostustyön lähde. Valitse asiakirja. Valitse  Lisää asetuksia  ja valitse sitten  Viimeistelyvaihtoehdot . Valitse  Nido  ja valitse asetus. Tulosta asiakirja. nidonnan viimeistelijä käyttäminen nidonta tulostetut arkit nidonta kopioidut asiakirjat"},{"UUID":"117cef40-253d-419f-b220-47b027aea7ae","title":"Tulostimen viimeistelijän vaihtoehdot","link":"using-staple-hole-punch-finisher-topic.html","desc":"Nidonnan ja rei'ityksen viimeistelijän käyttäminen","descFull":"Nidonnan ja rei'ityksen viimeistelijän käyttäminen Nidonnan ja rei'ityksen viimeistelijän käyttäminen Paperin nidonta tai lävistys tulostinohjaimella Windows-käyttäjät: Kun asiakirja on avattu, valitse  Tiedosto Tulosta . Valitse tulostin ja sitten  Ominaisuudet ,  Määritykset ,  Asetukset  tai  Asennus . Valitse  Paperi/viimeistely  ja määritä sitten  Paperi -asetukset. Valitse haluamasi viimeistelyn mukaan asetus kohdassa  Nitoja  tai  Rei'itys . Voit valita asetuksen molemmille, jos haluat nitoa ja rei'ittää tulostetut materiaalit. Valitse ensin  OK  ja sitten  Tulosta . Macintosh-käyttäjät: Kun asiakirja on avattu, valitse  Tiedosto Tulosta . Valitse tulostin. Valitse  Viimeistelyvaihtoehdot -valikosta  Käytä viimeistelyjä Tulostinasetukset . Valitse  Nitoja  tai  Rei'itys  ja valitse asetus. Napsauta kohtaa  Tulosta . Paperin nidonta tai rei'itys ohjauspaneelin avulla Valitse ohjauspaneelissa  Tulosta  ja valitse sitten tulostustyön lähde. Valitse asiakirja. Valitse  Lisää asetuksia  ja valitse sitten  Viimeistelyvaihtoehdot . Valitse haluamasi viimeistelyn mukaan asetus kohdassa  Nitoja  tai  Rei'itys . Voit valita asetuksen molemmille, jos haluat nitoa ja rei'ittää tulostetut materiaalit. Tulosta asiakirja. tulostettujen arkkien nidonta rei'ittäminen tulostetuissa arkeissa nidonnan ja rei'ityksen viimeistelijä käyttäminen"},{"UUID":"003e7602-072d-43d5-94ea-73838327b5d3","title":"Tulostimen viimeistelijän vaihtoehdot","link":"using-offset-stacker-topic.html","desc":"Offset-pinoajan käyttäminen Porrastettu pinoaminen tulostinohjaimen","descFull":"Offset-pinoajan käyttäminen Porrastettu pinoaminen tulostinohjaimen avulla Windows-käyttäjät: Kun asiakirja on avattu, valitse  Tiedosto Tulosta . Valitse tulostin ja sitten  Ominaisuudet ,  Määritykset ,  Asetukset  tai  Asennus . Valitse  Paperi/viimeistely  ja määritä sitten  Paperi -asetukset. Valitse  Offset -valikosta haluamasi asetus. Valitse ensin  OK  ja sitten  Tulosta . Macintosh-käyttäjät: Kun asiakirja on avattu, valitse  Tiedosto Tulosta . Valitse tulostin. Valitse  Viimeistelyvaihtoehdot -valikosta  Käytä viimeistelyjä Tulostinasetukset . Valitse  Porrastus  ja valitse asetus. Napsauta kohtaa  Tulosta . Porrastettu pinoaminen ohjauspaneelin avulla Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Vältä kuvan leikkautuminen varmistamalla, että alkuperäinen asiakirja ja kopiopaperi ovat saman kokoisia. Valitse ohjauspaneelissa  Kopio  ja määritä sitten kopioiden määrä. Valitse  Lisää asetuksia  ja valitse sitten  Porrasta sivut . Ota valikko käyttöön ja valitse sitten asetus. Tulosta asiakirja. offset-pinoaja käyttäminen porrastettu pinoaminen"},{"UUID":"73dac0ce-92a7-4cfb-a4fb-83083fc6c65d","title":"Tulostimen viimeistelijän vaihtoehdot","link":"using-booklet-finisher-topic.html","desc":"Vihkoviimeistelijän käyttäminen Ennen kuin luot","descFull":"Vihkoviimeistelijän käyttäminen Ennen kuin luot vihkon, lisää paperia lyhyt reuna lokeron oikeaa reunaa kohti. Vihkon luominen tulostinohjaimen avulla Windows-käyttäjät: Kun asiakirja on avattu, valitse  Tiedosto Tulosta . Valitse tulostin ja sitten  Ominaisuudet ,  Määritykset ,  Asetukset  tai  Asennus . Valitse  Vihko . Valitse  Paperi/viimeistely  -välilehti ja määritä sitten paperiasetukset. Valitse  Taitto -valikosta haluamasi asetus. Valitse ensin  OK  ja sitten  Tulosta . Macintosh-käyttäjät: Kun asiakirja on avattu, valitse  Tiedosto Tulosta . Valitse tulostin. Valitse  Viimeistelyvaihtoehdot -valikosta  Käytä viimeistelyjä Tulostinasetukset . Valitse  Vihko  ja valitse  taiton  asetus. Valitse  OK . Vihkon luominen ohjauspaneelin avulla Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Vältä kuvan leikkautuminen varmistamalla, että alkuperäinen asiakirja ja kopiopaperi ovat saman kokoisia. Valitse ohjauspaneelissa  Kopioi  ja määritä sitten asetukset. Valitse  Lisää asetuksia  ja valitse sitten  Luo vihko . Ota käyttöön  Vihkon viimeistely  ja valitse sitten asetus. Kopioi asiakirja. vihkon luominen vihkon tekeminen vihkoviimeistelijä käyttäminen"},{"UUID":"536f2108-c462-48a5-8f76-5e0edb301e57","title":"Tulostimen viimeistelijän vaihtoehdot","link":"using-hptfu-topic.html","desc":"Paperin siirron käyttäminen taittovalinnalla Paperin","descFull":"Paperin siirron käyttäminen taittovalinnalla Paperin taittaminen tulostinohjaimen avulla Windows-käyttäjät: Kun asiakirja on avattu, valitse  Tiedosto Tulosta . Valitse tulostin ja sitten  Ominaisuudet ,  Määritykset ,  Asetukset  tai  Asennus . Valitse  Paperi/viimeistely  ja määritä sitten paperiasetukset. Valitse  Taitto -valikosta haluamasi asetus. Valitse ensin  OK  ja sitten  Tulosta . Macintosh-käyttäjät: Kun asiakirja on avattu, valitse  Tiedosto Tulosta  . Valitse tulostin. Valitse  Viimeistelyvaihtoehdot -valikosta  Käytä viimeistelyjä Tulostinasetukset . Valitse  Taitto  ja valitse asetus. Napsauta kohtaa  Tulosta . Paperin taittaminen ohjauspaneelin avulla Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Vältä kuvan leikkautuminen varmistamalla, että alkuperäinen asiakirja ja kopiopaperi ovat saman kokoisia. Valitse ohjauspaneelissa  Kopio  ja määritä sitten kopioiden määrä. Valitse  Lisää asetuksia  ja valitse sitten  Viimeistelyvaihtoehdot . Valitse  Taitto  ja valitse asetus. Kopioi asiakirja. paperin siirto taittovalinnalla käyttäminen tulostettujen kopioiden taitto kopioitujen asiakirjojen taittaminen"},{"UUID":"95e93721-49e3-4cd0-ac4c-c5bc916144e7","title":"Tulostimen ylläpito","link":"checking-supplies-status-topic.html","desc":"Osien ja tarvikkeiden tilan tarkistaminen","descFull":"Osien ja tarvikkeiden tilan tarkistaminen Osien ja tarvikkeiden tilan tarkistaminen Valitse ohjauspaneelin oikeasta yläkulmasta  . Tarkastele tulostimen osien ja tarvikkeiden tilaa. Voit myös valita   tarkistaaksesi ilmoitukset, jotka edellyttävät käyttäjän toimia. tarkistaminen, tarvikkeiden tila tarvikkeiden tila tarkistaminen tulostimen osien tila tarkistaminen"},{"UUID":"27e47775-5405-4352-abe8-69b252d41d68","title":"Tulostimen ylläpito","link":"configuring-supply-notifications-topic.html","desc":"Tarvikeilmoitusten määrittäminen Tarvikeilmoitusten määrittäminen Avaa","descFull":"Tarvikeilmoitusten määrittäminen Tarvikeilmoitusten määrittäminen Avaa selain ja kirjoita tulostimen IP-osoite selaimen osoitekenttään. Tulostimen IP-osoite näkyy sen tulostimen päänäytössä. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Valitse  Asetukset Laite Ilmoitukset . Valitse  Mukautetut tarvikeilmoitukset . Valitse kullekin tarvikkeelle ilmoitus. Ota muutokset käyttöön. tarvikeilmoitukset konfigurointi tarvikeilmoituksien määrittäminen"},{"UUID":"9c4fe545-44be-4dc8-bd13-de617cc5292c","title":"Tulostimen ylläpito","link":"setting-up-email-alert-topic.html","desc":"Sähköpostihälytysten määrittäminen Sähköpostihälytysten määrittäminen Avaa","descFull":"Sähköpostihälytysten määrittäminen Sähköpostihälytysten määrittäminen Avaa selain ja kirjoita tulostimen IP-osoite selaimen osoitekenttään. Tulostimen IP-osoite näkyy sen tulostimen päänäytössä. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Valitse  Asetukset Laite Ilmoitukset . Valitse  Sähköpostihälytysten asetukset  ja määritä sitten asetukset. Lisätietoja SMTP-asetuksista saa sähköpostin palveluntarjoajalta. Ota muutokset käyttöön. Valitse  Määritä sähköpostiluettelot ja -hälytykset  ja määritä asetukset. Ota muutokset käyttöön. sähköpostihälytykset asetusten määrittäminen sähköpostihälytysten määrittäminen"},{"UUID":"11013735-fe9a-46ee-9747-7fc199bb8211","title":"Tulostimen ylläpito","link":"generating-reports-and-logs-topic.html","desc":"Raporttien ja lokien luominen Raporttien","descFull":"Raporttien ja lokien luominen Raporttien ja lokien luominen Siirry ohjauspaneelissa kohtaan  Asetukset Raportit . Valitse tulostettava raportti tai loki. Valikkoasetussivu –Näytä nykyiset tulostusasetukset, asetukset ja määritykset. Laite Laitetiedot –Näytä tulostimen sarjanumero, asennetut ratkaisut ja faksi. Laitetilastot –Näytä tarvikkeiden tila, tulostettujen arkkien kokonaismäärä ja tulostustyön tiedot. Profiililuettelo –Näytä luettelo tulostimeen tallennetuista profiileista tai pikakuvakkeista. Inventaariraportti –Näytä raportti, jossa on tulostimen inventaaritiedot, kuten sarjanumero ja mallinimi. Tulostaminen Tulosta fontit –Näytä kirjasimet, jotka ovat saatavilla kullakin tulostuskielellä. Tulosta demo –Näytä laiteohjelmistossa saatavilla olevat demo-tiedostot sekä Flash-muistin asetukset ja levyasetukset Tulosta hakemisto –Näytä resurssit, jotka on tallennettu Flash-asemaan, kiintolevylle tai älykkääseen tallennusasemaan. Raportti näkyy vain, jos Flash-asema, tulostimen kiintolevy tai ISD on asennettuna. Pikavalinnat Kaikki pikavalinnat –Näytä luettelo kaikista tulostimeen tallennetuista pikavalinnoista. Faksin pikakuvakkeet –Näytä luettelo kaikista tulostimeen tallennetuista faksin pikavalinnoista. Kopioinnin pikavalinnat –Näytä luettelo kaikista tulostimeen tallennetuista kopioinnin pikavalinnoista. Sähköpostin pikavalinnat –Näytä luettelo kaikista tulostimeen tallennetuista sähköpostin pikavalinnoista. FTP-pikavalinnat –Näytä luettelo kaikista tulostimeen tallennetuista FTP-pikavalinnoista. Verkkokansion pikavalinnat –Näytä luettelo kaikista tulostimeen tallennetuista verkkokansion pikavalinnoista. Faksi Faksityöloki –Luettelee 200 viimeistä valmistunutta faksityötä. Raportti näkyy ainoastaan, kun  Ota käyttöön työloki  on käytössä. Faksipuheluloki –Näytä resurssit, jotka on tallennettu flash-asemaan tai tallennusasemaan. Raportti näkyy vain, kun flash-asema tai tallennusasema on asennettu. Verkko Verkkoasetussivu –Näytä tulostimeen määritetyt verkkoasetukset ja langattomat asetukset. Tämä raportti näkyy ainoastaan verkkotulostimissa tai tulostuspalvelimeen liitetyissä tulostimissa. Wi-Fi Direct -yhdistetyt työasemat –Näytä luettelo laitteista, jotka on yhdistetty tulostimeen Wi-Fi Directin avulla. Tämä rapotti näkyy vain, jos  Ota käyttöön Wi-Fi Direct  -asetus on  Käytössä . raporttien tulostaminen lokien tulostaminen raporttien ja lokien tarkastelu mittarilukema, tarkastelu tulostetut arkit, tarkastelu"},{"UUID":"18de79cc-d88f-4d4f-9111-75cbf751a7af","title":"Tulostimen osien ja tarvikkeiden tilaaminen","link":"ordering-parts-and-supplies-group.html","desc":"Yhdysvalloissa saat tietoa alueesi valtuutetuista","descFull":"Yhdysvalloissa saat tietoa alueesi valtuutetuista Lexmark-jälleenmyyjistä soittamalla numeroon 1-800-539-6275. Muissa maissa tai muilla alueilla voit katsoa tietoja osoitteessa  www.lexmark.com  tai ottaa yhteyttä tulostimen myyjään. Jos haluat tilata laitteeseen tarvikkeita, ota yhteys tulostimen ostopaikkaan. Tulostimen kaikkien tarvikkeiden käyttöiän oletuksena on tulostus A4- tai Letter-kokoiselle tavalliselle paperille. Jos parasta mahdollista tulostuslaatua ei ylläpidetä tai osia ja tarvikkeita ei vaihdeta, tulostin voi vaurioitua. aidot osat ja tarvikkeet"},{"UUID":"006d3d5b-4ad7-4ff1-9f87-b4c3a6755948","title":"Tulostimen osien ja tarvikkeiden tilaaminen","link":"ordering-parts-and-supplies-group.html","desc":"Aitojen Lexmark-osien ja -tarvikkeiden käyttäminen","descFull":"Aitojen Lexmark-osien ja -tarvikkeiden käyttäminen Lexmark-tulostimesi toimii parhaiten aidoilla Lexmark-osilla ja -tarvikkeilla. Kolmannen osapuolen tarvikkeiden tai osien käyttö voi vaikuttaa tulostimen ja sen kuvantuottoyksikön suorituskykyyn, toimintavarmuuteen tai käyttöikään. Se voi vaikuttaa myös takuusuojaan. Takuu ei kata kolmannen osapuolen osien ja tarvikkeiden käytöstä aiheutuneita vaurioita. Kaikki käyttöiän merkkivalot on suunniteltu toimimaan Lexmarkin osien ja tarvikkeiden kanssa. Tulokset voivat olla odottamattomia, jos käytetään kolmannen osapuolen osia ja tarvikkeita. Kuvakomponenttien käyttäminen tarkoitettua käyttöikää kauemmin voi vaurioittaa Lexmark-tulostinta tai siihen liitettyjä komponentteja. Tarvikkeet ja osat, jotka eivät kuulu palautusohjelman sopimuksen piiriin, voidaan nollata ja uusiovalmistaa. Valmistajan takuu ei kuitenkaan kata muiden kuin aitojen tarvikkeiden tai osien aiheuttamia vahinkoja. Tarvikkeen tai osana laskurien nollaaminen ilman kunnollista uusiovalmistusta voi vahingoittaa tulostinta. Tarvikkeen tai osan laskurin nollaamisen jälkeen tulostimessa voi näkyä nollattuun kohteeseen viittaava virhe. aitojen Lexmark-osien ja -tarvikkeiden käyttäminen aitojen Lexmark-osien ja -tarvikkeiden käyttäminen"},{"UUID":"a38537c8-de5d-4bf2-83d7-bed31deba111","title":"Tulostimen osien ja tarvikkeiden tilaaminen","link":"ordering-parts-and-supplies-group.html","desc":"Väriainekasetin tilaaminen Väriainekasetin tilaaminen Väriaineen","descFull":"Väriainekasetin tilaaminen Väriainekasetin tilaaminen Väriaineen arvioitu riittoisuus perustuu ISO / IEC 19798 -standardiin. Pitkään kestävä erityisen alhainen peitto saattaa heikentää värin todellista riittävyyttä. Jos haluat tilata väriainekasetteja, ota yhteys tulostimen ostopaikkaan. Palautusohjelman väriainekasetit Lexmark CX833, CX961, CX962, CX963 Kohde Yhdysvallat, Kanada, Australia ja Uusi-Seelanti Euroopan unioni, Euroopan talousalue, Islanti, Liechtenstein, Norja, Sveitsi Muu Tyynenmeren Aasia Latinalainen Amerikka, Puerto Rico ja Meksiko Muu Eurooppa, Lähi-itä, Afrikka, keskinen Itä-Eurooppa ja Itsenäisten valtioiden yhteisö (IVY) Lisätietoja kunkin alueen maista on osoitteessa  www.lexmark.com/regions . Syaani 77L10C0 77L20C0 77L30C0 77L40C0 77L50C0 Magenta 77L10M0 77L20M0 77L30M0 77L40M0 77L50M0 Keltainen 77L10Y0 77L20Y0 77L30Y0 77L40Y0 77L50Y0 Musta 77L10K0 77L20K0 77L30K0 77L40K0 77L50K0 Palautusohjelman suuren riittoisuuden väriainekasetit Lexmark CX833 Kohde Yhdysvallat, Kanada, Australia ja Uusi-Seelanti Euroopan unioni, Euroopan talousalue, Islanti, Liechtenstein, Norja, Sveitsi Muu Tyynenmeren Aasia Latinalainen Amerikka, Puerto Rico ja Meksiko Muu Eurooppa, Lähi-itä, Afrikka, keskinen Itä-Eurooppa ja Itsenäisten valtioiden yhteisö (IVY) Lisätietoja kunkin alueen maista on osoitteessa  www.lexmark.com/regions . Syaani 79L10K0 79L20K0 79L30K0 79L40K0 79L50K0 Magenta 79L1HM0 79L2HM0 79L3HM0 79L4HM0 79L5HM0 Keltainen 79L1HY0 79L2HY0 79L3HY0 79L4HY0 79L5HY0 Musta 79L1HK0 79L2HK0 79L3HK0 79L4HK0 79L5HK0 Lexmark CX961, CX962, CX963 Kohde Yhdysvallat, Kanada, Australia ja Uusi-Seelanti Euroopan unioni, Euroopan talousalue, Islanti, Liechtenstein, Norja, Sveitsi Muu Tyynenmeren Aasia Latinalainen Amerikka, Puerto Rico ja Meksiko Muu Eurooppa, Lähi-itä, Afrikka, keskinen Itä-Eurooppa ja Itsenäisten valtioiden yhteisö (IVY) Lisätietoja kunkin alueen maista on osoitteessa  www.lexmark.com/regions . Syaani 77L10K0 77L20K0 77L30K0 77L40K0 77L50K0 Magenta 77L1HM0 77L2HM0 77L3HM0 77L4HM0 77L5HM0 Keltainen 77L1HY0 77L2HY0 77L3HY0 77L4HY0 77L5HY0 Musta 77L1HK0 77L2HK0 77L3HK0 77L4HK0 77L5HK0 Lexmark XC8355 Kohde Yhdysvallat, Kanada, Australia ja Uusi-Seelanti Muu Eurooppa, Lähi-itä ja Afrikka Lisätietoja kunkin alueen maista on osoitteessa  www.lexmark.com/regions . Syaani 24B7574 24B7582 Magenta 24B7575 24B7583 Keltainen 24B7576 24B7584 Musta 24B7577 24B7585 Lexmark XC9635, XC9645, XC9655 Kohde Yhdysvallat, Kanada, Australia ja Uusi-Seelanti Muu Eurooppa, Lähi-itä ja Afrikka Lisätietoja kunkin alueen maista on osoitteessa  www.lexmark.com/regions . Syaani 24B7570 24B7578 Magenta 24B7571 24B7579 Keltainen 24B7572 24B7580 Musta 24B7573 24B7581 Suuren riittoisuuden väriainekasetit Lexmark CX833 Kohde Muut maat Lisätietoja kunkin alueen maista on osoitteessa  www.lexmark.com/regions . Syaani 77L0H20 Magenta 77L0H30 Keltainen 77L0H40 Musta 77L0H10 Lexmark CX961, CX962, CX963 Kohde Muut maat Lisätietoja kunkin alueen maista on osoitteessa  www.lexmark.com/regions . Syaani 79L0H20 Magenta 79L0H30 Keltainen 79L0H40 Musta 79L0H10 tarvikkeiden tilaaminen värikasetti värikasetti tilaaminen"},{"UUID":"d0b6ff53-d28b-4bed-9b7d-6da78d1dea2f","title":"Tulostimen osien ja tarvikkeiden tilaaminen","link":"ordering-parts-and-supplies-group.html","desc":"Mustan kuvayksikön tilaaminen Mustan kuvayksikön","descFull":"Mustan kuvayksikön tilaaminen Mustan kuvayksikön tilaaminen Mustan kuvayksikön voi tilata ottamalla yhteyttä tulostimen ostopaikkaan. Musta kuvayksikkö ja sen tuotenumerot Kohde Tuotenumero Palautusohjelman musta kuvayksikkö 77L0ZK0 Musta kuvayksikkö 77L0Z10 musta kuvayksikkö tilaaminen tarvikkeiden tilaaminen musta kuvayksikkö"},{"UUID":"8b480901-1248-4121-8d8a-2730961d7a32","title":"Tulostimen osien ja tarvikkeiden tilaaminen","link":"ordering-parts-and-supplies-group.html","desc":"Värillisen kuvayksikön tilaaminen Jos haluat","descFull":"Värillisen kuvayksikön tilaaminen Jos haluat tilata värillisen kuvayksikön, ota yhteys tulostimen ostopaikkaan. Kohde Tuotenumero Palautusohjelman värillinen kuvayksikkö 77L0ZV0 Tavallinen värillinen kuvayksikkö 77L0Z50 värillinen kuvansiirtopaketti tilaaminen tarvikkeiden tilaaminen värillinen kuvansiirtopaketti"},{"UUID":"ea98f7c2-bf16-42d8-9d56-93eb4b116897","title":"Tulostimen osien ja tarvikkeiden tilaaminen","link":"ordering-parts-and-supplies-group.html","desc":"Hukkaväriainepullon tilaaminen Hukkaväriainepullon tilaaminen Jos","descFull":"Hukkaväriainepullon tilaaminen Hukkaväriainepullon tilaaminen Jos haluat tilata hukkaväriainepullon, ota yhteys tulostimen ostopaikkaan. Hukkaväriainepullon osanumero Kohde Tuotenumero Hukkavärisäiliö 77L0W00 tarvikkeiden tilaaminen hukkaväriainepullo hukkaväriainepullo tilaaminen"},{"UUID":"e92e4111-11ad-4a74-9443-0d384da2fbc1","title":"Tulostimen osien ja tarvikkeiden tilaaminen","link":"ordering-parts-and-supplies-group.html","desc":"Niittikasetin tilaaminen Jos haluat tilata","descFull":"Niittikasetin tilaaminen Jos haluat tilata niittikasetin, ota yhteys tulostimen ostopaikkaan. Niittikasetti ja sen osanumero Kohde Tuotenumero 1  Saatavilla vain vihkoalustaan. 2  Saatavilla vain vihkoviimeistelijälle, nidonnan viimeistelijälle ja nidonnan ja rei'ityksen viimeistelijälle. Niittikasetti (4 pakkausta) 1 20L7500 Niittikasetti (3 pakkausta) 2 25A0013 nitojan kasetti tilaaminen tarvikkeiden tilaaminen nitojan kasetti"},{"UUID":"f740e110-98a5-4085-88a9-fe52c736aae2","title":"Tulostimen osien ja tarvikkeiden tilaaminen","link":"ordering-parts-and-supplies-group.html","desc":"Huoltopaketin tilaaminen Huoltopaketin tilaaminen Huoltopaketin","descFull":"Huoltopaketin tilaaminen Huoltopaketin tilaaminen Huoltopaketin voi tilata ottamalla yhteyttä tulostimen ostopaikkaan. Varmista, että huoltopaketin jännite vastaa tulostimen jännitettä. Tiettyjen paperilajien käytön yhteydessä määräaikaishuoltopaketti on vaihdettava tavallista useammin. Määräaikaishuoltopaketissa on kiinnitysyksikkö ja nostorullat. Nämä osat voidaan tarvittaessa tilata ja vaihtaa myös erikseen. Suositellut huoltopaketit ja osanumerot Kohde Tuotenumero Vain valtuutettu huoltoteknikko saa vaihtaa huoltopaketin. Ota yhteyttä palveluntarjoajaan. 100 V kiinnitysyksikön huoltopaketin palautusohjelma, tyyppi 02 41X5654 100 -120  V kiinnitysyksikön huoltopaketin palautusohjelma, tyyppi 00 41X5655 220 -240  V kiinnitysyksikön huoltopaketin palautusohjelma, tyyppi 01 41X5656 100  V tavallisen kiinnitysyksikön huoltopaketti, tyyppi 12 41x6053 110-120  V tavallisen kiinnitysyksikön huoltopaketti, tyyppi 10 41X6051 220-240  V tavallisen kiinnitysyksikön huoltopaketti, tyyppi 11 41x6052 tarvikkeiden tilaaminen kiinnitysyksikön huoltopaketti kiinnitysyksikön huoltopaketti tilaaminen"},{"UUID":"c821f3bb-804c-4b35-9a4f-594583023ed7","title":"Tulostimen osien ja tarvikkeiden vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Väriainekasetin vaihtaminen Väriainekasetin vaihtaminen Avaa","descFull":"Väriainekasetin vaihtaminen Väriainekasetin vaihtaminen Avaa etuluukku.  Poista käytetty värikasetti. Ota uusi väriainekasetti pakkauksestaan. Työnnä uutta väriainekasettia, kunnes se  napsahtaa  paikalleen. Sulje luukku. värikasetti vaihtaminen tarvikkeiden vaihtaminen värikasetti"},{"UUID":"a60d40f1-5e0a-4af0-b3ec-f06256db2ee1","title":"Tulostimen osien ja tarvikkeiden vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Mustan kuvayksikön vaihtaminen Avaa etuluukku.","descFull":"Mustan kuvayksikön vaihtaminen Avaa etuluukku. Poista väriainekasetit. Irrota hukkaväriainepullo. Vältä läikkymistä asettamalla pullo pystyasentoon. Irrota kuvayksikkö. Älä altista kuvansiirtopakettia suoralle valolle. Pitkäaikainen altistuminen valolle voi aiheuttaa tulostuslaatuongelmia. Älä kosketa valojohderumpua. Rumpujen koskettaminen saattaa heikentää tulevien tulostustöiden laatua. Aseta kuvayksikkö puhtaalle, tasaiselle pinnalle ja pystysuoraan asentoon, jotta valojohderumpu ei naarmuunnu tai vaurioidu.  Vapauta käytetty musta kuvayksikkö. Irrota käytetty musta kuvayksikkö. Ota uusi musta kuvayksikkö pakkauksesta. Aseta uusi musta kuvayksikkö paikalleen. Lukitse uusi musta kuvayksikkö paikalleen. Aseta kuvayksikkö kunnolla paikalleen. Työnnä hukkaväriainepulloa, kunnes se  napsahtaa  paikalleen. Vedä tulostuspään pyyhkimet varovasti ulos ja puhdista sitten tulostuspään linssit. Lisätietoja tulostuspään linssien puhdistamisesta on kohdassa  . Asenna väriainekasetit. Sulje luukku. musta kuvayksikkö vaihtaminen tarvikkeiden vaihtaminen musta kuvayksikkö"},{"UUID":"d52ac916-ab0e-4b93-a40e-72b38a5cb8ab","title":"Tulostimen osien ja tarvikkeiden vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Värillisen kuvansiirtopaketin vaihtaminen Avaa etuluukku.","descFull":"Värillisen kuvansiirtopaketin vaihtaminen Avaa etuluukku. Poista väriainekasetit. Irrota hukkaväriainepullo. Vältä läikkymistä asettamalla pullo pystyasentoon. Irrota käytetty kuvansiirtopaketti. Aseta kuvayksikkö puhtaalle, tasaiselle pinnalle ja pystysuoraan asentoon, jotta valojohderumpu ei naarmuunnu tai vaurioidu.  Vapauta musta kuvayksikkö. Irrota musta kuvayksikkö. Älä heitä mustaa kuvayksikköä pois. Se asennetaan uuteen kuvayksikköön. Poista uusi kuvayksikkö pakkauksestaan. Kuvayksikössä on kuvansiirtopaketti sekä syaani, magenta, keltainen ja musta kehitysyksikkö. Älä altista kuvansiirtopakettia suoralle valolle. Pitkäaikainen altistuminen valolle voi aiheuttaa tulostuslaatuongelmia. Älä kosketa valojohderumpua. Rumpujen koskettaminen saattaa heikentää tulevien tulostustöiden laatua. Työnnä musta kuvayksikkö uuteen kuvayksikköön. Lukitse musta kuvayksikkö paikalleen. Aseta kuvayksikkö kunnolla paikalleen. Työnnä hukkaväriainepulloa, kunnes se  napsahtaa  paikalleen. Vedä tulostuspään pyyhkimet varovasti ulos ja puhdista sitten tulostuspään linssit. Lisätietoja tulostuspään linssien puhdistamisesta on kohdassa  . Asenna väriainekasetit. Sulje luukku. värillinen kuvansiirtopaketti vaihtaminen tarvikkeiden vaihtaminen värillinen kuvansiirtopaketti"},{"UUID":"fbb6e9e4-bd6d-4979-9d01-915ed9acc9a8","title":"Tulostimen osien ja tarvikkeiden vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Hukkaväriainepullon vaihtaminen Hukkaväriainepullon vaihtaminen Avaa","descFull":"Hukkaväriainepullon vaihtaminen Hukkaväriainepullon vaihtaminen Avaa etuluukku. Irrota käytetty hukkaväripullo. Vältä läikkymistä asettamalla pullo pystyasentoon. Pura uusi hukkaväripullo pakkauksesta. Työnnä uutta hukkaväriainepulloa, kunnes se  napsahtaa  paikalleen, ja sulje luukku. tarvikkeiden vaihtaminen hukkaväriainepullo hukkaväriainepullo vaihtaminen"},{"UUID":"4f06f343-e746-4b16-afea-e3cf13e1b791","title":"Tulostimen osien ja tarvikkeiden vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Kiinnitysyksikön vaihtaminen Kiinnitysyksikön vaihtaminen Katkaise","descFull":"Kiinnitysyksikön vaihtaminen Kiinnitysyksikön vaihtaminen Katkaise virta tulostimesta. Irrota virtajohto ensin pistorasiasta ja sitten tulostimesta. Avaa luukku B. Tulostimen sisäosat voivat olla kuumat. Voit välttää palovammoja koskettamalla osia vasta, kun niiden pinta on jäähtynyt. Avaa lukitus ja irrota sitten käytetty kiinnitysyksikkö. Poista uusi kiinnitysyksikkö pakkauksesta. Työnnä uutta kiinnitysyksikköä, kunnes se  napsahtaa  paikalleen, ja lukitse se. Sulje luukku B. Liitä virtajohdon toinen pää tulostimeen ja toinen pää pistorasiaan. Tulipalon tai sähköiskun vaaran välttämiseksi liitä virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Kytke tulostimen virta. kiinnitysyksikkö vaihtaminen osien vaihtaminen kiinnitysyksikkö"},{"UUID":"bef3ec44-b51f-4e39-ba58-b595bf4bb33f","title":"Tulostimen osien ja tarvikkeiden vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Asenna uusi lokeronasennus. Asenna uusi","descFull":"Asenna uusi lokeronasennus. Asenna uusi lokeronasennus. Vedä alustan sisäosa ulos. Ota uusi lokeronasennus pakkauksestaan. Asenna uusi lokeronasennus. lokeronasennus vaihtaminen osien vaihtaminen alustan sisäosa"},{"UUID":"8e9c86bd-398c-4b17-aebb-7198e387d6b8","title":"Tulostimen osien ja tarvikkeiden vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Valinnaisen 550 arkin lokeron sivuohjainten","descFull":"Valinnaisen 550 arkin lokeron sivuohjainten vaihtaminen Valinnaisen 550 arkin lokeron sivuohjainten vaihtaminen Vedä lokero auki. Irrota käytetyt sivuohjaimet. Ota uudet sivuohjaimet pakkauksesta. Asenna uudet sivuohjaimet ja varmista, että ne  napsahtavat  paikoilleen. Aseta alusta tulostimeen. sivuohjaimet vaihtaminen osien vaihtaminen sivuohjaimet"},{"UUID":"a8eebf82-31d4-4791-bd0a-b5b9a62241be","title":"Tulostimen osien ja tarvikkeiden vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"550 arkin lokeron kannen vaihtaminen","descFull":"550 arkin lokeron kannen vaihtaminen 550 arkin lokeron kannen vaihtaminen Irrota käytetty lokeron kansi. Ota uusi lokeron kansi pakkauksestaan. Työnnä uutta lokeron kantta, kunnes se napsahtaa paikalleen. osien vaihtaminen lokeron kansi lokeron kansi vaihtaminen 550 arkin lokeron kansi"},{"UUID":"875c9162-8a4d-4ea8-825f-626e002c9e35","title":"Tulostimen osien ja tarvikkeiden vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Vihkoviimeistelijän yläalustan laajennuksen vaihtaminen Poista","descFull":"Vihkoviimeistelijän yläalustan laajennuksen vaihtaminen Poista käytetty yläalustan laajennus. Ota uusi yläalustan laajennus pakkauksesta. Aseta uusi yläalustan laajennus paikalleen. osien vaihtaminen vihkoviimeistelijän yläalustan laajennus vihkoviimeistelijän yläalustan laajennus vaihtaminen"},{"UUID":"1eacd2b5-77fa-4af3-9c01-be1993717774","title":"Tulostimen osien ja tarvikkeiden vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Rei'ittimen laatikon vaihtaminen Rei'ittimen laatikon","descFull":"Rei'ittimen laatikon vaihtaminen Rei'ittimen laatikon ulkonäkö voi vaihdella asennetun viimeistelijän mukaan. Avaa viimeistelijän kansi. Poista käytetty rei'ittimen laatikko. Ota uusi rei'ittimen laatikko pakkauksesta. Aseta uusi rei'ittimen laatikko paikalleen. Sulje viimeistelijän luukku. osien vaihtaminen rei'ittimen laatikko rei'ittimen laatikko vaihtaminen"},{"UUID":"d5a956e5-7adb-4bb7-99d9-388a3f7469c1","title":"Tulostimen osien ja tarvikkeiden vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Vakioalustan vaihtaminen Vakioalustan vaihtaminen Irrota","descFull":"Vakioalustan vaihtaminen Vakioalustan vaihtaminen Irrota vakioalusta. Ota uusi vakioalusta pakkauksesta. Kiinnitä uusi vakioalusta. osien vaihtaminen Vakioalusta Vakioalusta vaihtaminen"},{"UUID":"31f05e79-93c7-47cd-8c22-6c7759f3e080","title":"Tulostimen osien ja tarvikkeiden vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Tuulettimen kannen vaihtaminen Irrota käytetty","descFull":"Tuulettimen kannen vaihtaminen Irrota käytetty tuulettimen kansi. Ota uusi kansi pakkauksesta. Työnnä uutta kantta, kunnes se  napsahtaa  paikalleen. osien vaihtaminen tuulettimen kansi tuulettimen kansi vaihtaminen"},{"UUID":"b04ac196-34c3-408f-a272-0d85458bcc2a","title":"Tulostimen osien ja tarvikkeiden vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Oikean suojuksen vaihtaminen Irrota käytetty","descFull":"Oikean suojuksen vaihtaminen Irrota käytetty oikea suojus. Ota uusi kansi pakkauksesta. Työnnä uutta kantta, kunnes se  napsahtaa  paikalleen. osien vaihtaminen oikea suojus oikea suojus vaihtaminen"},{"UUID":"267deea8-9fcc-4e2c-83ce-8841de101c11","title":"Tulostimen osien ja tarvikkeiden vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Tasonpuhdistustyökalun vaihto Avaa skannerin kansi.","descFull":"Tasonpuhdistustyökalun vaihto Avaa skannerin kansi. Irrota käytetty tasonpuhdistustyökalu. Ota uusi tasonpuhdistustyökalu pakkauksestaan. Laita uusi tasonpuhdistustyökalu paikalleen. Sulje skannerin kansi. osien vaihtaminen tasonpuhdistustyökalu tasonpuhdistustyökalu vaihtaminen"},{"UUID":"ce93ffd3-2edc-4954-906a-fce4757df645","title":"Tulostimen osien ja tarvikkeiden vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Paperin siirtoyksikön liittimen kannen vaihtaminen","descFull":"Paperin siirtoyksikön liittimen kannen vaihtaminen Paperin siirtoyksikön liittimen kannen vaihtaminen Poista vakioalusta. Irrota paperin siirtoyksikön liittimen kansi. Ota uusi liittimen kansi pakkauksesta. Kiinnitä uusi liittimen kansi niin, että se  napsahtaa  paikalleen. Kiinnitä vakioalusta. osien vaihtaminen paperin siirtoyksikön liittimen kansi paperin siirtoyksikön liittimen kansi vaihtaminen"},{"UUID":"4b9ab815-c0bd-4986-b7c6-9faee116b940","title":"Niittikasettikotelon vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Niittikasetin vaihtaminen nidonnan viimeistelijään Tartu","descFull":"Niittikasetin vaihtaminen nidonnan viimeistelijään Tartu kahvaan F alapuolella ja liu'uta nidonnan viimeistelijää vasemmalle. Irrota niittikasetin pidike. Poista tyhjä niittikasetti. Työnnä uutta niittikasettia, kunnes se  napsahtaa  paikalleen. Työnnä niittikasetin pidikettä, kunnes se  napsahtaa  paikalleen. Liu'uta nidonnan viimeistelijää oikealle. tarvikkeiden vaihtaminen nitojan kasetti nitojan kasetti vaihtaminen"},{"UUID":"e528ba57-3825-412a-b141-a3a77c0cda31","title":"Niittikasettikotelon vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Niittikasetin vaihtaminen nidonnan tai rei'ityksen","descFull":"Niittikasetin vaihtaminen nidonnan tai rei'ityksen viimeistelijään Avaa luukku H. Vedä vihreä kahva ulos ja irrota niittikasetin pidike. Poista tyhjä niittikasetti. Poista uusi niittikasetti pakkauksestaan. Työnnä uutta niittikasettia, kunnes se  napsahtaa  paikalleen. Työnnä niittikasetin pidikettä, kunnes se  napsahtaa  paikalleen. Sulje luukku H. tarvikkeiden vaihtaminen nitojan kasetti nitojan kasetti vaihtaminen"},{"UUID":"9d7ddcc4-ee88-4592-a5b9-8cd9fc2c8c87","title":"Niittikasettikotelon vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Niittikasetin vaihtaminen vihkon viimeistelijään Avaa","descFull":"Niittikasetin vaihtaminen vihkon viimeistelijään Avaa luukku H. Vedä vihreä kahva ulos ja irrota niittikasetin pidike. Poista tyhjä niittikasetti. Poista uusi niittikasetti pakkauksestaan. Työnnä uutta niittikasettia, kunnes se  napsahtaa  paikalleen. Työnnä niittikasetin pidikettä, kunnes se  napsahtaa  paikalleen. Sulje luukku H. tarvikkeiden vaihtaminen nitojan kasetti nitojan kasetti vaihtaminen"},{"UUID":"3e35861c-96c7-4eaa-87f4-b25b8a74e6e4","title":"Niittikasettikotelon vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Vihkoviimeistelijän niittikasetin pidikkeiden vaihtaminen Avaa","descFull":"Vihkoviimeistelijän niittikasetin pidikkeiden vaihtaminen Avaa viimeistelijän kansi. Vedä vihkoalusta ulos ja poista sitten käytetyt niittikasetin pidikkeet. Ota uudet niittikasetin pidikkeet pakkauksestaan. Aseta uudet niittikasetin pidikkeet paikalleen. Aseta vihkovalmistin paikalleen ja sulje viimeistelijän luukku. osien vaihtaminen niittikasetin pidike niittikasetin pidike vaihtaminen"},{"UUID":"59102a7c-7260-4b56-a398-7064934b77c3","title":"Tulostimen osien ja tarvikkeiden vaihtaminen","link":"replacing-toner-cartridge-topic.html","desc":"Tarvikkeiden käyttölaskurien nollaaminen Tarvikkeiden käyttölaskurien","descFull":"Tarvikkeiden käyttölaskurien nollaaminen Tarvikkeiden käyttölaskurien nollaaminen Valitse ohjauspaneelissa  Asetukset Laite Huolto Määritys-valikko Tarvikkeen käyttö ja laskurit . Valitse laskuri, jonka haluat nollata. Tarvikkeet ja osat, jotka eivät kuulu palautusohjelman sopimuksen piiriin, voidaan nollata ja uusiovalmistaa. Valmistajan takuu ei kuitenkaan kata muiden kuin aitojen tarvikkeiden tai osien aiheuttamia vahinkoja. Tarvikkeen tai osan laskurien nollaaminen ilman asianmukaista uudelleenvalmistusta voi vahingoittaa tulostinta. Kun tarvike- tai osalaskuri on nollattu, tulostimessa voi näkyä nollattuun kohteeseen viittaava virhe. Tarvikkeet ja osat, jotka eivät kuulu käyttö- ja palautusohjelman sopimuksen piiriin, voidaan nollata ja uusiovalmistaa. Valmistajan takuu ei kuitenkaan kata muiden kuin aitojen tarvikkeiden tai osien aiheuttamia vahinkoja. Tarvikkeen tai osan laskurien nollaaminen ilman asianmukaista uudelleenvalmistusta voi vahingoittaa tulostinta. Kun tarvike- tai osalaskuri on nollattu, tulostimessa voi näkyä nollattuun kohteeseen viittaava virhe. tarvikkeiden käyttölaskurit uudelleen asetus tarvikkeiden käyttölaskurien nollaaminen"},{"UUID":"7f24945a-8bb7-4449-abb0-6e4e3f25d7a5","title":"Tulostimen osien puhdistaminen","link":"cleaning-printer-topic.html","desc":"Tulostimen puhdistaminen Tulostimen puhdistaminen Voit","descFull":"Tulostimen puhdistaminen Tulostimen puhdistaminen Voit välttää sähköiskun vaaran tulostimen ulkopintaa puhdistettaessa irrottamalla virtajohdon pistorasiasta ja irrottamalla kaikki tulostimeen johtavat kaapelit. Suorita tämä toimenpide muutaman kuukauden välein. Takuu ei kata vaurioita, jotka aiheutuvat tulostimelle siitä, että sitä on käsitelty väärin. Sammuta tulostin ja irrota virtajohto pistorasiasta. Poista paperit vakiolokerosta ja monikäyttösyöttöaukosta. Poista pöly, nukka ja paperin palaset tulostimen ympäriltä pehmeällä harjalla tai imurilla.   Pyyhi tulostimen ulkopinnat pehmeällä, kostutetulla ja nukkaamattomalla kankaalla. Älä käytä kodin puhdistus- tai pesuaineita, sillä ne voivat vaurioittaa tulostimen pintaa. Varmista, että tulostimen kaikki alueet ovat kuivia puhdistuksen jälkeen. Liitä virtajohto pistorasiaan ja kytke tulostimen virta. Tulipalo- tai sähköiskuriskin välttämiseksi kytke virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. tulostimen puhdistaminen tulostin, puhdistaminen"},{"UUID":"d5d6da93-ebe1-40f7-ae53-7c429068b3fc","title":"Tulostimen osien puhdistaminen","link":"cleaning-printer-topic.html","desc":"Kosketusnäytön puhdistaminen Kosketusnäytön puhdistaminen Voit","descFull":"Kosketusnäytön puhdistaminen Kosketusnäytön puhdistaminen Voit välttää sähköiskun vaaran tulostimen ulkopintaa puhdistettaessa irrottamalla virtajohdon pistorasiasta ja irrottamalla kaikki tulostimeen johtavat kaapelit. Sammuta tulostin ja irrota virtajohto pistorasiasta. Pyyhi kosketusnäyttö kostealla, pehmeällä nukkaamattomalla liinalla: Älä käytä kodin puhdistus- ja pesuaineita, sillä ne voivat vaurioittaa kosketusnäyttöä. Varmista, että kosketusnäyttö on kuiva puhdistuksen jälkeen. Liitä virtajohto pistorasiaan ja kytke tulostimen virta. Tulipalon tai sähköiskun vaaran välttämiseksi liitä virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. kosketusnäyttö, puhdistaminen kosketusnäytön puhdistaminen"},{"UUID":"cc21e225-9487-469e-b860-cf21bbef6102","title":"Tulostimen osien puhdistaminen","link":"cleaning-printer-topic.html","desc":"Skannerin puhdistaminen Avaa skannerin kansi.","descFull":"Skannerin puhdistaminen Avaa skannerin kansi. Irrota tasonpuhdistustyökalu. Avaa luukku A1. Pyyhi ADF-lasi työkalulla. Sulje luukku A1. Pyyhi seuraavat alueet kostealla, pehmeällä nukkaamattomalla liinalla: asiakirjansyöttölaitteen taustalevy skannaustason taustalevy Skannaustaso Pyyhi ADF-lasi työkalulla. Palauta työkalu paikalleen. Sulje skannerin kansi. skanneri puhdistaminen tulostuslaatu skannerin puhdistaminen skannerin puhdistaminen"},{"UUID":"4f4530e4-b73b-4cb6-af0c-9db1be059417","title":"Tulostimen osien puhdistaminen","link":"cleaning-printer-topic.html","desc":"Tulostuspään linssien puhdistaminen Avaa etuluukku.","descFull":"Tulostuspään linssien puhdistaminen Avaa etuluukku. Poista väriainekasetit. Vedä varovasti pyyhintä ulospäin niin pitkälle kuin se tulee. Pyyhin ei irtoa tulostimesta. Työnnä pyyhin takaisin tulostuspäähän, kunnes se pysähtyy. Toista  vaihe 3  ja  vaihe 4  kolme kertaa jokaista tulostuspäätä kohden. Asenna väriainekasetit. Sulje etuluukku. tulostuspään linssit puhdistaminen tulostuspään linssien puhdistaminen"},{"UUID":"78e66993-ddc7-4c87-823d-a3412b2fca76","title":"Tulostimen osien puhdistaminen","link":"cleaning-printer-topic.html","desc":"Rei'ittimen laatikon tyhjentäminen Rei'ittimen laatikon","descFull":"Rei'ittimen laatikon tyhjentäminen Rei'ittimen laatikon ulkonäkö voi vaihdella asennetun viimeistelijän mukaan. Avaa viimeistelijän kansi. Irrota ja tyhjennä rei'ityslaatikko. Aseta rei'ittimen laatikko paikalleen. Sulje viimeistelijän luukku. rei'ittimen laatikko tyhjentäminen rei'ittimen laatikon tyhjentäminen"},{"UUID":"d0dec814-c8ce-4b83-9e6c-5d8ccf2fa5ca","title":"Energian ja paperin säästäminen","link":"configuring-power-save-mode-settings-topic.html","desc":"Virransäästötilan asetusten määrittäminen Virransäästötilan asetusten","descFull":"Virransäästötilan asetusten määrittäminen Virransäästötilan asetusten määrittäminen Lepotila Siirry ohjauspaneelissa kohtaan  Asetukset Laite Virranhallinta Aikakatkaisut Lepotila . Määritä aika, jonka tulostin odottaa käyttämättömänä ennen siirtymistä  Lepotilaan . Säästötila Siirry ohjauspaneelissa kohtaan  Asetukset Laite Virranhallinta Aikakatkaisut Horrostilan aikakatkaisu . Määritä aika, jonka tulostin odottaa käyttämättömänä ennen siirtymistä horrostilaan. Horrostilan aikakatkaisu  toimi, kun  Horrostilan aikakatkaisu yhdistettäessä  -asetuksen arvona on  Horrostila . Kun tulostin on horrostilassa, Embedded Web Server -palvelu on poissa käytöstä. Lepotila konfigurointi Säästötila konfigurointi virransäästötilat konfigurointi"},{"UUID":"7888d125-cda8-4b7d-9da8-204bd1c898db","title":"Energian ja paperin säästäminen","link":"configuring-power-save-mode-settings-topic.html","desc":"Näytön kirkkauden säätäminen Näytön kirkkauden","descFull":"Näytön kirkkauden säätäminen Näytön kirkkauden säätäminen Siirry ohjauspaneelissa kohtaan  Asetukset Laite Asetukset . Säädä asetusta  Näytön kirkkaus  -valikossa. näytön kirkkaus säätäminen kirkkauden säätäminen"},{"UUID":"40060ee6-8181-4bae-add8-28530de091b8","title":"Energian ja paperin säästäminen","link":"configuring-power-save-mode-settings-topic.html","desc":"Tulostustarvikkeiden säästäminen Tulosta paperin molemmille","descFull":"Tulostustarvikkeiden säästäminen Tulosta paperin molemmille puolille. Kaksipuolinen tulostus on oletusasetuksena tulostimessa. Tulosta useita sivuja yhdelle paperiarkille. Tarkastele asiakirjan ulkoasua esikatselutoiminnolla ennen tulostamista. Tulosta yksi kopio ja tarkista asiakirjan sisältö ja ulkoasu. tulostustarvikkeiden käyttöiän pidentäminen tulostustarvikkeet, säästäminen"},{"UUID":"7c1ea5b7-37bd-432f-8e2d-47f4f8592133","title":"Tulostimen ylläpito","link":"moving-printer-topic.html","desc":"Tulostimen siirtäminen toiseen paikkaan Tulostimen","descFull":"Tulostimen siirtäminen toiseen paikkaan Tulostimen siirtäminen toiseen paikkaan Jos tulostin painaa yli 20 kg, sen turvallinen siirtäminen edellyttää kahta tai useampaa henkilöä. Vältä tulipalon tai sähköiskun vaara: käytä vain tämän tuotteen mukana toimitettua tai valmistajan hyväksymää virtajohtoa. Ennen kuin siirrät tulostinta, tutustu seuraaviin ohjeisiin, jotta kukaan ei loukkaantuisi eikä tulostin vahingoittuisi: Varmista, että tulostimen kaikki luukut ja lokerot ovat kiinni. Sammuta tulostin ja irrota virtajohto pistorasiasta. Irrota kaikki kaapelit tulostimesta. Jos tulostimeen on liitetty erillisiä lattialle sijoitettavia valinnaisia lokeroita tai tulostuslisävarusteita, irrota ne, ennen kuin siirrät tulostinta. Jos tulostimessa on tulostintuki, rullaa se varovasti uuteen paikkaan. Ylitä kynnykset ja lattian epätasaisuudet varovasti. Jos tulostimessa ei ole tulostintukea mutta siinä on lisälokeroja tai tulostuslisävarusteita, irrota tulostuslisävarusteet nosta tulostin pois lokeroilta. Älä yritä nostaa tulostinta ja lisävarusteita samanaikaisesti. Nosta tulostinta aina sen sivuilla olevista kädensijoista. Tulostimen siirtämiseen käytettävien kärryjen on oltava senkokoiset, että ne tukevat tulostimen koko jalustaa. Laitteiden siirtämiseen käytettävien kärryjen on oltava niin suuret, että laitteet mahtuvat niihin kokonaan. Pidä tulostin pystyasennossa. Vältä erittäin äkkinäisiä liikkeitä. Varmista, että sormesi eivät ole tulostimen alla, kun lasket tulostimen alas. Varmista, että tulostimen ympärillä on riittävästi tilaa. Tulostimen takuu ei korvaa vahinkoa, jonka syynä on vääränlainen siirtely. tulostimen siirtäminen"},{"UUID":"858f6924-9d62-4931-b146-34c243557e84","title":"Vianmääritys","link":"print-quality-problems-topic.html","desc":"Tulostuslaatuongelmat Etsi kuva, joka vastaa","descFull":"Tulostuslaatuongelmat Etsi kuva, joka vastaa tulosteen laatuongelmaa, valitse sitten kuvan alla oleva linkki ja lue ohjeet ongelman ratkaisemiseen."},{"UUID":"b624c4a2-f7e3-4c16-947e-676a7a10d474","title":"Vianmääritys","link":"printer-error-codes-topic.html","desc":"Tulostimen virhekoodit Virhekoodit ja virheiden","descFull":"Tulostimen virhekoodit Virhekoodit ja virheiden ratkaiseminen Virhekoodit Virheilmoitus Ratkaisu 2.01 Tarvike tarvitaan. Valitse  Työn peruutus  ja tilaa tarvittava tarvike. Lisätietoja on kohdassa  . 3.01 Vakiovastaanottoalusta on täynnä. Poista paperi alustalta ja valitse sitten  Jatka . 3.02, 3.03, 3.04 Poista paperi alustalta<x>. Poista paperi alustalta ja valitse sitten  Jatka . 7.13, 7.23, 7.33,7.43 Asenna lokero [x]. Aseta ilmoituksessa mainittu lokero. 8.01 Sulje etuluukku. Pidä etuluukku suljettuna muulloin kuin huollon aikana. 8.02, 8.03, 8.04, 8.05, 8.08, 8.10, 8.11 Sulje luukku [x]. Pidä ilmoituksessa mainittu luukku suljettuna muulloin kuin huollon aikana. 8.06 Laita 1 500 arkin lokero takaisin paikalleen. Varmista, että lokero on kiinnitetty tulostimeen oikein. 8.07 Laita nidonnan viimeistelijä takaisin paikalleen. Varmista, että viimeistelijä on kiinnitetty tulostimeen oikein. 8.08 Sulje paperinsiirron kansi F. Pidä kansi suljettuna muulloin kuin huollon aikana. 8.09 Sulje paperinsiirron kansi G. 9 Tulostin oli käynnistettävä uudelleen. Viimeinen työ saattaa olla vaillinainen. Jatka tulostusta ja poista ilmoitus näytöstä valitsemalla  Jatka . 11.11, 11.21, 11.31, 11.41, 11.51, 11.81, 11.91 Lisää <lähde/> <laji/> <koko/>. Lisää ilmoituksessa mainittuun lokeroon paperia. Lisätietoja on kohdassa  . 11.12, 11.22, 11.32, 11.42, 11.82, 11.92 Lisää <lähde/> <laji/> <koko/> <suunta/>. 12.11, 12.21, 12.31, 12.41, 12.51, 12.91 Vaihda <lähde/> kohteeksi <laji/> <koko/>.  Vedä ulos ilmoituksessa mainittu lokero, poista paperit ja lisää sitten oikeanlaista paperia. Lisätietoja on kohdassa  . 12.12, 12.22, 12.32, 12.4212.92 Vaihda <lähde/> kohteeksi <laji/> <koko/> <suunta/>.  31.00 Rei'ityslaatikko puuttuu tai on täynnä. Avaa luukku H. Irrota rei'ityksen laatikko. Jos rei'ityslaatikko on täynnä, tyhjennä se. Aseta rei'ittimen laatikko paikalleen. Sulje luukku H. 31.35, 31.35A, 31.35B Asenna puuttuva tai reagoimaton hukkaväriainepullo uudelleen. Avaa etuluukku. Irrota hukkaväriainepullo. Vältä läikkymistä asettamalla pullo pystyasentoon. Aseta hukkaväriainepullo paikalleen. Sulje etuluukku. 31.40z, 31.41z, 31.42z, 31.43z Asenna uudelleen puuttuva tai reagoimaton [värillinen] värikasetti. Avaa etuluukku. Poista kasetti. Aseta kasetti paikalleen. Sulje etuluukku. 31.60z Asenna puuttuva tai reagoimaton musta kuvayksikkö uudelleen. Avaa etuluukku. Poista väriainekasetit. Irrota hukkaväriainepullo. Vältä läikkymistä asettamalla pullo pystyasentoon. Irrota kuvayksikkö. Älä altista kuvansiirtopakettia suoralle valolle. Pitkäaikainen altistuminen valolle voi aiheuttaa tulostuslaatuongelmia. Älä kosketa valojohderumpua. Rumpujen koskettaminen saattaa heikentää tulevien tulostustöiden laatua. Avaa lukitus ja poista musta kuvayksikkö. Aseta musta kuvayksikkö paikalleen ja lukitse se. Aseta kuvayksikkö kunnolla paikalleen. Aseta hukkaväriainepullo paikalleen. Asenna väriainekasetit. Sulje etuluukku. 31.64z Asenna uudelleen puuttuva, irrotettu tai vastaamaton värillinen kuvansiirtopaketti. Avaa etuluukku. Poista väriainekasetit. Irrota hukkaväriainepullo. Vältä läikkymistä asettamalla pullo pystyasentoon. Irrota kuvayksikkö. Älä altista kuvansiirtopakettia suoralle valolle. Pitkäaikainen altistuminen valolle voi aiheuttaa tulostuslaatuongelmia. Älä kosketa valojohderumpua. Rumpujen koskettaminen saattaa heikentää tulevien tulostustöiden laatua. Aseta kuvayksikkö kunnolla paikalleen. Aseta hukkaväriainepullo paikalleen. Asenna väriainekasetit. Sulje etuluukku. 31.80z Asenna puuttuva tai vastaamaton kiinnitysyksikkö uudelleen. Avaa luukku B. Tulostimen sisäosat voivat olla kuumat. Voit välttää palovammoja koskettamalla osia vasta, kun niiden pinta on jäähtynyt. Avaa lukitus ja irrota sitten kiinnitysyksikkö. Aseta kiinnitysyksikkö paikalleen ja lukitse se. Sulje luukku B. 32.40z, 32.41z, 32.42z, 32.43z Vaihda ei-tuettu [värillinen] värikasetti. Lisätietoja on kohdassa  . 32.60z Vaihda väärä musta kuvayksikkö. Lisätietoja on kohdassa  . 32.65z Vaihda väärä värillinen kuvansiirtopaketti. Lisätietoja on kohdassa  . 33.40z, 33.41z, 33.42z, 33.43z Uudelleentäytetty tavallinen [väri] kasetti. Lisätietoja on kohdassa  . 33.60z Ei aito musta kuvayksikkö, katso käyttöopas. Lisätietoja on kohdassa  . 33.64z Ei aito värillinen kuvansiirtopaketti, kts. käyttöopas 34.00 Paperi liian lyhyt Määritä paperikokoasetus lokeroon lisätyn paperin koon mukaiseksi. Valitse ohjauspaneelissa  Asetukset Paperi Lokero Määritys Paperikoko/-laji . 34.10, 34.20, 34.30, 34.40, 34.50 Tarkista [lähde], säädä ohjaimet ja suunta. Vedä ilmoituksessa mainittu lokero ulos ja varmista sitten, että paperi on lisätty oikein. Lisätietoja on kohdassa  . 34.90 Tarkista monikäyttösyöttöaukko ja säädä ohjaimet ja suunta. Varmista, että paperi on lisätty oikein. Lisätietoja on kohdassa  . 37.1 Muisti ei riitä työn lajitteluun Kokeile jompaakumpaa seuraavista: Tulosta työn tallennettu osa ja aloita tulostustyön loppuosan lajittelu valitsemalla  Jatka . Peruuta nykyinen tulostustyö. 37.3 Muisti ei riitä. Jotkin pidossa olevat työt poistettiin Jatka tulostusta ja poista ilmoitus näytöstä valitsemalla  Jatka . 38.1 Muisti täynnä. Kokeile jotakin seuraavista keinoista: Jatka tulostusta ja poista ilmoitus näytöstä valitsemalla  Jatka . Peruuta nykyinen tulostustyö. Asenna tulostimeen lisää muistia. Vähennä tulostustyön sivumäärää. 39.1 Monimutkainen sivu, jotkin tiedot eivät ehkä tulostuneet. Kokeile jotakin seuraavista keinoista: Jatka tulostusta ja poista ilmoitus näytöstä valitsemalla  Jatka . Peruuta nykyinen tulostustyö. Asenna tulostimeen lisää muistia. Vähennä tulostustyön monimutkaisuutta ja kokoa, ennen kuin lähetät sen tulostettavaksi uudelleen. Vähennä tulostustyön sivumäärää. Vähennä mahdollisten ladattujen fonttien määrää ja kokoa. Poista tulostustyöstä mahdolliset tarpeettomat fontit tai makrot. Vähennä tulostustyön kuvien määrää. 42.yyC, 42.yyK, 42.yyM, 42.yyY Vaihda [väri] kasetti, tulostimen alue ei täsmää. Lisätietoja on kohdassa  . 43.40Y, 43.41Y, 43.42Y, 43.43Y Asenna värikasetti uudelleen Avaa etuluukku. Poista kasetti. Aseta kasetti paikalleen. Sulje etuluukku. 43.40Z, 43.41Z, 43.42Z, 43.43Z Vaihda [väri] kasetti Lisätietoja on kohdassa  . 50 PPDS-fonttivirhe Asenna tulostustyössä ilmoitettu PPDS-fontti ja anna tulostimen etsiä korvaava fontti valitsemalla  Jatka  . 51 Flash-muisti on viallinen Kokeile jotakin seuraavista keinoista: Vaihda flash-muisti. Jatka tulostusta ja poista ilmoitus näytöstä valitsemalla  Jatka . Peruuta nykyinen tulostustyö. 52 Flash-muisti ei riitä resurssien tallennukseen Kokeile jotakin seuraavista keinoista: Jatka tulostusta ja poista ilmoitus näytöstä valitsemalla  Jatka . Poista fontit, makrot ja muut flash-muistiin tallennetut tiedot. Asenna tallennusasema. Poistetaan ladatut fontit ja makrot, joita ei ole aiemmin tallennettu flash-muistiin. 58.4 Väärä tulostuskokoonpano. Sammuta tulostin ja asenna oikea alusta tai viimeistelijä. 61 Poista viallinen levy Vaihda viallinen tallennusasema. 62 Levy täynnä. Kokeile jotakin seuraavista keinoista: Jatka tulostusta ja poista ilmoitus näytöstä valitsemalla  Jatka . Poista fontit, makrot ja muut tallennusasemaan tallennetut tiedot. Asenna tallennusasema. 63 Alusta levy. Alustus nyt pyyhkii kaikki tiedot tallennusasemasta. Alusta levy seuraavasti: Siirry ohjauspaneelista kohtaan  Asetukset Laite Huolto Poistaminen . Valitse  Siivoa kaikki kiintolevyn tiedot  ja valitse sitten  TYHJENNÄ . 71.01 Faksiasemalla ei ole nimeä. Ota yhteys järjestelmänvalvojaan. Lisätietoja on kohdassa  . 71.02 Faksiasemalla ei ole numeroa. Ota yhteys järjestelmänvalvojaan. 71.03 Modeemiin ei liitetty analogista puhelinlinjaa, faksi ei käytössä. Tarkista yhteyden ja linjan signaali. Lisätietoja on kohdassa  . 71.04 Analoginen puhelinlinja on liitetty väärään porttiin. Irrota puhelinlinja ja liitä se sitten LINE-porttiin. 71.06 HTTPS-faksipalvelimeen ei saada yhteyttä. Yhteys HTTPS-faksipalvelimeen on katkennut. Tarkista tulostimen Internet-yhteys. 71.07 Tulostinta ei ole rekisteröity HTTPS-faksipalvelimeen. Varmista, että tulostin on lisätty HTTPS-faksipalvelimen portaalin laiteluetteloon. Ota yhteyttä järjestelmänvalvojaan. 71.11 Faksiosio. Faksiosio ei toimi. Ota yhteyttä järjestelmänvalvojaan. 71.12 Muisti täynnä, fakseja ei voi tulostaa. Jos haluat tulostaa kaikki tallennetut faksit, valitse  Tulosta kaikki . 71.13 Muisti täynnä. Fakseja ei voi lähettää. Kokeile jompaakumpaa seuraavista: Jatka ja yritä lähettää faksi uudelleen. Skannaa alkuperäinen asiakirja sivu kerrallaan, valitse faksinumero ja faksaa asiakirja. 71.4 Tulostimen aika on väärä. Määritä tulostimen aika. Siirry ohjauspaneelista kohtaan  Asetukset Laite Määritykset Päivämäärä ja aika Määritä . 72.01 SMTP-sähköpostipalvelinta ei ole määritetty. Ota yhteys järjestelmänvalvojaan.  Kokeile jompaakumpaa seuraavista: Määritä sähköpostitoiminto. Lisätietoja on kohdassa  . Poista virheilmoitus käytöstä. Lisätietoja on kohdassa  . 72.02 Verkkolinkkipalvelinta ei määritetty. Ota yhteys järjestelmänvalvojaan. Ota yhteyttä järjestelmänvalvojaan. 72.04 Faksipalvelimen Muotoon-kohtaa ei määritetty. Ota yhteys järjestelmänvalvojaan. Kokeile jompaakumpaa seuraavista:  Määritä  Muotoon -asetus. Siirry ohjauspaneelista kohtaan  Asetukset Faksi Faksipalvelimen asetukset Yleiset faksiasetukset . Ota yhteyttä järjestelmänvalvojaan. 75.01 Havaittu suojattu elementti. Valitse jompikumpi seuraavista: Käytä asennettua suojattua elementtiä. Tulostin poistaa kaikki olemassa olevat varmenteet ja voi myös tyhjentää ja alustaa tallennusaseman. Sammuta tulostin ja poista suojattu elementti. 75.02 Suojattua elementtiä ei tunnisteta. 75.03 Virhe suojatun elementin yhteydessä.  Valitse jompikumpi seuraavista: Lopeta suojatun elementin käyttö. Tulostin poistaa kaikki olemassa olevat varmenteet ja voi myös tyhjentää ja alustaa tallennusaseman. Sammuta tulostin, poista ja asenna suojattu elementti. 75.11 Suojatun elementin päivitys epäonnistui. Valitse jompikumpi seuraavista: Yritä päivitystä uudelleen. Peruuta päivitys. Tulostin voi poistaa kaikki olemassa olevat varmenteet ja tallennusaseman sisällön. 75.12 Suojatun elementin päivitys on keskeneräinen. Valitse jompikumpi seuraavista: Käynnistä tulostin uudelleen. Odota 10 sekuntia päivityksen valmistumista. Peruuta päivitys. Tulostin voi poistaa kaikki olemassa olevat varmenteet ja tallennusaseman sisällön. 80.01, 80.09 Huoltopaketti lähes vähissä. Poista ilmoitus valitsemalla  Jatka . 80.11, 80.19 Huoltopaketti vähissä. 80.21, 80.29 Huoltopaketti erittäin vähissä. 80.31 Vaihda huoltopaketti, jotta voit jatkaa tulostusta. Lisätietoja on kohdassa  . 80.31 Vaihda huoltopaketti, suositeltu käyttöikä ylitetty. 81.11 1 500 arkin lokeron rullapaketti on vähissä. Poista ilmoitus valitsemalla  Jatka . 81.31 Vaihda 1 500 arkin lokeron rullapaketti, suositeltu käyttöikä ylitetty . Jos haluat lisätietoja, ota yhteyttä  asiakastuki . 82.00, 82.02, 82.09 Hukkaväriainepullo on lähes täynnä. Lisätietoja on kohdassa  . 82.3, 82.32, 82.33, 82.39 Vaihda hukkaväriainepullo. 83.1y Siirtomoduuli vähissä Poista ilmoitus valitsemalla  Jatka . 83.3y Vaihda siirtomoduuli, suositeltu käyttöikä ylitetty. Jos haluat lisätietoja, ota yhteyttä  asiakastuki . 83.4y Vaihda siirtomoduuli. 83.20 Niittikasetti vähissä. Poista ilmoitus valitsemalla  Jatka . 83.20 Nitojan S2 sisäinen kasetti vähissä. 83.20 Nitojan S2 ulkoinen kasetti vähissä. 83.30 Niittikasetti on tyhjä tai puuttuu. Kokeile jompaakumpaa seuraavista: Poista niittikasetti ja asenna se uudelleen. Vaihda niittikasetti. Lisätietoja on kohdissa   ja  . 83.30 Niittikasetti S1 tyhjä tai puuttuu. Kokeile jompaakumpaa seuraavista: Poista niittikasetti ja asenna se uudelleen. Vaihda niittikasetti. Lisätietoja on kohdassa  . 83.30 Sisäinen niittikasetti S2 tyhjä tai puuttuu. Kokeile jompaakumpaa seuraavista: Poista niittikasetti ja asenna se uudelleen. Vaihda niittikasetti. Lisätietoja on kohdassa  . 83.30 Ulkoinen niittikasetti S2 tyhjä tai puuttuu. 84.01K, 84.03K, 84.09K Musta kuvayksikkö vähissä Poista ilmoitus valitsemalla  Jatka . 84.11K, 84.13K, 84.19K Musta kuvayksikkö vähissä. 84.21C, 84.03C, 84.09C Musta kuvayksikkö erittäin vähissä. 84.01C, 84.03C, 84.09C Värillinen kuvasarja vähenemässä. 84.11C, 84.13C, 84.19C Värillinen kuvasarja vähissä. 84.21C, 84.23C, 84.29C Värillinen kuvansiirtopaketti erittäin vähissä. 84.31, 84.33 Vaihda musta kuvayksikkö, suositeltu käyttöikä ylitetty Lisätietoja on kohdassa  . 84.31, 84.33 Vaihda värillinen kuvansiirtopaketti, suositeltu käyttöikä ylitetty. Lisätietoja on kohdassa  . 84.41, 84.43, 84.48 Vaihda musta kuvayksikkö, jotta voit jatkaa tulostusta. Lisätietoja on kohdassa  . 84.41, 84.43, 84.48 Vaihda värillinen kuvansiirtopaketti, jotta voit jatkaa tulostusta. Lisätietoja on kohdassa  . 86.23 Skanneri on huollettava pian. Poista ilmoitus valitsemalla  Jatka . 86.33 Vaihda ADF-pakkaus, suositeltu käyttöikä ylitetty. Jos haluat lisätietoja, ota yhteyttä  asiakastuki . 88.00[x], 88.07[x], 88.08[x], 88.09[x] [Väri] kasetin väri on vähenemässä. Poista ilmoitus valitsemalla  Jatka . 88.10[x], 88.17[x], 88.18[x], 88.19[x] [Väri] aine on vähissä. 88.20[x], 88.27[x], 88.28[x], 88.29[x] [Väri] kasetin aine on erittäin vähissä. 88.30[x], 88.37[x], 88.38[x] Vaihda [Väri] kasetti. Arvio järjellä olevien sivujen määrästä: <NUM/> Lisätietoja on kohdassa  . 88.30[x], 88.37[x], 88.38[x] Vaihda [väri] kasetti 88.40[x], 88.47[x], 88.48[x] Vaihda [väri] kasetti, 0 sivua jäljellä. 88.40[x], 88.47[x], 88.48[x] Vaihda [väri] kasetti 200.03, 200.05, 200.12, 200.13, 200.14, 200.15, 200.22, 200.23, 200.24, 200.25, 200.26, 200.32, 200.33, 200.34, 200.35, 200.36, 200.42, 200.43, 200.44, 200.45, 200.46, 200.52, 200.53, 200.54, 200.55, 200.56, 200.91, 201.91, 202.02, 202.03, 202.04, 202.05, 202.12, 202.13, 202.14, 202.15, 202.22, 202.23, 202.24, 202.25, 202.32, 202.33, 202.34, 202.35, 202.42, 202.43, 202.44, 202.45, 202.52, 202.53, 202.54, 202.55, 202.91, 202.93, 202.95, 231.03, 231.05, 231.13, 231.15, 231.23, 231.25, 231.33, 231.35, 231.43, 231.45, 231.53, 231.55, 231.91, 232.03, 232.05, 232.13, 232.15, 232.23, 232.25, 232.33, 232.35, 232.43, 232.45, 232.53, 232.55, 232.93, 232.94, 232.95, 240.05, 240.25, 240.35, 240.45, 240.55, 240.91, 240.95, 241.12, 241.14, 241.15, 241.91 Paperitukos kohdassa [LOCATION/] Lisätietoja on kohdassa  . 240.06 Paperitukos kohdassa [LOCATION/] Lisätietoja on kohdassa  . 241.16, 241.82, 241.83, 241.84, 661.13, 661.84 Paperin lisäysvirhe kohdassa [LOCATION/] Avaa lokero 1. Poista ja säädä paperipino uudelleen. Säädä paperiohjaimia tarvittaessa. Täytä lokero 1 uudelleen. Sulje lokero 1. 242.23, 242.25, 242.35, 242.45, 242.55, 242.91 Paperitukos kohdassa [LOCATION/] Lisätietoja on kohdassa  . 242.33, 242.43, 243.33, 243.35, 243.36, 243.43, 243.35, 243.45, 243.45, 243.55, 243.91, 244.43, 244.45, 244.91 Paperitukos kohdassa [LOCATION/] Lisätietoja on seuraavissa: 243.43, 243.53, 244.43, 244.45, 244.46, 244.91, 245.53, 245.56, 245.55, 245.91, 602.59, 664.43, 665.53 Paperitukos kohdassa [LOCATION/] Lisätietoja on kohdassa  . 28X.13K, 28X.93K, 28X.15K, 28X.95K, 281.16K, 281.96K, 680.20K, 680.40K Vaihda kaikki alkuperäiset, jos aloitat työn uudelleen. Kokeile jompaakumpaa seuraavista: Käynnistä työ uudelleen. Peruuta työ. 28X.13Q, 28X.93Q, 28X.15Q, 28X.95Q, 281.16Q, 281.96Q, 680.20Q Vaihda juuttuneet alkuperäiset, jos jatkat työtä. Tee jokin seuraavista: Skannaa skannaustasolta. Skannaa asiakirjansyöttölaitteesta. Lopeta työ skannaamatta lisää. Peruuta työ. 280.06 Aseta alkuperäiset asiakirjansyöttölaitteeseen ja aloita työ uudelleen. 280.06, 280.11, 280.13, 280.15, 280.91, 280.93, 280.95, 281.11, 281.15, 281.16, 281.91, 281.95, 281.96, 282.11, 282.13, 282.15, 282.91, 282.93, 282.95, 283.11, 283.13, 283.91, 283.15, 283.93, 284.11, 284.13, 284.15, 284.91, 284.93, 284.95, 295.01 Skanneritukos. Lisätietoja on kohdassa  . 291.06 Jos aloitat työn alusta, sulje skannaustason kansi ja lisää alkuperäiset asiakirjat. Tee jokin seuraavista: Skannaa skannaustasolta. Skannaa asiakirjansyöttölaitteesta. Lopeta työ skannaamatta lisää. Peruuta työ. 400.11, 400.13, 400.15, 401.11, 401.13, 401.15, 404.19, 438.11, 438.21, 444.66, 450.21, 450.23, 450.25, 450.98, 450.99, 451.21, 451.23, 451.25, 452.66, 453.21, 453.23, 454.21, 454.23, 454.25, 457.21, 457.23, 457.25, 460.66, 461.66, 464.66, 465.66, 466.66, 467.66, 468.66, 469.66, 472.66, 477.66, 480.66, 483.66, 486.29, 504.11, 504.15, 505.11, 505.15, 514.19, 698.29 Paperitukos kohdassa [LOCATION/] Lisätietoja on kohdassa  . 400.11, 400.13, 400.15, 401.11, 401.13, 401.15, 404.19, 438.11, 438.21, 442.66, 444.66, 445.66, 450.21, 450.23, 450.25, 451.21, 451.23, 451.25, 451.98, 451.99, 452.66, 453.21, 453.23, 453.25, 454.21, 454.23, 454.25, 457.21, 457.23, 457.25, 459.66, 460.66, 461.66, 462.66, 463.66, 464.66, 465.66, 466.66, 467.66, 468.66, 469.66, 470.66, 472.66, 473.66, 476.66, 477.66, 480.66, 483.66, 486.29, 490.66, 491.21, 491.25, 491.66, 493.21, 494.21, 492.66, 494.66, 495.66, 496.66, 497.66, 504.11, 504.15, 505.11, 505.15, 514.19, 698.29 Paperitukos kohdassa [LOCATION/] Lisätietoja on kohdassa  . 420.11, 420.13, 420.15, 420.99, 421.56, 422.56, 423.56, 424.56, 425.13, 425.15, 425.11, 426.11, 426.15, 428.56A, 428.56B, 431.56, 435.56, 438.11, 439.19, 461.56, 698.19 Paperitukos kohdassa [LOCATION/] Lisätietoja on kohdassa  . 438.11, 500.11, 500.13, 500.15, 500.99, 502.11, 502.13, 502.15, 504.11, 504.13, 504.15, 505.13, 506.11, 506.13, 506.15, 507.11, 507.13, 507.15,  508.56, 509.56, 510.56, 511.56, 512.56, 513.56, 514.19, 698.19, 698.29 Paperitukos kohdassa [LOCATION/] Lisätietoja on kohdassa  . 602.29, 662.23 Paperin lisäysvirhe lokerossa 2. Lisätietoja on kohdassa  . 602.39, 663.33 Paperin lisäysvirhe lokerossa 3. Lisätietoja on seuraavissa: 602.49, 664.43 Paperin lisäysvirhe lokerossa 4. Lisätietoja on kohdassa  . tulostimen virhekoodit virhekoodit tulostimen ilmoitukset virheilmoitukset"},{"UUID":"3ff4844f-9646-435f-8ff2-a24d688e3ef4","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Tyhjät tai valkoiset sivut Tulosta","descFull":"Tyhjät tai valkoiset sivut Tulosta tulostuslaadun testisivut, ennen kuin yrität ratkaista ongelman. Valitse ohjauspaneelista  Asetukset Vianmääritys  Tulostuslaadun testisivut . Tulosta näytesivut alustalla 1 ja varmista, että paperi on asetettu pystysuunnassa. Kokeile jotakin seuraavista keinoista: Varmista, että kaikki pakkausmateriaalit on poistettu kuvasarjasta, kuvayksiköstä ja väriainekaseteista. Tarkista, onko tulostimessa aito ja tuettu Lexmarkin värikasetti. Tarkista, onko tulostimessa aito ja tuettu värikasetti. Jos kasettia ei tueta, asenna tuettu kasetti. Varmista, että kuvasarja ja musta kuvayksikkö on asennettu oikein. Poista kuvasarja ja sitten musta kuvayksikkö. Älä altista kuvasarjaa ja mustaa kuvayksikköä valolle 10 minuuttia kauempaa. Pitkäaikainen altistuminen valolle voi aiheuttaa tulostuslaatuongelmia. Älä kosketa valojohderummun osaa, joka on kuvayksikön ja mustan kuvansiirtopaketin alla. Rumpujen koskettaminen saattaa heikentää tulevien tulostustöiden laatua. Asenna musta kuvayksikkö ja sitten värillinen kuvasarja. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma valkoisia sivuja tulostuslaatuongelma tyhjiä sivuja tyhjiä sivuja valkoisia sivuja"},{"UUID":"8dc3029e-ea6b-403f-a23e-042758302dc5","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Tumma tuloste Tulosta tulostuslaadun testisivut,","descFull":"Tumma tuloste Tulosta tulostuslaadun testisivut, ennen kuin yrität ratkaista ongelman. Valitse ohjauspaneelista  Asetukset Vianmääritys  Tulostuslaadun testisivut . Tulosta näytesivut alustalla 1 ja varmista, että paperi on asetettu pystysuunnassa. Kokeile jotakin seuraavista keinoista: Siirry ohjauspaneelista kohtaan  Asetukset Tulosta Laatu Kuvankäsittelyn lisäasetukset  ja sitten valitse  Värinsäätö . Pienennä väriaineen tummuusastetta käyttöjärjestelmästä riippuen joko Tulostusmääritykset- tai Tulostus-valintaikkunassa. Voit muuttaa asetusta myös tulostimen ohjauspaneelista. Valitse  Asetukset Tulostus Laatu Väriaineen tummuus Määritä paperilaji käyttöjärjestelmän mukaan joko Tulostusmääritykset- tai Tulostus-valintaikkunassa. Varmista, että asetus vastaa lokeroon lisättyä paperia.  Voit muuttaa asetusta myös tulostimen ohjauspaneelista. Valitse  Asetukset Paperi Lokeromääritys Paperikoko/-laji Varmista, että paperissa ei ole kuvioita tai että se ei ole karkeaa. Lisää paperia uudesta pakkauksesta. Paperi imee kosteutta suuren kosteuspitoisuuden takia. Älä poista paperia kääreestään, ennen kuin otat sen käyttöön. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma tumma tuloste tumma tuloste"},{"UUID":"a76f5a29-6d74-4f9d-920a-96908e867f78","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Haamukuvat Tulosta tulostuslaadun testisivut, ennen","descFull":"Haamukuvat Tulosta tulostuslaadun testisivut, ennen kuin yrität ratkaista ongelman. Valitse ohjauspaneelista  Asetukset Vianmääritys  Tulostuslaadun testisivut . Tulosta näytesivut alustalla 1 ja varmista, että paperi on asetettu pystysuunnassa. Kokeile jotakin seuraavista keinoista: Lisää alustalle oikean lajista ja oikeanpainoista paperia. Määritä paperilaji käyttöjärjestelmän mukaan joko Tulostusmääritykset- tai Tulostus-valintaikkunassa. Varmista, että asetus vastaa lokeroon lisättyä paperia.  Voit muuttaa asetusta myös tulostimen ohjauspaneelista. Valitse  Asetukset Paperi Lokeromääritys Paperikoko/-laji Siirry ohjauspaneelista kohtaan  Asetukset Tulosta Laatu Kuvankäsittelyn lisäasetukset  ja sitten valitse  Värinsäätö . Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma haamukuvat haamukuvat"},{"UUID":"36112e93-c98f-430f-a9d3-069a97b64908","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Harmaa tai värillinen tausta Tulosta","descFull":"Harmaa tai värillinen tausta Tulosta tulostuslaadun testisivut, ennen kuin yrität ratkaista ongelman. Valitse ohjauspaneelista  Asetukset Vianmääritys  Tulostuslaadun testisivut . Tulosta näytesivut alustalla 1 ja varmista, että paperi on asetettu pystysuunnassa. Kokeile jotakin seuraavista keinoista: Nosta väriaineen tummuusastetta käyttöjärjestelmän mukaan joko Tulostusmääritykset- tai Tulostus-valintaikkunassa. Voit muuttaa asetusta myös tulostimen ohjauspaneelista. Valitse  Asetukset Tulostus Laatu Väriaineen tummuus Siirry ohjauspaneelista kohtaan  Asetukset Tulosta Laatu Kuvankäsittelyn lisäasetukset  ja sitten valitse  Värinsäätö . Varmista, että kuvasarja ja musta kuvayksikkö on asennettu oikein. Poista kuvasarja ja sitten musta kuvayksikkö. Älä altista kuvasarjaa ja mustaa kuvayksikköä valolle 10 minuuttia kauempaa. Pitkäaikainen altistuminen valolle voi aiheuttaa tulostuslaatuongelmia. Älä kosketa valojohderummun osaa, joka on kuvayksikön ja mustan kuvansiirtopaketin alla. Rumpujen koskettaminen saattaa heikentää tulevien tulostustöiden laatua. Asenna musta kuvayksikkö ja sitten värillinen kuvasarja. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma harmaa tai värillinen tausta tausta on harmaa tausta on värillinen"},{"UUID":"d33b93cb-6bdb-41c8-bd92-e5816b6e3d1f","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Väärät marginaalit Kokeile jotakin seuraavista","descFull":"Väärät marginaalit Kokeile jotakin seuraavista keinoista: Säädä lokeron paperinohjaimet oikeaan kohtaan lisätyn paperin koon mukaan. Määritä paperiasetukset käyttöjärjestelmän mukaan joko Tulostusmääritykset- tai Tulostus-valintaikkunassa. Varmista, että asetus vastaa lisättyä paperia.  Voit muuttaa asetusta myös tulostimen ohjauspaneelista. Valitse  Asetukset Paperi Lokeromääritys Paperikoko/-laji Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma väärät marginaalit väärät marginaalit"},{"UUID":"08c8c9a4-d201-40d0-888d-778e9b2c27fb","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Vaalea tuloste Tulosta tulostuslaadun testisivut,","descFull":"Vaalea tuloste Tulosta tulostuslaadun testisivut, ennen kuin yrität ratkaista ongelman. Valitse ohjauspaneelista  Asetukset Vianmääritys  Tulostuslaadun testisivut . Tulosta näytesivut alustalla 1 ja varmista, että paperi on asetettu pystysuunnassa. Kokeile jotakin seuraavista keinoista: Varmista, että kaikki pakkausmateriaalit on poistettu kuvasarjasta, kuvayksiköstä ja väriainekaseteista. Siirry ohjauspaneelista kohtaan  Asetukset Tulosta Laatu Kuvankäsittelyn lisäasetukset  ja sitten valitse  Värinsäätö . Nosta väriaineen tummuusastetta käyttöjärjestelmän mukaan joko Tulostusmääritykset- tai Tulostus-valintaikkunassa.  Voit muuttaa asetusta myös tulostimen ohjauspaneelista. Valitse  Asetukset Tulostus Laatu Väriaineen tummuus Siirry ohjauspaneelista kohtaan  Asetukset Tulosta Laatu  ja kytke sitten  Värinsäästäjä  pois. Määritä paperilaji käyttöjärjestelmän mukaan joko Tulostusmääritykset- tai Tulostus-valintaikkunassa. Varmista, että asetus vastaa lisättyä paperia.  Voit muuttaa asetusta myös tulostimen ohjauspaneelista. Valitse  Asetukset Paperi Lokeromääritys Paperikoko/-laji Varmista, että paperissa ei ole kuvioita tai että se ei ole karkeaa. Lisää paperia uudesta pakkauksesta. Paperi imee kosteutta suuren kosteuspitoisuuden takia. Älä poista paperia kääreestään, ennen kuin otat sen käyttöön. Varmista, että kuvasarja ja musta kuvayksikkö on asennettu oikein. Poista kuvasarja ja sitten musta kuvayksikkö. Älä altista kuvasarjaa ja mustaa kuvayksikköä valolle 10 minuuttia kauempaa. Pitkäaikainen altistuminen valolle voi aiheuttaa tulostuslaatuongelmia. Älä kosketa valojohderummun osaa, joka on kuvayksikön ja mustan kuvansiirtopaketin alla. Rumpujen koskettaminen saattaa heikentää tulevien tulostustöiden laatua. Asenna musta kuvayksikkö ja sitten värillinen kuvasarja. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma vaalea tuloste vaalea tuloste"},{"UUID":"1d17cd1f-0698-4ee8-8b01-2af36fa18f1a","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Puuttuvat värit Tulosta tulostuslaadun testisivut,","descFull":"Puuttuvat värit Tulosta tulostuslaadun testisivut, ennen kuin yrität ratkaista ongelman. Valitse ohjauspaneelista  Asetukset Vianmääritys  Tulostuslaadun testisivut . Tulosta näytesivut alustalla 1 ja varmista, että paperi on asetettu pystysuunnassa. Kokeile jotakin seuraavista keinoista: Varmista, että kaikki pakkausmateriaalit on poistettu kuvasarjasta, kuvayksiköstä ja väriainekaseteista. Poista puuttuvan värin kehitysyksikkö. Irrota kuvayksikkö. Älä altista kuvasarjaa ja mustaa kuvayksikköä valolle 10 minuuttia kauempaa. Pitkäaikainen altistuminen valolle voi aiheuttaa tulostuslaatuongelmia. Älä kosketa valojohderummun osaa, joka on kuvayksikön ja mustan kuvansiirtopaketin alla. Rumpujen koskettaminen saattaa heikentää tulevien tulostustöiden laatua. Poista ja aseta uudelleen puuttuvan värin kehitysyksikkö. Aseta kuvansiirtopaketti paikalleen. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma puuttuvat värit puuttuvat värit"},{"UUID":"0dcdfc89-71c9-4e49-9cad-3c3671d1234a","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Täplikäs tuloste ja pisteitä Täplikäs","descFull":"Täplikäs tuloste ja pisteitä Täplikäs tuloste ja pisteitä Tulosta tulostuslaadun testisivut, ennen kuin yrität ratkaista ongelman. Valitse ohjauspaneelista  Asetukset Vianmääritys  Tulostuslaadun testisivut . Tulosta näytesivut alustalla 1 ja varmista, että paperi on asetettu pystysuunnassa. Kokeile jotakin seuraavista keinoista: Tarkista, että tulostimeen ei ole vuotanut väriainetta. Varmista, että paperilaji- ja kokoasetukset vastaavat käytettävää lisättyä paperia. Valitse ohjauspaneelissa  Asetukset Paperi Lokeromääritys Paperikoko/-laji . Varmista, että paperissa ei ole kuvioita tai että se ei ole karkeaa. Määritä paperikoko ja -laji käyttöjärjestelmän mukaan joko Tulostusasetukset- tai Tulostus-valintaikkunassa. Varmista, että asetukset vastaavat alustalle lisättyä paperia. Lisää paperia uudesta pakkauksesta. Paperi imee kosteutta suuren kosteuspitoisuuden takia. Älä poista paperia kääreestään, ennen kuin otat sen käyttöön. Varmista, että kuvasarja ja musta kuvayksikkö on asennettu oikein. Poista kuvasarja ja sitten musta kuvayksikkö. Älä altista kuvasarjaa ja mustaa kuvayksikköä valolle 10 minuuttia kauempaa. Pitkäaikainen altistuminen valolle voi aiheuttaa tulostuslaatuongelmia. Älä kosketa valojohderummun osaa, joka on kuvayksikön ja mustan kuvansiirtopaketin alla. Rumpujen koskettaminen saattaa heikentää tulevien tulostustöiden laatua. Asenna musta kuvayksikkö ja sitten värillinen kuvasarja. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma täplikäs tuloste ja pisteitä täplikäs tuloste ja pisteitä pisteitä tulostetulla sivulla"},{"UUID":"c8ebb8fb-87a4-4ac0-8844-f480dfbad06b","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Tuloste vääntynyt tai vino Tulosta","descFull":"Tuloste vääntynyt tai vino Tulosta tulostuslaadun testisivut, ennen kuin yrität ratkaista ongelman. Valitse ohjauspaneelista  Asetukset Vianmääritys  Tulostuslaadun testisivut . Tulosta näytesivut alustalla 1 ja varmista, että paperi on asetettu pystysuunnassa. Kokeile jotakin seuraavista keinoista: Lisää paperia uudesta pakkauksesta. Avaa lokero ja poista paperi. Lisää paperia uudesta pakkauksesta. Paperi imee kosteutta suuren kosteuspitoisuuden takia. Älä poista paperia kääreestään, ennen kuin otat sen käyttöön. Säädä lokeron paperinohjaimet oikeaan kohtaan lisätyn paperin koon mukaan. Varmista, että käytät tuettua paperia. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma vino tuloste tulostuslaatuongelma vääntynyt tuloste vääntynyt tuloste vino tuloste"},{"UUID":"86e82351-ad24-4f02-9d12-3fea9a29e1e5","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Kokonaan värilliset tai mustat kuvat","descFull":"Kokonaan värilliset tai mustat kuvat Tulosta tulostuslaadun testisivut, ennen kuin yrität ratkaista ongelman. Valitse ohjauspaneelista  Asetukset Vianmääritys  Tulostuslaadun testisivut . Tulosta näytesivut alustalla 1 ja varmista, että paperi on asetettu pystysuunnassa. Poista kuvasarja ja sitten musta kuvayksikkö. Älä altista kuvasarjaa ja mustaa kuvayksikköä valolle 10 minuuttia kauempaa. Pitkäaikainen altistuminen valolle voi aiheuttaa tulostuslaatuongelmia. Älä kosketa valojohderummun osaa, joka on kuvayksikön ja mustan kuvansiirtopaketin alla. Rumpujen koskettaminen saattaa heikentää tulevien tulostustöiden laatua. Asenna musta kuvayksikkö ja sitten värillinen kuvasarja. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma kokonaan värilliset tai mustat kuvat yhtenäinen väri mustat kuvat"},{"UUID":"2ae93aee-1a40-41f1-b01f-26229a9120c9","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Tekstiä tai kuvia leikkautuu Tulosta","descFull":"Tekstiä tai kuvia leikkautuu Tulosta tulostuslaadun testisivut, ennen kuin yrität ratkaista ongelman. Valitse ohjauspaneelista  Asetukset Vianmääritys  Tulostuslaadun testisivut . Tulosta näytesivut alustalla 1 ja varmista, että paperi on asetettu pystysuunnassa. Kokeile jotakin seuraavista keinoista: Varmista, että kaikki pakkausmateriaalit on poistettu kuvasarjasta, kuvayksiköstä ja väriainekaseteista. Säädä lokeron paperinohjaimet oikeaan kohtaan lisätyn paperin koon mukaan. Määritä paperiasetukset käyttöjärjestelmän mukaan joko Tulostusmääritykset- tai Tulostus-valintaikkunassa. Varmista, että asetus vastaa lokeroon lisättyä paperia.  Voit muuttaa asetusta myös tulostimen ohjauspaneelista. Valitse  Asetukset Paperi Lokeromääritys Paperikoko/-laji Varmista, että kuvasarja ja musta kuvayksikkö on asennettu oikein. Poista kuvasarja ja sitten musta kuvayksikkö. Älä altista kuvasarjaa ja mustaa kuvayksikköä valolle 10 minuuttia kauempaa. Pitkäaikainen altistuminen valolle voi aiheuttaa tulostuslaatuongelmia. Älä kosketa valojohderummun osaa, joka on kuvayksikön ja mustan kuvansiirtopaketin alla. Rumpujen koskettaminen saattaa heikentää tulevien tulostustöiden laatua. Asenna musta kuvayksikkö ja sitten värillinen kuvasarja. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma tekstiä tai kuvia leikkautuu leikkautunutta tekstiä tulosteissa kuvia leikkautuu tulostettaessa"},{"UUID":"8f05e84b-235d-4625-b803-fc0c9b2b475b","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Väriaine hankautuu helposti pois Tulosta","descFull":"Väriaine hankautuu helposti pois Tulosta tulostuslaadun testisivut, ennen kuin yrität ratkaista ongelman. Valitse ohjauspaneelista  Asetukset Vianmääritys  Tulostuslaadun testisivut . Tulosta näytesivut alustalla 1 ja varmista, että paperi on asetettu pystysuunnassa. Kokeile jotakin seuraavista menetelmistä: Varmista, että tulostimen virtajohto on kunnolla kytketty tulostimeen ja nimellisarvoltaan soveltuvaan, oikein maadoitettuun pistorasiaan. Määritä paperilaji käyttöjärjestelmän mukaan joko Tulostusmääritykset- tai Tulostus-valintaikkunassa. Varmista, että asetus vastaa lisättyä paperia. Määritä paperilaji ohjauspaneelista. Valitse  Asetukset Paperi Lokeromääritys Paperikoko/-laji Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma väriaine hankautuu helposti pois väriaine hankautuu helposti pois"},{"UUID":"34a101fd-2481-493f-b372-c2180e065991","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Epätasainen tummuus Tulosta tulostuslaadun testisivut,","descFull":"Epätasainen tummuus Tulosta tulostuslaadun testisivut, ennen kuin yrität ratkaista ongelman. Valitse ohjauspaneelista  Asetukset Vianmääritys Tulostuslaadun testisivut . Tulosta näytesivut lokeron 1 avulla ja varmista, että paperi on asetettu pystysuunnassa. Kokeile jotakin seuraavista keinoista: Avaa luukku B ja varmista sitten, että toinen siirtotela on lukittu paikalleen. Varmista, että kuvasarja ja musta kuvayksikkö on asennettu oikein. Poista kuvasarja ja sitten musta kuvayksikkö. Älä altista kuvasarjaa ja mustaa kuvayksikköä valolle 10 minuuttia kauempaa. Pitkäaikainen altistuminen valolle voi aiheuttaa tulostuslaatuongelmia. Älä kosketa valojohderummun osaa, joka on kuvayksikön ja mustan kuvansiirtopaketin alla. Rumpujen koskettaminen saattaa heikentää tulevien tulostustöiden laatua. Asenna musta kuvayksikkö ja sitten värillinen kuvasarja. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma epätasainen tummuus epätasainen tummuus"},{"UUID":"6fa0002f-dc51-464d-aef2-3e6233d25010","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Vaakasuuntaiset tummat viivat Tulosta tulostuslaadun","descFull":"Vaakasuuntaiset tummat viivat Tulosta tulostuslaadun testisivut, ennen kuin yrität ratkaista ongelman. Valitse ohjauspaneelista  Asetukset Vianmääritys Tulostuslaadun testisivut . Tulosta näytesivut alustalla 1 ja varmista, että paperi on asetettu pystysuunnassa. Jos tulosteissa näkyy jatkuvasti vaakasuuntaisia tummia viivoja, katso kohta  Kokeile jotakin seuraavista keinoista: Määritä paperilaji käyttöjärjestelmän mukaan joko Tulostusmääritykset- tai Tulostus-valintaikkunassa. Varmista, että asetus vastaa lisättyä paperia. Voit muuttaa asetusta myös tulostimen ohjauspaneelista. Valitse  Asetukset Paperi Lokeromääritys Paperikoko/-laji Varmista, että paperissa ei ole kuvioita tai että se ei ole karkeaa. Lisää paperia uudesta pakkauksesta. Paperi imee kosteutta suuren kosteuspitoisuuden takia. Älä poista paperia kääreestään, ennen kuin otat sen käyttöön. Varmista, että kuvasarja ja musta kuvayksikkö on asennettu oikein. Poista kuvasarja ja sitten musta kuvayksikkö. Älä altista kuvasarjaa ja mustaa kuvayksikköä valolle 10 minuuttia kauempaa. Pitkäaikainen altistuminen valolle voi aiheuttaa tulostuslaatuongelmia. Älä kosketa valojohderummun osaa, joka on kuvayksikön ja mustan kuvansiirtopaketin alla. Rumpujen koskettaminen saattaa heikentää tulevien tulostustöiden laatua. Asenna musta kuvayksikkö ja sitten värillinen kuvasarja. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma vaakasuuntaiset tummat viivat vaakasuuntaiset tummat viivat"},{"UUID":"e8c4b00c-43c0-4d3d-8fe5-276f9b0b46e6","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Pystysuuntaiset tummat viivat Tulosta tulostuslaadun","descFull":"Pystysuuntaiset tummat viivat Tulosta tulostuslaadun testisivut, ennen kuin yrität ratkaista ongelman. Valitse ohjauspaneelista  Asetukset Vianmääritys Tulostuslaadun testisivut . Tulosta näytesivut lokeron 1 avulla ja varmista, että paperi on asetettu pystysuunnassa. Kokeile jotakin seuraavista keinoista: Määritä paperilaji käyttöjärjestelmän mukaan joko Tulostusmääritykset- tai Tulostus-valintaikkunassa. Varmista, että asetus vastaa lokeroon lisättyä paperia. Voit muuttaa asetusta myös tulostimen ohjauspaneelista. Valitse  Asetukset Paperi Lokeromääritys Paperikoko/-laji Varmista, että paperissa ei ole kuvioita tai että se ei ole karkeaa. Lisää paperia uudesta pakkauksesta. Paperi imee kosteutta suuren kosteuspitoisuuden takia. Älä poista paperia kääreestään, ennen kuin otat sen käyttöön. Varmista, että kuvasarja ja musta kuvayksikkö on asennettu oikein. Poista kuvasarja ja sitten musta kuvayksikkö. Älä altista kuvasarjaa ja mustaa kuvayksikköä valolle 10 minuuttia kauempaa. Pitkäaikainen altistuminen valolle voi aiheuttaa tulostuslaatuongelmia. Älä kosketa valojohderummun osaa, joka on kuvayksikön ja mustan kuvansiirtopaketin alla. Rumpujen koskettaminen saattaa heikentää tulevien tulostustöiden laatua. Asenna musta kuvayksikkö ja sitten värillinen kuvasarja. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma tulosteissa näkyy pystysuuntaisia tummia viivoja pystysuuntaiset tummat viivat tulosteissa"},{"UUID":"130bf929-e709-4bbd-8760-6a8b632deb5e","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Vaakasuuntaiset valkoiset viivat Tulosta tulostuslaadun","descFull":"Vaakasuuntaiset valkoiset viivat Tulosta tulostuslaadun testisivut, ennen kuin yrität ratkaista ongelman. Valitse ohjauspaneelista  Asetukset Vianmääritys Tulostuslaadun testisivut . Tulosta näytesivut lokeron 1 avulla ja varmista, että paperi on asetettu pystysuunnassa. Jos tulosteissa näkyy jatkuvasti vaakasuuntaisia valkoisia viivoja, katso kohta  Kokeile jotakin seuraavista keinoista: Määritä paperilaji käyttöjärjestelmän mukaan joko Tulostusmääritykset- tai Tulostus-valintaikkunassa. Varmista, että asetus vastaa lokeroon lisättyä paperia. Voit muuttaa asetusta myös tulostimen ohjauspaneelista. Valitse  Asetukset Paperi Lokeromääritys Paperikoko/-laji Lisää määritettyyn paperilähteeseen suositeltua paperilajia. Varmista, että kuvasarja ja musta kuvayksikkö on asennettu oikein. Poista kuvasarja ja sitten musta kuvayksikkö. Älä altista valojohderumpua suoralle valolle. Pitkäaikainen altistuminen valolle voi aiheuttaa tulostuslaatuongelmia. Älä kosketa valojohdeyksiköiden rumpuja. Rumpujen koskettaminen saattaa heikentää tulevien tulostustöiden laatua. Asenna musta kuvayksikkö ja sitten värillinen kuvasarja. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma vaakasuuntaiset valkoiset viivat vaakasuuntaiset valkoiset viivat"},{"UUID":"35791113-4830-49ce-b221-d21f9f58b82e","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Pystysuuntaiset valkoiset viivat Tulosta tulostuslaadun","descFull":"Pystysuuntaiset valkoiset viivat Tulosta tulostuslaadun testisivut, ennen kuin yrität ratkaista ongelman. Valitse ohjauspaneelista  Asetukset Vianmääritys Tulostuslaadun testisivut . Tulosta näytesivut lokeron 1 avulla ja varmista, että paperi on asetettu pystysuunnassa. Kokeile jotakin seuraavista keinoista: Määritä paperilaji käyttöjärjestelmän mukaan joko Tulostusmääritykset- tai Tulostus-valintaikkunassa. Varmista, että asetus vastaa lokeroon lisättyä paperia. Voit muuttaa asetusta myös tulostimen ohjauspaneelista. Valitse  Asetukset Paperi Lokeromääritys Paperikoko/-laji Tarkista, käytätkö suositeltua paperilajia. Varmista, että lisäät määritettyyn paperilähteeseen suositeltua paperilajia. Varmista, että kuvasarja ja musta kuvayksikkö on asennettu oikein. Poista kuvasarja ja sitten musta kuvayksikkö. Älä altista kuvasarjaa ja mustaa kuvayksikköä valolle 10 minuuttia kauempaa. Pitkäaikainen altistuminen valolle voi aiheuttaa tulostuslaatuongelmia. Älä kosketa valojohderummun osaa, joka on kuvayksikön ja mustan kuvansiirtopaketin alla. Rumpujen koskettaminen saattaa heikentää tulevien tulostustöiden laatua. Asenna musta kuvayksikkö ja sitten värillinen kuvasarja. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma pystysuuntaiset valkoiset viivat pystysuuntaiset valkoiset viivat"},{"UUID":"8934986b-27a9-450d-a9b9-484cbd71053f","title":"Tulostuslaatu on huono","link":"solving-printing-problems.html","desc":"Toistuvat virhekuviot Tulosta tulostuslaadun testisivut,","descFull":"Toistuvat virhekuviot Tulosta tulostuslaadun testisivut, ennen kuin yrität ratkaista ongelman. Valitse ohjauspaneelista  Asetukset Vianmääritys Tulostuslaadun testisivut . Tulosta näytesivut lokeron 1 avulla ja varmista, että paperi on asetettu pystysuunnassa. Määritä, kuinka monessa värissä on virheitä. Mittaa värisivun toistuvien vikojen välinen etäisyys. Mittaa virheellisellä värisivulla toistuvien virheiden väli huoltovirheviivaimen avulla. Vaihda tarvike tai osa, joka vastaa virheellisen värisivun mittaustulosta. Värillinen kuvansiirtopaketti tai musta kuvayksikkö 94,5 mm (3,72 tuumaa) 19,9 mm (1,18 tuumaa) 23,2 mm (0,19 tuumaa) Kehitysyksikkö 43,6 mm (1,72 tuumaa) 45,0 mm (1,77 tuumaa) Kiinnitysyksikkö 95 mm (3,74 tuumaa) 110 mm (4,33 tuumaa) Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma toistuvat tulostusviat toistuvat tulostusviat"},{"UUID":"675b981d-184d-4f7e-a8e2-a4f0476911c5","title":"Tulostusongelmat","link":"solving-printing-problems.html","desc":"Tulostustyöt eivät tulostu Kokeile jotakin","descFull":"Tulostustyöt eivät tulostu Kokeile jotakin seuraavista keinoista: Avaa Tulostusmääritykset tai tulostusvalintaikkuna siinä asiakirjassa, jonka yrität tulostaa, ja varmista, että oikea tulostin on valittu. Tarkista, onko tulostin päällä, ja korjaa sitten kaikki näytössä näkyvät virheilmoitukset. Varmista, että portit toimivat ja että kaapelit on liitetty pitävästi tietokoneeseen ja tulostimeen. Lisätietoja on tulostimen asennusohjeissa. Sammuta tulostin, odota noin 10 sekuntia ja käynnistä tulostin uudelleen. Poista tulostinohjain ja asenna se sitten uudelleen. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostusongelma tulostustyöt eivät tulostu tulostustöitä ei tulosteta tulostustyöt eivät tulostu"},{"UUID":"0f975821-5493-45ce-a9dc-ea4b3a8905ff","title":"Tulostusongelmat","link":"solving-printing-problems.html","desc":"Luottamukselliset ja pidossa olevat asiakirjat","descFull":"Luottamukselliset ja pidossa olevat asiakirjat eivät tulostu Kokeile jotakin seuraavista keinoista: Tarkista ohjauspaneelista, näkyykö työ  Pidossa olevat työt  -luettelossa. Jos asiakirjat eivät ole luettelossa, tulosta asiakirjat Print and Hold -valinnoilla. Korjaa mahdolliset muotoiluvirheet tai virheelliset tiedot tulostustyössä. Poista tulostustyö ja lähetä se sitten uudelleen. Jos kyseessä on PDF-tiedosto, luo uusi tiedosto ja tulosta asiakirja. Jos tulostat Internetistä, tulostin saattaa lukea useita työnimikkeitä päällekkäisinä. Windows-käyttäjät: muista valita  Säilytä asiakirjan kaksoiskappaleet  Tulostusmääritykset- tai Tulosta-valintaikkunassa. Macintosh-käyttäjät: nimeä jokainen työ eri tavalla. Vapauta tulostimen muistia poistamalla pidossa olevia töitä. Asenna tulostimeen lisää muistia. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma luottamukselliset ja pidossa olevat asiakirjat eivät tulostu luottamukselliset asiakirjat eivät tulostu pidossa olevat asiakirjat eivät tulostu"},{"UUID":"c58f06a8-ac8e-4709-8d5d-c0d9d6169809","title":"Tulostusongelmat","link":"solving-printing-problems.html","desc":"Työ tulostuu väärästä lokerosta tai","descFull":"Työ tulostuu väärästä lokerosta tai väärälle paperille. Kokeile jotakin seuraavista keinoista: Varmista, että käytät oikeaa paperia. Määritä paperikoko ja -laji käyttöjärjestelmän mukaan joko Tulostusasetukset- tai Tulostus-valintaikkunassa. Varmista, että asetukset vastaavat lisättyä paperia. Voit muuttaa näitä asetuksia myös tulostimen ohjauspaneelista. Valitse  Asetukset Paperi Lokeromääritys Paperikoko/-laji Tarkista, onko lokerot linkitetty. Lisätietoja on kohdassa  . Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostusongelma työ tulostuu väärästä lokerosta tulostusongelma työ tulostuu väärälle paperille työ tulostuu väärästä lokerosta työ tulostuu väärälle paperille"},{"UUID":"4b438dbf-2128-4ebd-ac49-8b244c919463","title":"Tulostusongelmat","link":"solving-printing-problems.html","desc":"Hidas tulostus Kokeile jotakin seuraavista","descFull":"Hidas tulostus Kokeile jotakin seuraavista keinoista: Varmista, että tulostinkaapeli on liitetty kunnolla tulostimeen, tietokoneeseen, tulostuspalvelimeen, lisävarusteeseen tai muuhun verkkolaitteeseen. Varmista, että tulostin ei ole  hiljaisessa tilassa . Siirry ohjauspaneelista kohtaan  Asetukset Laite Huolto Määritys-valikko Laitteen toiminnot Hiljainen tila . Määritä tulostettavan asiakirjan tarkkuus. Siirry käyttöjärjestelmän mukaan joko Tulostusmääritykset- tai Tulosta-valintaikkunaan. Määritä tarkkuudeksi  4800 CQ . Voit muuttaa asetusta myös ohjauspaneelista. Siirry kohtaan  Asetukset Tulosta Laatu Tarkkuus . Määritä paperilaji käyttöjärjestelmän mukaan joko Tulostusmääritykset- tai Tulostus-valintaikkunassa. Voit muuttaa asetusta myös ohjauspaneelista. Valitse  Asetukset Paperi Lokeromääritys Paperikoko/-laji Painava paperi tulostuu hitaammin. Letter-, A4- ja Legal-kokoa kapeampi paperi voi tulostua hitaammin. Varmista, että tulostimen tulostusmateriaalin laatu- ja painoasetukset vastaavat lisättävää paperia. Siirry ohjauspaneelista kohtaan  Asetukset Paperi Materiaalimääritykset Materiaalilajit .  Karkea ja painava paperi voi tulostua hitaammin. Poista pidossa olevat työt. Varmista, että tulostin ei kuumene liikaa. Anna tulostimen jäähtyä pitkän tulostustyön jälkeen. Huomioi tulostimen käyttöympäristön suositeltu lämpötila. Lisätietoja on kohdassa  . Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostusongelma hidas tulostus hidas tulostus"},{"UUID":"60ea43d9-ecf8-4a03-9cdf-34491f810af5","title":"Vianmääritys","link":"trb-printer-not-responding-topic.html","desc":"Tulostin ei vastaa Kokeile jotakin","descFull":"Tulostin ei vastaa Kokeile jotakin seuraavista keinoista: Tarkista, että virtajohto on liitetty pistorasiaan. Tulipalo- tai sähköiskuriskin välttämiseksi kytke virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Varmista, ettei pistorasian virtaa ole katkaistu kytkimellä tai katkaisimella. Tarkista, että tulostimeen on kytketty virta. Varmista, että tulostin ei ole lepo- tai horrostilassa. Varmista, että kaapelit, joilla tulostin ja tietokone on liitetty toisiinsa, on liitetty oikeisiin portteihin. Katkaise tulostimesta virta, asenna lisävarusteet ja kytke tulostimeen virta. Lisätietoja on lisälaitteen käyttöohjeessa. Asenna oikea tulostinohjain. Sammuta tulostin, odota noin 10 sekuntia ja käynnistä tulostin uudelleen. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostusongelma tulostin ei vastaa tulostin ei vastaa"},{"UUID":"05a70510-06be-42aa-bee2-ee5bce8505c4","title":"Vianmääritys","link":"trb-unable-to-read-flash-drive-topic.html","desc":"Flash-asemaa ei voi lukea Kokeile","descFull":"Flash-asemaa ei voi lukea Kokeile jotakin seuraavista keinoista: Varmista, että tulostin ei käsittele useita töitä. Varmista, että flash-asema on asetettu etuosan USB-porttiin. Flash-asema ei toimi, jos se on asetettu takaosassa olevaan USB-porttiin. Varmista, että flash-asema on tuettu. Lisätietoja on kohdassa  . Poista flash-asema ja aseta se sitten uudelleen. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . ei voi lukea flash-asemaa tulostusongelma ei voi lukea flash-asemaa"},{"UUID":"2e477487-79bf-4084-879d-6ae31abc6aa6","title":"Vianmääritys","link":"enabling-usb-port-topic.html","desc":"USB-portin käyttöönotto Siirry ohjauspaneelista kohtaan","descFull":"USB-portin käyttöönotto Siirry ohjauspaneelista kohtaan  Asetukset Verkko/Portit USB . Valitse  Ota USB-portti käyttöön . USB-portti ottaminen käyttöön USB-portin käyttöönotto USB-portin määrittäminen"},{"UUID":"feb7bf1d-edea-414b-ae17-75e25502a973","title":"Tukosten poistaminen","link":"clearing-jams.html","desc":"Tukosten välttäminen Lisää paperi oikein","descFull":"Tukosten välttäminen Lisää paperi oikein Varmista, että paperi on lokerossa suorassa. Paperin oikea ja väärä lisääminen Paperin oikea lisääminen Paperin väärä lisääminen Älä lisää lokeroon paperia tai poista lokeroa tulostamisen aikana. Älä lisää laitteeseen liikaa paperia. Varmista, että pinon korkeus on paperin enimmäistäyttöosoittimen alapuolella. Älä liu'uta paperia lokeroon. Lisää paperi kuvan mukaisesti. Varmista, että paperiohjaimet ovat oikeassa asennossa, eivätkä paina paperia tai kirjekuoria liian tiukasti. Työnnä lokero kunnolla paikalleen tulostimen sisään paperin lisäämisen jälkeen. Käytä suositeltua paperia. Käytä ainoastaan suositeltua paperia tai erikoistulostusmateriaalia. Älä lisää ryppyistä, taitettua, kosteaa tai käpristynyttä paperia. Taivuta ja ilmasta paperipino ja suorista sen reunat, ennen kuin lisäät sen tulostimeen. Älä käytä käsin leikattua tai rajattua materiaalia. Älä käytä samassa lokerossa eri kokoisia, painoisia tai tyyppisiä papereita. Varmista, että paperikoko ja -laji on asetettu oikein tietokoneen tai tulostimen ohjauspaneelissa. Säilytä paperi valmistajan suositusten mukaisesti. paperitukokset välttäminen tukokset, paperi välttäminen Paperitukosten välttäminen"},{"UUID":"28e54faa-51de-4a80-82fd-bb145448a44f","title":"Tukosten poistaminen","link":"clearing-jams.html","desc":"Tukoksen sijainnin tunnistaminen Kun ","descFull":"Tukoksen sijainnin tunnistaminen Kun  Tukosavustaja -asetuksena on  Käytössä , tulostin tyhjentää tyhjät tai osittain tulostetut sivut, kun juuttunut sivu on poistettu. Tarkista tyhjät sivut tulosteista. Kun  Tukosselvitys -asetuksena on  Käytössä  tai  Automaattinen , tulostin tulostaa juuttuneet sivut uudelleen. Tukosten sijainnit Tukosten sijainnit 1 Luukku B 2 Monikäyttösyöttöaukko 3 Vakiolokero 4 Vakioalusta 5 Automaattinen asiakirjansyöttölaite 6 Nidonnan viimeistelijä 7 Valinnainen 550 arkin lokero 8 Kaksi 550 arkin lokeroa 9 1500 arkin alusta 10 Nidonnan ja rei'ityksen viimeistelijä 11 Paperin siirtoyksikkö taittovalinnalla 12 2000 arkin kaksoislokero 13 Vihkoviimeistelijä paperitukokset etsiminen tukosten sijainnit havaitseminen"},{"UUID":"3cf3b47f-a845-43b1-af7d-89dc048dbe5a","title":"Tukosten poistaminen","link":"clearing-jams.html","desc":"Paperitukos vakiolokerossa Paperitukos vakiolokerossa Vedä","descFull":"Paperitukos vakiolokerossa Paperitukos vakiolokerossa Vedä vakiolokero ulos. Poista juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Aseta alusta tulostimeen. tukoksen poistaminen vakiolokerossa paperitukoksen poistaminen vakiolokerossa paperitukos vakiolokerossa"},{"UUID":"f4c8727d-8b95-4daa-b1a8-1f3541ead776","title":"Tukosten poistaminen","link":"clearing-jams.html","desc":"Paperitukos valinnaisessa 550 arkin lokerossa","descFull":"Paperitukos valinnaisessa 550 arkin lokerossa Avaa luukku D. Poista juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Sulje luukku. Vedä ulos valinnainen 550 arkin lokero. Poista juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Aseta alusta tulostimeen. tukoksen poistaminen 550 arkin lokero paperitukoksen poistaminen 550 arkin lokero paperitukos 550 arkin lokerossa"},{"UUID":"5b0575e6-c787-4df2-9518-3c37d7e9acde","title":"Tukosten poistaminen","link":"clearing-jams.html","desc":"Paperitukos automaattisessa asiakirjansyöttölaitteessa Paperitukos luukussa","descFull":"Paperitukos automaattisessa asiakirjansyöttölaitteessa Paperitukos luukussa A Avaa luukku A. Poista juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Sulje luukku A. Paperitukos luukussa A1 Avaa skannerin kansi. Avaa luukku A1 painamalla vihreää salpaa. Käännä luukun A1 lähellä olevaa nuppia oikealle ja poista juuttuneet paperit. Varmista, että poistat kaikki paperinpalat. Sulje luukku A1 ja skannerin kansi. Paperitukos automaattisen asiakirjansyöttölaitteen lokerossa Poista kaikki paperit automaattisen asiakirjansyöttölaitteen lokerosta. Poista juuttunut paperi. Varmista, että poistat kaikki paperinpalat. tukoksen poistaminen automaattisessa asiakirjansyöttölaitteessa paperitukos automaattisessa asiakirjansyöttölaitteessa paperitukoksen poistaminen automaattisessa asiakirjansyöttölaitteessa"},{"UUID":"1c885fa8-5350-4846-8f00-481810df6547","title":"Tukosten poistaminen","link":"clearing-jams.html","desc":"Paperitukos monisyöttölaitteessa Poista kaikki paperit","descFull":"Paperitukos monisyöttölaitteessa Poista kaikki paperit monisyöttöaukosta. Poista juuttunut paperi. Varmista, että poistat kaikki paperinpalat. tukoksen poistaminen monikäyttösyöttöaukossa paperitukoksen poistaminen monikäyttösyöttöaukossa paperitukos monikäyttösyöttöaukossa"},{"UUID":"cdd8e434-4bbf-4d1b-9ff8-b2033693d55f","title":"Tukosten poistaminen","link":"clearing-jams.html","desc":"Paperitukos 2 x 550 arkin","descFull":"Paperitukos 2 x 550 arkin lokerossa Avaa luukku E. Poista luukun E sisäpuolelle juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Sulje luukku E. Vedä ulos lokero 3. Poista juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Aseta lokero 3. Toista  vaihe 4  –  vaihe 6  lokero 4, tukoksen poistaminen 2 x 550 arkin lokero paperitukoksen poistaminen 2 x 550 arkin lokero paperitukos 2 x 550 arkin lokero"},{"UUID":"2ac618be-8571-4ad1-b430-8a35c9341f4c","title":"Tukosten poistaminen","link":"clearing-jams.html","desc":"Paperitukos 2000 arkin kaksoislokerossa Avaa","descFull":"Paperitukos 2000 arkin kaksoislokerossa Avaa luukku E. Poista luukun E sisäpuolelle juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Sulje luukku E. tukoksen poistaminen 2000 arkin kaksoislokerossa paperitukoksen poistaminen 2000 arkin kaksoislokerossa paperitukos 2000 arkin lokero"},{"UUID":"0391f8b2-1cec-4282-b087-0ab3504b2d7a","title":"Tukosten poistaminen","link":"clearing-jams.html","desc":"Paperitukos 1500 arkin lokerossa Avaa","descFull":"Paperitukos 1500 arkin lokerossa Avaa luukku K. Poista juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Sulje luukku K. Tartu kahvaan J ja liu'uta lokeroa oikealle. Poista juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Työnnä lokero takaisin paikalleen. tukoksen poistaminen 1500 arkin lokerossa paperitukoksen poistaminen 1500 arkin lokerossa paperitukos 1500 arkin lokerossa"},{"UUID":"ca4cfa48-71f0-4458-b015-332503fc697c","title":"Tukosten poistaminen","link":"clearing-jams.html","desc":"Paperitukos luukussa B Avaa luukku","descFull":"Paperitukos luukussa B Avaa luukku B. Tulostimen sisäosat voivat olla kuumat. Voit välttää palovammoja koskettamalla osia vasta, kun niiden pinta on jäähtynyt. Estä sähköstaattisen purkauksen aiheuttama vahinko koskettamalla tulostimen metallikehystä ennen kuin avaat tai kosketat tulostimen sisäosia. Poista juuttunut paperi seuraavista paikoista: Varmista, että poistat kaikki paperinpalat. Kiinnitysyksikön päältä Kiinnitysyksikössä Kiinnitysyksikön alapuolelta Vakioalustan poistotulorullan alta Arkinkääntäjästä Sulje luukku B. paperitukos luukussa B paperitukos kiinnitysyksikössä paperitukos arkinkääntäjässä tukoksen poistaminen kiinnitysyksikössä tukoksen poistaminen arkinkääntäjässä paperitukoksen poistaminen kiinnitysyksikössä paperitukoksen poistaminen arkinkääntäjässä"},{"UUID":"b1192e9a-21cd-4550-8aaa-d185cfc7c0df","title":"Tukosten poistaminen","link":"clearing-jams.html","desc":"Paperitukos vakiolokerossa Poista paperit vakioalustalta.","descFull":"Paperitukos vakiolokerossa Poista paperit vakioalustalta. Poista juuttunut paperi. Varmista, että poistat kaikki paperinpalat. tukoksen poistaminen vakioalusta paperitukoksen poistaminen vakioalustalla paperitukos vakioalustassa"},{"UUID":"50ca7c57-c9ee-4da5-9311-b540dfb6bd2c","title":"Tukosten poistaminen","link":"clearing-jams.html","desc":"Paperitukos nidonnan viimeistelijässä Poista juuttuneet","descFull":"Paperitukos nidonnan viimeistelijässä Poista juuttuneet paperit nidonnan viimeistelijän lokerosta. Varmista, että poistat kaikki paperinpalat. Tartu kahvaan F alapuolella ja liu'uta nidonnan viimeistelijää vasemmalle. Avaa luukku R1 ja käännä sitten nuppia R2 myötäpäivään. Poista juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Sulje luukku R1. Poista juuttunut paperi tavallisen lokeron ulostulotelasta. Varmista, että poistat kaikki paperinpalat. Liu'uta nidonnan viimeistelijä takaisin paikalleen. tukoksen poistaminen nidonnan viimeistelijässä paperitukoksen poistaminen nidonnan viimeistelijässä paperitukos nidonnan viimeistelijässä"},{"UUID":"5ffe6c0b-652e-4bcc-985a-e9a654b30dcd","title":"Tukosten poistaminen","link":"clearing-jams.html","desc":"Paperitukos paperin siirtoyksikössä taittovalinnalla Poista","descFull":"Paperitukos paperin siirtoyksikössä taittovalinnalla Poista juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Avaa luukku F. Nostokahva N4. Nostokahva N5. Poista juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Sulje kahva N5 ja sulje sitten kahva N4. Työnnä N1-kahvaa alaspäin. Käännä nuppia N2 vastapäivään. Poista juuttunut paperi. Estä tulostimen vioittuminen riisumalla käsistä kaikki asusteet, ennen kuin poistat juuttuneen paperin. Varmista, että poistat kaikki paperinpalat. Aseta kahva N1 takaisin paikoilleen. Sulje luukku F. tukoksen poistaminen paperin siirtoyksikössä taittovalinnalla paperitukoksen poistaminen paperin siirtoyksikössä taittovalinnalla paperitukos paperin siirtoyksikössä taittovalinnalla"},{"UUID":"cb543426-58e8-424c-b130-e18f08daaa3d","title":"Tukosten poistaminen","link":"clearing-jams.html","desc":"Paperitukos nidonnan tai rei'ityksen viimeistelijässä","descFull":"Paperitukos nidonnan tai rei'ityksen viimeistelijässä Jos tulostimesi on määritetty käyttämään paperin siirtoyksikköä, toimi seuraavasti: Poista alustaan 1 juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Älä poista nidonta-alustalla olevia tulostettuja sivuja välttääksesi sivujen puuttumisen. Poista juuttuneet paperit nidonnan viimeistelijän vakioalustasta. Varmista, että poistat kaikki paperinpalat. Poista alustaan 2 juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Avaa paperin siirtoyksikön kansi G ja poista juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Sulje paperinsiirron kansi G. Avaa luukku I ja sitten luukku R1, ja poista juuttuneet paperit. Varmista, että poistat kaikki paperinpalat. Sulje luukku R1 ja sitten luukku I. Avaa paperinsiirron kansi F. Avaa luukku H. Nostokahva R4. Käännä nuppia R3 vastapäivään ja poista sitten juuttunut paperi alustasta 1. Varmista, että poistat kaikki paperinpalat. Käännä nuppia R2 vastapäivään ja poista sitten juuttunut paperi paperin siirtoyksikön kannesta F. Varmista, että poistat kaikki paperinpalat. Sulje paperinsiirron kansi F. Käännä kahva R4 sen alkuperäiseen asentoon. Sulje luukku H. Jos tulostin on määritetty käyttämään paperin siirtoyksikköä taittomahdollisuudella, toimi seuraavasti: Poista alustaan 1 juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Älä poista nidonta-alustalla olevia tulostettuja sivuja välttääksesi sivujen puuttumisen. Poista juuttuneet paperit nidonnan viimeistelijän vakioalustasta. Varmista, että poistat kaikki paperinpalat. Poista alustaan 2 juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Avaa luukku F. Avaa luukku N4. Avaa luukku N5. Avaa luukku H. Nostokahva R4. Käännä nuppia R3 vastapäivään ja poista sitten juuttunut paperi alustasta 1. Varmista, että poistat kaikki paperinpalat. Käännä nuppia R2 vastapäivään ja poista sitten juuttunut paperi luukkujen N4 ja N5 välistä. Varmista, että poistat kaikki paperinpalat. Avaa luukku B. Tulostimen sisäosat voivat olla kuumat. Voit välttää palovammoja koskettamalla osia vasta, kun niiden pinta on jäähtynyt. Estä sähköstaattisen purkauksen aiheuttama vahinko koskettamalla tulostimen metallikehystä ennen kuin avaat tai kosketat tulostimen sisäosia. Poista juuttunut paperi vakioalustan ulostulotelan alta. Varmista, että poistat kaikki paperinpalat. Sulje luukku B. Työnnä N1-kahvaa alaspäin. Käännä nuppia N2 vastapäivään. Poista juuttunut paperi. Estä tulostimen vioittuminen riisumalla käsistä kaikki asusteet, ennen kuin poistat juuttuneen paperin. Varmista, että poistat kaikki paperinpalat. Aseta kahva N1 takaisin paikoilleen. Sulje kahva N5 ja sulje sitten kahva N4. Sulje luukku F. Käännä kahva R4 sen alkuperäiseen asentoon. Sulje luukku H. tukoksen poistaminen nidonnan ja rei'ityksen viimeistelijästä paperitukoksen poistaminen nidonnan ja rei'ityksen viimeistelijästä paperitukos nidonnan tai rei'ityksen viimeistelijässä"},{"UUID":"e4f22cfa-a732-469e-ab3f-f7bce3588823","title":"Tukosten poistaminen","link":"clearing-jams.html","desc":"Paperitukos vihkoviimeistelijässä Jos tulostimesi on","descFull":"Paperitukos vihkoviimeistelijässä Jos tulostimesi on määritetty käyttämään paperin siirtoyksikköä, toimi seuraavasti: Poista juuttuneet paperit nidonnan viimeistelijän vakioalustasta. Varmista, että poistat kaikki paperinpalat. Poista alustaan 1 juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Poista alustaan 1 juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Älä poista nidonta-alustalla olevia tulostettuja sivuja välttääksesi sivujen puuttumisen. Poista alustaan 3 juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Avaa paperin siirtoyksikön kansi G ja poista juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Sulje paperinsiirron kansi G. Avaa paperinsiirron kansi F. Avaa luukku H. Siirrä kahva R3 oikealle ja poista juuttuneet paperit. Varmista, että poistat kaikki paperinpalat. Siirrä kahvaa R1 vasemmalle, käännä nuppia R2 vastapäivään ja poista sitten juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Kierrä nuppia R5 vastapäivään ja poista sitten juuttunut paperi vakioviimeistelyalustalta. Varmista, että poistat kaikki paperinpalat. Nosta kahvaa R4, käännä nuppia R2 myötäpäivään ja poista sitten juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Sulje paperinsiirron kansi F. Palauta kahvat R1, R3 ja R4 alkuperäiseen asentoonsa. Sulje luukku H. Jos tulostin on määritetty käyttämään paperin siirtoyksikköä taittomahdollisuudella, toimi seuraavasti: Poista juuttuneet paperit nidonnan viimeistelijän vakioalustasta. Varmista, että poistat kaikki paperinpalat. Poista alustaan 1 juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Poista alustaan 1 juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Älä poista nidonta-alustalla olevia tulostettuja sivuja välttääksesi sivujen puuttumisen. Poista alustaan 3 juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Avaa luukku F. Avaa luukku H. Avaa luukku N4. Avaa luukku N5. Nostokahva R4. Kierrä nuppia R2 myötäpäivään ja poista sitten juuttunut paperi kahvasta R4. Varmista, että poistat kaikki paperinpalat. Siirrä kahvaa R1 vasemmalle, käännä nuppia R2 vastapäivään ja poista sitten juuttunut paperi luukkujen N4 ja N5 välistä. Varmista, että poistat kaikki paperinpalat. Avaa luukku B. Tulostimen sisäosat voivat olla kuumat. Voit välttää palovammoja koskettamalla osia vasta, kun niiden pinta on jäähtynyt. Estä sähköstaattisen purkauksen aiheuttama vahinko koskettamalla tulostimen metallikehystä ennen kuin avaat tai kosketat tulostimen sisäosia. Poista juuttunut paperi vakioalustan ulostulotelan alta. Varmista, että poistat kaikki paperinpalat. Sulje luukku B. Työnnä N1-kahvaa alaspäin. Käännä nuppia N2 vastapäivään. Poista juuttunut paperi. Estä tulostimen vioittuminen riisumalla käsistä kaikki asusteet, ennen kuin poistat juuttuneen paperin. Varmista, että poistat kaikki paperinpalat. Aseta kahva N1 takaisin paikoilleen. Sulje luukku N5 ja sitten luukku N4. Sulje luukku F. Palauta kahvat R1 ja R4 alkuperäiseen asentoonsa. Sulje luukku H. Paperitukos vihkoalustassa Poista alustaan 2 juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Avaa luukku H. Käännä nuppeja R6, R11 ja R10 myötäpäivään. Vedä vihkovalmistin ulos. Poista juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Käännä nuppia R9 vastapäivään, kunnes se pysähtyy. Avaa luukku R8. Poista juuttunut paperi. Varmista, että poistat kaikki paperinpalat. Sulje luukku R8. Palauta vihkoalusta vihkoviimeistelijään. Sulje luukku H. tukoksen poistaminen vihkoviimeistelijässä paperitukoksen poistaminen vihkoviimeistelijässä paperitukos vihkoviimeistelijässä"},{"UUID":"2f7b2925-6c30-4122-ab16-c52594c7cd7c","title":"Verkkoyhteysongelmat","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Embedded Web Server ei avaudu","descFull":"Embedded Web Server ei avaudu Embedded Web Server ei avaudu Kokeile jotakin seuraavista keinoista: Tarkista, että tulostin on käynnissä. Tarkista, että tulostimen IP-osoite on oikea. Katso IP-osoite ohjauspaneelista. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Varmista, että olet asentanut tuetun selaimen. Internet Explorer -versio 11 tai uudempi Microsoft Edge Safari-versio 6 tai uudempi Google Chrome  -versio 32 tai uudempi Mozilla Firefox -versio 24 tai uudempi Tarkista, että verkkoyhteys toimii. Jos yhteys ei toimi, ota yhteyttä järjestelmänvalvojaan. Tarkista, että kaapelit on liitetty tukevasti tulostimeen ja tulostuspalvelimeen. Lisätietoja on tulostuspalvelimen käyttöohjeissa. Tarkista, onko välityspalvelimet poistettu käytöstä. Jos palvelimet on poistettu käytöstä, ota yhteyttä järjestelmänvalvojaan. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . Embedded Web Server ei avaudu vianmääritys Embedded Web Server ei avaudu"},{"UUID":"ec8e5c9e-7f09-456d-81d4-a191970ee45d","title":"Verkkoyhteysongelmat","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Tulostinta ei voi liittää Wi-Fi-verkkoon","descFull":"Tulostinta ei voi liittää Wi-Fi-verkkoon Tulostinta ei voi liittää Wi-Fi-verkkoon Kokeile jotakin seuraavista keinoista: Valitse ohjauspaneelissa  Asetukset Verkko/portit Verkon esittely Aktiivinen sovitin  ja valitse  Automaattinen . Varmista, että tietokone ja tulostin on yhdistetty samaan Wi-Fi-verkkoon. Lisätietoja on kohdassa  . Jotkin reitittimet voivat jakaa oletus-Wi‑Fi-nimen. Varmista, että olet kirjoittanut oikean verkon salasanan. Huomioi salasanan välilyönnit, numerot ja isot kirjaimet. Varmista, että oikea langaton suojaustila on valittuna. Siirry ohjauspaneelista kohtaan  Asetukset Verkko/Portit Langaton Langaton suojaustila . Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostinta ei voi liittää Wi‑Fi-verkkoon vianmääritys tulostinta ei voi liittää Wi‑Fi-verkkoon"},{"UUID":"41d977e0-81d8-4ec1-9e5e-270f2025fac7","title":"Lisävarusteongelmat","link":"trb-cannot-detect-internal-option-topic.html","desc":"Sisäistä lisälaitetta ei löydy Sisäistä","descFull":"Sisäistä lisälaitetta ei löydy Sisäistä lisälaitetta ei löydy Kokeile jotakin seuraavista keinoista: Sammuta tulostin, odota noin 10 sekuntia ja käynnistä tulostin uudelleen. Tulosta  valikkoasetussivu  ja tarkista, onko sisäinen lisävaruste lisättyjen ominaisuuksien luettelossa. Siirry ohjauspaneelista kohtaan  Asetukset Raportit Valikkoasetussivu . Tarkista, onko sisäinen lisälaite asennettu oikein ohjainlevyyn. Sammuta tulostin ja irrota virtajohto pistorasiasta. Varmista, että sisäinen lisälaite on asennettu ohjainlevyn oikeaan liitäntään. Liitä virtajohto pistorasiaan ja kytke tulostimen virta. Tulipalon tai sähköiskun vaaran välttämiseksi liitä virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Varmista, että lisälaite on käytettävissä tulostinohjaimessa Sisäinen lisälaite on ehkä lisättävä tulostinohjaimeen manuaalisesti, jotta se on käytettävissä tulostustöissä. Lisätietoja on kohdassa  . Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . lisävarusteongelma sisäistä lisälaitetta ei löydy sisäistä lisälaitetta ei havaittu sisäistä lisälaitetta ei löydy"},{"UUID":"cd87faa5-5c26-46e5-952d-1e957bf31ed3","title":"Lisävarusteongelmat","link":"trb-cannot-detect-internal-option-topic.html","desc":"Sisäinen sovellusportti ei toimi oikein","descFull":"Sisäinen sovellusportti ei toimi oikein Sisäinen sovellusportti ei toimi oikein Kokeile jotakin seuraavista keinoista: Tulosta  Valikkoasetussivu  ja tarkista, onko sisäinen sovellusportti (ISP) asennettujen toimintojen luettelossa. Siirry ohjauspaneelista kohtaan  Asetukset Raportit Valikkoasetussivu . Poista ISP ja asenna se uudelleen. Lisätietoja on kohdassa  . Tarkista kaapelin ja sisäisen sovellusportin liitäntä. Käytä oikeaa kaapelia ja varmista, että se on liitetty pitävästi sisäiseen sovellusporttiin. Varmista, että sisäisen sovellusportin liitäntäkaapeli on liitetty pitävästi paikalleen ohjainlevyyn. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . vianmääritys sisäinen sovellusportti tulostimen lisävarusteiden ongelma sisäinen sovellusportti sisäinen sovellusportti ei toimi oikein"},{"UUID":"dd83f195-e827-43c5-af12-34fe12af7f96","title":"Lisävarusteongelmat","link":"trb-cannot-detect-internal-option-topic.html","desc":"Rinnakkais- tai sarjaliitäntäkortti ei toimi","descFull":"Rinnakkais- tai sarjaliitäntäkortti ei toimi oikein Rinnakkais- tai sarjaliitäntäkortti ei toimi oikein Kokeile jotakin seuraavista keinoista: Tulosta  Valikkoasetussivu  ja tarkista, onko rinnakkais- tai sarjaliitäntäkortti asennettujen toimintojen luettelossa. Siirry ohjauspaneelista kohtaan  Asetukset Raportit Valikkoasetussivu . Poista ja asenna uudelleen rinnakkais- tai sarjaliitäntäkortti. Lisätietoja on kohdassa  . Tarkista kaapelin ja rinnakkais- tai sarjaliitäntäkortin välinen yhteys. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostimen lisävarusteiden ongelma rinnakkaisliitäntäkortti tulostimen lisävarusteiden ongelma sarjaliitäntäkortti vianmääritys rinnakkaisliitäntäkortti vianmääritys sarjaliitäntäkortti"},{"UUID":"bbec1371-0a07-4d9a-af70-23452b52c510","title":"Lisävarusteongelmat","link":"trb-cannot-detect-internal-option-topic.html","desc":"Flash-muisti on viallinen Flash-muisti on","descFull":"Flash-muisti on viallinen Flash-muisti on viallinen Kokeile jotakin seuraavista keinoista: Vaihda viallinen flash-muisti toimivaan. Jatka tulostusta ja ohita ilmoitus valitsemalla  Jatka . Peruuta nykyinen tulostustyö. tulostimen ilmoitukset viallinen Flash-muisti havaittu Viallinen flash-muisti vianmääritys Viallinen flash-muisti"},{"UUID":"e189f208-8260-4677-affa-df484a150305","title":"Lisävarusteongelmat","link":"trb-cannot-detect-internal-option-topic.html","desc":"Flash-muistin vapaa tila ei riitä","descFull":"Flash-muistin vapaa tila ei riitä resursseja varten Flash-muistin vapaa tila ei riitä resursseja varten Kokeile jotakin seuraavista keinoista: Jatka tulostusta ja poista ilmoitus näytöstä valitsemalla  Jatka . Poista fontit, makrot ja muut flash-muistiin tallennetut tiedot. Asenna tallennusasema. Poistetaan ladatut fontit ja makrot, joita ei ole aiemmin tallennettu flash-muistiin. tulostimen ilmoitukset Flash-muistin vapaa tila ei riitä resursseja varten Flash-muistin vapaa tila ei riitä resursseja varten"},{"UUID":"b9606c3b-82c4-487f-b9fa-7259c290ddce","title":"Tarvikeongelmat","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Vaihda kasetti, tulostimen alue ei","descFull":"Vaihda kasetti, tulostimen alue ei täsmää Voit korjata ongelman ostamalla tulostimen aluetta vastaavan värikasetin tai kaikille alueille sopivan yleisvärikasetin. Virheviestin 42 ensimmäinen numero ilmaisee tulostimen alueen. Virheviestin 42 toinen numero ilmaisee värikasetin alueen. Asenna kelvollinen värikasetti. Tulostimen ja värikasetin alueet Alue Numerokoodi Maailmanlaajuinen tai aluetta ei ole määritetty 0 Pohjois-Amerikka (Yhdysvallat, Kanada) 1 Euroopan talousalue, Länsi-Eurooppa, Pohjoismaa, Sveitsi 2 Tyynenmeren Aasia 3 Latinalainen Amerikka 4 Muu Eurooppa, Lähi-itä ja Afrikka 5 Australia, Uusi-Seelanti 6 Virheellinen alue 9 Voit selvittää tulostimen ja värikasetin alueasetukset tulostamalla  Tulostuslaadun testisivut . Valitse ohjauspaneelista  Asetukset Vianmääritys Tulostuslaadun testisivut . tulostimen ilmoitukset Vaihda kasetti, tulostimen alue ei täsmää Vaihda kasetti, tulostimen alue ei täsmää väriainekasetti ja tulostimen alue eivät täsmää"},{"UUID":"c5b23911-245c-4fff-b9d8-bfda73183919","title":"Tarvikeongelmat","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Uudelleentäytetty tavallinen [väri] kasetti. Tulostin","descFull":"Uudelleentäytetty tavallinen [väri] kasetti. Tulostin on havainnut tavallisen Lexmark-kasetin, jonka muu osapuoli kuin Lexmark on täyttänyt uudelleen muulla kuin alkuperäisellä väriaineella. Tulostin on havainnut tavallisen kasetin, jonka muu osapuoli kuin tulostimen valmistaja on täyttänyt uudelleen muulla kuin alkuperäisellä väriaineella. Jatka valitsemalla  OK . Kaikki tulostimen osien käyttöiän ilmaisimet on suunniteltu toimimaan Lexmark-tarvikkeiden ja osien kanssa, ja ne voivat tuottaa arvaamattomia tuloksia käytettäessä Lexmark-tulostimessa tarvikkeita tai osia, jotka ovat muiden kuin Lexmarkin valmistamia. Kaikki tulostimen osien käyttöiän ilmaisimet on suunniteltu toimimaan valmistajan tarvikkeiden ja osien kanssa, ja ne voivat tuottaa arvaamattomia tuloksia käytettäessä tulostimessa tarvikkeita tai osia, jotka ovat muiden kuin tulostimen valmistajan valmistamia. Katso lisätietoja tulostimen rajoitetun takuun ilmoituksesta. tulostimen ilmoitukset uudelleentäytetty tavallinen värikasetti. värikasetti ei ole alkuperäinen kolmannen osapuolen tarvikkeet"},{"UUID":"d79acf1e-0ea3-4a6d-ab5c-1ff51765b9b2","title":"Tarvikeongelmat","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Muu kuin Lexmarkin tarvike Muu","descFull":"Muu kuin Lexmarkin tarvike Muu kuin Dellin tarvike Muu kuin tulostinvalmistajan tarvike Tulostin on havainnut muun kuin Lexmarkin valmistaman tarvikkeen tai osan tulostimessa. Tulostin on havainnut muun kuin Dellin valmistaman tarvikkeen tai osan tulostimessa. Tulostin on havainnut tunnistamattoman tarvikkeen tai osan tulostimessa. Lexmark-tulostin on suunniteltu käytettäväksi ja toimii parhaiten aitojen Lexmark-osien ja -tarvikkeiden kanssa. Kolmannen osapuolen tarvikkeiden tai osien käyttö voi vaikuttaa tulostimen ja sen kuvantuottoyksikön suorituskykyyn, toimintavarmuuteen tai käyttöikään. Dellin tulostin on suunniteltu toimimaan parhaiten aidoilla Dellin tarvikkeilla ja osilla. Kolmannen osapuolen tarvikkeiden tai osien käyttö voi vaikuttaa tulostimen ja sen kuvantuottoyksikön suorituskykyyn, toimintavarmuuteen tai käyttöikään. Tulostin on suunniteltu toimimaan parhaiten aidoilla tulostimen valmistajan tarvikkeilla ja osilla. Kolmannen osapuolen tarvikkeiden tai osien käyttö voi vaikuttaa tulostimen ja sen kuvantuottoyksikön suorituskykyyn, toimintavarmuuteen tai käyttöikään. Käyttöikää mittaavat osat on suunniteltu toimimaan Lexmarkin tarvikkeiden ja osien kanssa ja saattavat toimia odottamattomalla tavalla, jos kolmannen osapuolen osia tai tarvikkeita käytetään. Kuvantuottoyksikön osien käyttö suunnitellun käyttöiän kuluttua umpeen voi vahingoittaa Lexmark-tulostinta tai sen osia. Kaikki käyttöiän merkkivalot on suunniteltu toimimaan Dellin tarvikkeiden ja osien kanssa. Tulokset voivat olla odottamattomia, jos käytetään kolmannen osapuolen tarvikkeita tai osia. Kuvakomponenttien käyttäminen tarkoitettua käyttöikää kauemmin voi vaurioittaa Dellin tulostinta tai siihen liitettyjä komponentteja. Kaikki käyttöiän merkkivalot on suunniteltu toimimaan tulostimen valmistajan tarvikkeiden ja osien kanssa. Tulokset voivat olla odottamattomia, jos käytetään kolmannen osapuolen tarvikkeita tai osia. Kuvakomponenttien käyttäminen tarkoitettua käyttöikää kauemmin voi vaurioittaa tulostinta tai siihen liitettyjä komponentteja.  Kolmannen osapuolen tarvikkeiden tai osien käyttö voi vaikuttaa takuun kattavuuteen. Takuu ei välttämättä kata kolmannen osapuolen tarvikkeiden tai osien käytöstä aiheutuneita vahinkoja. Hyväksy kaikki mainitut riskitekijät ja jatka kolmannen osapuolen tarvikkeiden tai osien käyttöä tulostimessa koskettamalla näytössä olevaa virheilmoitusta kahdella sormella 15 sekunnin ajan. Kun näet vahvistusvalintaikkunan, valitse  Jatka . Jos et hyväksy mainittuja riskitekijöitä, poista kolmannen osapuolen tarvike tai osa tulostimesta ja asenna sen tilalle aito Lexmark-tarvike tai -osa. Lisätietoja on kohdassa  . Jos et hyväksy mainittuja riskitekijöitä, poista kolmannen osapuolen tarvike tai osa tulostimesta ja asenna sen tilalle aito Dell-tarvike tai -osa. Jos et hyväksy mainittuja riskitekijöitä, poista kolmannen osapuolen tarvike tai osa tulostimesta ja asenna sen tilalle aito tulostimen valmistajan tarvike tai osa. Jos tulostin ei tulosta, kun olet kuitannut virheilmoituksen, nollaa tarvikkeiden käyttölaskuri. Valitse ohjauspaneelissa  Asetukset Laite Huolto Määritys-valikko Tarvikkeen käyttö ja laskurit . Valitse osa tai tarvike, jonka käyttölaskurin haluat nollata, ja valitse sitten  Käynnistä . Lue varoitusviesti ja valitse  Jatka . Kuittaa ilmoitus koskettamalla näyttöä kahdella sormella 15 sekunnin ajan. Jos et voi nollata tarvikkeiden käyttölaskureita, palauta tarvike ostopaikkaan. tulostimen ilmoitukset Muu kuin Lexmarkin tarvike Muu kuin Lexmarkin tarvike tulostimen ilmoitukset Muu kuin Dellin tarvike Muu kuin Dellin tarvike tulostimen ilmoitukset Muu kuin tulostinvalmistajan tarvike Muu kuin tulostinvalmistajan tarvike uudelleen asetus tarvikkeiden käyttölaskurit tarvikkeiden käyttölaskurit uudelleen asetus tarvikkeiden käyttölaskurien nollaaminen"},{"UUID":"d04cd0ca-8a3b-46b3-a917-8adc2aaae88a","title":"Paperinsyöttöongelmat","link":"trb-paper-curl-topic.html","desc":"Paperin käpristyminen Kokeile jotakin seuraavista","descFull":"Paperin käpristyminen Kokeile jotakin seuraavista keinoista: Säädä lokeron ohjaimet oikeaan kohtaan lisätyn paperin koon mukaan. Määritä paperilaji käyttöjärjestelmän mukaan joko Tulostusmääritykset- tai Tulostus-valintaikkunassa. Varmista, että asetus vastaa lisättyä paperia. Voit muuttaa asetusta myös tulostimen ohjauspaneelista. Valitse  Asetukset Paperi Lokeromääritys Paperikoko/-laji Poista paperi, käännä se toisin päin ja aseta se uudelleen. Lisää paperia uudesta pakkauksesta. Paperi imee kosteutta suuren kosteuspitoisuuden takia. Älä poista paperia kääreestään, ennen kuin otat sen käyttöön. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostuslaatuongelma paperin käpristyminen paperin käpristyminen"},{"UUID":"35d47196-de45-44db-ae24-624ccf178f1e","title":"Paperinsyöttöongelmat","link":"trb-paper-curl-topic.html","desc":"Kirjekuori sulkeutuu tulostuksen aikana Kokeile","descFull":"Kirjekuori sulkeutuu tulostuksen aikana Kokeile jotakin seuraavista keinoista: Käytä kirjekuorta, jota on säilytetty kuivassa ympäristössä. Läpät voivat liimautua tulostettaessa kosteille kirjekuorille. Varmista, että Paperilaji-asetus on  Kirjekuori . Valitse ohjauspaneelissa  Asetukset Paperi Lokeromääritys Paperikoko/-laji . Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . paperinsyöttöongelma kirjekuori sulkeutuu tulostuksen aikana kirjekuori sulkeutuu tulostuksen aikana"},{"UUID":"57f778d7-6552-4dd4-860d-50b6aaa7a419","title":"Paperinsyöttöongelmat","link":"trb-paper-curl-topic.html","desc":"Lajittelutulostus ei toimi Kokeile jotakin","descFull":"Lajittelutulostus ei toimi Kokeile jotakin seuraavista keinoista: Siirry ohjauspaneelista kohtaan  Asetukset Tulosta Asettelu Lajittele  ja valitse sitten  Käytössä [1,2,1,2,1,2] . Avaa Tulostusasetukset tai tulostusvalintaikkuna siinä asiakirjassa, jonka yrität tulostaa, ja valitse  Lajittelu . Vähennä tulostettavien sivujen määrää. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . paperinsyöttöongelma lajittelutulostus ei toimi lajittelutulostus ei toimi"},{"UUID":"e1881aec-1def-4576-8383-9090a7c8bc86","title":"Paperinsyöttöongelmat","link":"trb-paper-curl-topic.html","desc":"Lokeroiden yhdistäminen ei toimi Kokeile","descFull":"Lokeroiden yhdistäminen ei toimi Kokeile jotakin seuraavista keinoista: Varmista, että yhdistetyissä lokeroissa on sama paperikoko, -suunta ja -laji. Varmista, että paperiohjeimet ovat oikeassa asennossa. Määritä paperin koko ja laji vastaamaan yhdistetyissä lokeroissa olevaa paperia. Valitse ohjauspaneelissa  Asetukset Paperi Lokeromääritys Paperikoko/-laji . Varmista, että  lokeroiden yhdistämisasetuksena  on  Automaattinen . Lisätietoja on kohdassa  . Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . paperinsyöttöongelma alustojen yhdistäminen ei toimi alustojen yhdistäminen ei toimi"},{"UUID":"ac363779-9236-4cfb-965b-e95c8a2a5109","title":"Paperinsyöttöongelmat","link":"trb-paper-curl-topic.html","desc":"Paperi juuttuu usein Kokeile jotakin","descFull":"Paperi juuttuu usein Kokeile jotakin seuraavista keinoista: Tarkista, että paperi on lisätty oikein. Varmista, että paperiohjeimet ovat oikeassa asennossa. Varmista, että pinon korkeus on paperin enimmäistäyttöosoittimen alapuolella. Varmista, että käytät tulostamisessa suositeltua paperikokoa ja -lajia. Määritä oikea paperikoko ja -laji. Valitse ohjauspaneelissa  Asetukset Paperi Lokeromääritys Paperikoko/-laji . Lisää paperia uudesta pakkauksesta. Paperi imee kosteutta suuren kosteuspitoisuuden takia. Älä poista paperia kääreestään, ennen kuin otat sen käyttöön. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . paperinsyöttöongelma paperi jumittuu usein paperi jumittuu usein"},{"UUID":"ceac9734-4841-4a02-a464-c7ec30f0c3ed","title":"Paperinsyöttöongelmat","link":"trb-paper-curl-topic.html","desc":"Juuttuneet sivut eivät tulostu uudelleen","descFull":"Juuttuneet sivut eivät tulostu uudelleen Siirry ohjauspaneelista kohtaan  Asetukset Laite Ilmoitukset Sisällön tukosselvitys . Valitse  Tukosselvitys -valikossa  Käytössä  tai  Automaattinen . Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . tulostusongelma juuttuneet sivut eivät tulostu uudelleen juuttuneet sivut eivät tulostu uudelleen"},{"UUID":"85071a1d-d8c9-4e4d-9dc1-1323af2a3301","title":"Sähköpostiongelmat","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"SMTP-palvelinta ei ole määritetty -virheilmoituksen","descFull":"SMTP-palvelinta ei ole määritetty -virheilmoituksen poistaminen käytöstä Siirry ohjauspaneelista kohtaan  Asetukset Sähköposti Sähköpostiasetukset . Määritä  Poista käytöstä SMTP-palvelinta ei ole määritetty  -virhe asetukseksi  Käytössä Estä virhe jatkossa tekemällä jokin seuraavista: Päivitä tulostimen laiteohjelmisto Lisätietoja on kohdassa Laiteohjelmiston päivittäminen. Määritä sähköpostin SMTP-asetukset. Lisätietoja on kohdassa  . SMTP-palvelinta ei ole määritetty -virhe poistaminen käytöstä vianmääritys SMTP-palvelinta ei ole määritetty -virhe SMTP-palvelinta ei ole määritetty -virheen poistaminen käytöstä"},{"UUID":"eb2452f5-6bcc-474f-bf4f-339153282dff","title":"Sähköpostiongelmat","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Sähköpostin lähettäminen ei onnistu Kokeile","descFull":"Sähköpostin lähettäminen ei onnistu Kokeile jotakin seuraavista keinoista: Varmista, että sähköpostin SMTP-asetukset on määritetty oikein Lisätietoja on kohdassa  . Varmista, että tulostin on liitetty verkkoon ja että verkossa on Internet-yhteys. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . sähköpostiongelma sähköpostien lähettäminen ei onnistu sähköpostien lähettäminen ei onnistu"},{"UUID":"8e5b968f-94cf-4003-b0c3-d17a0085abec","title":"Faksausongelmat","link":"trb-caller-id-not-shown-topic.html","desc":"Soittajan tunnus ei näy Soittajan","descFull":"Soittajan tunnus ei näy Soittajan tunnus ei näy Nämä ohjeet koskevat vain tulostimia, joihin on asennettu faksikortti. Siirry ohjauspaneelissa kohtaan  Asetukset Faksi Faksiasetukset Faksin vastaanottoasetukset Järjestelmänvalvojan asetukset . Aseta  Ota soittajan tunnus käyttöön  -asetukseksi  Käytössä . Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . faksiongelma soittajan tunnus ei näy soittajan tunnus ei näy"},{"UUID":"39053ca8-3852-44cb-a86f-59e885ee5b27","title":"Faksausongelmat","link":"trb-caller-id-not-shown-topic.html","desc":"Faksien lähettäminen tai vastaanottaminen ei","descFull":"Faksien lähettäminen tai vastaanottaminen ei onnistu analogisen faksin kautta Faksien lähettäminen tai vastaanottaminen ei onnistu analogisen faksin kautta Kokeile jotakin seuraavista keinoista : Ratkaise näyttöön avautuvat virheilmoitukset. Tarkista puhelimen, kuulokkeen ja vastaajan kaapeliliitännät. Tarkista valintaääni. Varmista faksinumeron toimivuus soittamalla siihen. Jos käytät Valinta kuuloke paikallaan -toimintoa, lisää äänenvoimakkuutta ja tarkista valintaäänen kuuluminen. Tarkista puhelimen seinäpistoke. Liitä analoginen puhelin suoraan pistorasiaan. Odota valintaääntä. Jos valintaääntä ei kuulu, käytä toista puhelinkaapelia. Jos valintaääntä ei edelleenkään kuulu, liitä puhelinkaapeli toiseen pistorasiaan. Jos kuulet valintaäänen, liitä tulostin kyseiseen pistorasiaan. Tarkista, onko tulostin liitetty analogiseen puhelinpalveluun tai oikeaan digitaaliseen liitäntään. Jos käytät ISDN-puhelinpalvelua, liitä tulostin ISDN-päätelaitteen analogiseen puhelinliitäntään. Pyydä lisätietoja ISDN-palveluntarjoajalta. Jos käytät DSL-yhteyttä, käytä DSL-suodatinta tai analogista käyttöä tukevaa reititintä. Pyydä lisätietoja DSL-palveluntarjoajalta. Jos käytät tilaajavaihdetta, varmista että käytät tilaajavaihteen analogista liitäntää. Jos sellaista ei ole, voit asentaa faksilaitteelle analogisen puhelinlinjan. Irrota tilapäisesti muut laitteet ja poista muut puhelinpalvelut käytöstä. Irrota muut tulostimen ja puhelinlinjan välillä olevat laitteet (esimerkiksi vastaajat, tietokoneet, joissa on modeemi ja puhelinjakorasiat). Poista käytöstä koputus ja puheposti. Pyydä lisätietoja puhelinyhtiöltä. Skannaa alkuperäinen asiakirja sivu kerrallaan. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . faksiongelma faksien lähettäminen tai vastaanottaminen ei onnistu analogisen faksin kautta faksien lähettäminen tai vastaanottaminen ei onnistu analogisen faksin kautta"},{"UUID":"19fc8579-0fcb-4cb0-b76a-fd930490eb46","title":"Faksausongelmat","link":"trb-caller-id-not-shown-topic.html","desc":"Faksien vastaanottaminen onnistuu mutta lähettäminen","descFull":"Faksien vastaanottaminen onnistuu mutta lähettäminen ei analogisen faksin kautta Faksien vastaanottaminen onnistuu mutta lähettäminen ei analogisen faksin kautta Kokeile jotakin seuraavista keinoista: Aseta alkuperäinen asiakirja automaattisen asiakirjansyöttölaitteen lokeroon tai skannaustasolle. Määritä pikavalintanumero oikein. Tarkista, että pikavalintanumero on määritetty haluamallesi puhelinnumerolle. Valitse puhelinnumero manuaalisesti. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . faksiongelma faksien lähettäminen ei onnistu analogisen faksin kautta faksien lähettäminen ei onnistu analogisen faksin kautta"},{"UUID":"b8f1a58e-b900-482e-9143-2ea395023769","title":"Faksausongelmat","link":"trb-caller-id-not-shown-topic.html","desc":"Faksien lähettäminen onnistuu mutta vastaanottaminen","descFull":"Faksien lähettäminen onnistuu mutta vastaanottaminen ei analogisen faksin kautta Faksien lähettäminen onnistuu mutta vastaanottaminen ei analogisen faksin kautta Kokeile jotakin seuraavista keinoista: Tarkista, ettei paperilähde ole tyhjä. Tarkista soiton viiveasetukset. Valitse ohjauspaneelissa  Asetukset Faksi Faksiasetukset Faksin vastaanottoasetukset Hälytykset ennen vastaamista . Jos tulostin tulostaa tyhjiä sivuja, katso kohta  . Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . faksiongelma faksien lähettäminen onnistuu mutta vastaanottaminen ei analogisen faksin kautta faksien vastaanottaminen ei onnistu analogisen faksin kautta"},{"UUID":"0a2a200b-ce2f-4e24-bfbf-4e639b9502ad","title":"Faksausongelmat","link":"trb-caller-id-not-shown-topic.html","desc":"etherFAXin määrittäminen ei onnistu etherFAXin","descFull":"etherFAXin määrittäminen ei onnistu etherFAXin määrittäminen ei onnistu Kokeile jotakin seuraavista keinoista : Tarkista tulostimen yhteydet. Siirry ohjauspaneelista kohtaan  Asetukset Raportit Verkko Verkkoasetussivu . Tarkista verkon tila tulostetulta sivulta. Varmista, että tulostin on liitetty verkkoon ja että verkossa on Internet-yhteys. Varmista, että etherFAX on määritetty oikein. Lisätietoja on kohdassa  . Jos ongelma ei poistu, siirry osoitteeseen  https://www.etherfax.net/lexmark . faksiongelma etherFAXin määrittäminen ei onnistu etherFAXin määrittäminen ei onnistu"},{"UUID":"c912cbe1-8ad3-4870-8031-6497e12230b4","title":"Faksausongelmat","link":"trb-caller-id-not-shown-topic.html","desc":"Faksien lähettäminen tai vastaanottaminen ei","descFull":"Faksien lähettäminen tai vastaanottaminen ei onnistu etherFAXin kautta Faksien lähettäminen tai vastaanottaminen ei onnistu etherFAXin kautta Kokeile jotakin seuraavista keinoista : Varmista, että tulostin on liitetty verkkoon ja että verkossa on Internet-yhteys. Varmista, että etherFAX on määritetty oikein. Lisätietoja on kohdassa  . Jaa isot asiakirjat pienempiin osiin. Jos ongelma ei poistu, siirry osoitteeseen  https://www.etherfax.net/lexmark . faksiongelma faksien lähettäminen tai vastaanottaminen ei onnistu etherFAXin kautta faksien lähettäminen tai vastaanottaminen ei onnistu etherFAXin kautta"},{"UUID":"3a3dbd48-1524-4084-b6ee-dec3db9dd41e","title":"Faksausongelmat","link":"trb-caller-id-not-shown-topic.html","desc":"Huono faksien tulostuslaatu Huono faksien","descFull":"Huono faksien tulostuslaatu Huono faksien tulostuslaatu Kokeile jotakin seuraavista keinoista: Korjaa tulostuslaatuongelmat. Tulosta  Tulostuslaadun testisivut , Valitse ohjauspaneelista  Asetukset Vianmääritys Tulostuslaadun testisivut . Korjaa tulostuslaatuongelmat. Lisätietoja on kohdassa  . Jos käytät analogista faksia, vähennä tulevan faksin lähetysnopeutta. Siirry ohjauspaneelissa kohtaan  Asetukset Faksi Faksiasetukset Faksin vastaanottoasetukset Järjestelmänvalvojan asetukset . Valitse  Enimmäisnopeus -valikossa pienempi lähetysnopeus. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . faksiongelma huono tulostuslaatu huono faksien tulostuslaatu"},{"UUID":"b17f57ca-a94e-4b3e-86a7-e4f40fe9f63a","title":"Faksausongelmat","link":"trb-caller-id-not-shown-topic.html","desc":"Faksin kansilehdestä puuttuu tietoja Faksin","descFull":"Faksin kansilehdestä puuttuu tietoja Faksin kansilehdestä puuttuu tietoja Sammuta tulostin, odota noin 10 sekuntia ja käynnistä tulostin uudelleen. Lähetä tai nouda faksi. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . faksiongelma faksin kansilehdestä puuttuu tietoja faksin kansilehdestä puuttuu tietoja"},{"UUID":"4c5c7640-1d3d-44e4-afa1-b49b68eab670","title":"Faksausongelmat","link":"trb-caller-id-not-shown-topic.html","desc":"Faksin kansilehden lähettäminen ei onnistu","descFull":"Faksin kansilehden lähettäminen ei onnistu tietokoneesta Faksin kansilehden lähettäminen ei onnistu tietokoneesta Kokeile jotakin seuraavista keinoista : Tarkista, että tulostinohjain on päivitetty. Lisätietoja on osoitteessa  www.lexmark.com/downloads . Tarkista, että tulostinohjain on päivitetty. Kysy lisätietoja tulostimen ostopaikasta. Varmista, että tulostinohjain on päivitetty, ja lähetä sitten faksi. Jos haluat lisätietoja, ota yhteyttä  jälleenmyyjääsi . Poista valinta  Näytä aina asetukset ennen faksaamista  -kohdasta. Avaa  Tulosta -valintaikkuna asiakirjassa, jonka yrität faksata. Valitse tulostin ja sitten  Ominaisuudet ,  Määritykset ,  Valinnat  tai  Asetukset . Valitse  Faksi  ja poista valinta  Näytä aina asetukset ennen faksaamista  -kohdasta. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . faksiongelma faksin kansilehden lähettäminen tietokoneesta ei onnistu faksin kansilehden lähettäminen tietokoneesta ei onnistu"},{"UUID":"cb4eca80-1867-4410-8837-69d8d926df0e","title":"Skannausongelmat","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skannaaminen tietokoneeseen ei onnistu Kokeile","descFull":"Skannaaminen tietokoneeseen ei onnistu Kokeile jotakin seuraavista keinoista: Tee kopiointityö. Jos työ epäonnistui, sammuta tulostin, odota noin 10 sekuntia ja käynnistä tulostin uudelleen. Tarkista tulostimen yhteydet. Tulosta  Verkkoasetussivu . Siirry ohjauspaneelista kohtaan  Asetukset Raportit Verkko  ja valitse sitten  Verkkoasetussivu . Tarkista sivun ensimmäinen osa ja varmista, että yhteys on muodostettu. Varmista, että tulostin ja tietokone on liitetty samaan verkkoon Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . skannausongelma skannaaminen tietokoneeseen ei onnistu skannaaminen tietokoneeseen ei onnistu"},{"UUID":"9938d792-6e8e-459d-8daf-6edd3808dd45","title":"Skannausongelmat","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skannaaminen verkkokansioon ei onnistu Kokeile","descFull":"Skannaaminen verkkokansioon ei onnistu Kokeile jotakin seuraavista keinoista: Luo verkkokansion pikakuvake ja skannaa sitten asiakirja pikakuvakkeen avulla. Lisätietoja on kohdassa  . Varmista, että verkkokansion polku ja muoto ovat oikein. Esimerkiksi  // palvelimen_isantanimi /kansionimi/polku , jossa  palvelimen_isantanimi  on täydellinen toimialueen nimi (FQDN) tai IP-osoite. Varmista, että sinulla on verkkokansion kirjoitusoikeus. Päivitä verkkokansion pikakuvake. Avaa selain ja kirjoita tulostimen IP-osoite selaimen osoitekenttään. Tulostimen IP-osoite näkyy sen tulostimen päänäytössä. IP-osoite on neljä pisteillä erotettua numerosarjaa, kuten 123.123.123.123. Jos käytät välityspalvelinta, poista se tilapäisesti käytöstä, jotta verkkosivu latautuu oikein. Napsauta  Pikakuvakkeet -painiketta ja valitse pikakuvake. Jos pikakuvaketyyppejä on useita, valitse  Verkkokansio . Kirjoita Jakopolku-kenttään verkkokansion polku. Esimerkiksi  \\\\palvelimen_isäntänimi\\kansionnimi\\polku . Käytä aina vinoviivaa kirjoittaessasi jakopolkua. Valitse todennusmenetelmä  Todennus -valikosta. Jos  Todennus -asetukseksi on määritetty  Käytä määritettyä käyttäjätunnusta ja salasanaa , kirjoita kirjautumistietosi Käyttäjätunnus- ja Salasana-kenttiin. Napsauta  Tallenna . Varmista, että tulostin ja verkkokansio on liitetty samaan verkkoon. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . skannaaminen verkkokansioon ei onnistu skannausongelma skannaaminen verkkokansioon ei onnistu"},{"UUID":"033deed8-f9a3-4c52-a13c-a2fc4806a67c","title":"Skannausongelmat","link":"trb-cannot-scan-to-computer-topic.html","desc":"Epätäydellinen asiakirja tai valokuva Kokeile","descFull":"Epätäydellinen asiakirja tai valokuva Kokeile jotakin seuraavista keinoista: Varmista, että asiakirja tai valokuva on skannaustasolla skannattava puoli alaspäin vasemmassa ylänurkassa. Varmista, että paperikokoasetus vastaa lokeroon lisättyä paperia. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . kopiointiongelma epätäydelliset asiakirjat kopiointiongelma epätäydelliset valokuvat epätäydelliset asiakirjat tai valokuvat skannausongelma epätäydelliset asiakirjat skannausongelma epätäydelliset valokuvat"},{"UUID":"5938a28d-96c1-4cce-a2db-dfc07e61bc29","title":"Skannausongelmat","link":"trb-cannot-scan-to-computer-topic.html","desc":"Heikko kopiointilaatu Kokeile jotakin seuraavista","descFull":"Heikko kopiointilaatu Kokeile jotakin seuraavista keinoista: Puhdista skannaustaso ja asiakirjansyöttölaite kostealla, pehmeällä ja nukkaamattomalla liinalla. Jos tulostimen asiakirjansyöttölaitteen sisällä on toinen taso, pudista myös sen lasi. Lisätietoja on kohdassa  . Varmista, että asiakirja tai valokuva on skannaustasolla skannattava puoli alaspäin vasemmassa ylänurkassa. Tarkista alkuperäisen asiakirjan tai valokuvan laatu ja säädä skannauslaatuasetukset vastaavasti. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . kopiointiongelma kopion laatu on huono kopion laatu on huono skannausongelma kopion laatu on huono huono skannauslaatu"},{"UUID":"5858312d-34db-4b8a-9316-eda892ba1f71","title":"Skannausongelmat","link":"trb-cannot-scan-to-computer-topic.html","desc":"Pystysuuntaisia tummia raitoja skannattaessa asiankirjasyöttölaitteesta","descFull":"Pystysuuntaisia tummia raitoja skannattaessa asiankirjasyöttölaitteesta Nosta skannerin kansi ja irrota tasonpuhdistustyökalu. Pyyhi ADF-lasi skannerin lasin vieressä. Avaa luukku A1 ja puhdista asiakirjansyöttölaitteen lasi. Palauta työkalu paikalleen. Sulje skannerin kansi. Lisätietoja skannerin puhdistamisesta on kohdassa  . Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . skannausongelma tulosteessa on pystysuuntaisia tummia raitoja skannattaessa asiankirjasyöttölaitteesta tulosteessa on pystysuuntaisia tummia raitoja skannattaessa asiankirjasyöttölaitteesta skannauslaatuongelmat"},{"UUID":"84aae7be-e1d9-4319-ba59-229e47708852","title":"Skannausongelmat","link":"trb-cannot-scan-to-computer-topic.html","desc":"Rosoinen kuva tai teksti skannattaessa","descFull":"Rosoinen kuva tai teksti skannattaessa asiakirjansyöttölaitteesta Rosoinen kuva tai teksti skannattaessa asiakirjansyöttölaitteesta Aseta asiakirjansyöttölaitteeseen 50 arkkia puhdasta, tavallista paperia. Tavallinen paperi irrottaa pölyä ja muuta likaa asiakirjansyöttölaitteen rullista. Pyyhkäise ohjauspaneelissa oikealle ohjauskeskukseen ja valitse sitten  . Lisää alkuperäinen asiakirja asiakirjansyöttölaitteeseen. Skannaa asiakirja. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . skannausongelma rosoinen kuva skannausongelma rosoinen teksti vianmääritys rosoinen kuva ADF-skannauksesta vianmääritys rosoinen teksti ADF-skannauksesta rosoinen kuva ADF-skannauksesta rosoinen teksti ADF-skannauksesta"},{"UUID":"27336157-228a-4c66-bc79-b084446458a0","title":"Skannausongelmat","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skannaus epäonnistui Skannaus epäonnistui Kokeile","descFull":"Skannaus epäonnistui Skannaus epäonnistui Kokeile jotakin seuraavista keinoista: Varmista, että Ethernet- tai USB-kaapeli on liitetty kunnolla tietokoneeseen ja tulostimeen. Tarkista tiedosto, jonka haluat skannata, ja varmista, että: Tiedoston nimi ei ole jo käytössä kohdekansiossa. Skannattava asiakirja tai valokuva ei ole auki toisessa sovelluksessa. Varmista, että  Liitä aikaleima - tai  Korvaa aiemmin luotu tiedosto  -valintaruutu on valittuna kohteen kokoonpanoasetuksissa. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . skannausongelma skannaustyö ei onnistunut skannaustyö ei onnistunut vianmääritys skannaustyö ei onnistunut"},{"UUID":"52294642-30a5-432e-978a-f2def8621fff","title":"Skannausongelmat","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skanneri ei sulkeudu Skanneri ei","descFull":"Skanneri ei sulkeudu Skanneri ei sulkeudu Poista esteet, jotka pitävät skannerin kantta auki. Sulje skanneri. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . skannausongelma skanneri ei sulkeudu skanneri ei sulkeudu"},{"UUID":"318e751e-f393-4688-b2cb-1bdb2ff46d35","title":"Skannausongelmat","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skannaaminen kestää liian kauan tai","descFull":"Skannaaminen kestää liian kauan tai aiheuttaa tietokoneen toimintahäiriön Skannaaminen kestää liian kauan tai aiheuttaa tietokoneen toimintahäiriön Sulje kaikki sovellukset, jotka häiritsevät skannausta. Skannaa asiakirja uudelleen. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . skannausongelma skannaaminen kestää liian kauan skannausongelma skannaaminen aiheuttaa tietokoneen toimintahäiriön skannaaminen kestää liian kauan tai aiheuttaa tietokoneen toimintahäiriön"},{"UUID":"29ef5e68-8bcd-463e-a33b-8ca1dc696e32","title":"Skannausongelmat","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skanneri ei vastaa Skanneri ei","descFull":"Skanneri ei vastaa Skanneri ei vastaa Kokeile jotakin seuraavista keinoista: Tarkista, että virtajohto on liitetty kunnolla tulostimeen ja pistorasiaan. Tulipalo- tai sähköiskuriskin välttämiseksi kytke virtajohto suoraan asianmukaiseen maadoitettuun sähköpistokkeeseen, joka on lähellä ja helposti saatavilla. Tarkista, onko tulostin kytketty päälle, ja korjaa sitten kaikki näytössä näkyvät virheilmoitukset. Sammuta tulostin, odota noin 10 sekuntia ja käynnistä tulostin uudelleen. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . kopiointiongelma skanneri ei vastaa skannausongelma skanneri ei vastaa skanneri ei vastaa"},{"UUID":"a1bd9060-a888-44e3-901b-a736abca6761","title":"Skannausongelmat","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skannerin kohdistaminen Skannerin kohdistaminen Siirry","descFull":"Skannerin kohdistaminen Skannerin kohdistaminen Siirry ohjauspaneelista kohtaan  Asetukset Laite Huolto Määritys-valikko Skannerimääritykset Skannerin manuaalinen rekisteröinti . Valitse  Tulostuksen pikatesti  -valikosta  Käynnistä . Aseta testisivu skannaustasolle ja valitse  Tasorekisteröinti . Valitse  Kopioinnin pikatesti  -valikosta  Käynnistä . Vertaa testisivua alkuperäiseen asiakirjaan. Jos testisivun marginaalit poikkeavat alkuperäisestä asiakirjasta, muuta  Vasen marginaali - ja  Ylämarginaali -asetusta. Toista kohtia   ja  , kunnes  kopioinnin pikatesti sivun marginaalit vastaavat alkuperäistä asiakirjaa. säätäminen skannerin kohdistaminen"},{"UUID":"28b58d9c-75df-43d8-b754-b47376f2ba44","title":"Skannausongelmat","link":"trb-cannot-scan-to-computer-topic.html","desc":"Automaattisen asiakirjansyöttölaitteen kohdistaminen Siirry ohjauspaneelista","descFull":"Automaattisen asiakirjansyöttölaitteen kohdistaminen Siirry ohjauspaneelista kohtaan  Asetukset Laite Huolto Määritys-valikko Skannerimääritykset Skannerin manuaalinen rekisteröinti . Valitse  Tulostuksen pikatesti  -valikosta  Käynnistä . Aseta tulostuksen testisivu asiakirjansyöttölaitteen lokeroon. Valitse  Etu-ADF-rekisteröinti  tai  Taka-ADF-rekisteröinti . Etu-ADF-rekisteröinnin  kohdistus: aseta testisivu asiakirjansyöttölaitteeseen kuvapuoli ylöspäin ja lyhyt reuna edellä. Taka-ADF-rekisteröinnin  kohdistus: aseta testisivu asiakirjansyöttölaitteeseen kuvapuoli alaspäin ja lyhyt reuna edellä. Valitse  Kopioinnin pikatesti  -valikosta  Käynnistä . Vertaa testisivua alkuperäiseen asiakirjaan. Jos testisivun marginaalit poikkeavat alkuperäisestä asiakirjasta, muuta  vaakasäätöä  ja  ylämarginaalia . Toista kohtia   ja  , kunnes  kopioinnin pikatesti sivun marginaalit vastaavat alkuperäistä asiakirjaa. automaattisen asiakirjansyöttölaitteen kohdistaminen säätäminen automaattisen asiakirjansyöttölaitteen kohdistaminen"},{"UUID":"3f621ade-4489-47fc-9895-c25ae016a7ad","title":"Värinlaatuongelmat","link":"modifying-colors-in-printed-output-topic.html","desc":"Tulosteen värien muokkaaminen Siirry ohjauspaneelista","descFull":"Tulosteen värien muokkaaminen Siirry ohjauspaneelista kohtaan  Asetukset Tulosta Laatu Kuvankäsittelyn lisäasetukset Värinsäätö . Valitse  Värinkorjaus -valikosta  Manuaalinen . Valitse  Värien korjaussisältö  -valikosta sopiva värin muunnosasetus. Värinsäätö käsin -valikon objektit ja niiden värinmuuntotaulukot Kohteen tyyppi Värinmuuntotaulukot RGB-kuva RGB Text RGB-grafiikka Kirkas  tuottaa tavallista kirkkaammat ja kylläisemmät värit, ja sitä voidaan käyttää kaikkien tulevien värimuotojen yhteydessä. sRGB-näyttö : tuottaa värit, jotka muistuttavat tietokoneen näytön värejä. Mustan värin käyttö on optimoitu valokuvien tulostusta varten. Näyttö – Tod. musta : tuottaa värit, jotka muistuttavat tietokoneen näytön värejä. Tämä asetus luo kaikki neutraalit harmaasävyt ainoastaan mustalla musteella. Tarkka sRGB : tuottaa erityisen värikylläiset värit  sRGB-näyttö -värinkorjauksen yhteydessä. Mustan väriaineen käyttö on optimoitu yritysgrafiikan tulostamista varten. Ei käytössä CMYK-kuva CMYK-teksti CMYK-grafiikka US CMYK : tulostin käyttää värinmuuntotaulukkoa, joka jäljittelee SWOP (Specifications for Web Offset Publishing) -väritulostusta. Euro CMYK : tulostin käyttää värinmuuntotaulukkoa, joka jäljittelee EuroScale-väritulostusta. Tarkka CMYK : tulostaa värit täyteläisinä käytettäessä  US CMYK  -värinmuuntotaulukkoa. Ei käytössä väritulostuksen muokkaaminen manuaalinen värinkorjaus värinkorjaus"},{"UUID":"0c66ff73-27d9-4579-8449-ef9ad550440e","title":"Värinlaatuongelmat","link":"modifying-colors-in-printed-output-topic.html","desc":"Väritulostuksen usein kysyttyjä kysymyksiä Mikä","descFull":"Väritulostuksen usein kysyttyjä kysymyksiä Mikä on RGB-väri? RGB-väri on värien kuvausmenetelmä, joka osoittaa, kuinka paljon punaista, vihreää ja sinistä käytetään tietyn värin tuottamiseen. Punaista, vihreää ja sinistä valoa voidaan sekoittaa erisuuruisina määrinä, jolloin saadaan aikaan suuri määrä luonnossa esiintyviä värejä. Tietokoneiden näytöt, skannerit ja digitaaliset kamerat käyttävät tätä menetelmää värien näyttämiseen. Mikä on CMYK-väri? CMYK-väri on värien kuvausmenetelmä, joka osoittaa, kuinka paljon syaania, magentaa, keltaista ja mustaa käytetään tietyn värin tuottamiseen. CMYK-mustetta tai -väriainetta voidaan tulostaa erisuuruisina määrinä, jolloin saadaan aikaan suuri määrä luonnossa esiintyviä värejä. Painokoneet, mustesuihkutulostimet ja laserväritulostimet tuottavat värit tällä tavalla.  Miten väri määritetään tulostettavassa asiakirjassa? Sovelluksissa asiakirjan värit määritetään ja muokataan käyttämällä RGB- tai CMYK-väriyhdistelmiä. Lisätietoja on sovelluksen ohjeessa. Miten tulostin tietää, mitä väriä sen on tulostettava? Kun asiakirja tulostetaan, jokaisen objektin tyyppiä ja väriä koskeva tieto lähetetään tulostimeen. Tiedot välitetään sitten värimuunnostaulukoiden kautta. Värit muunnetaan sopiviksi määriksi CMYK-väriaineita, joita käytetään tuottamaan haluamasi väri. Objektityyppitiedot määrittävät värinmuuntotaulukoiden käytön. Voidaan esimerkiksi käyttää yhtä värinmuuntotaulukkoa tekstiin ja jotain toista värinmuuntotaulukkoa valokuviin. Mitä on manuaalinen värinkorjaus? Kun manuaalinen värinkorjaus on käytössä, tulostin käsittelee kohteita käyttäjän valitsemien värinmuuntotaulukoiden avulla. Manuaaliset värinkorjausasetukset määräytyvät tulostuskohteen tyypin mukaan (teksti, grafiikka tai kuvat). Ne määräytyvät myös sen mukaan, miten kohteen väri on määritetty sovelluksessa (RGB- tai CMYK-yhdistelmät). Tietoja eri värinmuuntotaulukon käyttämisestä manuaalisesti on kohdassa  . Jos sovellus ei määritä värejä RGB- tai CMYK-yhdistelmillä, manuaalisesta värinkorjauksesta ei ole hyötyä. Siitä ei ole hyötyä myöskään, jos värien säätöä hallitaan sovelluksen tai tietokoneen käyttöjärjestelmän avulla. Useimmissa tapauksissa Värinkorjausasetuksen määrittäminen automaattiseksi luo asiakirjaan halutunlaiset värit. Miten saan jonkin tietyn värin (esimerkiksi yrityksen logon värin) vastaamaan tulostimen tulostamaa väriä? Tulostimen  Laatu -valikossa on valittavissa yhdeksän  värinäytesarjaa . Sarjat ovat käytettävissä myös Embedded Web Server -palvelimen  Värinäytteet -sivulla. Valitsemalla esimerkkisarja voidaan tulostaa useita sivuja, jotka koostuvat sadoista värillisistä ruuduista. Jokaisessa ruudussa on CMYK- tai RGB-yhdistelmä valitun taulukon mukaan. Kussakin ruudussa tarkasteltavana oleva väri on saatu aikaan siten, että ruudun kohdalla oleva CMYK- tai RGB-yhdistelmä on lähetetty. Tutkimalla  värinäytesarjoja  voidaan määrittää, minkä ruudun väri on lähimpänä haluttua väriä. Ruudun väriyhdistelmää voidaan sitten käyttää objektin värin muuntamiseen sovellusohjelmassa. Lisätietoja on sovelluksen ohjeessa. Manuaalinen värinkorjaus -asetus voi olla tarpeen, jotta valittua värinmuuntotaulukkoa voidaan käyttää objektille. Tietyn värin etsintäongelman ratkaisemisessa käytettävät  värinäytesarjat  määräytyvät käytettävän  Värinkorjaus -asetuksen ( Automaattinen ,  Ei käytössä  tai  Manuaalinen ) mukaan tulostustyön tyypin (teksti, grafiikka tai kuvat) mukaan sekä sen mukaan, mitä väriyhdistelmäasetusta sovellusohjelma käyttää (RGB- tai CMYK-yhdistelmät). Jos sovellus ei määritä värejä RGB- tai CMYK-yhdistelmillä,  värinäyte sivuista ei ole hyötyä. Jotkin sovellukset säätävät sovelluksessa määritetyt RGB- tai CMYK-yhdistelmät värienhallinnan kautta. Näissä tapauksissa tulostusväri ei aina vastaa tarkasti  värinäyte sivujen väriä. värin laatuongelma Väritulostuksen usein kysyttyjä kysymyksiä väritulostus värinkorjaus väriesimerkit"},{"UUID":"9b19aad7-cd12-4354-9523-73e13143ed75","title":"Värinlaatuongelmat","link":"modifying-colors-in-printed-output-topic.html","desc":"Tuloste näyttää sävytetyltä Tuloste näyttää","descFull":"Tuloste näyttää sävytetyltä Tuloste näyttää sävytetyltä Kokeile jotakin seuraavista keinoista: Siirry ohjauspaneelista kohtaan  Asetukset Tulosta Laatu Kuvankäsittelyn lisäasetukset  ja sitten valitse  Värinsäätö . Siirry ohjauspaneelista kohtaan  Asetukset Tulosta Laatu Kuvankäsittelyn lisäasetukset  ja valitse sitten   Väritasapaino  ja muuta asetuksia. Jos ongelma ei poistu, ota yhteyttä  asiakastuki . Jos ongelma ei poistu, ota yhteyttä  jälleenmyyjääsi . värin laatuongelma tuloste näyttää sävytetyltä tuloste näyttää sävytetyltä vianmääritys tuloste näyttää sävytetyltä"},{"UUID":"a6e980ea-5f9e-4d8a-bc04-8e535d749213","title":"Vianmääritys","link":"trb-contacting-customer-support-topic.html","desc":"Yhteyden ottaminen asiakastukeen Yhteyden ottaminen","descFull":"Yhteyden ottaminen asiakastukeen Yhteyden ottaminen asiakastukeen Tarkista seuraavat tiedot, ennen kuin otat yhteyttä asiakaspalveluun: Tulostimen ongelma Virheilmoitus Tulostimen malli ja sarjanumero Siirry osoitteeseen  https://support.lexmark.com , jossa voit käyttää sähköposti- ja chat-tukea tai selailla oppaita, tukiasiakirjoja, ohjaimia ja muita ladattavia kohteita. Tekninen tuki on käytettävissä myös puhelimitse. Soita Yhdysvalloissa tai Kanadassa numeroon 1‑800‑539‑6275. Katso muiden maiden tai alueiden tiedot  kansainvälisen tuen yhteystietohakemistosta . Käy tulostimen ostopaikassa. yhteyden ottaminen asiakastukeen asiakastuki"},{"UUID":"41e35de1-f893-4344-8de0-d84922eaacd5","title":"Vianmääritys","link":"troubleshooting-chapter.html","desc":"Yhteyden ottaminen jälleenmyyjään Tarkista seuraavat","descFull":"Yhteyden ottaminen jälleenmyyjään Tarkista seuraavat tiedot, ennen kuin otat yhteyttä jälleenmyyjään: Tulostimen ongelma Virheilmoitus Tulostimen malli ja sarjanumero yhteyden ottaminen jälleenmyyjään tulostimien jälleenmyyjä"},{"UUID":"cb4806a3-3f7c-4e91-b28a-055d70cd66ec","title":"Vianmääritys","link":"troubleshooting-chapter.html","desc":"Yhteyden ottaminen tekniseen tukeen Kun","descFull":"Yhteyden ottaminen tekniseen tukeen Kun soitat tekniseen tukeen, valmistaudu kuvailemaan ongelma, tulostimen näytössä näkyvä virheilmoitus ja vianmääritysvaiheet, joiden avulla olet jo yrittänyt ratkaista ongelman. Katso tiedot tulostimen yläetukannen sisäpuolelta tai tulostimen takaa ja merkitse muistiin seuraavat asiat: tulostimen malli palvelutunnnistenumero tai pikahuoltokoodi. Lisätietoja on osoitteessa  www.dell.com/support . vianmääritys yhteyden ottaminen tekniseen tukeen yhteyden ottaminen tekniseen tukeen"},{"UUID":"ae1e0b3d-35d7-459e-b56e-a8df94d08e65","title":"Kierrätys ja hävittäminen","link":"recycling-lexmark-products-topic.html","desc":"Lexmark-tuotteiden kierrättäminen Lexmark-tuotteiden kierrättäminen Siirry","descFull":"Lexmark-tuotteiden kierrättäminen Lexmark-tuotteiden kierrättäminen Siirry osoitteeseen  www.lexmark.com/recycle . Valitse maa tai alue. Valitse kierrätysohjelma. tuotteiden kierrätys"},{"UUID":"66ace436-78ea-4007-8e2d-7a13b2d5b3ff","title":"Kierrätys ja hävittäminen","link":"recycling-lexmark-packaging-topic.html","desc":"Lexmark-pakkauksen kierrättäminen Lexmark-pakkauksen kierrättäminen Lexmark","descFull":"Lexmark-pakkauksen kierrättäminen Lexmark-pakkauksen kierrättäminen Lexmark pyrkii jatkuvasti vähentämään käyttämänsä pakkausmateriaalin määrää. Pienempi määrä pakkausmateriaalia auttaa varmistamaan, että Lexmark-tulostimet kuljetetaan kaikkein tehokkaimmalla ja ympäristöystävällisimmällä tavalla, ja että hävitettävää pakkausmateriaalia jää vähemmän. Nämä tehostamiset johtavat pienempiin kasvihuonekaasupäästöihin sekä energian ja luonnonvarojen säästöön. Joissakin maissa tai joillakin alueilla Lexmark tarjoaa myös pakkausmateriaalin kierrätyksen. Lisätietoja on osoitteessa  www.lexmark.com/recycle . Lexmark-pahvit ovat 100-prosenttisesti kierrätettäviä, jos aaltopahvin kierrätys on järjestetty. Omalla alueellasi sitä ei ehkä ole järjestetty. Lexmark-pakkausmateriaaleissa käytetty vaahtomuovi on kierrätettävää, jos vaahtomuovin kierrätys on järjestetty. Omalla alueellasi sitä ei ehkä ole järjestetty.  Palauttaessasi värikasettia Lexmarkille, voit käyttää sen oman pakkauslaatikon uudelleen. Lexmark huolehtii laatikon kierrättämisestä. tuotteen kierrätys pakkausmateriaali"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 Monitoimilaitteet"}},[_vm._v("\n    CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 Monitoimilaitteet\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"safety.html#safety_fi","title":"Turvaohjeita"}},[_vm._v("\n    Turvaohjeita\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":".html#d0e23","title":"Merkint&auml;tavat"}},[_vm._v("\n     Merkintätavat\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"safety-cable-topic.html#d0e43","title":"Tuotelausunnot"}},[_vm._v("\n     Tuotelausunnot\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"learning-about-printer-chapter.html#learning-about-printer-chapter_fi","title":"Tietoja tulostimesta"}},[_vm._v("\n    Tietoja tulostimesta\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e221"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-information-about-printer-topic.html#finding-information-about-printer_fi","title":"Tulostintietojen etsiminen"}},[_vm._v("\n     Tulostintietojen etsiminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-printer-serial-number-topic.html#finding-printer-serial-number_fi","title":"Tulostimien sarjanumeron etsiminen"}},[_vm._v("\n     Tulostimien sarjanumeron etsiminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-configurations-topic.html#printer-configurations_fi","title":"Tulostinkokoonpanot"}},[_vm._v("\n     Tulostinkokoonpanot\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-control-panel-topic.html#using-control-panel_fi","title":"Ohjauspaneelin k&auml;ytt&auml;minen"}},[_vm._v("\n     Ohjauspaneelin käyttäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-home-screen-topic.html#using-home-screen_fi","title":"Aloitusn&auml;yt&ouml;n kuvakkeet"}},[_vm._v("\n     Aloitusnäytön kuvakkeet\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"colors-of-indicator-light-topic.html#colors-of-indicator-light_fi","title":"Merkkivalon v&auml;rit"}},[_vm._v("\n     Merkkivalon värit\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_fi","title":"Automaattisen asiakirjansy&ouml;tt&ouml;laitteen ja skannaustason k&auml;ytt&auml;minen"}},[_vm._v("\n     Automaattisen asiakirjansyöttölaitteen ja skannaustason käyttäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"locating-security-slot-topic.html#locating-security-slot_fi","title":"Turvalukon etsiminen"}},[_vm._v("\n     Turvalukon etsiminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"paper-guidelines-topic.html#d0e769","title":"Paperin valinta"}},[_vm._v("\n     Paperin valinta\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-applications-topic.html#d0e10635","title":"Tulostimen lis&auml;ominaisuudet ja tuki"}},[_vm._v("\n     Tulostimen lisäominaisuudet ja tuki\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_fi","title":"K&auml;ytt&ouml;&ouml;notto, asennus ja kokoonpano"}},[_vm._v("\n    Käyttöönotto, asennus ja kokoonpano\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10762"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-location-printer-topic.html#selecting-location-printer_fi","title":"Tulostimen paikan valitseminen"}},[_vm._v("\n     Tulostimen paikan valitseminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-ports-topic.html#printer-ports_fi","title":"Tulostimen portit"}},[_vm._v("\n     Tulostimen portit\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-scan-center-topic.html#d0e10961","title":"Sovellusten ja ratkaisujen m&auml;&auml;ritt&auml;minen"}},[_vm._v("\n     Sovellusten ja ratkaisujen määrittäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"activating-voice-guidance-topic.html#d0e11138","title":"Helppok&auml;ytt&ouml;toimintojen k&auml;ytt&ouml;&ouml;nottaminen ja k&auml;ytt&auml;minen"}},[_vm._v("\n     Helppokäyttötoimintojen käyttöönottaminen ja käyttäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-printer-to-fax-group.html#d0e11443","title":"Tulostimen asentaminen faksaamista varten"}},[_vm._v("\n     Tulostimen asentaminen faksaamista varten\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"loading-trays-group.html#loading-trays-group_fi","title":"Paperin ja erikoismateriaalin lis&auml;&auml;minen"}},[_vm._v("\n     Paperin ja erikoismateriaalin lisääminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-printer-software-topic.html#d0e12239","title":"Ohjelmiston, ohjaimien ja laiteohjelmiston asentaminen ja p&auml;ivitt&auml;minen"}},[_vm._v("\n     Ohjelmiston, ohjaimien ja laiteohjelmiston asentaminen ja päivittäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-optional-550-sheet-tray-topic.html#d0e12565","title":"Lis&auml;varusteiden asentaminen"}},[_vm._v("\n     Lisävarusteiden asentaminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"connecting-printer-to-wireless-network-topic.html#d0e14096","title":"Verkkoyhteydet"}},[_vm._v("\n     Verkkoyhteydet\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-the-printer.html#securing-the-printer_fi","title":"Tulostimen suojaaminen"}},[_vm._v("\n    Tulostimen suojaaminen\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e14448"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-memory-topic.html#erasing-printer-memory_fi","title":"Tulostinmuistin tyhjent&auml;minen"}},[_vm._v("\n     Tulostinmuistin tyhjentäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_fi","title":"Tulostimen tallennusaseman tyhjent&auml;minen"}},[_vm._v("\n     Tulostimen tallennusaseman tyhjentäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restoring-factory-default-settings-topic.html#restoring-factory-default-settings_fi","title":"Tehdasasetusten palautus"}},[_vm._v("\n     Tehdasasetusten palautus\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"statement-of-volatility-topic.html#statement-of-volatility_fi","title":"Haihtuvuusjulistus"}},[_vm._v("\n     Haihtuvuusjulistus\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printing-chapter.html#printing-chapter_fi","title":"Tulostaminen"}},[_vm._v("\n    Tulostaminen\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e14640"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-computer-topic.html#printing-from-computer_fi","title":"Tulostaminen tietokoneella"}},[_vm._v("\n     Tulostaminen tietokoneella\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14691","title":"Tulostaminen mobiililaitteesta"}},[_vm._v("\n     Tulostaminen mobiililaitteesta\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-flash-drive-topic.html#printing-from-flash-drive_fi","title":"Tulostaminen flash-asemasta"}},[_vm._v("\n     Tulostaminen flash-asemasta\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-confidential-jobs-topic.html#configuring-confidential-jobs_fi","title":"Luottamuksellisten t&ouml;iden m&auml;&auml;ritt&auml;minen"}},[_vm._v("\n     Luottamuksellisten töiden määrittäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_fi","title":"Luottamuksellisten ja muiden pidossa olevien t&ouml;iden tulostaminen"}},[_vm._v("\n     Luottamuksellisten ja muiden pidossa olevien töiden tulostaminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-font-sample-list-topic.html#printing-font-sample-list_fi","title":"Fonttimalliluettelon tulostaminen"}},[_vm._v("\n     Fonttimalliluettelon tulostaminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-directory-list-topic.html#printing-directory-list_fi","title":"Hakemistoluettelon tulostaminen"}},[_vm._v("\n     Hakemistoluettelon tulostaminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_fi","title":"Erotinarkkien asettaminen tulostust&ouml;ihin"}},[_vm._v("\n     Erotinarkkien asettaminen tulostustöihin\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-print-job-topic.html#canceling-print-job_fi","title":"Tulostusty&ouml;n peruuttaminen"}},[_vm._v("\n     Tulostustyön peruuttaminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-toner-darkness-topic.html#adjusting-toner-darkness_fi","title":"V&auml;riaineen tummuuden s&auml;&auml;t&auml;minen"}},[_vm._v("\n     Väriaineen tummuuden säätäminen\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"copying.html#copying_fi","title":"Kopioiminen"}},[_vm._v("\n    Kopioiminen\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e15186"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"making-copies-topic.html#making-copies_fi","title":"Kopioiminen"}},[_vm._v("\n     Kopioiminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-photos-topic.html#copying-photos_fi","title":"Valokuvien kopioiminen"}},[_vm._v("\n     Valokuvien kopioiminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-letterhead-topic.html#copying-on-letterhead_fi","title":"Kopioiminen kirjelomakkeelle"}},[_vm._v("\n     Kopioiminen kirjelomakkeelle\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_fi","title":"Paperin molemmille puolille kopioiminen"}},[_vm._v("\n     Paperin molemmille puolille kopioiminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"reducing-or-enlarging-copies-topic.html#reducing-or-enlarging-copies_fi","title":"Kopioiden pienent&auml;minen tai suurentaminen"}},[_vm._v("\n     Kopioiden pienentäminen tai suurentaminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"collating-copies-topic.html#collating-copies_fi","title":"Kopioiden lajittelu"}},[_vm._v("\n     Kopioiden lajittelu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_fi","title":"Erotinsivujen lis&auml;&auml;minen kopioiden v&auml;liin"}},[_vm._v("\n     Erotinsivujen lisääminen kopioiden väliin\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-multiple-pages-onto-single-sheet-topic.html#copying-multiple-pages-onto-single-sheet_fi","title":"Useiden sivujen kopioiminen yhdelle arkille"}},[_vm._v("\n     Useiden sivujen kopioiminen yhdelle arkille\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-cards-topic.html#copying-cards_fi","title":"Korttien kopioiminen"}},[_vm._v("\n     Korttien kopioiminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-copy-shortcut-topic.html#creating-copy-shortcut_fi","title":"Kopioinnin pikavalinnan luominen"}},[_vm._v("\n     Kopioinnin pikavalinnan luominen\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"E-mailing.html#E-mailing_fi","title":"S&auml;hk&ouml;posti"}},[_vm._v("\n    Sähköposti\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e15459"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-smtp-settings-topic.html#configuring-smtp-settings_fi","title":"SMTP-asetusten m&auml;&auml;ritt&auml;minen"}},[_vm._v("\n     SMTP-asetusten määrittäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-email-topic.html#sending-email_fi","title":"S&auml;hk&ouml;postiviestin l&auml;hett&auml;minen"}},[_vm._v("\n     Sähköpostiviestin lähettäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_fi","title":"S&auml;hk&ouml;postin pikavalinnan luominen"}},[_vm._v("\n     Sähköpostin pikavalinnan luominen\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"Faxing.html#Faxing_fi","title":"Faksaaminen"}},[_vm._v("\n    Faksaaminen\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e16908"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-fax-topic.html#sending-fax_fi","title":"Faksin l&auml;hett&auml;minen"}},[_vm._v("\n     Faksin lähettäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scheduling-fax-topic.html#scheduling-fax_fi","title":"Faksin ajastaminen"}},[_vm._v("\n     Faksin ajastaminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_fi","title":"Faksin kohdepikavalinnan luominen"}},[_vm._v("\n     Faksin kohdepikavalinnan luominen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-fax-resolution-topic.html#changing-fax-resolution_fi","title":"Faksin tarkkuuden muuttaminen"}},[_vm._v("\n     Faksin tarkkuuden muuttaminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-fax-darkness-topic.html#adjusting-fax-darkness_fi","title":"Faksin tummuuden s&auml;&auml;t&auml;minen"}},[_vm._v("\n     Faksin tummuuden säätäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-fax-log-topic.html#printing-fax-log_fi","title":"Faksilokin tulostaminen"}},[_vm._v("\n     Faksilokin tulostaminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"blocking-junk-faxes-topic.html#blocking-junk-faxes_fi","title":"Roskafaksien est&auml;minen"}},[_vm._v("\n     Roskafaksien estäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"holding-faxes-topic.html#holding-faxes_fi","title":"Faksien pys&auml;ytt&auml;minen"}},[_vm._v("\n     Faksien pysäyttäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forwarding-fax-topic.html#forwarding-fax_fi","title":"Faksin v&auml;litt&auml;minen"}},[_vm._v("\n     Faksin välittäminen\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"FTP.html#FTP_fi","title":"Skannaaminen"}},[_vm._v("\n    Skannaaminen\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e17204"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-computer-topic.html#scanning-to-computer_fi","title":"Skannaaminen tietokoneeseen"}},[_vm._v("\n     Skannaaminen tietokoneeseen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_fi","title":"Skannaaminen FTP-palvelimelle"}},[_vm._v("\n     Skannaaminen FTP-palvelimelle\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-FTP-shortcut-topic.html#creating-FTP-shortcut_fi","title":"FTP-pikavalintojen luominen"}},[_vm._v("\n     FTP-pikavalintojen luominen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-network-folder-topic.html#scanning-to-network-folder_fi","title":"Skannaaminen verkkokansioon"}},[_vm._v("\n     Skannaaminen verkkokansioon\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-network-folder-destination-topic.html#configuring-network-folder-destination_fi","title":"Verkkokansiokohteen m&auml;&auml;ritt&auml;minen"}},[_vm._v("\n     Verkkokansiokohteen määrittäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_fi","title":"Verkkokansion pikakuvakkeen luominen"}},[_vm._v("\n     Verkkokansion pikakuvakkeen luominen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-flash-drive-topic.html#scanning-to-flash-drive_fi","title":"Skannaaminen flash-asemaan"}},[_vm._v("\n     Skannaaminen flash-asemaan\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printer-menus-chapter.html#printer-menus-chapter_fi","title":"Tulostimen valikot"}},[_vm._v("\n    Tulostimen valikot\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e17493"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-map-topic.html#menu-map_fi","title":"Valikkokartta"}},[_vm._v("\n     Valikkokartta\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"preferences-topic.html#d0e17807","title":"Laite"}},[_vm._v("\n     Laite\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"layout-topic.html#d0e20041","title":"Tulostaminen"}},[_vm._v("\n     Tulostaminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"tray-configuration-topic.html#d0e21323","title":"Paperi"}},[_vm._v("\n     Paperi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copy-defaults-topic.html#d0e21655","title":"Kopioiminen"}},[_vm._v("\n     Kopioiminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"fax-defaults-subgroup.html#d0e22214","title":"Faksi"}},[_vm._v("\n     Faksi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"email-setup-topic.html#d0e24081","title":"S&auml;hk&ouml;posti"}},[_vm._v("\n     Sähköposti\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ftp-defaults-topic.html#d0e25178","title":"FTP"}},[_vm._v("\n     FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"flash-drive-scan-topic.html#d0e25884","title":"USB-asema"}},[_vm._v("\n     USB-asema\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"network-overview-topic.html#d0e26730","title":"Verkko/portit"}},[_vm._v("\n     Verkko/portit\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"login-methods-subgroup.html#d0e28881","title":"Suojaus"}},[_vm._v("\n     Suojaus\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cloud-services-enrollment-topic.html#d0e29978","title":"Cloud-palvelut"}},[_vm._v("\n     Cloud-palvelut\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-settings-page-topic.html#d0e30035","title":"Raportit"}},[_vm._v("\n     Raportit\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"troubleshooting-menu-topic.html#troubleshooting-menu_fi","title":"Vianm&auml;&auml;ritys"}},[_c('strong',[_vm._v("\n      Vianmääritys\n     ")])])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forms-merge-topic.html#forms-merge_fi","title":"Lomakkeiden yhdist&auml;minen"}},[_c('strong',[_vm._v("\n      Lomakkeiden yhdistäminen\n     ")])])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-menu-settings-page-topic.html#printing-menu-settings-page_fi","title":"Valikkoasetussivun tulostus"}},[_c('strong',[_vm._v("\n      Valikkoasetussivun\n     ")]),_vm._v("\n     tulostus\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_fi","title":"Tulostimen viimeistelij&auml;n vaihtoehdot"}},[_vm._v("\n    Tulostimen viimeistelijän vaihtoehdot\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e30518"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-staple-finisher-topic.html#using-staple-finisher_fi","title":"Nidonnan viimeistelij&auml;n k&auml;ytt&auml;minen"}},[_vm._v("\n     Nidonnan viimeistelijän käyttäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_fi","title":"Nidonnan ja rei'ityksen viimeistelij&auml;n k&auml;ytt&auml;minen"}},[_vm._v("\n     Nidonnan ja rei'ityksen viimeistelijän käyttäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-offset-stacker-topic.html#using-offset-stacker_fi","title":"Offset-pinoajan k&auml;ytt&auml;minen"}},[_vm._v("\n     Offset-pinoajan käyttäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-booklet-finisher-topic.html#using-booklet-finisher_fi","title":"Vihkoviimeistelij&auml;n k&auml;ytt&auml;minen"}},[_vm._v("\n     Vihkoviimeistelijän käyttäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-hptfu-topic.html#using-hptfu_fi","title":"Paperin siirron k&auml;ytt&auml;minen taittovalinnalla"}},[_vm._v("\n     Paperin siirron käyttäminen taittovalinnalla\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintain-printer-chapter.html#maintain-printer-chapter_fi","title":"Tulostimen yll&auml;pito"}},[_vm._v("\n    Tulostimen ylläpito\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e30928"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-supplies-status-topic.html#checking-supplies-status_fi","title":"Osien ja tarvikkeiden tilan tarkistaminen"}},[_vm._v("\n     Osien ja tarvikkeiden tilan tarkistaminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-supply-notifications-topic.html#configuring-supply-notifications_fi","title":"Tarvikeilmoitusten m&auml;&auml;ritt&auml;minen"}},[_vm._v("\n     Tarvikeilmoitusten määrittäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-email-alert-topic.html#setting-up-email-alert_fi","title":"S&auml;hk&ouml;postih&auml;lytysten m&auml;&auml;ritt&auml;minen"}},[_vm._v("\n     Sähköpostihälytysten määrittäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"generating-reports-and-logs-topic.html#generating-reports-and-logs_fi","title":"Raporttien ja lokien luominen"}},[_vm._v("\n     Raporttien ja lokien luominen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_fi","title":"Tulostimen osien ja tarvikkeiden tilaaminen"}},[_vm._v("\n     Tulostimen osien ja tarvikkeiden tilaaminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"replacing-toner-cartridge-topic.html#d0e31783","title":"Tulostimen osien ja tarvikkeiden vaihtaminen"}},[_vm._v("\n     Tulostimen osien ja tarvikkeiden vaihtaminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cleaning-printer-topic.html#d0e32407","title":"Tulostimen osien puhdistaminen"}},[_vm._v("\n     Tulostimen osien puhdistaminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-power-save-mode-settings-topic.html#d0e32571","title":"Energian ja paperin s&auml;&auml;st&auml;minen"}},[_vm._v("\n     Energian ja paperin säästäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"moving-printer-topic.html#moving-printer_fi","title":"Tulostimen siirt&auml;minen toiseen paikkaan"}},[_vm._v("\n     Tulostimen siirtäminen toiseen paikkaan\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_fi","title":"Vianm&auml;&auml;ritys"}},[_vm._v("\n    Vianmääritys\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e32709"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"print-quality-problems-topic.html#print-quality-problems_fi","title":"Tulostuslaatuongelmat"}},[_vm._v("\n     Tulostuslaatuongelmat\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-error-codes-topic.html#printer-error-codes_fi","title":"Tulostimen virhekoodit"}},[_vm._v("\n     Tulostimen virhekoodit\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"solving-printing-problems.html#solving-printing-problems_fi","title":"Tulostusongelmat"}},[_vm._v("\n     Tulostusongelmat\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-printer-not-responding-topic.html#trb-printer-not-responding_fi","title":"Tulostin ei vastaa"}},[_vm._v("\n     Tulostin ei vastaa\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_fi","title":"Flash-asemaa ei voi lukea"}},[_vm._v("\n     Flash-asemaa ei voi lukea\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-usb-port-topic.html#enabling-usb-port_fi","title":"USB-portin k&auml;ytt&ouml;&ouml;notto"}},[_vm._v("\n     USB-portin käyttöönotto\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"clearing-jams.html#clearing-jams_fi","title":"Tukosten poistaminen"}},[_vm._v("\n     Tukosten poistaminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-open-embedded-web-server-topic.html#d0e36133","title":"Verkkoyhteysongelmat"}},[_vm._v("\n     Verkkoyhteysongelmat\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-detect-internal-option-topic.html#d0e36226","title":"Lis&auml;varusteongelmat"}},[_vm._v("\n     Lisävarusteongelmat\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-replace-cartridge-printer-region-mismatch-topic.html#d0e36399","title":"Tarvikeongelmat"}},[_vm._v("\n     Tarvikeongelmat\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-paper-curl-topic.html#d0e36547","title":"Paperinsy&ouml;tt&ouml;ongelmat"}},[_vm._v("\n     Paperinsyöttöongelmat\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"disabling-smtp-server-not-setup-error-topic.html#d0e36741","title":"S&auml;hk&ouml;postiongelmat"}},[_vm._v("\n     Sähköpostiongelmat\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-caller-id-not-shown-topic.html#d0e36796","title":"Faksausongelmat"}},[_vm._v("\n     Faksausongelmat\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-scan-to-computer-topic.html#d0e37118","title":"Skannausongelmat"}},[_vm._v("\n     Skannausongelmat\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"modifying-colors-in-printed-output-topic.html#d0e37536","title":"V&auml;rinlaatuongelmat"}},[_vm._v("\n     Värinlaatuongelmat\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-contacting-customer-support-topic.html#trb-contacting-customer-support_fi","title":"Yhteyden ottaminen asiakastukeen"}},[_vm._v("\n     Yhteyden ottaminen asiakastukeen\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"recycle-dispose-chapter.html#recycle-dispose-chapter_fi","title":"Kierr&auml;tys ja h&auml;vitt&auml;minen"}},[_vm._v("\n    Kierrätys ja hävittäminen\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e37762"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-products-topic.html#recycling-lexmark-products_fi","title":"Lexmark-tuotteiden kierr&auml;tt&auml;minen"}},[_vm._v("\n     Lexmark-tuotteiden kierrättäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_fi","title":"Lexmark-pakkauksen kierr&auml;tt&auml;minen"}},[_vm._v("\n     Lexmark-pakkauksen kierrättäminen\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser_ug_notices_fi","title":"Tiedotteet"}},[_vm._v("\n    Tiedotteet\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e37798"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37801","title":"Tuotetiedot"}},[_vm._v("\n     Tuotetiedot\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37818","title":"Painosta koskeva tiedote"}},[_vm._v("\n     Painosta koskeva tiedote\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#trademarks_fi","title":"Tavaramerkit"}},[_vm._v("\n     Tavaramerkit\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#licensing-notices_fi","title":"K&auml;ytt&ouml;oikeustiedote"}},[_vm._v("\n     Käyttöoikeustiedote\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#noise-emission-levels_fi","title":"Emissiotaso"}},[_vm._v("\n     Emissiotaso\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#weee-directive_fi","title":"S&auml;hk&ouml;- ja elektroniikkaromudirektiivi (SER)"}},[_vm._v("\n     Sähkö- ja elektroniikkaromudirektiivi (SER)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37924","title":"Litiumioniakku"}},[_vm._v("\n     Litiumioniakku\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#eu-battery-directive-2023-1542_fi","title":"Asetus (EU) 2023/1542"}},[_vm._v("\n     Asetus (EU) 2023/1542\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37962","title":"Environmental labeling for packaging"}},[_vm._v("\n     Environmental labeling for packaging\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#product-disposal_fi","title":"Laitteen h&auml;vitt&auml;minen"}},[_vm._v("\n     Laitteen hävittäminen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#static-sensitivity-notice_fi","title":"Staattista s&auml;hk&ouml;&auml; koskeva tiedote"}},[_vm._v("\n     Staattista sähköä koskeva tiedote\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#energy-star_fi","title":"ENERGY STAR"}},[_vm._v("\n     ENERGY STAR\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#temperature-information_fi","title":"L&auml;mp&ouml;tilatiedot"}},[_vm._v("\n     Lämpötilatiedot\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser-notice_fi","title":"Laserilmoitus"}},[_vm._v("\n     Laserilmoitus\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#power-consumption_fi","title":"Virrankulutus"}},[_vm._v("\n     Virrankulutus\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e38205","title":"Langattomia tuotteita koskevat s&auml;&auml;nn&ouml;kset"}},[_vm._v("\n     Langattomia tuotteita koskevat säännökset\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#modular-component-notice_fi","title":"Ilmoitus modulaarisista komponenteista"}},[_vm._v("\n     Ilmoitus modulaarisista komponenteista\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#exposure-to-radio-frequency-radiation_fi","title":"Altistus radiotaajuuss&auml;teilylle"}},[_vm._v("\n     Altistus radiotaajuussäteilylle\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e38230","title":"Euroopan yhteis&ouml;n (EY) direktiivien mukainen ilmoitus"}},[_vm._v("\n     Euroopan yhteisön (EY) direktiivien mukainen ilmoitus\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#european-community-ec-directives-conformity-class-a_fi","title":"Euroopan yhteis&ouml;n (EY) direktiivien mukainen ilmoitus"}},[_vm._v("\n     Euroopan yhteisön (EY) direktiivien mukainen ilmoitus\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#radio-interference-notice_fi","title":"Radioh&auml;iri&ouml;lausunto"}},[_vm._v("\n     Radiohäiriölausunto\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js